import React, { useEffect, useState, useRef } from 'react';
// import Table from 'react-bootstrap/Table';
import { useTheme } from '@mui/material/styles';
import CloudQueueIcon from '@mui/icons-material/CloudQueue';
import DragIndicatorOutlinedIcon from '@mui/icons-material/DragIndicatorOutlined';
import ScienceOutlinedIcon from '@mui/icons-material/ScienceOutlined';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import ArrowCircleRightOutlinedIcon from '@mui/icons-material/ArrowCircleRightOutlined';
import { ClientTablee } from './ClientTablee';
import TransferWithinAStationIcon from '@mui/icons-material/TransferWithinAStation';
import { ShowClientsActions } from './ShowClientsActions';
import { ReciveSalesToLeed } from './ReciveSalesToLeed';
import ReplyIcon from '@mui/icons-material/Reply';
import {
  Autocomplete,
  Badge,
  Box,
  Checkbox,
  Chip,
  CircularProgress,
  createFilterOptions,
  FormControl,
  ListItemText,
  MenuItem,
  Paper,
  Select,
  Skeleton,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
} from '@mui/material';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { Snackbar, Alert } from '@mui/material';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import XLSX from '../utils/excelUtils';
import axios from 'axios';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import CloseIcon from '@mui/icons-material/Close';
import ControlPointDuplicateIcon from '@mui/icons-material/ControlPointDuplicate';
import ClearAllIcon from '@mui/icons-material/ClearAll';
import {
  DeleteUserAction,
  Getalldata,
  GetalldataLeadsWithPages,
  Getalldatasearch,
  GetAllLeadsSearchAction,
  UpdateClientAction,
} from '../Redux/Actions/UsersAction';
import { useDispatch, useSelector } from 'react-redux';
import {
  Accordion,
  Col,
  Container,
  Dropdown,
  Form,
  Offcanvas,
  OffcanvasHeader,
  Row,
  Spinner,
  Table,
} from 'react-bootstrap';
import IconButton from '@mui/material/IconButton';
import moment from 'moment-timezone';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { Get_All_Sales_Action } from '../Redux/Actions/SalesAction';
import { GetAllchannalData } from '../Redux/Actions/ChannalActions';
import { GetallProjectsdata } from '../Redux/Actions/Projects_Action';
import { CountrySelect } from 'react-country-state-city';
import { GetAll_stage_Data } from '../Redux/Actions/Stage_Action';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import CheckIcon from '@mui/icons-material/Check';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Notify } from '../Utility/Notify';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import countries from 'i18n-iso-countries';
import en from 'i18n-iso-countries/langs/en.json';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
// import { Pagination } from '../Utility/Pagination';
import { ShowAllCommentsForoneuser } from './ShowAllCommentsForoneuser';
import { GetDevelopersData } from '../Redux/Actions/DevelopersAction';
import { GetCommunicationwayData } from '../Redux/Actions/CommunicationWay_Action';
import { GetAllCampainData } from '../Redux/Actions/Campaign_Actions';
import { AllLeadHook } from '../Hook Code/AllLeadHook';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
// import TransferWithinAStationIcon from '@mui/icons-material/TransferWithinAStation';
import { FaWhatsapp } from 'react-icons/fa';
import { GetActionsData_action } from '../Redux/Actions/Action_action';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import EditNoteIcon from '@mui/icons-material/EditNote';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import ClearIcon from '@mui/icons-material/Clear';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
// import NotificationBell from '../Pages/NotificationBell';
// import MoreHorizIcon from '@mui/icons-material/MoreHoriz'; // 3 نقاط أفقية
// import SearchIcon from '@mui/icons-material/Search';
import { Getalldatauserlog_forsearch } from '../Redux/Actions/AuthAction';
import SearchIcon from '@mui/icons-material/Search';
import ImportExportOutlinedIcon from '@mui/icons-material/ImportExportOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import { db_url } from '../Api/BaseUrl';
import { io } from 'socket.io-client';
import SevereColdIcon from '@mui/icons-material/SevereCold';
import AlarmOffSharpIcon from '@mui/icons-material/AlarmOffSharp';
import { AssignLeadsModal } from '../Pages/AssignLeadsModal';

// From https://bitbucket.org/atlassian/atlaskit-mk-2/raw/4ad0e56649c3e6c973e226b7efaeb28cb240ccb0/packages/core/select/src/data/countries.js
const countries2 = [
  { code: 'AD', label: 'Andorra', phone: '376' },
  {
    code: 'AE',
    label: 'United Arab Emirates',
    phone: '971',
  },
  { code: 'AF', label: 'Afghanistan', phone: '93' },
  {
    code: 'AG',
    label: 'Antigua and Barbuda',
    phone: '1-268',
  },
  { code: 'AI', label: 'Anguilla', phone: '1-264' },
  { code: 'AL', label: 'Albania', phone: '355' },
  { code: 'AM', label: 'Armenia', phone: '374' },
  { code: 'AO', label: 'Angola', phone: '244' },
  { code: 'AQ', label: 'Antarctica', phone: '672' },
  { code: 'AR', label: 'Argentina', phone: '54' },
  { code: 'AS', label: 'American Samoa', phone: '1-684' },
  { code: 'AT', label: 'Austria', phone: '43' },
  {
    code: 'AU',
    label: 'Australia',
    phone: '61',
    suggested: true,
  },
  { code: 'AW', label: 'Aruba', phone: '297' },
  { code: 'AX', label: 'Alland Islands', phone: '358' },
  { code: 'AZ', label: 'Azerbaijan', phone: '994' },
  {
    code: 'BA',
    label: 'Bosnia and Herzegovina',
    phone: '387',
  },
  { code: 'BB', label: 'Barbados', phone: '1-246' },
  { code: 'BD', label: 'Bangladesh', phone: '880' },
  { code: 'BE', label: 'Belgium', phone: '32' },
  { code: 'BF', label: 'Burkina Faso', phone: '226' },
  { code: 'BG', label: 'Bulgaria', phone: '359' },
  { code: 'BH', label: 'Bahrain', phone: '973' },
  { code: 'BI', label: 'Burundi', phone: '257' },
  { code: 'BJ', label: 'Benin', phone: '229' },
  { code: 'BL', label: 'Saint Barthelemy', phone: '590' },
  { code: 'BM', label: 'Bermuda', phone: '1-441' },
  { code: 'BN', label: 'Brunei Darussalam', phone: '673' },
  { code: 'BO', label: 'Bolivia', phone: '591' },
  { code: 'BR', label: 'Brazil', phone: '55' },
  { code: 'BS', label: 'Bahamas', phone: '1-242' },
  { code: 'BT', label: 'Bhutan', phone: '975' },
  { code: 'BV', label: 'Bouvet Island', phone: '47' },
  { code: 'BW', label: 'Botswana', phone: '267' },
  { code: 'BY', label: 'Belarus', phone: '375' },
  { code: 'BZ', label: 'Belize', phone: '501' },
  {
    code: 'CA',
    label: 'Canada',
    phone: '1',
    suggested: true,
  },
  {
    code: 'CC',
    label: 'Cocos (Keeling) Islands',
    phone: '61',
  },
  {
    code: 'CD',
    label: 'Congo, Democratic Republic of the',
    phone: '243',
  },
  {
    code: 'CF',
    label: 'Central African Republic',
    phone: '236',
  },
  {
    code: 'CG',
    label: 'Congo, Republic of the',
    phone: '242',
  },
  { code: 'CH', label: 'Switzerland', phone: '41' },
  { code: 'CI', label: "Cote d'Ivoire", phone: '225' },
  { code: 'CK', label: 'Cook Islands', phone: '682' },
  { code: 'CL', label: 'Chile', phone: '56' },
  { code: 'CM', label: 'Cameroon', phone: '237' },
  { code: 'CN', label: 'China', phone: '86' },
  { code: 'CO', label: 'Colombia', phone: '57' },
  { code: 'CR', label: 'Costa Rica', phone: '506' },
  { code: 'CU', label: 'Cuba', phone: '53' },
  { code: 'CV', label: 'Cape Verde', phone: '238' },
  { code: 'CW', label: 'Curacao', phone: '599' },
  { code: 'CX', label: 'Christmas Island', phone: '61' },
  { code: 'CY', label: 'Cyprus', phone: '357' },
  { code: 'CZ', label: 'Czech Republic', phone: '420' },
  {
    code: 'DE',
    label: 'Germany',
    phone: '49',
    suggested: true,
  },
  { code: 'DJ', label: 'Djibouti', phone: '253' },
  { code: 'DK', label: 'Denmark', phone: '45' },
  { code: 'DM', label: 'Dominica', phone: '1-767' },
  {
    code: 'DO',
    label: 'Dominican Republic',
    phone: '1-809',
  },
  { code: 'DZ', label: 'Algeria', phone: '213' },
  { code: 'EC', label: 'Ecuador', phone: '593' },
  { code: 'EE', label: 'Estonia', phone: '372' },
  { code: 'EG', label: 'Egypt', phone: '20' },
  { code: 'EH', label: 'Western Sahara', phone: '212' },
  { code: 'ER', label: 'Eritrea', phone: '291' },
  { code: 'ES', label: 'Spain', phone: '34' },
  { code: 'ET', label: 'Ethiopia', phone: '251' },
  { code: 'FI', label: 'Finland', phone: '358' },
  { code: 'FJ', label: 'Fiji', phone: '679' },
  {
    code: 'FK',
    label: 'Falkland Islands (Malvinas)',
    phone: '500',
  },
  {
    code: 'FM',
    label: 'Micronesia, Federated States of',
    phone: '691',
  },
  { code: 'FO', label: 'Faroe Islands', phone: '298' },
  {
    code: 'FR',
    label: 'France',
    phone: '33',
    suggested: true,
  },
  { code: 'GA', label: 'Gabon', phone: '241' },
  { code: 'GB', label: 'United Kingdom', phone: '44' },
  { code: 'GD', label: 'Grenada', phone: '1-473' },
  { code: 'GE', label: 'Georgia', phone: '995' },
  { code: 'GF', label: 'French Guiana', phone: '594' },
  { code: 'GG', label: 'Guernsey', phone: '44' },
  { code: 'GH', label: 'Ghana', phone: '233' },
  { code: 'GI', label: 'Gibraltar', phone: '350' },
  { code: 'GL', label: 'Greenland', phone: '299' },
  { code: 'GM', label: 'Gambia', phone: '220' },
  { code: 'GN', label: 'Guinea', phone: '224' },
  { code: 'GP', label: 'Guadeloupe', phone: '590' },
  { code: 'GQ', label: 'Equatorial Guinea', phone: '240' },
  { code: 'GR', label: 'Greece', phone: '30' },
  {
    code: 'GS',
    label: 'South Georgia and the South Sandwich Islands',
    phone: '500',
  },
  { code: 'GT', label: 'Guatemala', phone: '502' },
  { code: 'GU', label: 'Guam', phone: '1-671' },
  { code: 'GW', label: 'Guinea-Bissau', phone: '245' },
  { code: 'GY', label: 'Guyana', phone: '592' },
  { code: 'HK', label: 'Hong Kong', phone: '852' },
  {
    code: 'HM',
    label: 'Heard Island and McDonald Islands',
    phone: '672',
  },
  { code: 'HN', label: 'Honduras', phone: '504' },
  { code: 'HR', label: 'Croatia', phone: '385' },
  { code: 'HT', label: 'Haiti', phone: '509' },
  { code: 'HU', label: 'Hungary', phone: '36' },
  { code: 'ID', label: 'Indonesia', phone: '62' },
  { code: 'IE', label: 'Ireland', phone: '353' },
  { code: 'IL', label: 'Israel', phone: '972' },
  { code: 'IM', label: 'Isle of Man', phone: '44' },
  { code: 'IN', label: 'India', phone: '91' },
  {
    code: 'IO',
    label: 'British Indian Ocean Territory',
    phone: '246',
  },
  { code: 'IQ', label: 'Iraq', phone: '964' },
  {
    code: 'IR',
    label: 'Iran, Islamic Republic of',
    phone: '98',
  },
  { code: 'IS', label: 'Iceland', phone: '354' },
  { code: 'IT', label: 'Italy', phone: '39' },
  { code: 'JE', label: 'Jersey', phone: '44' },
  { code: 'JM', label: 'Jamaica', phone: '1-876' },
  { code: 'JO', label: 'Jordan', phone: '962' },
  {
    code: 'JP',
    label: 'Japan',
    phone: '81',
    suggested: true,
  },
  { code: 'KE', label: 'Kenya', phone: '254' },
  { code: 'KG', label: 'Kyrgyzstan', phone: '996' },
  { code: 'KH', label: 'Cambodia', phone: '855' },
  { code: 'KI', label: 'Kiribati', phone: '686' },
  { code: 'KM', label: 'Comoros', phone: '269' },
  {
    code: 'KN',
    label: 'Saint Kitts and Nevis',
    phone: '1-869',
  },
  {
    code: 'KP',
    label: "Korea, Democratic People's Republic of",
    phone: '850',
  },
  { code: 'KR', label: 'Korea, Republic of', phone: '82' },
  { code: 'KW', label: 'Kuwait', phone: '965' },
  { code: 'KY', label: 'Cayman Islands', phone: '1-345' },
  { code: 'KZ', label: 'Kazakhstan', phone: '7' },
  {
    code: 'LA',
    label: "Lao People's Democratic Republic",
    phone: '856',
  },
  { code: 'LB', label: 'Lebanon', phone: '961' },
  { code: 'LC', label: 'Saint Lucia', phone: '1-758' },
  { code: 'LI', label: 'Liechtenstein', phone: '423' },
  { code: 'LK', label: 'Sri Lanka', phone: '94' },
  { code: 'LR', label: 'Liberia', phone: '231' },
  { code: 'LS', label: 'Lesotho', phone: '266' },
  { code: 'LT', label: 'Lithuania', phone: '370' },
  { code: 'LU', label: 'Luxembourg', phone: '352' },
  { code: 'LV', label: 'Latvia', phone: '371' },
  { code: 'LY', label: 'Libya', phone: '218' },
  { code: 'MA', label: 'Morocco', phone: '212' },
  { code: 'MC', label: 'Monaco', phone: '377' },
  {
    code: 'MD',
    label: 'Moldova, Republic of',
    phone: '373',
  },
  { code: 'ME', label: 'Montenegro', phone: '382' },
  {
    code: 'MF',
    label: 'Saint Martin (French part)',
    phone: '590',
  },
  { code: 'MG', label: 'Madagascar', phone: '261' },
  { code: 'MH', label: 'Marshall Islands', phone: '692' },
  {
    code: 'MK',
    label: 'Macedonia, the Former Yugoslav Republic of',
    phone: '389',
  },
  { code: 'ML', label: 'Mali', phone: '223' },
  { code: 'MM', label: 'Myanmar', phone: '95' },
  { code: 'MN', label: 'Mongolia', phone: '976' },
  { code: 'MO', label: 'Macao', phone: '853' },
  {
    code: 'MP',
    label: 'Northern Mariana Islands',
    phone: '1-670',
  },
  { code: 'MQ', label: 'Martinique', phone: '596' },
  { code: 'MR', label: 'Mauritania', phone: '222' },
  { code: 'MS', label: 'Montserrat', phone: '1-664' },
  { code: 'MT', label: 'Malta', phone: '356' },
  { code: 'MU', label: 'Mauritius', phone: '230' },
  { code: 'MV', label: 'Maldives', phone: '960' },
  { code: 'MW', label: 'Malawi', phone: '265' },
  { code: 'MX', label: 'Mexico', phone: '52' },
  { code: 'MY', label: 'Malaysia', phone: '60' },
  { code: 'MZ', label: 'Mozambique', phone: '258' },
  { code: 'NA', label: 'Namibia', phone: '264' },
  { code: 'NC', label: 'New Caledonia', phone: '687' },
  { code: 'NE', label: 'Niger', phone: '227' },
  { code: 'NF', label: 'Norfolk Island', phone: '672' },
  { code: 'NG', label: 'Nigeria', phone: '234' },
  { code: 'NI', label: 'Nicaragua', phone: '505' },
  { code: 'NL', label: 'Netherlands', phone: '31' },
  { code: 'NO', label: 'Norway', phone: '47' },
  { code: 'NP', label: 'Nepal', phone: '977' },
  { code: 'NR', label: 'Nauru', phone: '674' },
  { code: 'NU', label: 'Niue', phone: '683' },
  { code: 'NZ', label: 'New Zealand', phone: '64' },
  { code: 'OM', label: 'Oman', phone: '968' },
  { code: 'PA', label: 'Panama', phone: '507' },
  { code: 'PE', label: 'Peru', phone: '51' },
  { code: 'PF', label: 'French Polynesia', phone: '689' },
  { code: 'PG', label: 'Papua New Guinea', phone: '675' },
  { code: 'PH', label: 'Philippines', phone: '63' },
  { code: 'PK', label: 'Pakistan', phone: '92' },
  { code: 'PL', label: 'Poland', phone: '48' },
  {
    code: 'PM',
    label: 'Saint Pierre and Miquelon',
    phone: '508',
  },
  { code: 'PN', label: 'Pitcairn', phone: '870' },
  { code: 'PR', label: 'Puerto Rico', phone: '1' },
  {
    code: 'PS',
    label: 'Palestine, State of',
    phone: '970',
  },
  { code: 'PT', label: 'Portugal', phone: '351' },
  { code: 'PW', label: 'Palau', phone: '680' },
  { code: 'PY', label: 'Paraguay', phone: '595' },
  { code: 'QA', label: 'Qatar', phone: '974' },
  { code: 'RE', label: 'Reunion', phone: '262' },
  { code: 'RO', label: 'Romania', phone: '40' },
  { code: 'RS', label: 'Serbia', phone: '381' },
  { code: 'RU', label: 'Russian Federation', phone: '7' },
  { code: 'RW', label: 'Rwanda', phone: '250' },
  { code: 'SA', label: 'Saudi Arabia', phone: '966' },
  { code: 'SB', label: 'Solomon Islands', phone: '677' },
  { code: 'SC', label: 'Seychelles', phone: '248' },
  { code: 'SD', label: 'Sudan', phone: '249' },
  { code: 'SE', label: 'Sweden', phone: '46' },
  { code: 'SG', label: 'Singapore', phone: '65' },
  { code: 'SH', label: 'Saint Helena', phone: '290' },
  { code: 'SI', label: 'Slovenia', phone: '386' },
  {
    code: 'SJ',
    label: 'Svalbard and Jan Mayen',
    phone: '47',
  },
  { code: 'SK', label: 'Slovakia', phone: '421' },
  { code: 'SL', label: 'Sierra Leone', phone: '232' },
  { code: 'SM', label: 'San Marino', phone: '378' },
  { code: 'SN', label: 'Senegal', phone: '221' },
  { code: 'SO', label: 'Somalia', phone: '252' },
  { code: 'SR', label: 'Suriname', phone: '597' },
  { code: 'SS', label: 'South Sudan', phone: '211' },
  {
    code: 'ST',
    label: 'Sao Tome and Principe',
    phone: '239',
  },
  { code: 'SV', label: 'El Salvador', phone: '503' },
  {
    code: 'SX',
    label: 'Sint Maarten (Dutch part)',
    phone: '1-721',
  },
  {
    code: 'SY',
    label: 'Syrian Arab Republic',
    phone: '963',
  },
  { code: 'SZ', label: 'Swaziland', phone: '268' },
  {
    code: 'TC',
    label: 'Turks and Caicos Islands',
    phone: '1-649',
  },
  { code: 'TD', label: 'Chad', phone: '235' },
  {
    code: 'TF',
    label: 'French Southern Territories',
    phone: '262',
  },
  { code: 'TG', label: 'Togo', phone: '228' },
  { code: 'TH', label: 'Thailand', phone: '66' },
  { code: 'TJ', label: 'Tajikistan', phone: '992' },
  { code: 'TK', label: 'Tokelau', phone: '690' },
  { code: 'TL', label: 'Timor-Leste', phone: '670' },
  { code: 'TM', label: 'Turkmenistan', phone: '993' },
  { code: 'TN', label: 'Tunisia', phone: '216' },
  { code: 'TO', label: 'Tonga', phone: '676' },
  { code: 'TR', label: 'Turkey', phone: '90' },
  {
    code: 'TT',
    label: 'Trinidad and Tobago',
    phone: '1-868',
  },
  { code: 'TV', label: 'Tuvalu', phone: '688' },
  {
    code: 'TW',
    label: 'Taiwan',
    phone: '886',
  },
  {
    code: 'TZ',
    label: 'United Republic of Tanzania',
    phone: '255',
  },
  { code: 'UA', label: 'Ukraine', phone: '380' },
  { code: 'UG', label: 'Uganda', phone: '256' },
  {
    code: 'US',
    label: 'United States',
    phone: '1',
    suggested: true,
  },
  { code: 'UY', label: 'Uruguay', phone: '598' },
  { code: 'UZ', label: 'Uzbekistan', phone: '998' },
  {
    code: 'VA',
    label: 'Holy See (Vatican City State)',
    phone: '379',
  },
  {
    code: 'VC',
    label: 'Saint Vincent and the Grenadines',
    phone: '1-784',
  },
  { code: 'VE', label: 'Venezuela', phone: '58' },
  {
    code: 'VG',
    label: 'British Virgin Islands',
    phone: '1-284',
  },
  {
    code: 'VI',
    label: 'US Virgin Islands',
    phone: '1-340',
  },
  { code: 'VN', label: 'Vietnam', phone: '84' },
  { code: 'VU', label: 'Vanuatu', phone: '678' },
  { code: 'WF', label: 'Wallis and Futuna', phone: '681' },
  { code: 'WS', label: 'Samoa', phone: '685' },
  { code: 'XK', label: 'Kosovo', phone: '383' },
  { code: 'YE', label: 'Yemen', phone: '967' },
  { code: 'YT', label: 'Mayotte', phone: '262' },
  { code: 'ZA', label: 'South Africa', phone: '27' },
  { code: 'ZM', label: 'Zambia', phone: '260' },
  { code: 'ZW', label: 'Zimbabwe', phone: '263' },
];

countries2.forEach((country) => {
  if (country.code === 'IL') {
    country.code = 'PS';
    country.label = 'Palestine';
    country.phone = '972'; // نفس كود الاتصال
  }
});
export const LeadsForAdmin = () => {
  const dispatch = useDispatch();
  // const [usersarray, allleads, loading, pagecount, getpages,fetchData] = AllLeadHook();
  const [usersarray, allleads, loading, pagecount, getpages, fetchData, resumeLoading] =
    AllLeadHook();

  // let limit = 5;
  // console.log(usersarray," usersarray usersarray  4444555")
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [limit, setLimit] = useState(25); // القيمة الافتراضية 10
  const [sortOption, setSortOption] = useState('newestToOldestCreation'); // <--- أضف هذه الحالة الجديدة

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const duplicates = searchParams.get('duplicates');
  const ignoredublicate = searchParams.get('ignoredublicate');
  const currentStageRef = useRef('');

  const [currentPage, setCurrentPage] = useState(1);
  const [selectedStage, setSelectedStage] = useState(null);
  const [socket, setSocket] = useState(null);

  const [datefromstage, setdatefromstage] = useState(null);

  const handleDatefromChangestage = (newValue) => {
    if (newValue) {
      // التنسيق ليظهر التاريخ فقط بدون الوقت
      const formattedDate = newValue.format('YYYY-MM-DD');
      setdatefromstage(formattedDate); // تخزين التاريخ بالتنسيق المناسب
    } else {
      setdatefromstage(null); // إذا كانت القيمة فارغة
    }
  };

  const [datetostage, setdatetostage] = useState(null);
  const handleDatetoChangestage = (newValue) => {
    if (newValue) {
      // التنسيق ليظهر التاريخ فقط بدون الوقت
      const formattedDate = newValue.format('YYYY-MM-DD');
      setdatetostage(formattedDate); // تخزين التاريخ بالتنسيق المناسب
    } else {
      setdatetostage(null); // إذا كانت القيمة فارغة
    }
  };

  // Calculate pagination
  const indexOfLastRow = currentPage * limit;
  const indexOfFirstRow = indexOfLastRow - limit;
  const currentRows = filteredUsers.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(filteredUsers?.length / limit);

  // get all information about logged user
  const [userlogin, setuserlogin] = useState('');
  useEffect(() => {
    if (JSON.parse(localStorage.getItem('user')) != null) {
      setuserlogin(JSON.parse(localStorage.getItem('user')));
    }
  }, []);

  useEffect(() => {
    if (usersarray && usersarray?.length > 0) {
      setFilteredUsers(usersarray);
    }
  }, [usersarray]);
  // ===============================

  const [show, setShow] = useState(false);
  const [showmoredelete, setshowmoredelete] = useState(false);

  const handleClose = () => {
    setShow(false);
  };

  const handleShow = () => {
    setShow(true);
  };

  const handleClosemoredelete = () => {
    setshowmoredelete(false);
  };

  const handleShowmoredelete = () => {
    setshowmoredelete(true);
  };

  // clipboard copy channel id
  const [open, setOpen] = useState(false);
  // const handleCopy = () => {
  //   setOpen(true);
  //   setTimeout(() => setOpen(false), 2000);
  // };

  // Export Data To Excel
  // const exportToExcel = () => {
  //   const ws = XLSX.utils.json_to_sheet(allleads);
  //   const wb = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, "Leads Data");
  //   XLSX.writeFile(wb, "data.xlsx");
  // };

  // ✅ الدالة الجديدة التي تصدر البيانات المفلترة فقط
  // ✅ الدالة الجديدة والمحسّنة التي تصدّر البيانات المفلترة والمعالَجة
  const exportFilteredToExcel = () => {
    if (filteredUsers.length === 0) {
      Notify('warning', 'No filtered data to export.', 'warning');
      return;
    }

    // ✨ الخطوة الأهم: معالجة البيانات قبل التصدير
    // نقوم بإنشاء نسخة جديدة من البيانات بالتنسيق المطلوب لـ Excel
    const dataToExport = filteredUsers.map((user) => ({
      Name: user.name,
      Email: user.email,
      Phone: user.phone,
      phonenumber2: user.phonenumber2,
      whatsappnumber: user.whatsappnumber,

      Project: user.project?.name || 'N/A', // ✨ استخراج الاسم من الكائن
      Sales: user.sales?.name || 'N/A', // ✨ استخراج الاسم من الكائن
      Stage: user.stage?.name || 'N/A', // ✨ استخراج الاسم من الكائن
      'Last Stage Date': moment(user.stagedateupdated).tz('Asia/Dubai').format('DD/MM/YYYY h:mm A'),

      Channel: user.chanel?.name || 'N/A', // ✨ استخراج الاسم من الكائن
      Developer: user.project?.developer?.name || 'N/A', // ✨ استخراج الاسم من الكائن المتداخل
      'Creation Date': moment(user.date).tz('Asia/Dubai').format('DD/MM/YYYY h:mm A'),
      notes: user.notes,
      budget: user.budget,
      // ... يمكنك إضافة أي حقول أخرى بنفس الطريقة
    }));

    // الآن نستخدم `dataToExport` التي تحتوي على الأسماء النصية
    const ws = XLSX.utils.json_to_sheet(dataToExport);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Filtered Leads Data');
    XLSX.writeFile(wb, 'filtered_leads_data.xlsx');
    Notify('success', 'Filtered data exported successfully!', 'success');
  };

  // import data from excel sheet to database
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState('');
  const [loadingimport, setloadingimport] = useState(false);
  const [fileName, setFileName] = useState('No file chosen');

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
    setFileName(selectedFile ? selectedFile.name : 'No file chosen');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      setMessage('Please select a file to upload');
      return;
    }

    const formData = new FormData();
    formData.append('file', file);

    try {
      setloadingimport(true);
      setMessage('');

      // console.log("Uploading file:", file.name); // للتأكد
      // console.log("Upload URL:", `${db_url}/api/v1/users/import`); // للتأكد

      const response = await axios.post(`${db_url}api/v1/users/import`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        // قد تحتاج لإضافة timeout
        timeout: 30000, // 30 ثانية
      });

      setloadingimport(false);
      setMessage('Leads imported successfully!');
      // console.log("Upload success:", response.data);

      // إغلاق المودال بعد النجاح
      setTimeout(() => {
        handleClose();
        getallleads();
      }, 2000);
    } catch (error) {
      setloadingimport(false);
      console.error('Upload error:', error);

      if (error.response) {
        // الخطأ من السيرفر
        setMessage(
          `Error: ${error.response.status} - ${error.response.data?.message || 'Server error'}`,
        );
      } else if (error.request) {
        // لا يوجد response من السيرفر
        setMessage('Network error - Cannot connect to server');
      } else {
        // خطأ آخر
        setMessage('Error: ' + error.message);
      }
    }
  };
  let quary = '';
  // all leads
  const navigate = useNavigate();

  const getallleads = async () => {
    // 👇 تنظيف الـ URL من أي stage أو query
    navigate('/AllLeads', { replace: true });

    // 👇 جلب كل البيانات بدون أي تصفية
    await dispatch(Getalldatasearch('leadisactive=true'));
  };

  // دالة استخراج الدولة من الرقم
  countries.registerLocale(en);

  // const getCountryFromPhone = (phone) => {
  //   if (!phone || typeof phone !== "string") return "Unknown Country";
  //   const phoneNumber = parsePhoneNumberFromString(phone.toString());
  //   if (!phoneNumber) return "Unknown Country";
  //   const countryCode = phoneNumber.country;
  //   const countryName = countries.getName(countryCode, "en");
  //   return countryName || "Unknown Country";
  // };
  const cleanPhone = (phone) => {
    if (!phone || typeof phone !== 'string') return null;

    // نحذف كل حاجة ما عدا الأرقام، و+ بس لو في أول الرقم
    let result = phone.trim();

    // لو بيبدأ ب + نخليها، وباقي الرقم نخليه أرقام بس
    if (result.startsWith('+')) {
      result = '+' + result.slice(1).replace(/\D/g, '');
    } else {
      result = result.replace(/\D/g, '');
    }

    return result;
  };

  const getCountryFromPhone = (phone) => {
    const cleanedPhone = cleanPhone(phone);
    if (!cleanedPhone) return 'Unknown Country';

    const phoneNumber = parsePhoneNumberFromString(cleanedPhone);
    if (!phoneNumber || !phoneNumber.country) return 'Unknown Country';

    let countryName = countries.getName(phoneNumber.country, 'en');

    // ✅ هنا التعديل
    if (countryName === 'Israel') {
      countryName = 'Palestine';
    }

    return countryName || 'Unknown Country';
  };
  // =========================================================assign lead
  const [selectedLeads, setSelectedLeads] = useState([]);
  const [selectedLeadsforupdateanddelete, setselectedLeadsforupdateanddelete] = useState(null);
  // const [selectedLeadsStages, setSelectedLeadsStages] = useState([]); // ⬅️ هنا بنخزن الـ stage names

  // const handleLeadSelection = (leadId) => {
  //   setSelectedLeads((prevSelectedLeads) => {
  //     if (prevSelectedLeads.includes(leadId)) {
  //       return prevSelectedLeads.filter(id => id !== leadId);
  //     } else {
  //       return [...prevSelectedLeads, leadId];
  //     }
  //   });
  //   setselectedLeadsforupdateanddelete(leadId);
  // };

  const handleLeadSelection = (leadId, stageName) => {
    setSelectedLeads((prev) => {
      if (prev.includes(leadId)) {
        return prev.filter((id) => id !== leadId);
      } else {
        return [...prev, leadId];
      }
    });

    setSelectedLeadsStages((prev) => {
      if (selectedLeads.includes(leadId)) {
        return prev.filter((_, i) => selectedLeads[i] !== leadId);
      } else {
        return [...prev, stageName];
      }
    });

    setselectedLeadsforupdateanddelete(leadId);
  };

  const [selectedLeadsData, setSelectedLeadsData] = useState({});

  // const handleLeadSelection = (leadId, stageName, salesName) => {
  //   setSelectedLeadsData((prev) => {
  //     if (prev[leadId]) {
  //       // إذا الـ lead موجود، اشيله
  //       const { [leadId]: removed, ...rest } = prev;
  //       return rest;
  //     } else {
  //       // إذا الـ lead مش موجود، ضيفه مع الـ stage والـ sales
  //       return {
  //         ...prev,
  //         [leadId]: {
  //           stage: stageName,
  //           sales: salesName,
  //           // إذا عايز تضيف بيانات تانيه
  //           leadId: leadId
  //         }
  //       };
  //     }
  //   });

  //   setselectedLeadsforupdateanddelete(leadId);
  // };

  useEffect(() => {
    localStorage.setItem('selectedleeds', JSON.stringify(selectedLeads));
  }, [selectedLeads]);

  // useEffect(() => {
  //   localStorage.setItem('selectedleeds', JSON.stringify(selectedLeadsData));
  // }, [selectedLeadsData]);

  const handleAssignClick = (e) => {
    if (selectedLeads?.length === 0) {
      e.preventDefault();
      Notify('error', 'Please select at least one Lead to assign.', 'error');
      return;
    }

    if (selectedLeadsStages.includes('Transfer')) {
      e.preventDefault(); // يمنع الذهاب للرابط
      Notify(
        'error',
        "You can't assign Transfer Leads from this icon. This icon is for normal assign only.",
        'error',
      );
      return;
    }

    handleCloseassign(); // كمل العملية لو مفيش Transfer
  };

  // يدخل علي الايقون والراوت لو الاستيدج ترانسفير فقط
  const handleTransferClickicon = (e) => {
    if (selectedLeads?.length === 0) {
      e.preventDefault();
      Notify('error', 'Please select at least one Lead for transfer.', 'error');
      return;
    }

    const allAreTransfer = selectedLeadsStages.every((stage) => stage === 'Transfer');

    if (!allAreTransfer) {
      e.preventDefault(); // تمنع الانتقال للرابط
      Notify(
        'error',
        "You can't assign  Leads from this icon. This icon is for Transfer Leads only.",
        'error',
      );
      return;
    }
    localStorage.setItem('action', 'Transfer'); // حفظ القيمة

    // لو كله تمام تقدر تكمل أي لوجيك إضافي هنا
    handleCloseassign();
  };
  // const handleTransferClickicon = (e) => {
  //   const selectedData = JSON.parse(localStorage.getItem('selectedleeds'));

  //   if (Object.keys(selectedData).length === 0) {
  //     e.preventDefault();
  //     Notify("error", "Please select at least one Lead for transfer.", "error");
  //     return;
  //   }

  //   // التأكد من أن كل الـ stages هي "Transfer"
  //   const allAreTransfer = Object.values(selectedData).every(
  //     lead => lead.stage === "Transfer"
  //   );

  //   if (!allAreTransfer) {
  //     e.preventDefault();
  //     Notify("error", "You can't assign Leads from this icon. This icon is for Transfer Leads only.", "error");
  //     return;
  //   }

  //   localStorage.setItem('action', 'Transfer');
  //   handleCloseassign();
  // };

  // old stage

  // استبدل مصفوفة stages الثابتة بالحالة التالية
  const [stages, setStages] = useState([]);

  // احصل على البيانات من الـ Redux store
  const resallstages = useSelector((state) => state?.Allstages?.stage);
  const res_All_Stages_array = Array.isArray(resallstages?.data)
    ? resallstages.data
    : Array.isArray(resallstages)
      ? resallstages
      : [];
  // عند تحميل المكون أو تغير البيانات، حدّث مصفوفة stages
  useEffect(() => {
    if (res_All_Stages_array) {
      // استخراج أسماء المراحل فقط
      const stageNames = res_All_Stages_array?.map((stage) => stage?.name);
      setStages(stageNames);

      // أو إذا كنت تريد استخدام كائنات كاملة:
      // setStages(resallstages.data);
    }
  }, [res_All_Stages_array]);

  // دالة جلب البيانات
  const getallstages = async () => {
    await dispatch(GetAll_stage_Data());
  };

  useEffect(() => {
    getallstages();
  }, []);

  // console.log(resallstages,"resallstages resallstages")

  // ===========================================

  // ========================================================
  // assign form
  const [openassign, setOpenassign] = React.useState(false);

  // const handleClick = () => {
  //   setOpenassign(true);
  // };

  // const handleCloseassign = (event, reason) => {
  //   if (reason === 'clickaway') {
  //     return;
  //   }
  //   setOpenassign(false);
  // };

  useEffect(() => {
    if (selectedLeads.length > 0) {
      setOpenassign(true); // إظهار الـ Snackbar إذا كان هناك تحديد
    } else {
      setOpenassign(false); // إخفاء الـ Snackbar تلقائيًا إذا كان التحديد صفرًا
    }
  }, [selectedLeads]); // هذا الـ hook يعمل كلما تغيرت مصفوفة selectedLeads

  const handleCloseassign = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
  };

  const [selecteduserAuth, setselecteduserAuth] = useState('');

  // get users data
  const getusers = async () => {
    await dispatch(Getalldatauserlog_forsearch());
  };

  useEffect(() => {
    getusers();
  }, []);

  // users
  const resusersAuth = useSelector((state) => state.AuthRoot.Signup);
  // let usersAuth = Array.isArray(resusersAuth?.data) ? resusersAuth.data : [];

  let usersAuth = (Array.isArray(resusersAuth?.data) ? resusersAuth.data : []).filter(
    (user) =>
      user.name !== 'Default' &&
      user.name !== 'Default M' &&
      user.name !== 'Default T' &&
      user.name !== 'Default S' &&
      user.name !== 'Deveolper' &&
      user.name !== 'Dev',
  );

  const sortLeads = (leads) => {
    if (!leads) return [];

    switch (sortOption) {
      case 'today':
        return leads.filter((lead) => moment(lead.date).isSame(moment(), 'day'));

      case 'newestToOldestCreation':
        return [...leads].sort((a, b) => moment(b.date).diff(moment(a.date)));

      case 'oldestToNewestCreation':
        return [...leads].sort((a, b) => moment(a.date).diff(moment(b.date)));

      case 'newestToOldestStage':
        return [...leads].sort((a, b) => {
          const dateA =
            a.stagedateupdated && a.stagedateupdated !== '-'
              ? moment(a.stagedateupdated)
              : moment('1970-01-01');
          const dateB =
            b.stagedateupdated && b.stagedateupdated !== '-'
              ? moment(b.stagedateupdated)
              : moment('1970-01-01');
          return dateB.diff(dateA);
        });

      case 'oldestToNewestStage':
        return [...leads].sort((a, b) => {
          const dateA =
            a.stagedateupdated && a.stagedateupdated !== '-'
              ? moment(a.stagedateupdated)
              : moment('2999-01-01');
          const dateB =
            b.stagedateupdated && b.stagedateupdated !== '-'
              ? moment(b.stagedateupdated)
              : moment('2999-01-01');
          return dateA.diff(dateB);
        });

      default:
        // الترتيب الافتراضي هو الأحدث بناءً على تاريخ الإنشاء
        return [...leads].sort((a, b) => moment(b.date).diff(moment(a.date)));
    }
  };

  // ==============================
  // search filtration
  const [filters, setFilters] = useState({
    name: [],
    email: [],
    phone: [],
    project: [],
    // stages: [],
    stageDateRange: {
      from: null, // تاريخ البداية
      to: null, // تاريخ النهاية
    },
    budget: null,
    // creationDate: null,
    dateRange: {
      from: null,
      to: null,
    },
    stageDate: null,
    channel: [],
    country: null,
    sales: [],
    developer: [],
    communicationway: [],
    campaign: [],
    // ActionDate:null
    actionDateRange: {
      from: null,
      to: null,
    },
    oldStage: [], // هتخزن هنا الـ Stages اللي هتختارها
    addedBy: [], // أضف هذا السطر
    assignedFrom: [], // لتخزين المستخدمين الذين قاموا بالتعيين
    assignedTo: [], // لتخزين المندوبين الذين تم تعيين العملاء لهم
  });

  const [budget, setbudget] = useState(null);
  const [country, setCountry] = useState(null);

  // budget change
  const budgetchaneg = (e) => {
    setbudget(e.target.value);
    setFilters((prev) => ({ ...prev, budget: e.target.value }));
  };

  // creation date
  const [value, setValue] = useState(null);
  const handleDateChange = (newValue) => {
    if (newValue) {
      const formattedDate = newValue.format('YYYY-MM-DD');
      setValue(formattedDate);
      setFilters((prev) => ({ ...prev, creationDate: formattedDate }));
    } else {
      setValue(null);
      setFilters((prev) => ({ ...prev, creationDate: null }));
    }
  };

  const handleCountryChange = (selectedCountry) => {
    // setCountry(_country);
    // setFilters(prev => ({ ...prev, country: _country }));

    setCountry(selectedCountry);
    // Store the entire country object for comparison
    setFilters((prev) => ({ ...prev, country: selectedCountry }));
  };

  // action date
  const [ValueActionDate, setValueActionDate] = useState(null);
  // const handlevalueactionDateChange = (newValue) => {
  //   if (newValue) {
  //     const formattedDate = newValue.format("YYYY-MM-DD");
  //     setValueActionDate(formattedDate);
  //     setFilters(prev => ({ ...prev, ActionDate: formattedDate }));
  //   } else {
  //     setValueActionDate(null);
  //     setFilters(prev => ({ ...prev, ActionDate: null }));
  //   }
  // };

  const handleActionDateFromChange = (newValue) => {
    setFilters((prev) => ({
      ...prev,
      actionDateRange: {
        ...prev.actionDateRange,
        from: newValue ? newValue.format('YYYY-MM-DD') : null,
      },
    }));
  };

  const handleActionDateToChange = (newValue) => {
    setFilters((prev) => ({
      ...prev,
      actionDateRange: {
        ...prev.actionDateRange,
        to: newValue ? newValue.format('YYYY-MM-DD') : null,
      },
    }));
  };

  const handleStageDateFromChange = (newValue) => {
    setFilters((prev) => ({
      ...prev,
      stageDateRange: {
        ...prev.stageDateRange,
        from: newValue ? newValue.format('YYYY-MM-DD') : null,
      },
    }));
  };

  const handleStageDateToChange = (newValue) => {
    setFilters((prev) => ({
      ...prev,
      stageDateRange: {
        ...prev.stageDateRange,
        to: newValue ? newValue.format('YYYY-MM-DD') : null,
      },
    }));
  };
  // =======================================================
  const getsales = async () => {
    await dispatch(Get_All_Sales_Action());
  };

  const ressales = useSelector((state) => state.AllSales.sales);
  // let salesarray = Array.isArray(ressales?.data) ? ressales.data : [];
  let salesarray = (Array.isArray(ressales?.data) ? ressales.data : [])
    .filter(
      (sale) =>
        sale.name !== 'Default' &&
        sale.name !== 'Default M' &&
        sale.name !== 'Default T' &&
        sale.name !== 'Default S' &&
        sale.name !== 'Developer' &&
        sale.name !== 'Dev',
    )
    .sort((a, b) => {
      if (a.name === 'No Sales') return -1; // a الأول
      if (b.name === 'No Sales') return 1; // b بعده
      return 0; // باقي العناصر زي ما هي
    });
  // console.log(salesarray,"salesarray");
  const getchannels = async () => {
    await dispatch(GetAllchannalData());
  };

  const reschannel = useSelector((state) => state.AllChannalRoot.channal);
  let channelarray = Array.isArray(reschannel?.data) ? reschannel.data : [];

  // stage date filtration
  const [stagedatevalue, setstagedatevalue] = useState(null);
  const handlestageDateChange = (newValue) => {
    if (newValue) {
      const formattedDate = newValue.format('YYYY-MM-DD');
      setstagedatevalue(formattedDate);
      setFilters((prev) => ({ ...prev, stageDate: formattedDate }));
    } else {
      setstagedatevalue(null);
      setFilters((prev) => ({ ...prev, stageDate: null }));
    }
  };

  const getproject = async () => {
    await dispatch(GetallProjectsdata());
  };

  const resproject = useSelector((state) => state.AllProjects.Projects);
  let projectarray = Array.isArray(resproject?.data) ? resproject.data : [];

  const get_stages_data = async () => {
    await dispatch(GetAll_stage_Data());
  };

  const res_stages_data = useSelector((state) => state.Allstages.stage);
  let stages_data_array = Array.isArray(res_stages_data?.data) ? res_stages_data.data : [];

  // get developers
  const getDevelopers = async () => {
    await dispatch(GetDevelopersData());
  };

  const resdevelopers = useSelector((state) => state.AllDevelopers.Developers);
  let DevelopersArray = Array.isArray(resdevelopers?.data) ? resdevelopers.data : [];

  // get Communication way
  const getcommunication_way = async () => {
    await dispatch(GetCommunicationwayData());
  };

  const resCommunicationWay = useSelector((state) => state.AllCommunicationway.communicationway);
  let resCommunicationWayArray = Array.isArray(resCommunicationWay?.data)
    ? resCommunicationWay.data
    : [];

  // get Campaigns
  const getcampaigns = async () => {
    await dispatch(GetAllCampainData());
  };

  const resCampaigns = useSelector((state) => state.AllCampaign.campaign);
  let resCampaignArray = Array.isArray(resCampaigns?.data) ? resCampaigns.data : [];

  useEffect(() => {
    getproject();
    getchannels();
    getsales();
    get_stages_data();
    getDevelopers();
    getcommunication_way();
    getcampaigns();
  }, []);

  const handledeleteallselectedleads = async () => {
    if (selectedLeads?.length === 0) {
      Notify('error', 'Please select at least one Lead to delete.', 'error');
      return;
    }

    const deletePromises = selectedLeads?.map((leadId) =>
      dispatch(
        UpdateClientAction(leadId, {
          leadisactive: 'false',
        }),
      ),
    );

    await Promise.all(deletePromises);

    Notify('success', 'Leads deleted successfully', 'success');
    // setTimeout(() => {
    //   window.location.reload(false);
    // }, 1000);
    fetchData();
  };

  const today = moment().startOf('day');
  const stagedate = moment(usersarray.stagedateupdated).startOf('day');

  const theme = useTheme();
  const mode = theme.palette.mode;
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
  const isExtraSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const handleTransferClick = () => {
    localStorage.setItem('action', 'Transfer'); // حفظ القيمة
    handleCloseassign(); // تابع الإغلاق لو لسه محتاجه
  };

  //
  //  useEffect(() => {
  //   const newSocket = io(db_url)
  //   setSocket(newSocket)

  //   // ✅ event للاتصال
  //   const handleConnect = () => {
  //     console.log("📡 Socket connected")
  //   }

  //   // ✅ event للـ leads الجديدة
  //   const handleNewLead = (newLeadData) => {
  //     console.log("🆕 New lead received via socket:", newLeadData)

  //     // استخدم State الموجود لديك (usersarray أو filteredUsers)
  //     setFilteredUsers(prev => {
  //       const isExist = prev.some(item => item._id === newLeadData._id)
  //       if (isExist) return prev
  //       return [newLeadData, ...prev]
  //     })
  //   }

  //   // ✅ event للتحديثات
  //   const handleNotification = (updatedLead) => {
  //     console.log("🔄 Lead updated via socket:", updatedLead)

  //     setFilteredUsers(prev =>
  //       prev.map(item => item._id === updatedLead._id ? updatedLead : item)
  //     )
  //         // getallleads()

  //   }

  //   // ✅ event للأخطاء
  //   const handleError = (error) => {
  //     console.error("❌ Socket error:", error)
  //   }

  //   // ✅ event للانفصال
  //   const handleDisconnect = (reason) => {
  //     console.log("🔌 Socket disconnected:", reason)
  //   }

  //   // ✅ تسجيل جميع الـ events
  //   newSocket.on("connect", handleConnect)
  //   newSocket.on("newLead", handleNewLead)
  //   newSocket.on("newNotification", handleNotification)
  //   newSocket.on("error", handleError)
  //   newSocket.on("disconnect", handleDisconnect)

  //   // ✅ Cleanup صحيح
  //   return () => {
  //     console.log("🧹 Cleaning up socket connections...")

  //     // إزالة جميع الـ listeners
  //     newSocket.off("connect", handleConnect)
  //     newSocket.off("newLead", handleNewLead)
  //     newSocket.off("newNotification", handleNotification)
  //     newSocket.off("error", handleError)
  //     newSocket.off("disconnect", handleDisconnect)

  //     // قطع الاتصال
  //     newSocket.disconnect()
  //   }
  // }, [])

  useEffect(() => {
    const newSocket = io(db_url);
    setSocket(newSocket);

    // ✅ event للاتصال
    const handleConnect = () => {
      console.log('📡 Socket connected');
    };

    // ✅ event للـ leads الجديدة
    const handleNewLead = (newLeadData) => {
      console.log('🆕 New lead received via socket:', newLeadData);

      // استخدم State الموجود لديك (usersarray أو filteredUsers)
      setFilteredUsers((prev) => {
        const isExist = prev.some((item) => item._id === newLeadData._id);
        if (isExist) return prev;
        return [newLeadData, ...prev];
      });
    };

    // ✅ event للتحديثات
    const handleNotification = (updatedLead) => {
      console.log('🔄 Lead updated via socket:', updatedLead);

      setFilteredUsers((prev) =>
        prev.map((item) => (item._id === updatedLead._id ? updatedLead : item)),
      );
      // getallleads()
    };

    // ✅ event للأخطاء
    const handleError = (error) => {
      console.error('❌ Socket error:', error);
    };

    // ✅ event للانفصال
    const handleDisconnect = (reason) => {
      console.log('🔌 Socket disconnected:', reason);
    };

    // ✅ تسجيل جميع الـ events
    newSocket.on('connect', handleConnect);
    newSocket.on('newLead', handleNewLead);
    newSocket.on('newNotification', handleNotification);
    newSocket.on('error', handleError);
    newSocket.on('disconnect', handleDisconnect);

    // ✅ Cleanup صحيح
    return () => {
      console.log('🧹 Cleaning up socket connections...');

      // إزالة جميع الـ listeners
      newSocket.off('connect', handleConnect);
      newSocket.off('newLead', handleNewLead);
      newSocket.off('newNotification', handleNotification);
      newSocket.off('error', handleError);
      newSocket.off('disconnect', handleDisconnect);

      // قطع الاتصال
      newSocket.disconnect();
    };
  }, []);

  const handleignoreupdate = async () => {
    if (selectedLeads?.length === 0) {
      Notify('error', 'Please select at least one Lead to ignore duplicate.', 'error');
      return;
    }
    const ignorePromises = selectedLeads?.map((leadId) =>
      dispatch(
        UpdateClientAction(leadId, {
          ignoredublicate: 'false',
        }),
      ),
    );
    await Promise.all(ignorePromises);

    Notify('success', 'Leads ignored duplicate successfully', 'success');
    getallleads();
  };

  const [showAssignModal, setShowAssignModal] = useState(false);

  const handleShowAssignModal = () => {
    console.log('handleShowAssignModal: Attempting to open modal.'); // تتبع 1

    if (!selectedLeads || selectedLeads.length === 0) {
      Notify('error', 'Please select at least one Lead to assign.', 'error');
      console.log('handleShowAssignModal: Aborted, no leads selected.'); // تتبع 2
      return;
    }

    localStorage.setItem('action', 'Assigned'); // يمكنك تغيير هذا لاحقًا لـ Transfer
    console.log('handleShowAssignModal: State is about to be set to true.'); // تتبع 3
    setShowAssignModal(true);
  };

  const handleCloseAssignModal = () => {
    console.log('handleCloseAssignModal: Closing modal.'); // تتبع 4
    setShowAssignModal(false);
  };

  const action = (
    <React.Fragment>
      {/* assign leads */}
      {/* <Link to={`/assignleed`}  style={{ height: '100%', textDecoration: 'none', color: 'white' }} className='mx-2'>
        <Button  style={{ background: '#0F7687', border: 'none' }} size="small" onClick={handleCloseassign}>
          <ReplyIcon />
        </Button>
      </Link> */}

      {/* Assign Normal Leads */}
      {/* <Tooltip title="Assign Leads">
       <Link
        to={`/assignleed`}
        onClick={handleAssignClick}
        style={{ height: '100%', textDecoration: 'none', color: 'white' }}
        className='mx-2'
      >
        <Button style={{ background: '#102dff', border: 'none' }} size="small">
          <ReplyIcon />
        </Button>
      </Link>
</Tooltip> */}

      <Tooltip title="Assign Leads">
        {/* تأكد من أن الزر يستدعي الدالة مباشرة عند الضغط عليه */}
        <div style={{ border: '2px dashed red', padding: '10px', margin: '20px 0' }}>
          {/* <h4>Debug Area</h4> */}
          <p>Selected Leads: {selectedLeads.length}</p>
          <Button variant="danger" onClick={handleShowAssignModal}>
            Open Assign Modal
          </Button>
          <p className="mt-2">Click this button after selecting one or more leads.</p>
        </div>
      </Tooltip>

      {/* // زر Transfer Leads */}
      <Tooltip title="Transfer Leads">
        <Button
          className="mx-2"
          style={{ background: '#102dff', border: 'none' }}
          size="small"
          onClick={() => {
            // نفس المنطق السابق للتحقق من الشروط
            if (selectedLeads?.length === 0) {
              Notify('error', 'Please select at least one Lead for transfer.', 'error');
              return;
            }
            const allAreTransfer = selectedLeadsStages.every((stage) => stage === 'Transfer');
            if (!allAreTransfer) {
              Notify('error', 'This icon is for Transfer Leads only.', 'error');
              return;
            }
            localStorage.setItem('action', 'Transfer');
            setShowAssignModal(true); // فتح الـ Modal
          }}
        >
          <TransferWithinAStationIcon />
        </Button>
      </Tooltip>

      {/* Update Client */}
      {/* <Tooltip title="Update Leads">
      <Link to={`/updateclient/${selectedLeadsforupdateanddelete}`} style={{ height: '100%', textDecoration: 'none', color: 'white' }}>
        <Button style={{ background: '#0F7687', border: 'none' }} size="small" onClick={handleCloseassign}>
          <BorderColorIcon />
        </Button>
      </Link>
</Tooltip> */}

      <Tooltip title="Update Leads">
        <Link
          to={`/updateclient/${selectedLeadsforupdateanddelete}`}
          style={{ height: '100%', textDecoration: 'none', color: 'white' }}
          onClick={(e) => {
            if (!selectedLeads || selectedLeads?.length === 0 || selectedLeads?.length > 1) {
              e.preventDefault(); // تمنع الذهاب للرابط
              Notify('error', 'Please select one lead to update.', 'error');
              return;
            }
            handleCloseassign(); // كمل طبيعي لو فيه ID
          }}
        >
          <Button style={{ background: '#102dff', border: 'none' }} size="small">
            <BorderColorIcon />
          </Button>
        </Link>
      </Tooltip>

      {/* transfer leads */}
      {/* <Link
      to="/assignleed"
      style={{ height: '100%', textDecoration: 'none', color: 'white' }}
      onClick={handleTransferClick} // حدث الحفظ هنا
    >
      <Button
        className="mx-2"
        style={{ background: '#0F7687', border: 'none' }}
        size="small"
      >
        <TransferWithinAStationIcon />
      </Button>
    </Link> */}

      {/* Transfer Normal Leads */}
      {/* <Tooltip title="Transfer Leads">
      <Link
      to="/assignleed"
      style={{ height: '100%', textDecoration: 'none', color: 'white' }}
      onClick={handleTransferClickicon}
    >
      <Button
        className="mx-2"
        style={{ background: '#102dff', border: 'none' }}
        size="small"
      >
        <TransferWithinAStationIcon />
      </Button>
    </Link>
</Tooltip> */}

      <Tooltip title="Delete Leads">
        <Button
          className="mx-2"
          style={{ background: '#102dff', border: 'none' }}
          size="small"
          onClick={handleShowmoredelete}
        >
          <DeleteOutlineIcon />
        </Button>
      </Tooltip>

      {/* <Tooltip title="Ignore Dublicate">
      <Button className="mx-2" style={{ background: '#102dff', border: 'none',margin:'10px' }} size="small" className='' onClick={handleignoreupdate}>
        <AlarmOffSharpIcon />
      </Button>
</Tooltip> */}

      {duplicates === 'true' && ignoredublicate === 'true' && (
        <Tooltip title="Ignore Dublicate">
          <Button
            className="mx-2"
            style={{ background: '#102dff', border: 'none', margin: '10px' }}
            size="small"
            onClick={handleignoreupdate}
          >
            <AlarmOffSharpIcon />
          </Button>
        </Tooltip>
      )}

      <IconButton size="small" aria-label="close" color="inherit" onClick={handleCloseassign}>
        <CloseIcon fontSize="small" />
      </IconButton>

      <AssignLeadsModal show={showAssignModal} onHide={handleCloseAssignModal} />
    </React.Fragment>
  );

  // sales Changes
  const [selectedSale, setSelectedSale] = useState([]);
  const handleChange_sales_filteration = (event, newValue) => {
    // console.log("Selected Sales:", newValue);
    setSelectedSale(newValue);
    setFilters((prev) => ({ ...prev, sales: newValue }));
  };

  const filterOptionssales = (options, { inputValue }) => {
    return options.filter((option) => option.name.toLowerCase().includes(inputValue.toLowerCase()));
  };

  // channel
  const [selectedSalechannel, setSelectedSalechannel] = useState([]);
  const handleChange_channel_filteration = (event, newValue) => {
    setSelectedSalechannel(newValue);
    setFilters((prev) => ({ ...prev, channel: newValue }));
  };

  const filterOptionschannel = (options, { inputValue }) => {
    return options.filter(
      (option) =>
        option.name.toLowerCase().includes(inputValue.toLowerCase()) ||
        (option.description && option.description.toLowerCase().includes(inputValue.toLowerCase())),
    );
  };

  // stages data
  const [selected_stages, setselected_stages] = useState([]);
  const handleChange_stages_data_filteration = (event, newValue) => {
    setselected_stages(newValue);
    setFilters((prev) => ({ ...prev, stages: newValue }));
  };

  const filter_stages_data = (options, { inputValue }) => {
    return options.filter(
      (option) =>
        option.name.toLowerCase().includes(inputValue.toLowerCase()) ||
        (option.description && option.description.toLowerCase().includes(inputValue.toLowerCase())),
    );
  };

  // console.log(usersarray,"userarray")
  // project
  const [selectedproject, setSelectedprojetc] = useState([]);
  const filterOptionsproject = (options, { inputValue }) => {
    return options.filter(
      (option) =>
        option.name.toLowerCase().includes(inputValue.toLowerCase()) ||
        (option.description && option.description.toLowerCase().includes(inputValue.toLowerCase())),
    );
  };

  const handleChange_project_filteration = (event, newValue) => {
    // console.log("Selected Projects:", {
    //   objects: newValue,
    //   names: newValue.map(proj => proj.name),
    //   ids: newValue.map(proj => proj._id)
    // });
    setSelectedprojetc(newValue);
    setFilters((prev) => ({ ...prev, project: newValue }));
  };

  // developers
  const [selecteddevelopers, setselecteddevelopers] = useState([]);

  const filterOptionsdevelopers = (options, { inputValue }) => {
    return options.filter(
      (option) =>
        option.name.toLowerCase().includes(inputValue.toLowerCase()) ||
        (option.description && option.description.toLowerCase().includes(inputValue.toLowerCase())),
    );
  };

  const handleChange_developers_filteration = (event, newValue) => {
    //  console.log("Selected Developers:", {
    //   objects: newValue,
    //   names: newValue.map(dev => dev.name),
    //   ids: newValue.map(dev => dev._id)
    // });
    setselecteddevelopers(newValue);
    setFilters((prev) => ({ ...prev, developer: newValue }));
  };

  // Communication Way
  const [selectedCommunicationWay, setselectedCommunicationWay] = useState([]);
  const filterOptionsCommunicationWay = (options, { inputValue }) => {
    return options.filter(
      (option) =>
        option.name.toLowerCase().includes(inputValue.toLowerCase()) ||
        (option.description && option.description.toLowerCase().includes(inputValue.toLowerCase())),
    );
  };

  const handleChange_CommunicationWay_filteration = (event, newValue) => {
    // console.log("Selected Communication Ways:", {
    //   objects: newValue,
    //   names: newValue.map(way => way.name),
    //   ids: newValue.map(way => way._id)
    // });
    setselectedCommunicationWay(newValue);
    setFilters((prev) => ({ ...prev, communicationway: newValue }));
  };

  // Campaign name
  const [selectedCampaign, setselectedCampaign] = useState([]);
  const filterOptionsCampaign = (options, { inputValue }) => {
    return options.filter(
      (option) =>
        option.CampainName.toLowerCase().includes(inputValue.toLowerCase()) ||
        (option.description && option.description.toLowerCase().includes(inputValue.toLowerCase())),
    );
  };

  const handleChange_Campaign_filteration = (event, newValue) => {
    // console.log("Selected Campaign:", {
    //   objects: newValue,
    //   names: newValue.map(cam => cam.CampainName),
    //   ids: newValue.map(cam => cam._id)
    // });
    setselectedCampaign(newValue);
    setFilters((prev) => ({ ...prev, campaign: newValue }));
  };

  // أضف هذه الدوال للتعامل مع تغيير التاريخ:
  const handleFromDateChange = (newValue) => {
    setFilters((prev) => ({
      ...prev,
      dateRange: {
        ...prev.dateRange,
        from: newValue ? newValue.format('YYYY-MM-DD') : null,
      },
    }));
  };

  const handleToDateChange = (newValue) => {
    setFilters((prev) => ({
      ...prev,
      dateRange: {
        ...prev.dateRange,
        to: newValue ? newValue.format('YYYY-MM-DD') : null,
      },
    }));
  };

  const filterOptionsselecteduser = (options, { inputValue }) => {
    return options.filter(
      (option) =>
        option.name.toLowerCase().includes(inputValue.toLowerCase()) ||
        (option.email && option.email.toLowerCase().includes(inputValue.toLowerCase())),
    );
  };

  const handleChangeselecteduser = (event, newValue) => {
    setFilters((prev) => ({ ...prev, addedBy: newValue }));
  };

  // ... (باقي حالات useState)
  const [assignedFromValue, setAssignedFromValue] = useState([]); // <-- أضف هذا السطر
  const [assignedToValue, setAssignedToValue] = useState([]); // <-- وهذا أيضاً لحل نفس المشكلة في فلتر Assigned To
  const [oldstagevalue, setoldstagevalue] = useState([]);
  const [Addedbyvalue, setAddedbyvalue] = useState([]);

  const [showtablesetting, setshowtablesetting] = useState(false);

  const handleClosetablesetting = () => setshowtablesetting(false);
  const handleShowtablesetting = () => setshowtablesetting(true);

  // Apply filters function
  const applyFilters = () => {
    if (!usersarray) return [];

    return usersarray.filter((user) => {
      // Filter by Project
      if (
        filters?.project?.length > 0 &&
        !filters.project.some((proj) => proj._id === user?.project?._id)
      ) {
        return false;
      }

      // Filter by Stages
      if (
        filters?.stages?.length > 0 &&
        !filters.stages.some((stage) => stage._id === user?.stage?._id)
      ) {
        return false;
      }

      // فلترة نطاق تاريخ الإنشاء (موجود مسبقًا)
      if (filters?.dateRange?.from || filters?.dateRange?.to) {
        const userDate = moment(user?.date);
        const fromDate = filters.dateRange.from ? moment(filters.dateRange.from) : null;
        const toDate = filters.dateRange.to ? moment(filters.dateRange.to) : null;

        if (fromDate && userDate.isBefore(fromDate, 'day')) return false;
        if (toDate && userDate.isAfter(toDate, 'day')) return false;
      }

      // فلترة نطاق تاريخ المرحلة (الجديدة)
      if (filters.stageDateRange.from || filters.stageDateRange.to) {
        if (!user.stagedateupdated || user.stagedateupdated === '-') return false;

        const stageDate = moment(user.stagedateupdated);
        const fromDate = filters.stageDateRange.from ? moment(filters.stageDateRange.from) : null;
        const toDate = filters.stageDateRange.to ? moment(filters.stageDateRange.to) : null;

        if (fromDate && stageDate.isBefore(fromDate, 'day')) return false;
        if (toDate && stageDate.isAfter(toDate, 'day')) return false;
      }

      // Filter by Budget
      if (filters.budget && user.budget < filters.budget) {
        return false;
      }

      // Filter by Creation Date
      // if (filters.creationDate &&
      //     !moment(user.date).isSame(filters.creationDate, 'day')) {
      //   return false;
      // }

      // فلترة حسب النطاق الزمني
      if (filters?.dateRange?.from || filters?.dateRange.to) {
        const userDate = moment(user.date);
        const fromDate = filters.dateRange.from ? moment(filters.dateRange.from) : null;
        const toDate = filters.dateRange.to ? moment(filters.dateRange.to) : null;

        if (fromDate && userDate.isBefore(fromDate, 'day')) {
          return false;
        }
        if (toDate && userDate.isAfter(toDate, 'day')) {
          return false;
        }
      }

      // Filter by Stage Date
      // if (filters.stageDate &&
      //     !moment(user.stagedateupdated).isSame(filters.stageDate, 'day')) {
      //   return false;
      // }

      // Filter by Channel
      if (
        filters?.channel?.length > 0 &&
        !filters?.channel.some((ch) => ch._id === user?.chanel?._id)
      ) {
        return false;
      }

      // Filter by Country
      // if (filters.country &&
      //     getCountryFromPhone(`+${user.phone}`) !== filters?.country?.name) {
      //   return false;
      // }

      if (filters.country && getCountryFromPhone(`+${user.phone}`) !== filters.country.label) {
        return false;
      }

      // Filter by Sales
      if (
        filters?.sales?.length > 0 &&
        !filters?.sales?.some((sale) => sale?._id === user?.sales?._id)
      ) {
        return false;
      }

      // Filter by Developer
      if (filters?.developer?.length > 0) {
        // تحقق مما إذا كان project موجوداً وله developer
        const userDeveloperId = user?.project?.developer?._id;

        if (!userDeveloperId || !filters?.developer.some((dev) => dev?._id === userDeveloperId)) {
          return false;
        }
      }

      // Filter by Communication Way
      if (
        filters?.communicationway?.length > 0 &&
        !filters?.communicationway.some((way) => way?._id === user?.communicationway?._id)
      ) {
        return false;
      }

      // Filter by Campaign
      if (
        filters?.campaign?.length > 0 &&
        !filters?.campaign.some((camp) => camp?._id === user?.campaign?._id)
      ) {
        return false;
      }

      // فلترة حسب Added By
      if (
        filters?.addedBy?.length > 0 &&
        !filters?.addedBy?.some((added) => added?._id === user?.addby?._id)
      ) {
        return false;
      }
      // Filter by Action date laset comment
      //   if (filters.ActionDate &&
      //     !moment(user.lastcommentdate).isSame(filters.ActionDate, 'day')) {
      //   return false;
      // }
      // فلترة حسب نطاق Action Date
      // فلترة حسب نطاق Action Date
      if (filters.actionDateRange.from || filters.actionDateRange.to) {
        // إذا كان العميل ليس لديه تاريخ تعليق، يتم استبعاده من النتائج
        if (!user.lastcommentdate || user.lastcommentdate === '-') {
          return false;
        }

        const actionDate = moment(user.lastcommentdate);
        const fromDate = filters.actionDateRange.from ? moment(filters.actionDateRange.from) : null;
        const toDate = filters.actionDateRange.to ? moment(filters.actionDateRange.to) : null;

        if (fromDate && actionDate.isBefore(fromDate, 'day')) {
          return false;
        }
        if (toDate && actionDate.isAfter(toDate, 'day')) {
          return false;
        }
      }

      // فلترة حسب Old Stage
      // فلترة حسب Old Stage
      if (filters?.oldStage?.length > 0) {
        const hasOldStage = user.leadStages?.some((stageItem) =>
          filters.oldStage.some((filterStage) => filterStage._id === stageItem.stage?._id),
        );
        if (!hasOldStage) return false;
      }

      // Filter by Assigned From (User who assigned the lead)
      if (filters.assignedFrom.length > 0) {
        const hasMatchingAssigner = user.leadAssigns?.some((assign) =>
          filters.assignedFrom.some((user) => user._id === assign.Assigned_From?._id),
        );
        if (!hasMatchingAssigner) return false;
      }

      // Filter by Assigned To (Sales who was assigned the lead)
      if (filters.assignedTo.length > 0) {
        const hasMatchingAssignee = user.leadAssigns?.some((assign) =>
          filters.assignedTo.some((sales) => sales._id === assign.Assigned_to?._id),
        );
        if (!hasMatchingAssignee) return false;
      }

      return true;
    });
  };

  const handlesearchsubmit = async () => {
    const queryParams = [];

    if (filters?.project?.length > 0) {
      queryParams.push(`project=${filters.project.map((p) => p._id).join(',')}`);
    }

    if (filters?.stages?.length > 0) {
      queryParams.push(`stage=${filters.stages.map((s) => s._id).join(',')}`);
    }

    if (filters?.budget) {
      queryParams.push(`budget=${filters.budget}`);
    }

    if (filters?.creationDate) {
      queryParams.push(`creationDate=${filters.creationDate}`);
    }

    if (filters?.ActionDate) {
      queryParams.push(`lastcommentdate=${filters.ActionDate}`);
    }

    if (filters?.stageDate) {
      queryParams.push(`stageDate=${filters.stageDate}`);
    }

    if (filters?.channel?.length > 0) {
      queryParams.push(`channel=${filters.channel.map((c) => c._id).join(',')}`);
    }

    if (filters?.country) {
      queryParams.push(`country=${filters.country.isoCode}`);
    }

    if (filters?.sales?.length > 0) {
      queryParams.push(`sales=${filters.sales.map((s) => s._id).join(',')}`);
    }

    if (filters?.developer?.length > 0) {
      queryParams.push(`developer=${filters.developer.map((d) => d._id).join(',')}`);
    }

    if (filters?.communicationway?.length > 0) {
      queryParams.push(`communicationway=${filters.communicationway.map((w) => w._id).join(',')}`);
    }

    if (filters?.campaign?.length > 0) {
      queryParams.push(`campaign=${filters.campaign.map((c) => c._id).join(',')}`);
    }

    queryParams.push(`limit=${5000}`);

    // Add assigned from users to query
    if (filters.assignedFrom.length > 0) {
      queryParams.push(`assignedFrom=${filters.assignedFrom.map((u) => u._id).join(',')}`);
    }

    // Add assigned to sales to query
    if (filters.assignedTo.length > 0) {
      queryParams.push(`assignedTo=${filters.assignedTo.map((s) => s._id).join(',')}`);
    }

    try {
      localStorage.setItem('lastAppliedFilter', JSON.stringify(filters));
      console.log('Filter saved to localStorage:', filters);
    } catch (error) {
      console.error('Could not save filter to localStorage:', error);
    }

    const query = queryParams.join('&');
    await dispatch(GetAllLeadsSearchAction(query));
  };

  // Apply filters whenever filters or usersarray changes
  // useEffect(() => {
  //   if (usersarray) {
  //     const filtered = applyFilters();
  //     setFilteredUsers(filtered);
  //   }
  // }, [filters, usersarray, limit]); // أضف limit هنا

  //تخزين ال search بتاع ال Quick filter
  const handleApplyFilters = () => {
    // ✅ استخدام "Optional Chaining" (?.) و "Nullish Coalescing" (??) للأمان
    const filtersToApply = {
      project: (filters.project ?? []).map((p) => p._id).join(','),
      sales: (filters.sales ?? []).map((s) => s._id).join(','),
      stage: (filters.stages ?? []).map((s) => s._id).join(','),
      channel: (filters.channel ?? []).map((c) => c._id).join(','),
      developer: (filters.developer ?? []).map((d) => d._id).join(','),
      campaign: (filters.campaign ?? []).map((c) => c._id).join(','),
      addedBy: (filters.addedBy ?? []).map((u) => u._id).join(','),
      assignedFrom: (filters.assignedFrom ?? []).map((u) => u._id).join(','),
      assignedTo: (filters.assignedTo ?? []).map((s) => s._id).join(','),

      // الفلاتر الأخرى تبقى كما هي
      budget: filters.budget ? `[gte]=${filters.budget}` : '',
      country: filters.country ? filters.country.label : '',
      dateFrom: filters.dateRange?.from,
      dateTo: filters.dateRange?.to,
      stageDateFrom: filters.stageDateRange?.from,
      stageDateTo: filters.stageDateRange?.to,
      actionDateFrom: filters.actionDateRange?.from,
      actionDateTo: filters.actionDateRange?.to,
      keyword: searchword,
    };

    // ... (باقي الكود يبقى كما هو)
    Object.keys(filtersToApply).forEach((key) => {
      if (!filtersToApply[key]) {
        delete filtersToApply[key];
      }
    });

    localStorage.setItem('lastAppliedFilter', JSON.stringify(filters));

    setCurrentPage(1);
    fetchData();
  };
  const applyLastFilter = () => {
    const savedFilterString = localStorage.getItem('lastAppliedFilter');

    if (savedFilterString) {
      try {
        const savedFilters = JSON.parse(savedFilterString);
        Notify('info', 'Applying last saved filter...', 'info');

        // 1. تحديث حالة الفلاتر الرئيسية (مهم للـ logic)
        setFilters(savedFilters);

        // 2. ✅ تحديث حالات واجهة المستخدم (مهم للعرض)
        // هذا هو الجزء الذي سيقوم بملء الحقول
        setSelectedSale(savedFilters.sales || []);
        setSelectedprojetc(savedFilters.project || []);
        setselected_stages(savedFilters.stages || []);
        setSelectedSalechannel(savedFilters.channel || []);
        setselecteddevelopers(savedFilters.developer || []);
        setselectedCommunicationWay(savedFilters.communicationway || []);
        setselectedCampaign(savedFilters.campaign || []);
        setAssignedFromValue(savedFilters.assignedFrom || []); // للفلتر Assigned From
        setAssignedToValue(savedFilters.assignedTo || []);
        setoldstagevalue(savedFilters.oldStage || []);
        setAddedbyvalue(savedFilters.addedBy || []);
        // للحقول التي ليست Autocomplete
        setCountry(savedFilters.country || null);
        setbudget(savedFilters.budget || '');
        setSearchword(savedFilters.keyword || '');

        // تحديث حالات التواريخ
        const newDateRange = savedFilters.dateRange || { from: null, to: null };
        const newStageDateRange = savedFilters.stageDateRange || { from: null, to: null };
        const newActionDateRange = savedFilters.actionDateRange || { from: null, to: null };

        // تحديث كائن الفلاتر الرئيسي بالتواريخ الصحيحة
        setFilters((prev) => ({
          ...prev,
          dateRange: newDateRange,
          stageDateRange: newStageDateRange,
          actionDateRange: newActionDateRange,
        }));

        // 3. استدعاء دالة البحث لتطبيق الفلتر على الخادم
        // نستخدم setTimeout لإعطاء React فرصة لتحديث كل الـ states قبل إرسال الطلب
        setTimeout(() => {
          handleApplyFilters();
        }, 100);
      } catch (error) {
        console.error('Error applying saved filter:', error);
        Notify('error', 'Could not apply saved filter.', 'error');
      }
    } else {
      Notify('warning', 'No saved filter found.', 'warning');
    }
  };

  useEffect(() => {
    // لا تقم بالحفظ إذا كانت الفلاتر فارغة (لتجنب الكتابة فوق فلتر محفوظ عند รีเซ็ต)
    const isEmpty = Object.values(filters).every((value) => {
      if (Array.isArray(value)) return value.length === 0;
      if (typeof value === 'object' && value !== null) {
        // للتعامل مع كائنات التواريخ
        return Object.values(value).every((subVal) => subVal === null);
      }
      return value === null || value === '';
    });

    if (isEmpty) {
      return;
    }

    // إعداد Debounce: انتظر 1.5 ثانية بعد آخر تغيير قبل الحفظ
    const handler = setTimeout(() => {
      try {
        console.log('Auto-saving filter to localStorage...', filters);
        localStorage.setItem('lastAppliedFilter', JSON.stringify(filters));
      } catch (error) {
        console.error('Could not auto-save filter:', error);
      }
    }, 1500); // 1500ms = 1.5 ثانية

    // دالة التنظيف: يتم استدعاؤها عند كل تغيير جديد لإلغاء المؤقت القديم
    return () => {
      clearTimeout(handler);
    };
  }, [filters]); // ✅ هذا الـ useEffect يعمل في كل مرة يتغير فيها كائن الفلاتر

  const [searchword, setSearchword] = useState(localStorage.getItem('mainsearchstorage') || '');
  const [Leadsarray, setLeadsarray] = useState([]);

  useEffect(() => {
    const handleSearchUpdate = () => {
      setSearchword(localStorage.getItem('mainsearchstorage') || '');
    };

    window.addEventListener('mainsearchupdated', handleSearchUpdate);
    return () => window.removeEventListener('mainsearchupdated', handleSearchUpdate);
  }, []);

  useEffect(() => {
    if (usersarray?.length) {
      // تأكد من أن الـ userarray غير فارغ
      const cleanedSearch = searchword.trim().toLowerCase();
      const results = usersarray.filter((user) => {
        // البحث في name و email و phone
        const nameMatch = user.name?.toLowerCase().includes(cleanedSearch);
        const emailMatch = user.email?.toLowerCase().includes(cleanedSearch);
        const phoneMatch = user.phone?.includes(searchword.trim()); // البحث في الرقم كما هو
        const unitnumber = user.unitnumber?.toLowerCase().includes(cleanedSearch);
        return nameMatch || emailMatch || phoneMatch || unitnumber;
      });
      setFilteredUsers(results);
    }
  }, [searchword]); // الـ useEffect هيشتغل بس لما الـ searchword يتغير

  // console.log(usersarray,"filteredUsers")

  // lead more search

  useEffect(() => {
    if (!usersarray) {
      setFilteredUsers([]);
      return;
    }

    let processedLeads = [...usersarray];

    // 1. تطبيق الفلاتر (من Quick Filter ودالة applyFilters)
    processedLeads = applyFilters();

    // 2. تطبيق البحث بالكلمة
    if (searchword) {
      const cleanedSearch = searchword.trim().toLowerCase();
      processedLeads = processedLeads.filter((lead) => {
        if (!lead) return false;
        const nameMatch = lead.name?.toLowerCase().includes(cleanedSearch);
        const emailMatch = lead.email?.toLowerCase().includes(cleanedSearch);
        const phoneMatch = lead.phone?.includes(searchword.trim());
        const unitnumber = lead.unitnumber?.toLowerCase().includes(cleanedSearch);
        return nameMatch || emailMatch || phoneMatch || unitnumber;
      });
    }

    // 3. تطبيق الترتيب
    const sortedLeads = sortLeads(processedLeads);

    // 4. تحديث الحالة النهائية للعرض
    setFilteredUsers(sortedLeads);
  }, [usersarray, filters, searchword, sortOption]); // <--- لاحظ إضافة sortOption هنا

  const [showFullNumber, setShowFullNumber] = useState(false); // تعريف الحالة هنا

  const [hoveredLeadId, setHoveredLeadId] = useState(null);
  const [lastComment, setLastComment] = useState('');

  const [comments, setComments] = useState([]);
  const [loadingComments, setLoadingComments] = useState(false); // ← جديد

  // show last comment when make hover on the lead
  // GetActionsData_action
  // AllActions.Action
  const getallactiondata = async (leadId) => {
    setHoveredLeadId(leadId);
    setLoadingComments(true); // ← قبل البدء في الجلب
    await dispatch(GetActionsData_action(leadId));
    setLoadingComments(false); // ← بعد الانتهاء
  };
  // const [comments, setComments] = useState([]);

  const resgetallactions = useSelector((state) => state.AllActions.Action);

  useEffect(() => {
    if (Array.isArray(resgetallactions?.data)) {
      let filteredData = resgetallactions.data.filter((item) => item.leed?._id === hoveredLeadId);

      if (userlogin?.data?.CloseDoneDealcomments === true) {
        filteredData = filteredData.filter(
          (item) =>
            !item.Comments?.some((c) => c?.stage?.name?.trim()?.toLowerCase() === 'done deal'),
        );
      }

      const allComments = filteredData.flatMap((item) => item.Comments || []);
      const sorted = allComments.sort(
        (a, b) => new Date(b.stageDate || b.createdAt) - new Date(a.stageDate || a.createdAt),
      );
      const lastComment = sorted[0];

      if (lastComment) {
        setComments([{ Comments: [lastComment] }]);
      } else {
        setComments([]);
      }
    }
  }, [resgetallactions, hoveredLeadId, userlogin?.data?.CloseDoneDealcomments]);

  // const exportToExcelWithLastComment = async () => {
  //   try {
  //     // جلب جميع التعليقات من API
  //     // const commentsResponse = await axios.get('https://apirender8.onrender.com/api/v1/Action');
  //         const commentsResponse = await axios.get(`${db_url}api/v1/Action`);

  //     const allActions = commentsResponse.data.data;

  //     // تحضير البيانات
  //     const dataWithComments = allleads.map(lead => {
  //       // البحث عن الإجراءات الخاصة بهذا العميل
  //       const leadActions = allActions.filter(action => action.leed?._id === lead._id);

  //       // استخراج جميع التعليقات من الإجراءات
  //       const allLeadComments = leadActions.flatMap(action => action.Comments || []);

  //       // استخراج آخر تعليق
  //       let lastComment = "No comment";
  //       let lastStage = "No stage";
  //       let lastCommentDate = "No date";

  //       if (allLeadComments?.length > 0) {
  //         // ترتيب التعليقات حسب التاريخ
  //         const sortedComments = allLeadComments.sort((a, b) =>
  //           new Date(b.stageDate || b.createdAt) - new Date(a.stageDate || a.createdAt)
  //         );

  //         const latestComment = sortedComments[0];

  //         if (latestComment) {
  //           lastStage = latestComment.stage?.name || 'N/A';
  //           lastCommentDate = latestComment.stageDate || latestComment.createdAt || 'N/A';

  //           // بناء نص التعليق
  //           const firstComment = latestComment.firstcomment?.text || 'No first comment';
  //           const secondComment = latestComment.secondcomment?.text || 'No second comment';

  //           lastComment = `
  //             Stage: ${lastStage},
  //             First Comment: ${firstComment},
  //             Second Comment: ${secondComment},
  //             Date: ${new Date(lastCommentDate).toLocaleString()}
  //           `;
  //         }
  //       }

  //       return {
  //         ...lead,
  //         lastComment: lastComment.trim(),
  //         lastStage,
  //         lastCommentDate,
  //         // projectName: lead.project?.name || 'N/A',
  //         // salesName: lead.sales?.name || 'N/A',
  //         // channelName: lead.chanel?.name || 'N/A',
  //         // stageName: lead.stage?.name || 'N/A',
  //         // addedByName: lead.addby?.name || 'N/A'
  //       };
  //     });

  //     // تصدير إلى Excel
  //     const ws = XLSX.utils.json_to_sheet(dataWithComments);
  //     const wb = XLSX.utils.book_new();
  //     XLSX.utils.book_append_sheet(wb, ws, "Leads Data With Comments");
  //     XLSX.writeFile(wb, "leads_with_comments.xlsx");

  //     Notify("success", "Data exported successfully with comments", "success");
  //   } catch (error) {
  //     console.error("Export failed:", error);
  //     Notify("error", "Failed to export data with comments", "error");
  //   }
  // };

  const exportToExcelWithLastComment = async () => {
    // ✨ 1. التحقق من وجود بيانات مفلترة
    if (filteredUsers.length === 0) {
      Notify('warning', 'No filtered data to export.', 'warning');
      return;
    }

    try {
      Notify('info', 'Preparing data for export... This may take a moment.', 'info');

      // ✨ 2. جلب جميع التعليقات من الـ API (هذه الخطوة تبقى كما هي)
      const commentsResponse = await axios.get(`${db_url}api/v1/Action`);
      const allActions = commentsResponse.data.data;

      // ✨ 3. تحضير البيانات بناءً على `filteredUsers` بدلاً من `allleads`
      const dataWithComments = filteredUsers.map((lead) => {
        // البحث عن الإجراءات الخاصة بهذا العميل
        const leadActions = allActions.filter((action) => action.leed?._id === lead._id);

        // استخراج جميع التعليقات من الإجراءات
        const allLeadComments = leadActions.flatMap((action) => action.Comments || []);

        let lastCommentText = 'No comment';
        let lastStage = lead.stage?.name || 'N/A'; // القيمة الافتراضية هي الـ stage الحالي
        let lastCommentDate = 'No date';

        if (allLeadComments.length > 0) {
          const sortedComments = allLeadComments.sort(
            (a, b) => new Date(b.stageDate || b.createdAt) - new Date(a.stageDate || a.createdAt),
          );

          const latestComment = sortedComments[0];

          if (latestComment) {
            lastStage = latestComment.stage?.name || 'N/A';
            lastCommentDate = latestComment.stageDate || latestComment.createdAt || 'N/A';

            const firstComment = latestComment.firstcomment?.text || '';
            const secondComment = latestComment.secondcomment?.text || '';

            // دمج التعليقين مع فاصل واضح
            lastCommentText = [firstComment, secondComment].filter(Boolean).join(' | Action: ');
            if (!lastCommentText) {
              lastCommentText = 'No comment text';
            }
          }
        }

        // ✨ 4. إنشاء كائن نظيف للتصدير بأسماء أعمدة واضحة
        return {
          Name: lead.name,
          Email: lead.email,
          Phone: lead.phone,
          'Phone Number 2': lead.phonenumber2,
          'Whatsapp Number': lead.whatsappnumber,
          budget: lead.budget || 'N/A',
          Chanal: lead.chanel?.name,
          Project: lead.project?.name || 'N/A',
          Sales: lead.sales?.name || 'N/A',
          'Current Stage': lead.stage?.name || 'N/A',
          'Creation Date': moment(lead.date).tz('Asia/Dubai').format('DD/MM/YYYY h:mm A'),
          'Last Comment': lastCommentText,
          'Last Comment Stage': lastStage,
          'Last Comment Date':
            lastCommentDate !== 'No date' ? new Date(lastCommentDate).toLocaleString() : 'No date',
          Notes: lead.notes,
        };
      });

      // 5. تصدير البيانات المُعالجة إلى Excel
      const ws = XLSX.utils.json_to_sheet(dataWithComments);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Filtered Leads With Comments');
      XLSX.writeFile(wb, 'filtered_leads_with_comments.xlsx');

      Notify('success', 'Filtered data with comments exported successfully!', 'success');
    } catch (error) {
      console.error('Export with comments failed:', error);
      Notify('error', 'Failed to export data with comments. Check console for details.', 'error');
    }
  };

  const [selectedSalesId, setSelectedSalesId] = useState(null);

  // const fetchLeadsByStage = async () => {
  //   if (!datefromstage || !datetostage || !selectedStage) {
  //     Notify("error", "Please select From Date, To Date and Stage", "error");
  //     return;
  //   }

  //   try {
  //     const url = new URL(`https://apirender8.onrender.com/api/v1/LeadStages/leads-by-stage/${selectedStage._id}`);
  //     url.searchParams.append('stageDateFrom', new Date(datefromstage).toISOString());
  //     url.searchParams.append('stageDateTo', new Date(datetostage).toISOString());

  //     // إضافة معامل salesId إذا كان محدداً
  //     if (selectedSalesId) {
  //       url.searchParams.append('salesId', selectedSalesId);
  //     }

  //     const response = await axios.get(url.toString());
  //     const leadIds = response?.data?.data?.flatMap(stageData =>
  //       stageData.leads?.map(lead => lead.leadId) || []
  //     );

  //     if (leadIds?.length > 0) {
  //       const filtered = usersarray.filter(user => leadIds.includes(user._id));
  //       setFilteredUsers(filtered);

  //       if (filtered?.length === 0) {
  //         Notify("warning", `No leads found in stage ${selectedStage?.name}`, "warning");
  //       } else {
  //         Notify("success", `Found ${filtered?.length} leads in stage ${selectedStage?.name}`, "success");
  //       }
  //     } else {
  //       Notify("warning", `No leads found in stage ${selectedStage?.name}`, "warning");
  //       setFilteredUsers([]);
  //     }
  //   } catch (error) {
  //     console.error("Error:", error);
  //     Notify("error", "Failed to load leads", "error");
  //   }
  // };
  const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));
  //  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  // const resetFilters = () => {
  //   // 1. إعادة تعيين كائن الفلاتر الرئيسي إلى القيم الافتراضية
  //   setFilters({
  //     name: [],
  //     email: [],
  //     unitnumber:[],
  //     phone: [],
  //     project: [],
  //     stages: [], // تأكد من وجود هذا
  //     stageDateRange: { from: null, to: null },
  //     budget: '', // استخدم سلسلة فارغة بدلاً من null لـ TextField
  //     dateRange: { from: null, to: null },
  //     stageDate: null,
  //     channel: [],
  //     country: null,
  //     sales: [],
  //     developer: [],
  //     communicationway: [],
  //     campaign: [],
  //     actionDateRange: { from: null, to: null },
  //     oldStage: [],
  //     addedBy: [],
  //     assignedFrom: [],
  //     assignedTo: [],
  //   });

  //   // 2. إعادة تعيين الحالات التي تتحكم مباشرة في واجهة المستخدم (UI States)
  //   // هذه الخطوة هي الأهم لمسح الاختيارات من الحقول
  //   setbudget(''); // TextField
  //   setCountry(null); // CountrySelect
  //   setValue(null); // Creation Date
  //   setstagedatevalue(null); // Stage Date
  //   setValueActionDate(null); // Action Date

  //   // إعادة تعيين حالات مكونات Autocomplete إلى مصفوفات فارغة
  //   setSelectedSale([]);
  //   setSelectedSalechannel([]);
  //   setselected_stages([]);
  //   setSelectedprojetc([]);
  //   setselecteddevelopers([]);
  //   setselectedCommunicationWay([]);
  //   setselectedCampaign([]);
  //     setInputValue('');
  //   setInputValuestage('');
  //   // إعادة تعيين حالات الفلاتر الجديدة (Added By, Assigned From, etc.)
  //   // إذا كنت قد أنشأت لها حالات منفصلة، قم بإضافتها هنا.
  //   // مثال:
  //   // setAssignedFromState([]);
  //   // setAssignedToState([]);
  //   // setAddedByState([]);

  //   // 3. إعادة عرض القائمة الكاملة للبيانات
  //   if (usersarray && usersarray.length > 0) {
  //     setFilteredUsers(usersarray);
  //   } else {
  //     setFilteredUsers([]);
  //   }
  //   navigate('/AllLeads', { replace: true });

  //   // 4. (اختياري) إظهار رسالة للمستخدم
  //   // Notify("success", "All filters have been reset.", "success");
  // };

  const resetFilters = () => {
    // 1. إعادة تعيين كائن الفلاتر الرئيسي
    setFilters({
      name: [],
      email: [],
      unitnumber: [],
      phone: [],
      project: [],
      stages: [],
      stageDateRange: { from: null, to: null },
      budget: '',
      dateRange: { from: null, to: null },
      stageDate: null,
      channel: [],
      country: null,
      sales: [],
      developer: [],
      communicationway: [],
      campaign: [],
      actionDateRange: { from: null, to: null },
      oldStage: [],
      addedBy: [],
      assignedFrom: [],
      assignedTo: [],
    });

    // 2. إعادة تعيين الحالات التي تتحكم مباشرة في واجهة المستخدم (UI States)
    // 🟢 هذا هو الجزء الأهم لحل المشكلة
    setbudget('');
    setCountry(null);
    setValue(null); // يفترض أنه يتحكم في تاريخ الإنشاء
    setstagedatevalue(null); // يفترض أنه يتحكم في تاريخ المرحلة
    setValueActionDate(null); // يفترض أنه يتحكم في تاريخ الإجراء

    // إعادة تعيين حالات مكونات Autocomplete إلى قيمها الأولية
    setSelectedSale([]);
    setSelectedSalechannel([]);
    setselected_stages([]);
    setSelectedprojetc([]);
    setselecteddevelopers([]);
    setselectedCommunicationWay([]);
    setselectedCampaign([]);
    setAssignedFromValue([]);
    setAssignedToValue([]);
    setoldstagevalue([]);
    setAddedbyvalue([]);
    // 🔹 إعادة تعيين حالات البحث النصي داخل Autocomplete
    setInputValue('');
    setInputValuestage('');
    setInputValuechannal('');
    setInputValueDeveloper('');
    setInputValueProject('');
    setInputValueCommunicationWay('');
    setInputValueCampaign('');
    setInputValueOldStage('');
    setInputValueAddedBy('');
    setInputValueAssignedFrom('');
    setInputValueAssignedTo('');
    // 3. إعادة عرض البيانات الأصلية
    if (usersarray && usersarray.length > 0) {
      setFilteredUsers(usersarray);
    } else {
      setFilteredUsers([]);
    }

    // 4. (اختياري) العودة إلى الرابط الأصلي
    // navigate('/AllLeads', { replace: true });
  };

  // 1. تعريف اسم فريد للمفتاح في localStorage
  const COLUMN_SETTINGS_KEY = 'tableColumnSettings';

  // 2. دالة للحصول على الإعدادات الافتراضية أو المحفوظة
  const getInitialColumns = () => {
    try {
      const savedSettings = localStorage.getItem(COLUMN_SETTINGS_KEY);
      if (savedSettings) {
        // إذا وجدت إعدادات محفوظة، قم بتحميلها
        return JSON.parse(savedSettings);
      }
    } catch (error) {
      console.error('Failed to parse column settings from localStorage', error);
    }

    // إذا لم توجد إعدادات، استخدم الحالة الافتراضية
    return [
      { key: 'select', label: 'Select', visible: true, width: 80 },
      { key: 'name', label: 'Name', visible: true, width: 130 },
      { key: 'duplicate', label: 'Duplicate', visible: true, width: 70 },
      { key: 'phone', label: 'Phone', visible: true, width: 250 },
      { key: 'project', label: 'Project', visible: true, width: 80 },
      { key: 'lastComment', label: 'LC', visible: true, width: 30 },
      { key: 'sales', label: 'Sales', visible: true, width: 180 },
      { key: 'channel', label: 'Channel', visible: true, width: 80 },
      { key: 'developer', label: 'Developer', visible: false, width: 80 }, // مخفي افتراضياً كمثال
      { key: 'campaign', label: 'Campaign', visible: false, width: 70 }, // مخفي افتراضياً كمثال
      { key: 'stage', label: 'Stage', visible: true, width: 170 },
      { key: 'creationDate', label: 'Creation Date', visible: true, width: 80 },
      { key: 'addedBy', label: 'Added By', visible: false, width: 120 }, // مخفي افتراضياً كمثال
      { key: 'actions', label: 'Actions', visible: true, width: 160 },
    ];
  };

  // 3. استخدام الدالة لتعيين الحالة الأولية للأعمدة
  const [columns, setColumns] = useState(getInitialColumns);

  useEffect(() => {
    try {
      localStorage.setItem(COLUMN_SETTINGS_KEY, JSON.stringify(columns));
    } catch (error) {
      console.error('Failed to save column settings to localStorage', error);
    }
  }, [columns]); // هذا الـ hook سيعمل فقط عند تغيير حالة `columns`

  // حالة لتتبع العمود الذي يتم تغيير حجمه حالياً
  const [resizingColumn, setResizingColumn] = useState(null);

  const startResizing = (e, colIndex) => {
    e.preventDefault();
    const startX = e.clientX;
    const startWidth = columns[colIndex].width;

    const onMouseMove = (e) => {
      const newWidth = Math.max(startWidth + e.clientX - startX, 50); // عرض أقل 50px
      setColumns((prevCols) => {
        const newCols = [...prevCols];
        newCols[colIndex] = { ...newCols[colIndex], width: newWidth };
        return newCols;
      });
    };

    const onMouseUp = () => {
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    };

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
  };

  const toggleColumn = (key) => {
    setColumns((prevCols) =>
      prevCols.map((col) => (col.key === key ? { ...col, visible: !col.visible } : col)),
    );
  };

  const [selectedLeadsStages, setSelectedLeadsStages] = useState([]);

  // الحصول على الـ IDs الخاصة بالصفوف المعروضة حاليًا
  const currentRowsIds = currentRows.map((user) => user._id);

  // التحقق مما إذا كانت كل الصفوف الحالية محددة
  const areAllCurrentRowsSelected =
    currentRowsIds.length > 0 && currentRowsIds.every((id) => selectedLeads.includes(id));

  // دالة للتحكم في تحديد/إلغاء تحديد الكل
  const handleSelectAll = () => {
    if (areAllCurrentRowsSelected) {
      // إذا كان الكل محددًا، قم بإلغاء تحديدهم
      setSelectedLeads((prev) => prev.filter((id) => !currentRowsIds.includes(id)));
    } else {
      // إذا لم يكن الكل محددًا، قم بتحديدهم جميعًا
      setSelectedLeads((prev) => [...new Set([...prev, ...currentRowsIds])]);
    }
  };

  const [draggedColumnIndex, setDraggedColumnIndex] = useState(null);

  // const [draggedColIndex, setDraggedColIndex] = useState(null);

  const onDragStart = (e, index) => {
    setDraggedColumnIndex(index);
  };

  const onDragOver = (e) => {
    e.preventDefault(); // مهم عشان يسمح بالإفلات
  };

  const onDrop = (e, dropIndex) => {
    if (draggedColumnIndex === null) return;

    const newColumns = [...columns];
    const draggedCol = newColumns[draggedColumnIndex];
    newColumns.splice(draggedColumnIndex, 1);
    newColumns.splice(dropIndex, 0, draggedCol);
    setColumns(newColumns); // هنا انت بتغير ترتيب الأعمدة فعليًا

    setDraggedColumnIndex(null);
  };

  const [isOpen, setIsOpen] = useState(false);

  const toggleDiv = () => {
    setIsOpen(!isOpen);
  };

  const [isOpenimportandexport, setisOpenimportandexport] = useState(false);

  const toggleDivisOpenimportandexport = () => {
    setisOpenimportandexport(!isOpenimportandexport);
  };

  const [isOpencolumnsetting, setisOpencolumnsetting] = useState(false);

  const toggleDivcolumntabletoggle = () => {
    setisOpencolumnsetting(!isOpencolumnsetting);
  };

  const [openimport2, setopenimport2] = useState(false);
  const [fileimport2, setFileimport2] = useState(null);
  const [previewData, setPreviewData] = useState([]);
  const [loadingimprt2, setLoadingimort2] = useState(false);
  const [resultimport2, setResultimport2] = useState(null);
  const [errorimport2, setErrorimport2] = useState(null);

  const handleOpenimport2 = () => setopenimport2(true);
  const handleCloseimport2 = () => {
    setopenimport2(false);
    setFileimport2(null);
    setPreviewData([]);
    setResultimport2(null);
    setErrorimport2(null);
  };

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setFileimport2(file);
    setResultimport2(null);
    setErrorimport2(null);

    const reader = new FileReader();
    reader.onload = async (e) => {
      const data = e.target.result;
      const workbook = await XLSX.readAsync(data);
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const json = XLSX.utils.sheet_to_json(sheet);
      setPreviewData(json);
    };
    reader.readAsBinaryString(file);
  };

  const onUploadimportleads2 = async () => {
    if (!fileimport2) {
      alert('Please select a file first');
      return;
    }

    const formData = new FormData();
    formData.append('file', fileimport2);

    setLoadingimort2(true);
    try {
      const res = await axios.post(`${db_url}api/v1/users/import-leads`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      setResultimport2(res.data);
    } catch (err) {
      setErrorimport2(err.response?.data || { message: err.message });
    }
    setLoadingimort2(false);
    getallleads();
  };

  const [inputValue, setInputValue] = useState(''); // 🔹 نتحكم في قيمة البحث
  const [inputValuestage, setInputValuestage] = useState(''); // 🔹 نتحكم في قيمة البحث
  const [inputValuechannal, setInputValuechannal] = useState('');
  const [inputValueDeveloper, setInputValueDeveloper] = useState('');
  const [inputValueProject, setInputValueProject] = useState('');
  const [inputValueCommunicationWay, setInputValueCommunicationWay] = useState('');
  const [inputValueCampaign, setInputValueCampaign] = useState('');
  const [inputValueOldStage, setInputValueOldStage] = useState('');
  const [inputValueAddedBy, setInputValueAddedBy] = useState('');
  const [inputValueAssignedFrom, setInputValueAssignedFrom] = useState('');
  const [inputValueAssignedTo, setInputValueAssignedTo] = useState('');

  const exportFilteredLeadsWithAllComments = async () => {
    // التأكد من وجود بيانات لتصديرها
    if (!filteredUsers || filteredUsers.length === 0) {
      Notify('warning', 'No filtered leads to export.', 'warning');
      return;
    }

    Notify('info', 'Preparing data... This may take a moment.', 'info');

    try {
      // 1. جلب جميع الإجراءات (التي تحتوي على التعليقات) مرة واحدة
      const response = await axios.get(`${db_url}api/v1/Action`);
      const allActions = response.data.data;

      // 2. معالجة البيانات لتضمين التعليقات
      const dataToExport = filteredUsers.map((lead) => {
        // البحث عن الإجراءات الخاصة بهذا الـ lead
        const leadActions = allActions.filter((action) => action.leed?._id === lead._id);

        // تجميع كل التعليقات الخاصة بالـ lead من جميع الإجراءات
        const allLeadComments = leadActions.flatMap((action) => action.Comments || []);

        // ترتيب التعليقات من الأقدم إلى الأحدث
        const sortedComments = allLeadComments.sort(
          (a, b) => new Date(a.stageDate || a.createdAt) - new Date(b.stageDate || b.createdAt),
        );

        // 3. تنسيق جميع التعليقات في نص واحد удобочитаемый
        const formattedComments = sortedComments
          .map((comment, index) => {
            const commentDate = moment(comment.stageDate || comment.createdAt).format(
              'DD/MM/YYYY h:mm A',
            );
            const stageName = comment.stage?.name || 'N/A';
            const salesName = comment.sales?.name || 'N/A';
            const firstComment = comment.firstcomment?.text || 'No text';
            const secondComment = comment.secondcomment?.text || 'No text';

            return `(${index + 1}) [${commentDate}] - [Stage: ${stageName}] - [By: ${salesName}]\nComment: ${firstComment}\nNext Action: ${secondComment}\n------------------`;
          })
          .join('\n\n'); // فصل بين كل تعليق والآخر بأسطر فارغة

        // 4. إرجاع كائن جديد يحتوي على بيانات الـ lead والتعليقات المنسقة
        return {
          Name: lead.name,
          // Email: lead.email,
          Phone: lead.phone,
          Project: lead.project?.name || 'N/A',
          Sales: lead.sales?.name || 'N/A',
          Channel: lead.chanel?.name || 'N/A',
          'Creation Date': moment(lead.date).format('DD/MM/YYYY h:mm A'),
          'All Comments': formattedComments || 'No Comments Found', // إضافة حقل التعليقات
        };
      });

      // 5. تصدير البيانات إلى ملف Excel
      const worksheet = XLSX.utils.json_to_sheet(dataToExport);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Filtered Leads with Comments');

      // ضبط عرض الأعمدة تلقائيًا
      const columnWidths = Object.keys(dataToExport[0]).map((key) => {
        if (key === 'All Comments') return { wch: 80 }; // عرض كبير لعمود التعليقات
        if (key === 'Creation Date' || key === 'Email') return { wch: 25 };
        return { wch: 20 }; // عرض افتراضي لباقي الأعمدة
      });
      worksheet['!cols'] = columnWidths;

      XLSX.writeFile(workbook, 'Filtered_Leads_With_All_Comments.xlsx');

      Notify('success', 'Filtered leads exported successfully with all comments!', 'success');
    } catch (error) {
      console.error('Export with all comments failed:', error);
      Notify('error', 'Failed to export data. Please check the console.', 'error');
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        marginTop: isSmallScreen ? '120px' : isMediumScreen ? '30px' : '50px',
        marginLeft: isSmallScreen ? '10px' : isMediumScreen ? '30px' : '50px',
        padding: isSmallScreen ? '10px' : '20px',
        backgroundColor: mode === 'dark' ? '#121212' : '#fff',
        position: 'relative',
      }}
      className="startPage "
    >
      {' '}
      {/* More Search Model */}
      {/* ========================================================= */}
      <div>
        <Snackbar
          open={openassign}
          onClose={handleCloseassign}
          message="More Actions"
          action={action}
          style={{ zIndex: '20000' }}
          ContentProps={{
            style: {
              backgroundColor: '#fff', // الخلفية بيضا
              color: '#000', // النص أسود عشان يبان
              border: '1px solid #ddd',
              boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
            },
          }}
        />
      </div>
      <div>
        {/* <Modal style={{ zIndex: '20000' }} show={show} onHide={handleClose} centered>
  <Modal.Header closeButton>
    <Modal.Title>Upload Excel File</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <p style={{ color: "#666", fontSize: "14px" }}>
      Add your documents here...
    </p>
  {message && (
    <div 
      className={`alert ${message.includes('successfully') ? 'alert-success' : 'alert-danger'} mt-3`}
      style={{ fontSize: "14px" }}
    >
      {message}
    </div>
  )}
    <div
      style={{
        border: "2px dashed #ced4da",
        borderRadius: "8px",
        padding: "30px",
        textAlign: "center",
        marginTop: "20px",
        backgroundColor: "#f8f9fa",
      }}
      onClick={() => document.getElementById("file-upload").click()}
    >
<svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_162_20126)">
<path d="M33.4432 3.12109H14.1758V11.1111H37.5582V7.23451C37.5582 4.96616 35.7122 3.12109 33.4432 3.12109Z" fill="#CED9F9"/>
<path d="M22.5352 12.3403H0V4.92636C0 2.20972 2.21068 0 4.92828 0H12.1336C12.8497 0 13.5396 0.150925 14.1664 0.434509C15.0418 0.828964 15.7939 1.47913 16.3213 2.3286L22.5352 12.3403Z" fill="#0C21BF"/>
<path d="M42 13.9984V37.8798C42 40.151 40.1511 41.9983 37.8789 41.9983H4.12111C1.84891 41.9983 0 40.151 0 37.8798V9.87891H37.8789C40.1511 9.87891 42 11.7269 42 13.9984Z" fill="#0C21BF"/>
<path d="M42 13.9984V37.8798C42 40.151 40.1511 41.9983 37.8789 41.9983H21V9.87891H37.8789C40.1511 9.87891 42 11.7269 42 13.9984Z" fill="#0C21BF"/>
<path d="M32.049 25.9386C32.049 32.031 27.0928 36.9875 21.0011 36.9875C14.9093 36.9875 9.95312 32.031 9.95312 25.9386C9.95312 19.8471 14.9093 14.8906 21.0011 14.8906C27.0928 14.8906 32.049 19.8471 32.049 25.9386Z" fill="#E7ECFC"/>
<path d="M32.0479 25.9386C32.0479 32.031 27.0918 36.9875 21 36.9875V14.8906C27.0918 14.8906 32.0479 19.8471 32.0479 25.9386Z" fill="#CED9F9"/>
<path d="M24.5593 26.0758C24.3289 26.2709 24.0466 26.3661 23.7668 26.3661C23.4166 26.3661 23.0686 26.2177 22.8251 25.9287L22.2287 25.2218V29.8499C22.2287 30.5292 21.6776 31.0803 20.9983 31.0803C20.3189 31.0803 19.7678 30.5292 19.7678 29.8499V25.2218L19.1715 25.9287C18.7325 26.4481 17.9567 26.5145 17.4373 26.0758C16.9182 25.6378 16.8515 24.8617 17.2896 24.3422L19.7252 21.4548C20.0427 21.0793 20.5061 20.8633 20.9983 20.8633C21.4905 20.8633 21.9538 21.0793 22.2714 21.4548L24.707 24.3422C25.145 24.8617 25.0784 25.6378 24.5593 26.0758Z" fill="#326677" fill-opacity="0.7"/>
<path d="M24.561 26.0758C24.3306 26.2709 24.0483 26.3661 23.7686 26.3661C23.4183 26.3661 23.0703 26.2177 22.8268 25.9287L22.2305 25.2218V29.8499C22.2305 30.5292 21.6793 31.0803 21 31.0803V20.8633C21.4922 20.8633 21.9555 21.0793 22.2731 21.4548L24.7087 24.3422C25.1467 24.8617 25.0801 25.6378 24.561 26.0758Z" fill="#0C21BF"/>
</g>
<defs>
<clipPath id="clip0_162_20126">
<rect width="42" height="42" fill="white"/>
</clipPath>
</defs>
</svg>

      <p style={{ margin: "15px 0 5px", fontWeight: "500" }}>
        Drag your file(s) to start uploading
      </p>
      <p style={{ color: "#666", fontSize: "13px", marginBottom: "10px" }}>OR</p>
      <Button style={{background:"#fff",color:"#102dff",border:'2px solid #102dff'}} size="sm" onClick={(e) => {
        e.stopPropagation();
        document.getElementById("file-upload").click();
      }}>
        Browse files
      </Button>
      <input
        type="file"
        id="file-upload"
        name="file"
        style={{ display: "none",background:'#fff',color:"#102dff" ,border:"1px solid #102dff"}}
      
        onChange={handleFileChange}
      />
    </div>

    <p style={{ fontSize: "13px", marginTop: "10px", color: "#666" }}>
      Only support .excel and zip files
    </p>
  </Modal.Body>

  <Modal.Footer>
  <Button 
    style={{background:"#fff",color:"#102dff",border:"1px solid #102dff"}} 
    onClick={handleClose}
    disabled={loadingimport}
  >
    Cancel
  </Button>
  <Button 
    style={{color:"#fff",background:"#102dff"}} 
    onClick={handleSubmit}
    disabled={loadingimport || !file}
  >
    {loadingimport ? (
      <>
        <span className="spinner-border spinner-border-sm me-2" />
        Uploading...
      </>
    ) : (
      "Upload"
    )}
  </Button>
</Modal.Footer>
</Modal> */}

        <Modal style={{ zIndex: '20000' }} show={show} onHide={handleClose} centered>
          <Modal.Header closeButton>
            <Modal.Title>Upload Excel File</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p style={{ color: '#666', fontSize: '14px' }}>Add your documents here...</p>

            <div
              style={{
                border: '2px dashed #ced4da',
                borderRadius: '8px',
                padding: '30px',
                textAlign: 'center',
                marginTop: '20px',
                backgroundColor: '#f8f9fa',
                cursor: 'pointer',
              }}
              onClick={() => document.getElementById('file-upload').click()}
            >
              <svg
                width="42"
                height="42"
                viewBox="0 0 42 42"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                {/* SVG code here */}
              </svg>

              <p style={{ margin: '15px 0 5px', fontWeight: '500' }}>
                Drag your file(s) to start uploading
              </p>
              <p style={{ color: '#666', fontSize: '13px', marginBottom: '10px' }}>OR</p>
              <Button
                style={{ background: '#fff', color: '#102dff', border: '2px solid #102dff' }}
                size="sm"
                onClick={(e) => {
                  e.stopPropagation();
                  document.getElementById('file-upload').click();
                }}
              >
                Browse files
              </Button>

              {/* عرض اسم الملف المختار */}
              {fileName && fileName !== 'No file chosen' && (
                <div
                  style={{
                    marginTop: '15px',
                    padding: '10px',
                    backgroundColor: '#e7f3ff',
                    borderRadius: '5px',
                    border: '1px solid #b3d9ff',
                  }}
                >
                  <p
                    style={{
                      margin: 0,
                      fontSize: '14px',
                      color: '#0066cc',
                      fontWeight: '500',
                    }}
                  >
                    📁 Selected file:
                  </p>
                  <p
                    style={{
                      margin: '5px 0 0 0',
                      fontSize: '13px',
                      color: '#004d99',
                      wordBreak: 'break-all',
                    }}
                  >
                    {fileName}
                  </p>
                </div>
              )}

              <input
                type="file"
                id="file-upload"
                name="file"
                style={{ display: 'none' }}
                accept=".xlsx,.xls,.csv,.zip"
                onChange={handleFileChange}
              />
            </div>

            {/* رسالة حالة الرفع */}
            {loadingimport && (
              <div
                style={{
                  marginTop: '15px',
                  padding: '10px',
                  backgroundColor: '#fff3cd',
                  borderRadius: '5px',
                  border: '1px solid #ffeaa7',
                }}
              >
                <p
                  style={{
                    margin: 0,
                    fontSize: '14px',
                    color: '#856404',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    style={{ width: '1rem', height: '1rem' }}
                  />
                  Uploading {fileName}...
                </p>
              </div>
            )}

            {message && (
              <div
                style={{
                  marginTop: '15px',
                  padding: '10px',
                  backgroundColor: message.includes('successfully') ? '#d4edda' : '#f8d7da',
                  borderRadius: '5px',
                  border: message.includes('successfully')
                    ? '1px solid #c3e6cb'
                    : '1px solid #f5c6cb',
                  color: message.includes('successfully') ? '#155724' : '#721c24',
                }}
              >
                {message}
              </div>
            )}

            <p style={{ fontSize: '13px', marginTop: '10px', color: '#666' }}>
              Only support .excel and zip files
            </p>
          </Modal.Body>

          <Modal.Footer>
            <Button
              style={{ background: '#fff', color: '#102dff', border: '1px solid #102dff' }}
              onClick={handleClose}
              disabled={loadingimport}
            >
              Cancel
            </Button>
            <Button
              style={{ color: '#fff', background: '#102dff' }}
              onClick={handleSubmit}
              disabled={loadingimport || !file}
            >
              {loadingimport ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" />
                  Uploading...
                </>
              ) : (
                'Upload'
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Delete All Selected */}
        <Modal style={{ zIndex: '20000' }} show={showmoredelete} onHide={handleClosemoredelete}>
          <Modal.Header
            closeButton
            style={{
              color: mode === 'dark' ? '#90caf9' : '#666',
              backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
            }}
          >
            <Modal.Title>Delete All Selected Leads</Modal.Title>
          </Modal.Header>
          <Modal.Body
            style={{
              color: mode === 'dark' ? '#90caf9' : '#666',
              backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
            }}
          >
            <h5>Do You Want To Delete All Selected Leads ?</h5>
            <hr />
            <div
              className="d-flex justify-content-between"
              style={{
                color: mode === 'dark' ? '#90caf9' : '#666',
                backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
              }}
            >
              <Button
                style={{ background: '#fff', color: '#102dff', border: '1px solid #102dff' }}
                onClick={handleClosemoredelete}
              >
                <CloseIcon /> Close
              </Button>
              <Button
                style={{ background: '#102dff', color: '#fff', border: '#102dff' }}
                type="submit"
                onClick={handledeleteallselectedleads}
              >
                <DeleteOutlineIcon /> Yes I Want To Delete
              </Button>
            </div>
          </Modal.Body>
          <div className="d-flex justify-content-center flex-wrap">
            {message && <p>{message}</p>}
          </div>
        </Modal>

        <Row className="fade-in">
          <Col className="" style={{ marginTop: '10px' }}>
            <Link to={`/dashboard`} style={{ textDecoration: 'none', color: '#102dff' }}>
              <span style={{ fontWeight: 'bold' }}>Dashboard</span>
            </Link>
            <ArrowCircleRightOutlinedIcon className="mx-1" style={{ color: '#102dff' }} />{' '}
            <span style={{ color: '#03216d' }}>All Leads</span>
            {userlogin && userlogin.data && userlogin.data.role !== 'Sales' ? (
              <div className="my-3 d-flex justify-content-end w-100">
                {/* <div 
      style={{ border: 'none' }} 
      className='btn btn-info icon-plus leedimportandexportandadd' 
      onClick={getallleads}
    >
      <ClearAllIcon/> All Leads <span style={{ fontSize: '16px', fontWeight: 'bold' }}>{`(${usersarray?.length})`}</span>
    </div> */}
                {/* <div onClick={toggleDiv}  style={{ border: 'none' }} className='btn  icon-plus addnewclientbtn leedimportandexportandadd mx-1'>
       <ScienceOutlinedIcon/> Quick Filter

      </div> */}

                <div
                  className="filter-item "
                  style={{
                    backgroundColor: '#f1f2f2',
                    padding: '10px 20px',
                    margin: 8,
                    borderRadius: 12,
                    cursor: 'pointer',
                    color: '#102dff',
                    fontWeight: 'bold',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                    border: '2px solid #102dff',
                    width: isSmallScreen ? '100%' : 'auto',
                    boxShadow: '0px 2px 8px rgba(0,0,0,0.1)',
                    transition: 'all 0.5s',
                    textAlign: 'center',
                  }}
                  onClick={toggleDiv}
                >
                  <ScienceOutlinedIcon /> Quick Filter
                </div>

                {/* <div
          className="filter-item button-5"
          style={{
            backgroundColor: '#f1f2f2',
            padding: '10px 20px',
            margin: 8,
            borderRadius: 12,
            cursor: 'pointer',
            color: '#102dff',
            fontWeight: 'bold',
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            border:'2px solid #102dff',
            width: isSmallScreen ? '100%' : 'auto',
            boxShadow: '0px 2px 8px rgba(0,0,0,0.1)'
          }}
        onClick={toggleDivisOpenimportandexport}
        >
          <ImportExportOutlinedIcon /> Import And Export
        </div> */}

                <div
                  className="filter-item button-5"
                  style={{
                    backgroundColor: '#f1f2f2',
                    padding: '10px 20px',
                    margin: 8,
                    borderRadius: 12,
                    cursor: 'pointer',
                    color: '#102dff',
                    fontWeight: 'bold',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                    border: '2px solid #102dff',
                    width: isSmallScreen ? '100%' : 'auto',
                    boxShadow: '0px 2px 8px rgba(0,0,0,0.1)',
                  }}
                  onClick={handleShowtablesetting}
                >
                  <SettingsOutlinedIcon /> Table Setting
                </div>

                {/* import leads with Names */}

                <div>
                  {/* ✅ الزرار اللي بيفتح المودال */}
                  <div
                    className="filter-item button-5"
                    style={{
                      backgroundColor: '#f1f2f2',
                      padding: '10px 20px',
                      margin: 8,
                      borderRadius: 12,
                      cursor: 'pointer',
                      color: '#102dff',
                      fontWeight: 'bold',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 6,
                      border: '2px solid #102dff',
                      width: isSmallScreen ? '100%' : 'auto',
                      boxShadow: '0px 2px 8px rgba(0,0,0,0.1)',
                    }}
                    onClick={handleOpenimport2}
                  >
                    <CloudQueueIcon /> Import Leads
                  </div>

                  {/* المودال */}
                  <Modal show={openimport2} onHide={handleCloseimport2} centered>
                    <Modal.Header closeButton>
                      <Modal.Title>(Import Leads)</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Form.Group controlId="formFile" className="mb-3">
                        <Form.Label
                          style={{
                            textDecoration: 'underline',
                            cursor: 'pointer',
                            color: '#007bff',
                          }}
                        >
                          Choose Excel File From Your PC
                        </Form.Label>
                        <Form.Control type="file" accept=".xlsx,.xls" onChange={handleFileSelect} />
                      </Form.Group>

                      {fileimport2 && (
                        <p className="text-muted">
                          📎 Selected File: <strong>{fileimport2.name}</strong>
                        </p>
                      )}

                      {previewData.length > 0 && (
                        <div
                          style={{
                            maxHeight: 150,
                            overflowY: 'auto',
                            border: '1px solid #ccc',
                            padding: 10,
                          }}
                        >
                          <strong> Preview First Two Record:</strong>
                          <pre>{JSON.stringify(previewData.slice(0, 2), null, 2)}</pre>
                        </div>
                      )}

                      <Button
                        variant="primary"
                        onClick={onUploadimportleads2}
                        disabled={loadingimprt2 || !fileimport2}
                        className="w-100 mt-3"
                      >
                        {loadingimprt2 ? (
                          <Spinner animation="border" size="sm" />
                        ) : (
                          ' Upload Excell File'
                        )}
                      </Button>

                      {resultimport2 && (
                        <Alert variant="success" className="mt-3">
                          <pre>{JSON.stringify(resultimport2, null, 2)}</pre>
                        </Alert>
                      )}

                      {errorimport2 && (
                        <Alert variant="danger" className="mt-3">
                          <pre>{JSON.stringify(errorimport2, null, 2)}</pre>
                        </Alert>
                      )}
                    </Modal.Body>
                    <Modal.Footer>
                      <Button variant="secondary" onClick={handleCloseimport2}>
                        Close
                      </Button>
                    </Modal.Footer>
                  </Modal>
                </div>

                {/* <div onClick={handleShowtablesetting }  style={{ border: 'none' }} className='btn btn-info icon-plus addnewclientbtn leedimportandexportandadd mx-1'>
        <SettingsOutlinedIcon /> Table Setting
      </div> */}

                <Link to={`/addclient`} style={{ textDecoration: 'none' }}>
                  <div
                    className="filter-item button-5"
                    style={{
                      backgroundColor: '#f1f2f2',
                      padding: '10px 20px',
                      margin: 8,
                      borderRadius: 12,
                      cursor: 'pointer',
                      color: '#102dff',
                      fontWeight: 'bold',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 6,
                      border: '2px solid #102dff',
                      width: isSmallScreen ? '100%' : 'auto',
                      boxShadow: '0px 2px 8px rgba(0,0,0,0.1)',
                    }}
                  >
                    <AddCircleOutlineOutlinedIcon /> Add New Lead
                  </div>
                </Link>

                {/* <Link to={`/addclient`}>
      <div 
        style={{ border: 'none' }} 
        className='btn btn-info icon-plus addnewclientbtn leedimportandexportandadd mx-1'
      >
        <AddCircleOutlineOutlinedIcon/> Add New Lead
      </div>
    </Link> */}

                {/* <div style={{ border: 'none' }} className=' btn btn-info icon-plus  leedimportandexportandadd ' onClick={exportToExcel}>
                  <SystemUpdateAltIcon/> Export Leads To Excel Sheet
                </div>
                 */}
                {/* <div style={{ border: 'none' }} className=' btn btn-info icon-plus  leedimportandexportandadd mx-md-2' onClick={handleShow}>
                  <ImportExportIcon/> Import Leads Data From Excel Sheet
                </div> */}

                {/* <div style={{ border: 'none' }} className=' btn btn-info icon-plus  leedimportandexportandadd mx-md-2' 
    
    onClick={exportToExcelWithLastComment}
    disabled={!allleads?.length}
  >
    <SystemUpdateAltIcon /> Export Leads To Excell with Last Comments
                </div> */}
              </div>
            ) : null}
            <hr />
            {/* <Row className="filter-container" > */}
            <div
              style={{
                transition: 'all 0.3s ease',
                maxHeight: isOpen ? '500px' : '0',
                overflow: 'hidden',
                background: '#f4f4f4',
                padding: isOpen ? '15px' : '0 15px',
                border: isOpen ? '1px solid #ccc' : 'none',
                marginTop: '10px',
                borderRadius: '10px',
              }}
            >
              <h4 style={{ color: '#102dff' }}>Quick Filter</h4>

              <div
                className="filter-grid fade-in my-2"
                style={{
                  display: 'grid',
                  gap: '16px',
                  gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                }}
              >
                {/* Budget */}
                <TextField
                  value={budget}
                  onChange={budgetchaneg}
                  label="Budget"
                  variant="standard"
                  type="number"
                  fullWidth
                  InputProps={{
                    style: {
                      color: '#666',
                    },
                  }}
                  InputLabelProps={{
                    style: {
                      color: '#666',
                    },
                  }}
                />

                {/* Creation Date */}
                {/* <div className="filter-item" style={{ display: 'flex', gap: '10px', alignItems: 'center' }}> */}
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="Creation Date From"
                    value={filters.dateRange.from ? dayjs(filters.dateRange.from) : null}
                    onChange={handleFromDateChange}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        sx: {
                          '.MuiOutlinedInput-root': {
                            borderRadius: '10px',
                            minHeight: '48px',
                            paddingTop: '4px',
                            paddingBottom: '4px',
                            display: 'flex',
                            alignItems: 'center',
                            boxShadow: '0 1px solid #666 4px rgba(0,0,0,0.1)',
                            transition: 'border-color 0.3s, box-shadow 0.3s',
                            background: mode === 'dark' ? '#333' : '#fff',
                            '& fieldset': {
                              border:
                                mode === 'dark' ? '1px solid #333' : '1px solid #666 solid #ccc',
                            },
                            '&:hover fieldset': {
                              border: '2px solid #102dff',
                              boxShadow: '0 0 6px rgba(25, 118, 210, 0.4)',
                            },
                            '&.Mui-focused fieldset': {
                              border: '2px solid #102dff',
                              boxShadow: '0 0 8px rgba(25, 118, 210, 0.6)',
                            },
                          },
                          '.MuiInputLabel-root': {
                            color: mode === 'dark' ? '#fff' : '#666',
                            fontSize: '15px',
                            fontWeight: 500,
                            transition: 'color 0.3s',
                            '&.Mui-focused': {
                              color: '#666',
                            },
                          },
                          '.MuiOutlinedInput-input': {
                            padding: '10px 12px',
                          },
                        },
                      },
                    }}
                  />
                </LocalizationProvider>

                {/* <span style={{ fontWeight: 'bold' }}>to</span> */}

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="Creation Date To "
                    value={filters.dateRange.to ? dayjs(filters.dateRange.to) : null}
                    onChange={handleToDateChange}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        sx: {
                          '.MuiOutlinedInput-root': {
                            borderRadius: '10px',
                            minHeight: '48px',
                            paddingTop: '4px',
                            paddingBottom: '4px',
                            display: 'flex',
                            alignItems: 'center',
                            boxShadow: '0 1px solid #666 4px rgba(0,0,0,0.1)',
                            transition: 'border-color 0.3s, box-shadow 0.3s',
                            background: mode === 'dark' ? '#333' : '#fff',

                            '& fieldset': {
                              border:
                                mode === 'dark' ? '1px solid #333' : '1px solid #666 solid #ccc',
                            },
                            '&:hover fieldset': {
                              border: '2px solid #102dff',
                              boxShadow: '0 0 6px rgba(25, 118, 210, 0.4)',
                            },
                            '&.Mui-focused fieldset': {
                              border: '2px solid #1976d2',
                              boxShadow: '0 0 8px rgba(25, 118, 210, 0.6)',
                            },
                          },
                          '.MuiInputLabel-root': {
                            color: mode === 'dark' ? '#fff' : '#666',
                            fontSize: '15px',
                            fontWeight: 500,
                            transition: 'color 0.3s',
                            '&.Mui-focused': {
                              color: '#666',
                            },
                          },
                          '.MuiOutlinedInput-input': {
                            padding: '10px 12px',
                          },
                        },
                      },
                    }}
                  />
                </LocalizationProvider>
                {/* </div> */}

                {/* Action Date */}
                {/* <div className="filter-item">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
  <DatePicker
    label="Action Date"
    value={ValueActionDate ? dayjs(ValueActionDate) : null}
    onChange={handlevalueactionDateChange}
    slotProps={{
      textField: {
        fullWidth: true,
        sx: {
          ".MuiOutlinedInput-root": {
            borderRadius: "10px",
            minHeight: "48px",
            paddingTop: "4px",
            paddingBottom: "4px",
            display: "flex",
            alignItems: "center",
            boxShadow: "0 1px solid #0F7687 4px rgba(0,0,0,0.1)",
            transition: "border-color 0.3s, box-shadow 0.3s",
            "& fieldset": {
              border: "2px solid #ccc",
            },
            "&:hover fieldset": {
              border: "2px solid #1976d2",
              boxShadow: "0 0 6px rgba(25, 118, 210, 0.4)",
            },
            "&.Mui-focused fieldset": {
              border: "2px solid #1976d2",
              boxShadow: "0 0 8px rgba(25, 118, 210, 0.6)",
            },
          },
          ".MuiInputLabel-root": {
            color: "#333",
            fontSize: "15px",
            fontWeight: 500,
            transition: "color 0.3s",
            "&.Mui-focused": {
              color: "#1976d2",
            },
          },
          ".MuiOutlinedInput-input": {
            padding: "10px 12px",
          },
        },
      },
    }}
  />
</LocalizationProvider>
              </div> */}

                {/* <div className="filter-item" style={{ display: 'flex', gap: '10px', alignItems: 'center' }}> */}
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="Action From"
                    value={
                      filters.actionDateRange.from ? dayjs(filters.actionDateRange.from) : null
                    }
                    onChange={handleActionDateFromChange}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        sx: {
                          '.MuiOutlinedInput-root': {
                            borderRadius: '10px',
                            minHeight: '48px',
                            paddingTop: '4px',
                            paddingBottom: '4px',
                            display: 'flex',
                            alignItems: 'center',
                            boxShadow: '0 1px solid #666 4px rgba(0,0,0,0.1)',
                            transition: 'border-color 0.3s, box-shadow 0.3s',
                            background: mode === 'dark' ? '#333' : '#fff',

                            '& fieldset': {
                              border:
                                mode === 'dark'
                                  ? '1px solid #666 solid #333'
                                  : '1px solid #666 solid #ccc',
                            },
                            '&:hover fieldset': {
                              border: '2px solid #102dff',
                              boxShadow: '0 0 6px rgba(25, 118, 210, 0.4)',
                            },
                            '&.Mui-focused fieldset': {
                              border: '2px solid #102dff',
                              boxShadow: '0 0 8px rgba(25, 118, 210, 0.6)',
                            },
                          },
                          '.MuiInputLabel-root': {
                            color: mode === 'dark' ? '#fff' : '#666',
                            fontSize: '15px',
                            fontWeight: 500,
                            transition: 'color 0.3s',
                            '&.Mui-focused': {
                              color: '#1976d2',
                            },
                          },
                          '.MuiOutlinedInput-input': {
                            padding: '10px 12px',
                          },
                        },
                      },
                    }}
                  />
                </LocalizationProvider>

                {/* <span style={{ fontWeight: 'bold' }}>to</span> */}

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="Action To"
                    value={filters.actionDateRange.to ? dayjs(filters.actionDateRange.to) : null}
                    onChange={handleActionDateToChange}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        sx: {
                          '.MuiOutlinedInput-root': {
                            borderRadius: '10px',
                            minHeight: '48px',
                            paddingTop: '4px',
                            paddingBottom: '4px',
                            display: 'flex',
                            alignItems: 'center',
                            boxShadow: '0 1px solid #666 4px rgba(0,0,0,0.1)',
                            transition: 'border-color 0.3s, box-shadow 0.3s',
                            background: mode === 'dark' ? '#333' : '#fff',

                            '& fieldset': {
                              border:
                                mode === 'dark'
                                  ? '1px solid #666 solid #333'
                                  : '1px solid #666 solid #ccc',
                            },
                            '&:hover fieldset': {
                              border: '2px solid #102dff',
                              boxShadow: '0 0 6px rgba(25, 118, 210, 0.4)',
                            },
                            '&.Mui-focused fieldset': {
                              border: '2px solid #102dff',
                              boxShadow: '0 0 8px rgba(25, 118, 210, 0.6)',
                            },
                          },
                          '.MuiInputLabel-root': {
                            color: mode === 'dark' ? '#fff' : '#666',
                            fontSize: '15px',
                            fontWeight: 500,
                            transition: 'color 0.3s',
                            '&.Mui-focused': {
                              color: '#1976d2',
                            },
                          },
                          '.MuiOutlinedInput-input': {
                            padding: '10px 12px',
                          },
                        },
                      },
                    }}
                  />
                </LocalizationProvider>
                {/* </div> */}

                {/* Stage Date */}
                {/* <div className="filter-item">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
  <DatePicker
    label="Stage Date"
    value={stagedatevalue ? dayjs(stagedatevalue) : null}
    onChange={handlestageDateChange}
    slotProps={{
      textField: {
        fullWidth: true,
        sx: {
          ".MuiOutlinedInput-root": {
            borderRadius: "10px",
            minHeight: "48px",
            paddingTop: "4px",
            paddingBottom: "4px",
            display: "flex",
            alignItems: "center",
            boxShadow: "0 1px solid #0F7687 4px rgba(0,0,0,0.1)",
            transition: "border-color 0.3s, box-shadow 0.3s",
            "& fieldset": {
              border: "2px solid #ccc",
            },
            "&:hover fieldset": {
              border: "2px solid #1976d2",
              boxShadow: "0 0 6px rgba(25, 118, 210, 0.4)",
            },
            "&.Mui-focused fieldset": {
              border: "2px solid #1976d2",
              boxShadow: "0 0 8px rgba(25, 118, 210, 0.6)",
            },
          },
          ".MuiInputLabel-root": {
            color: "#333",
            fontSize: "15px",
            fontWeight: 500,
            transition: "color 0.3s",
            "&.Mui-focused": {
              color: "#1976d2",
            },
          },
          ".MuiOutlinedInput-input": {
            padding: "10px 12px",
          },
        },
      },
    }}
  />
</LocalizationProvider>
              </div> */}

                {/* <div className="filter-item" style={{ display: 'flex', gap: '10px', alignItems: 'center' }}> */}
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="Stage Date From"
                    value={filters.stageDateRange.from ? dayjs(filters.stageDateRange.from) : null}
                    onChange={handleStageDateFromChange}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        sx: {
                          '.MuiOutlinedInput-root': {
                            borderRadius: '10px',
                            minHeight: '48px',
                            paddingTop: '4px',
                            paddingBottom: '4px',
                            display: 'flex',
                            alignItems: 'center',
                            boxShadow: '0 1px solid #666 4px rgba(0,0,0,0.1)',
                            transition: 'border-color 0.3s, box-shadow 0.3s',
                            background: mode === 'dark' ? '#333' : '#fff',

                            '& fieldset': {
                              border:
                                mode === 'dark'
                                  ? '1px solid #666 solid #333'
                                  : '1px solid #666 solid #ccc',
                            },
                            '&:hover fieldset': {
                              border: '2px solid #102dff',
                              boxShadow: '0 0 6px rgba(25, 118, 210, 0.4)',
                            },
                            '&.Mui-focused fieldset': {
                              border: '2px solid #1976d2',
                              boxShadow: '0 0 8px rgba(25, 118, 210, 0.6)',
                            },
                          },
                          '.MuiInputLabel-root': {
                            color: mode === 'dark' ? '#fff' : '#666',
                            fontSize: '15px',
                            fontWeight: 500,
                            transition: 'color 0.3s',
                            '&.Mui-focused': {
                              color: '#1976d2',
                            },
                          },
                          '.MuiOutlinedInput-input': {
                            padding: '10px 12px',
                          },
                        },
                      },
                    }}
                  />
                </LocalizationProvider>

                {/* <span style={{ fontWeight: 'bold' }}>to</span> */}

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="Stage Date To"
                    value={filters.stageDateRange.to ? dayjs(filters.stageDateRange.to) : null}
                    onChange={handleStageDateToChange}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        sx: {
                          '.MuiOutlinedInput-root': {
                            borderRadius: '10px',
                            minHeight: '48px',
                            paddingTop: '4px',
                            paddingBottom: '4px',
                            display: 'flex',
                            alignItems: 'center',
                            boxShadow: '0 1px solid #666 4px rgba(0,0,0,0.1)',
                            transition: 'border-color 0.3s, box-shadow 0.3s',
                            background: mode === 'dark' ? '#333' : '#fff',

                            '& fieldset': {
                              border:
                                mode === 'dark'
                                  ? '1px solid #666 solid #333'
                                  : '1px solid #666 solid #ccc',
                            },
                            '&:hover fieldset': {
                              border: '2px solid #102dff',
                              boxShadow: '0 0 6px rgba(25, 118, 210, 0.4)',
                            },
                            '&.Mui-focused fieldset': {
                              border: '2px solid #1976d2',
                              boxShadow: '0 0 8px rgba(25, 118, 210, 0.6)',
                            },
                          },
                          '.MuiInputLabel-root': {
                            color: mode === 'dark' ? '#fff' : '#666',
                            fontSize: '15px',
                            fontWeight: 500,
                            transition: 'color 0.3s',
                            '&.Mui-focused': {
                              color: '#1976d2',
                            },
                          },
                          '.MuiOutlinedInput-input': {
                            padding: '10px 12px',
                          },
                        },
                      },
                    }}
                  />
                </LocalizationProvider>
                {/* </div> */}

                {/* Sales Filter */}
                {/* <div className="filter-item"> */}

                {/*               
<FormControl fullWidth>
  <Autocomplete
    multiple
    options={salesarray}
    getOptionLabel={(option) => option.name}
    filterOptions={filterOptionssales}
    onChange={handleChange_sales_filteration}
    disableCloseOnSelect
    disableListWrap
    limitTags={100}
    renderInput={(params) => (
      <TextField
        {...params}
        label="Choose Sales"
        variant="outlined"
        InputLabelProps={{
          style: {
              color:mode==="dark"?"#fff":"#666",
            fontSize: '15px',
            fontWeight: 500,
          }
        }}
      />
    )}
    renderOption={(props, option, { selected }) => {
      const isMe = option?.userlog?.email === userlogin?.data?.email;
      return (
        <MenuItem {...props}>
          <Checkbox 
            checked={selected}
            sx={{
              color: '#666',
              '&.Mui-checked': {
                color: '#666',
              },
            }}
          />
          <ListItemText 
            primary={`${option.name} ${isMe ? '(ME)' : ''}`}
            secondary={option?.userlog?.role || 'No Role'}
            primaryTypographyProps={{
              fontWeight: 600
            }}
            secondaryTypographyProps={{
              style: {
                fontSize: '0.75rem',
                color: '#666'
              }
            }}
          />
        </MenuItem>
      );
    }}
    renderTags={(value, getTagProps) => {
      const allSelectedNames = value.map(option => option.name).join(', ');
      return (
        <Tooltip title={allSelectedNames || "No sales selected"} arrow placement="top">
          <div
            style={{
              display: 'flex',
              overflowX: 'auto',
              whiteSpace: 'nowrap',
              flexWrap: 'nowrap',
              gap: '6px',
              cursor: 'pointer',
              alignItems: 'center',
              scrollbarWidth: 'thin',
              '&::-webkit-scrollbar': {
                height: '6px',
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: '#666',
                borderRadius: '3px',
              },
              '&::-webkit-scrollbar-track': {
                backgroundColor: '#f0f0f0',
              }
            }}
          >
            {value.map((option, index) => (
              <Chip
                key={option._id}
                label={option.name}
                size="small"
                {...getTagProps({ index })}
                sx={{
                  borderRadius: '8px',
                  backgroundColor: '#1976d2',
                  color: '#fff',
                  fontWeight: 500,
                  '.MuiChip-deleteIcon': {
                    color: '#fff',
                  },
                  '&:hover': {
                    backgroundColor: '#115293',
                  },
                }}
              />
            ))}
          </div>
        </Tooltip>
      );
    }}
    sx={{
      '.MuiOutlinedInput-root': {
        borderRadius: '10px',
        minHeight: '48px !important',
        paddingTop: '4px',
        paddingBottom: '4px',
        display: 'flex',
        alignItems: 'center',
        boxShadow: '0 1px solid #666 4px rgba(0,0,0,0.1)',
        transition: 'border-color 0.3s, box-shadow 0.3s',
        background:mode==="dark"?"#333":"#fff",
        '& fieldset': {
          border: mode==="dark"?"1px solid #666 solid #333":'1px solid #666 solid #ccc',
        },
        '&:hover fieldset': {
                border: "2px solid #102dff",
          boxShadow: '0 0 6px rgba(25, 118, 210, 0.4)',
        },
        '&.Mui-focused fieldset': {
          border: '2px solid #102dff',
          boxShadow: '0 0 8px rgba(25, 118, 210, 0.6)',
        },
      },
      '.MuiAutocomplete-inputRoot': {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'nowrap !important',
      },
      '.MuiAutocomplete-input': {
        width: '1px solid #666 !important',
        minWidth: '1px solid #666 !important',
        padding: '0 !important',
        margin: '0 !important',
        flex: '0 0 1px solid #666 !important',
      },
    }}
  />
</FormControl> */}

                <FormControl fullWidth>
                  <Autocomplete
                    multiple
                    options={salesarray}
                    value={selectedSale} // ✅ هذا هو السطر الأهم. يربط الواجهة بالـ state
                    isOptionEqualToValue={(option, value) => option._id === value._id}
                    getOptionLabel={(option) => option.name}
                    filterOptions={filterOptionssales}
                    onChange={handleChange_sales_filteration}
                    disableCloseOnSelect
                    disableListWrap
                    limitTags={100}
                    inputValue={inputValue} // 👈 نربط الـ inputValue بالـ state
                    onInputChange={(event, newInputValue, reason) => {
                      // 👇 لما المستخدم يختار قيمة، منخليش البحث يتمسح
                      if (reason === 'reset') return;
                      setInputValue(newInputValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Choose Sales"
                        variant="outlined"
                        InputLabelProps={{
                          style: {
                            color: mode === 'dark' ? '#fff' : '#666',
                            fontSize: '15px',
                            fontWeight: 500,
                          },
                        }}
                      />
                    )}
                    renderOption={(props, option, { selected }) => {
                      const isMe = option?.userlog?.email === userlogin?.data?.email;
                      return (
                        <MenuItem {...props}>
                          <Checkbox
                            checked={selected}
                            sx={{
                              color: '#666',
                              '&.Mui-checked': {
                                color: '#666',
                              },
                            }}
                          />
                          <ListItemText
                            primary={`${option.name} ${isMe ? '(ME)' : ''}`}
                            secondary={option?.userlog?.role || 'No Role'}
                            primaryTypographyProps={{ fontWeight: 600 }}
                            secondaryTypographyProps={{
                              style: {
                                fontSize: '0.75rem',
                                color: '#666',
                              },
                            }}
                          />
                        </MenuItem>
                      );
                    }}
                    renderTags={(value, getTagProps) => {
                      const allSelectedNames = value.map((option) => option.name).join(', ');
                      return (
                        <Tooltip
                          title={allSelectedNames || 'No sales selected'}
                          arrow
                          placement="top"
                        >
                          <div
                            style={{
                              display: 'flex',
                              overflowX: 'auto',
                              whiteSpace: 'nowrap',
                              flexWrap: 'nowrap',
                              gap: '6px',
                              cursor: 'pointer',
                              alignItems: 'center',
                              scrollbarWidth: 'thin',
                            }}
                          >
                            {value.map((option, index) => (
                              <Chip
                                key={option._id}
                                label={option.name}
                                size="small"
                                {...getTagProps({ index })}
                                sx={{
                                  borderRadius: '8px',
                                  backgroundColor: '#1976d2',
                                  color: '#fff',
                                  fontWeight: 500,
                                  '.MuiChip-deleteIcon': { color: '#fff' },
                                  '&:hover': { backgroundColor: '#115293' },
                                }}
                              />
                            ))}
                          </div>
                        </Tooltip>
                      );
                    }}
                    sx={{
                      '.MuiOutlinedInput-root': {
                        borderRadius: '10px',
                        minHeight: '48px !important',
                        paddingTop: '4px',
                        paddingBottom: '4px',
                        background: mode === 'dark' ? '#333' : '#fff',
                        '&:hover fieldset': {
                          border: '2px solid #102dff',
                          boxShadow: '0 0 6px rgba(25, 118, 210, 0.4)',
                        },
                        '&.Mui-focused fieldset': {
                          border: '2px solid #102dff',
                          boxShadow: '0 0 8px rgba(25, 118, 210, 0.6)',
                        },
                      },
                    }}
                  />
                </FormControl>

                {/* </div> */}

                {/* Stages Data */}
                {/* <div className="filter-item"> */}

                {/* ********دا اللي اتعدل */}
                {/* <FormControl fullWidth>
  <Autocomplete
    multiple
    options={stages_data_array}
    getOptionLabel={(option) => option.name}
    filterOptions={filter_stages_data}
    onChange={handleChange_stages_data_filteration}

    disableCloseOnSelect
    disableListWrap
    limitTags={100}
    renderInput={(params) => (
      <TextField
        {...params}
        label="Choose Stages"
        variant="outlined"
        InputLabelProps={{
          style: {
              color:mode==="dark"?"#fff":"#666",
            fontSize: '15px',
            fontWeight: 500,
          }
        }}
      />
    )}
    renderOption={(props, option, { selected }) => (
      <MenuItem {...props}>
        <Checkbox 
          checked={selected}
          sx={{
            color: '#666',
            '&.Mui-checked': {
              color: '#666',
            },
          }}
        />
        <ListItemText 
          primary={option.name}
          secondary={option.description ? option.description : null}
          secondaryTypographyProps={{
            style: {
              fontSize: '0.75rem',
              color: '#666'
            }
          }}
        />
      </MenuItem>
    )}
    renderTags={(value, getTagProps) => {
      const allSelectedNames = value.map(option => option.name).join(', ');
      return (
        <Tooltip title={allSelectedNames || "No stages selected"} arrow placement="top">
          <div
            style={{
              display: 'flex',
              overflowX: 'auto',
              whiteSpace: 'nowrap',
              flexWrap: 'nowrap',
              gap: '6px',
              cursor: 'pointer',
              alignItems: 'center',
              scrollbarWidth: 'thin',
              '&::-webkit-scrollbar': {
                height: '6px',
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: '#666',
                borderRadius: '3px',
              },
              '&::-webkit-scrollbar-track': {
                backgroundColor: '#f0f0f0',
              }
            }}
          >
            {value.map((option, index) => (
              <Chip
                key={option._id}
                label={option.name}
                size="small"
                {...getTagProps({ index })}
                sx={{
                  borderRadius: '8px',
                  backgroundColor: '#1976d2',
                  color: '#fff',
                  fontWeight: 500,
                  '.MuiChip-deleteIcon': {
                    color: '#fff',
                  },
                  '&:hover': {
                    backgroundColor: '#115293',
                  },
                }}
              />
            ))}
          </div>
        </Tooltip>
      );
    }}
    sx={{
      '.MuiOutlinedInput-root': {
        borderRadius: '10px',
        minHeight: '48px !important',
        paddingTop: '4px',
        paddingBottom: '4px',
        display: 'flex',
        alignItems: 'center',
        boxShadow: '0 1px solid #666 4px rgba(0,0,0,0.1)',
        transition: 'border-color 0.3s, box-shadow 0.3s',
        background:mode==="dark"?"#333":"#fff",
        '& fieldset': {
          border: mode==="dark"?"1px solid #666 solid #333":'1px solid #666 solid #ccc',
        },
        '&:hover fieldset': {
                border: "2px solid #102dff",
          boxShadow: '0 0 6px rgba(25, 118, 210, 0.4)',
        },
        '&.Mui-focused fieldset': {
          border: '2px solid #102dff',
          boxShadow: '0 0 8px rgba(25, 118, 210, 0.6)',
        },
      },
      '.MuiAutocomplete-inputRoot': {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'nowrap !important',
      },
      '.MuiAutocomplete-input': {
        width: '1px solid #666 !important',
        minWidth: '1px solid #666 !important',
        padding: '0 !important',
        margin: '0 !important',
        flex: '0 0 1px solid #666 !important',
      },
    }}
  />
</FormControl> */}

                <FormControl fullWidth>
                  <Autocomplete
                    multiple
                    options={stages_data_array}
                    value={selected_stages} // ✅ هذا هو السطر الأهم. يربط الواجهة بالـ state
                    isOptionEqualToValue={(option, value) => option._id === value._id}
                    getOptionLabel={(option) => option.name}
                    filterOptions={filter_stages_data}
                    onChange={handleChange_stages_data_filteration}
                    disableCloseOnSelect
                    disableListWrap
                    limitTags={100}
                    // 👇 إعادة استخدام نفس الـ inputValue اللي عندك من قبل
                    inputValue={inputValuestage}
                    onInputChange={(event, newInputValuestage, reason) => {
                      if (reason === 'reset') return; // منمنع مسح البحث بعد الاختيار
                      setInputValuestage(newInputValuestage);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Choose Stages"
                        variant="outlined"
                        InputLabelProps={{
                          style: {
                            color: mode === 'dark' ? '#fff' : '#666',
                            fontSize: '15px',
                            fontWeight: 500,
                          },
                        }}
                      />
                    )}
                    renderOption={(props, option, { selected }) => (
                      <MenuItem {...props}>
                        <Checkbox
                          checked={selected}
                          sx={{
                            color: '#666',
                            '&.Mui-checked': { color: '#666' },
                          }}
                        />
                        <ListItemText
                          primary={option.name}
                          secondary={option.description || null}
                          secondaryTypographyProps={{
                            style: { fontSize: '0.75rem', color: '#666' },
                          }}
                        />
                      </MenuItem>
                    )}
                    renderTags={(value, getTagProps) => {
                      const allSelectedNames = value.map((option) => option.name).join(', ');
                      return (
                        <Tooltip
                          title={allSelectedNames || 'No stages selected'}
                          arrow
                          placement="top"
                        >
                          <div
                            style={{
                              display: 'flex',
                              overflowX: 'auto',
                              whiteSpace: 'nowrap',
                              flexWrap: 'nowrap',
                              gap: '6px',
                              cursor: 'pointer',
                              alignItems: 'center',
                              scrollbarWidth: 'thin',
                            }}
                          >
                            {value.map((option, index) => (
                              <Chip
                                key={option._id}
                                label={option.name}
                                size="small"
                                {...getTagProps({ index })}
                                sx={{
                                  borderRadius: '8px',
                                  backgroundColor: '#1976d2',
                                  color: '#fff',
                                  fontWeight: 500,
                                  '.MuiChip-deleteIcon': { color: '#fff' },
                                  '&:hover': { backgroundColor: '#115293' },
                                }}
                              />
                            ))}
                          </div>
                        </Tooltip>
                      );
                    }}
                    sx={{
                      '.MuiOutlinedInput-root': {
                        borderRadius: '10px',
                        minHeight: '48px !important',
                        paddingTop: '4px',
                        paddingBottom: '4px',
                        display: 'flex',
                        alignItems: 'center',
                        background: mode === 'dark' ? '#333' : '#fff',
                        '& fieldset': {
                          border: mode === 'dark' ? '1px solid #666' : '1px solid #ccc',
                        },
                        '&:hover fieldset': {
                          border: '2px solid #102dff',
                          boxShadow: '0 0 6px rgba(25, 118, 210, 0.4)',
                        },
                        '&.Mui-focused fieldset': {
                          border: '2px solid #102dff',
                          boxShadow: '0 0 8px rgba(25, 118, 210, 0.6)',
                        },
                      },
                      '.MuiAutocomplete-inputRoot': {
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'nowrap !important',
                      },
                    }}
                  />
                </FormControl>

                {/* </div> */}

                {/* Channel */}
                {/* <div className="filter-item"> */}
                {/* <FormControl fullWidth>
  <Autocomplete
    multiple
    options={channelarray}
    getOptionLabel={(option) => option.name}
    filterOptions={filterOptionschannel}
    onChange={handleChange_channel_filteration}
    disableCloseOnSelect
    disableListWrap
    limitTags={100}
    renderInput={(params) => (
      <TextField
        {...params}
        label="Choose Channel"
        variant="outlined"
        InputLabelProps={{
          style: {
              color:mode==="dark"?"#fff":"#666",
            fontSize: '15px',
            fontWeight: 500,

          }
        }}
      />
    )}
    renderOption={(props, option, { selected }) => (
      <MenuItem {...props}>
        <Checkbox 
          checked={selected}
          sx={{
            color: '#666',
            '&.Mui-checked': {
              color: '#666',
            },
          }}
        />
        <ListItemText 
          primary={option.name}
          secondary={option.description ? option.description : null}
          secondaryTypographyProps={{
            style: {
              fontSize: '0.75rem',
              color: '#666'
            }
          }}
        />
      </MenuItem>
    )}
    renderTags={(value, getTagProps) => {
      const allSelectedNames = value.map(option => option.name).join(', ');
      return (
        <Tooltip title={allSelectedNames || "No channels selected"} arrow placement="top">
          <div
            style={{
              display: 'flex',
              overflowX: 'auto',
              whiteSpace: 'nowrap',
              flexWrap: 'nowrap',
              gap: '6px',
              cursor: 'pointer',
              alignItems: 'center',
              scrollbarWidth: 'thin',
              '&::-webkit-scrollbar': {
                height: '6px',
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: '#666',
                borderRadius: '3px',
              },
              '&::-webkit-scrollbar-track': {
                backgroundColor: '#f0f0f0',
              }
            }}
          >
            {value.map((option, index) => (
              <Chip
                key={option._id}
                label={option.name}
                size="small"
                {...getTagProps({ index })}
                sx={{
                  borderRadius: '8px',
                  backgroundColor: '#1976d2',
                  color: '#fff',
                  fontWeight: 500,
                  '.MuiChip-deleteIcon': {
                    color: '#fff',
                  },
                  '&:hover': {
                    backgroundColor: '#115293',
                  },
                }}
              />
            ))}
          </div>
        </Tooltip>
      );
    }}
    sx={{
      '.MuiOutlinedInput-root': {
        borderRadius: '10px',
        minHeight: '48px !important',
        paddingTop: '4px',
        paddingBottom: '4px',
        display: 'flex',
        alignItems: 'center',
        boxShadow: '0 1px solid #666 4px rgba(0,0,0,0.1)',
        transition: 'border-color 0.3s, box-shadow 0.3s',
        background:mode==="dark"?"#333":"#fff",
        '& fieldset': {
          border: mode==="dark"?"#333":'1px solid #666 solid #ccc',
        },
        '&:hover fieldset': {
                border: "2px solid #102dff",
          boxShadow: '0 0 6px rgba(25, 118, 210, 0.4)',
        },
        '&.Mui-focused fieldset': {
          border: '2px solid #102dff',
          boxShadow: '0 0 8px rgba(25, 118, 210, 0.6)',
        },
      },
      '.MuiAutocomplete-inputRoot': {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'nowrap !important',
      },
      '.MuiAutocomplete-input': {
        width: '1px solid #666 !important',
        minWidth: '1px solid #666 !important',
        padding: '0 !important',
        margin: '0 !important',
        flex: '0 0 1px solid #666 !important',
      },
    }}
  />
</FormControl> */}

                <FormControl fullWidth>
                  <Autocomplete
                    multiple
                    options={channelarray}
                    value={selectedSalechannel} // ✅ هذا هو السطر الأهم. يربط الواجهة بالـ state
                    isOptionEqualToValue={(option, value) => option._id === value._id}
                    getOptionLabel={(option) => option.name}
                    filterOptions={filterOptionschannel}
                    onChange={handleChange_channel_filteration}
                    disableCloseOnSelect
                    disableListWrap
                    limitTags={100}
                    // 👇 هنا نربط الـ state الجديدة
                    inputValue={inputValuechannal}
                    onInputChange={(event, newInputValuechanal, reason) => {
                      if (reason === 'reset') return; // منمنع مسح البحث بعد الاختيار
                      setInputValuechannal(newInputValuechanal);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Choose Channel"
                        variant="outlined"
                        InputLabelProps={{
                          style: {
                            color: mode === 'dark' ? '#fff' : '#666',
                            fontSize: '15px',
                            fontWeight: 500,
                          },
                        }}
                      />
                    )}
                    renderOption={(props, option, { selected }) => (
                      <MenuItem {...props}>
                        <Checkbox
                          checked={selected}
                          sx={{
                            color: '#666',
                            '&.Mui-checked': { color: '#666' },
                          }}
                        />
                        <ListItemText
                          primary={option.name}
                          secondary={option.description || null}
                          secondaryTypographyProps={{
                            style: { fontSize: '0.75rem', color: '#666' },
                          }}
                        />
                      </MenuItem>
                    )}
                    renderTags={(value, getTagProps) => {
                      const allSelectedNames = value.map((option) => option.name).join(', ');
                      return (
                        <Tooltip
                          title={allSelectedNames || 'No channels selected'}
                          arrow
                          placement="top"
                        >
                          <div
                            style={{
                              display: 'flex',
                              overflowX: 'auto',
                              whiteSpace: 'nowrap',
                              flexWrap: 'nowrap',
                              gap: '6px',
                              cursor: 'pointer',
                              alignItems: 'center',
                              scrollbarWidth: 'thin',
                            }}
                          >
                            {value.map((option, index) => (
                              <Chip
                                key={option._id}
                                label={option.name}
                                size="small"
                                {...getTagProps({ index })}
                                sx={{
                                  borderRadius: '8px',
                                  backgroundColor: '#1976d2',
                                  color: '#fff',
                                  fontWeight: 500,
                                  '.MuiChip-deleteIcon': { color: '#fff' },
                                  '&:hover': { backgroundColor: '#115293' },
                                }}
                              />
                            ))}
                          </div>
                        </Tooltip>
                      );
                    }}
                    sx={{
                      '.MuiOutlinedInput-root': {
                        borderRadius: '10px',
                        minHeight: '48px !important',
                        paddingTop: '4px',
                        paddingBottom: '4px',
                        display: 'flex',
                        alignItems: 'center',
                        background: mode === 'dark' ? '#333' : '#fff',
                        '& fieldset': {
                          border: mode === 'dark' ? '1px solid #666' : '1px solid #ccc',
                        },
                        '&:hover fieldset': {
                          border: '2px solid #102dff',
                          boxShadow: '0 0 6px rgba(25, 118, 210, 0.4)',
                        },
                        '&.Mui-focused fieldset': {
                          border: '2px solid #102dff',
                          boxShadow: '0 0 8px rgba(25, 118, 210, 0.6)',
                        },
                      },
                      '.MuiAutocomplete-inputRoot': {
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'nowrap !important',
                      },
                    }}
                  />
                </FormControl>

                {/* </div> */}

                {/* Developer */}
                {/* <div className="filter-item"> */}
                {/* <FormControl fullWidth>
  <Autocomplete
    multiple
    options={DevelopersArray}
    getOptionLabel={(option) => option.name}
    filterOptions={filterOptionsdevelopers}
    onChange={handleChange_developers_filteration}
    disableCloseOnSelect
    disableListWrap
    limitTags={100}
    renderInput={(params) => (
      <TextField
        {...params}
        label="Choose Developer"
        variant="outlined"
        InputLabelProps={{
          style: {
              color:mode==="dark"?"#fff":"#666",
            fontSize: '15px',
            fontWeight: 500,
          }
        }}
      />
    )}
    renderOption={(props, option, { selected }) => (
      <MenuItem {...props}>
        <Checkbox 
          checked={selected}
          sx={{
            color: '#666',
            '&.Mui-checked': {
              color: '#666',
            },
          }}
        />
        <ListItemText 
          primary={option.name}
          secondary={option.description ? option.description : null}
          secondaryTypographyProps={{
            style: {
              fontSize: '0.75rem',
              color: '#666'
            }
          }}
        />
      </MenuItem>
    )}
    renderTags={(value, getTagProps) => {
      const allSelectedNames = value.map(option => option.name).join(', ');
      return (
        <Tooltip title={allSelectedNames || "No developers selected"} arrow placement="top">
          <div
            style={{
              display: 'flex',
              overflowX: 'auto',
              whiteSpace: 'nowrap',
              flexWrap: 'nowrap',
              gap: '6px',
              cursor: 'pointer',
              alignItems: 'center',
              scrollbarWidth: 'thin',
              '&::-webkit-scrollbar': {
                height: '6px',
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: '#666',
                borderRadius: '3px',
              },
              '&::-webkit-scrollbar-track': {
                backgroundColor: '#f0f0f0',
              }
            }}
          >
            {value.map((option, index) => (
              <Chip
                key={option._id}
                label={option.name}
                size="small"
                {...getTagProps({ index })}
                sx={{
                  borderRadius: '8px',
                  backgroundColor: '#1976d2',
                  color: '#fff',
                  fontWeight: 500,
                  '.MuiChip-deleteIcon': {
                    color: '#fff',
                  },
                  '&:hover': {
                    backgroundColor: '#115293',
                  },
                }}
              />
            ))}
          </div>
        </Tooltip>
      );
    }}
    sx={{
      '.MuiOutlinedInput-root': {
        borderRadius: '10px',
        minHeight: '48px !important',
        paddingTop: '4px',
        paddingBottom: '4px',
        display: 'flex',
        alignItems: 'center',
        boxShadow: '0 1px solid #666 4px rgba(0,0,0,0.1)',
        transition: 'border-color 0.3s, box-shadow 0.3s',
        background:mode==="dark"?"#333":"#fff",
              color:mode==="dark"?"#fff":"#666",
        '& fieldset': {
          border: mode==="dark"?"1px solid #666 solid #333":'1px solid #666 solid #ccc',
        },
        '&:hover fieldset': {
                border: "2px solid #102dff",
          boxShadow: '0 0 6px rgba(25, 118, 210, 0.4)',
        },
        '&.Mui-focused fieldset': {
          border: '2px solid #1976d2',
          boxShadow: '0 0 8px rgba(25, 118, 210, 0.6)',
        },
      },
      '.MuiAutocomplete-inputRoot': {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'nowrap !important',
      },
      '.MuiAutocomplete-input': {
        width: '1px solid #666 !important',
        minWidth: '1px solid #666 !important',
        padding: '0 !important',
        margin: '0 !important',
        flex: '0 0 1px solid #666 !important',
      },
    }}
  />
</FormControl> */}

                <FormControl fullWidth>
                  <Autocomplete
                    multiple
                    options={DevelopersArray}
                    value={selecteddevelopers}
                    isOptionEqualToValue={(option, value) => option._id === value._id}
                    getOptionLabel={(option) => option.name}
                    filterOptions={filterOptionsdevelopers}
                    onChange={handleChange_developers_filteration}
                    disableCloseOnSelect
                    disableListWrap
                    limitTags={100}
                    // 👇 نربطها بالـ state الجديدة
                    inputValue={inputValueDeveloper}
                    onInputChange={(event, newInputValuedeveloper, reason) => {
                      if (reason === 'reset') return; // منمنع مسح البحث بعد الاختيار
                      setInputValueDeveloper(newInputValuedeveloper);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Choose Developer"
                        variant="outlined"
                        InputLabelProps={{
                          style: {
                            color: mode === 'dark' ? '#fff' : '#666',
                            fontSize: '15px',
                            fontWeight: 500,
                          },
                        }}
                      />
                    )}
                    renderOption={(props, option, { selected }) => (
                      <MenuItem {...props}>
                        <Checkbox
                          checked={selected}
                          sx={{
                            color: '#666',
                            '&.Mui-checked': {
                              color: '#666',
                            },
                          }}
                        />
                        <ListItemText
                          primary={option.name}
                          secondary={option.description || null}
                          secondaryTypographyProps={{
                            style: {
                              fontSize: '0.75rem',
                              color: '#666',
                            },
                          }}
                        />
                      </MenuItem>
                    )}
                    renderTags={(value, getTagProps) => {
                      const allSelectedNames = value.map((option) => option.name).join(', ');
                      return (
                        <Tooltip
                          title={allSelectedNames || 'No developers selected'}
                          arrow
                          placement="top"
                        >
                          <div
                            style={{
                              display: 'flex',
                              overflowX: 'auto',
                              whiteSpace: 'nowrap',
                              flexWrap: 'nowrap',
                              gap: '6px',
                              cursor: 'pointer',
                              alignItems: 'center',
                              scrollbarWidth: 'thin',
                            }}
                          >
                            {value.map((option, index) => (
                              <Chip
                                key={option._id}
                                label={option.name}
                                size="small"
                                {...getTagProps({ index })}
                                sx={{
                                  borderRadius: '8px',
                                  backgroundColor: '#1976d2',
                                  color: '#fff',
                                  fontWeight: 500,
                                  '.MuiChip-deleteIcon': { color: '#fff' },
                                  '&:hover': { backgroundColor: '#115293' },
                                }}
                              />
                            ))}
                          </div>
                        </Tooltip>
                      );
                    }}
                    sx={{
                      '.MuiOutlinedInput-root': {
                        borderRadius: '10px',
                        minHeight: '48px !important',
                        paddingTop: '4px',
                        paddingBottom: '4px',
                        display: 'flex',
                        alignItems: 'center',
                        background: mode === 'dark' ? '#333' : '#fff',
                        color: mode === 'dark' ? '#fff' : '#666',
                        '& fieldset': {
                          border: mode === 'dark' ? '1px solid #666' : '1px solid #ccc',
                        },
                        '&:hover fieldset': {
                          border: '2px solid #102dff',
                          boxShadow: '0 0 6px rgba(25, 118, 210, 0.4)',
                        },
                        '&.Mui-focused fieldset': {
                          border: '2px solid #1976d2',
                          boxShadow: '0 0 8px rgba(25, 118, 210, 0.6)',
                        },
                      },
                      '.MuiAutocomplete-inputRoot': {
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'nowrap !important',
                      },
                      '.MuiAutocomplete-input': {
                        width: '1px solid #666 !important',
                        minWidth: '1px solid #666 !important',
                        padding: '0 !important',
                        margin: '0 !important',
                        flex: '0 0 1px solid #666 !important',
                      },
                    }}
                  />
                </FormControl>
                {/* </div> */}

                {/* Project */}
                {/* <div className="filter-item"> */}
                {/* <FormControl fullWidth>
  <Autocomplete
    multiple
    options={projectarray}
    getOptionLabel={(option) => option.name}
    filterOptions={filterOptionsproject}
    onChange={handleChange_project_filteration}
    disableCloseOnSelect
    disableListWrap
    limitTags={100}
    renderInput={(params) => (
      <TextField
        {...params}
        label="Choose Project"
        variant="outlined"
        InputLabelProps={{
          style: {
              color:mode==="dark"?"#fff":"#666",
            fontSize: '15px',
            fontWeight: 500,
          }
        }}
      />
    )}
    renderOption={(props, option, { selected }) => (
      <MenuItem {...props}>
        <Checkbox 
          checked={selected}
          sx={{
            color: '#666',
            '&.Mui-checked': {
              color: '#666',
            },
          }}
        />
        <ListItemText 
          primary={option.name}
          secondary={option.description ? option.description : null}
          secondaryTypographyProps={{
            style: {
              fontSize: '0.75rem',
              color: '#666'
            }
          }}
        />
      </MenuItem>
    )}
    renderTags={(value, getTagProps) => {
      const allSelectedNames = value.map(option => option.name).join(', ');
      return (
        <Tooltip title={allSelectedNames || "No projects selected"} arrow placement="top">
          <div
            style={{
              display: 'flex',
              overflowX: 'auto',
              whiteSpace: 'nowrap',
              flexWrap: 'nowrap',
              gap: '6px',
              cursor: 'pointer',
              alignItems: 'center',
              scrollbarWidth: 'thin',
              '&::-webkit-scrollbar': {
                height: '6px',
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: '#666',
                borderRadius: '3px',
              },
              '&::-webkit-scrollbar-track': {
                backgroundColor: '#f0f0f0',
              }
            }}
          >
            {value.map((option, index) => (
              <Chip
                key={option._id}
                label={option.name}
                size="small"
                {...getTagProps({ index })}
                sx={{
                  borderRadius: '8px',
                  backgroundColor: '#1976d2',
                  color: '#fff',
                  fontWeight: 500,
                  '.MuiChip-deleteIcon': {
                    color: '#fff',
                  },
                  '&:hover': {
                    backgroundColor: '#115293',
                  },
                }}
              />
            ))}
          </div>
        </Tooltip>
      );
    }}
    sx={{
      '.MuiOutlinedInput-root': {
        borderRadius: '10px',
        minHeight: '48px !important',
        paddingTop: '4px',
        paddingBottom: '4px',
        display: 'flex',
        alignItems: 'center',
        boxShadow: '0 1px solid #666 4px rgba(0,0,0,0.1)',
        transition: 'border-color 0.3s, box-shadow 0.3s',
          background:mode==="dark"?"#333":"#fff",
              color:mode==="dark"?"#fff":"#666",
        '& fieldset': {
          border: mode==="dark"?"1px solid #666 solid #333":'1px solid #666 solid #ccc',
        },
        '&:hover fieldset': {
                border: "2px solid #102dff",
          boxShadow: '0 0 6px rgba(25, 118, 210, 0.4)',
        },
        '&.Mui-focused fieldset': {
          border: '2px solid #1976d2',
          boxShadow: '0 0 8px rgba(25, 118, 210, 0.6)',
        },
      },
      '.MuiAutocomplete-inputRoot': {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'nowrap !important',
      },
      '.MuiAutocomplete-input': {
        width: '1px solid #666 !important',
        minWidth: '1px solid #666 !important',
        padding: '0 !important',
        margin: '0 !important',
        flex: '0 0 1px solid #666 !important',
      },
    }}
  />
</FormControl> */}

                <FormControl fullWidth>
                  <Autocomplete
                    multiple
                    options={projectarray}
                    value={selectedproject}
                    isOptionEqualToValue={(option, value) => option._id === value._id}
                    getOptionLabel={(option) => option.name}
                    filterOptions={filterOptionsproject}
                    onChange={handleChange_project_filteration}
                    disableCloseOnSelect
                    disableListWrap
                    limitTags={100}
                    // 👇 التحكم في إدخال البحث
                    inputValue={inputValueProject}
                    onInputChange={(event, newInputValueproject, reason) => {
                      if (reason === 'reset') return; // منع المسح بعد الاختيار
                      setInputValueProject(newInputValueproject);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Choose Project"
                        variant="outlined"
                        InputLabelProps={{
                          style: {
                            color: mode === 'dark' ? '#fff' : '#666',
                            fontSize: '15px',
                            fontWeight: 500,
                          },
                        }}
                      />
                    )}
                    renderOption={(props, option, { selected }) => (
                      <MenuItem {...props}>
                        <Checkbox
                          checked={selected}
                          sx={{
                            color: '#666',
                            '&.Mui-checked': { color: '#666' },
                          }}
                        />
                        <ListItemText
                          primary={option.name}
                          secondary={option.description || null}
                          secondaryTypographyProps={{
                            style: {
                              fontSize: '0.75rem',
                              color: '#666',
                            },
                          }}
                        />
                      </MenuItem>
                    )}
                    renderTags={(value, getTagProps) => {
                      const allSelectedNames = value.map((option) => option.name).join(', ');
                      return (
                        <Tooltip
                          title={allSelectedNames || 'No projects selected'}
                          arrow
                          placement="top"
                        >
                          <div
                            style={{
                              display: 'flex',
                              overflowX: 'auto',
                              whiteSpace: 'nowrap',
                              flexWrap: 'nowrap',
                              gap: '6px',
                              cursor: 'pointer',
                              alignItems: 'center',
                              scrollbarWidth: 'thin',
                            }}
                          >
                            {value.map((option, index) => (
                              <Chip
                                key={option._id}
                                label={option.name}
                                size="small"
                                {...getTagProps({ index })}
                                sx={{
                                  borderRadius: '8px',
                                  backgroundColor: '#1976d2',
                                  color: '#fff',
                                  fontWeight: 500,
                                  '.MuiChip-deleteIcon': { color: '#fff' },
                                  '&:hover': { backgroundColor: '#115293' },
                                }}
                              />
                            ))}
                          </div>
                        </Tooltip>
                      );
                    }}
                    sx={{
                      '.MuiOutlinedInput-root': {
                        borderRadius: '10px',
                        minHeight: '48px !important',
                        paddingTop: '4px',
                        paddingBottom: '4px',
                        display: 'flex',
                        alignItems: 'center',
                        background: mode === 'dark' ? '#333' : '#fff',
                        color: mode === 'dark' ? '#fff' : '#666',
                        '& fieldset': {
                          border: mode === 'dark' ? '1px solid #666' : '1px solid #ccc',
                        },
                        '&:hover fieldset': {
                          border: '2px solid #102dff',
                          boxShadow: '0 0 6px rgba(25, 118, 210, 0.4)',
                        },
                        '&.Mui-focused fieldset': {
                          border: '2px solid #1976d2',
                          boxShadow: '0 0 8px rgba(25, 118, 210, 0.6)',
                        },
                      },
                      '.MuiAutocomplete-inputRoot': {
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'nowrap !important',
                      },
                      '.MuiAutocomplete-input': {
                        width: '1px solid #666 !important',
                        minWidth: '1px solid #666 !important',
                        padding: '0 !important',
                        margin: '0 !important',
                        flex: '0 0 1px solid #666 !important',
                      },
                    }}
                  />
                </FormControl>
                {/* </div> */}

                {/* Communication Way */}
                {/* <div className="filter-item"> */}
                {/* <FormControl fullWidth>
  <Autocomplete
    multiple
    options={resCommunicationWayArray}
    getOptionLabel={(option) => option.name}
    filterOptions={filterOptionsCommunicationWay}
    onChange={handleChange_CommunicationWay_filteration}
    disableCloseOnSelect
    disableListWrap
    limitTags={100}
    renderInput={(params) => (
      <TextField
        {...params}
        label="Communication Way"
        variant="outlined"
        InputLabelProps={{
          style: {
              color:mode==="dark"?"#fff":"#666",
            fontSize: '15px',
            fontWeight: 500,
          }
        }}
      />
    )}
    renderOption={(props, option, { selected }) => (
      <MenuItem {...props}>
        <Checkbox 
          checked={selected}
          sx={{
            color: '#666',
            '&.Mui-checked': {
              color: '#666',
            },
          }}
        />
        <ListItemText 
          primary={option.name}
          secondary={option.description ? option.description : null}
          secondaryTypographyProps={{
            style: {
              fontSize: '0.75rem',
              color: '#666'
            }
          }}
        />
      </MenuItem>
    )}
    renderTags={(value, getTagProps) => {
      const allSelectedNames = value.map(option => option.name).join(', ');
      return (
        <Tooltip title={allSelectedNames} arrow placement="top">
          <div
            style={{
              display: 'flex',
              overflowX: 'auto',
              whiteSpace: 'nowrap',
              flexWrap: 'nowrap',
              gap: '6px',
              cursor: 'pointer',
              alignItems: 'center',
              scrollbarWidth: 'thin',
              '&::-webkit-scrollbar': {
                height: '6px',
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: '#666',
                borderRadius: '3px',
              },
              '&::-webkit-scrollbar-track': {
                backgroundColor: '#f0f0f0',
              }
            }}
          >
            {value.map((option, index) => (
              <Chip
                key={option._id}
                label={option.name}
                size="small"
                {...getTagProps({ index })}
                sx={{
                  borderRadius: '8px',
                  backgroundColor: '#1976d2',
                  color: '#fff',
                  fontWeight: 500,
                  '.MuiChip-deleteIcon': {
                    color: '#fff',
                  },
                  '&:hover': {
                    backgroundColor: '#115293',
                  },
                }}
              />
            ))}
          </div>
        </Tooltip>
      );
    }}
    sx={{
      '.MuiOutlinedInput-root': {
        borderRadius: '10px',
        minHeight: '48px !important',
        paddingTop: '4px',
        paddingBottom: '4px',
        display: 'flex',
        alignItems: 'center',
        boxShadow: '0 1px solid #666 4px rgba(0,0,0,0.1)',
        transition: 'border-color 0.3s, box-shadow 0.3s',
        background:mode==="dark"?"#333":"#fff",
        '& fieldset': {
          border: mode==="dark"?"1px solid #666 solid #333":'1px solid #666 solid #ccc',
        },
        '&:hover fieldset': {
                border: "2px solid #102dff",
          boxShadow: '0 0 6px rgba(25, 118, 210, 0.4)',
        },
        '&.Mui-focused fieldset': {
          border: '2px solid #102dff',
          boxShadow: '0 0 8px rgba(25, 118, 210, 0.6)',
        },
      },
      '.MuiAutocomplete-inputRoot': {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'nowrap !important',
      },
      '.MuiAutocomplete-input': {
        width: '1px solid #666 !important',
        minWidth: '1px solid #666 !important',
        padding: '0 !important',
        margin: '0 !important',
        flex: '0 0 1px solid #666 !important',
      },
    }}
  />
</FormControl> */}

                {/* communication way */}
                {/* <FormControl fullWidth>
      <Autocomplete
        multiple
        options={resCommunicationWayArray}
        getOptionLabel={(option) => option.name}
        filterOptions={filterOptionsCommunicationWay}
        onChange={handleChange_CommunicationWay_filteration}
        disableCloseOnSelect
        disableListWrap
        limitTags={100}

        // 👇 التحكم في البحث ومنع مسحه بعد الاختيار
        inputValue={inputValueCommunicationWay}
        onInputChange={(event, newInputValuecommunicationway, reason) => {
          if (reason === 'reset') return; // منع مسح النص بعد اختيار عنصر
          setInputValueCommunicationWay(newInputValuecommunicationway);
        }}

        renderInput={(params) => (
          <TextField
            {...params}
            label="Communication Way"
            variant="outlined"
            InputLabelProps={{
              style: {
                color: mode === "dark" ? "#fff" : "#666",
                fontSize: '15px',
                fontWeight: 500,
              }
            }}
          />
        )}

        renderOption={(props, option, { selected }) => (
          <MenuItem {...props}>
            <Checkbox
              checked={selected}
              sx={{
                color: '#666',
                '&.Mui-checked': { color: '#666' },
              }}
            />
            <ListItemText
              primary={option.name}
              secondary={option.description ? option.description : null}
              secondaryTypographyProps={{
                style: {
                  fontSize: '0.75rem',
                  color: '#666'
                }
              }}
            />
          </MenuItem>
        )}

        renderTags={(value, getTagProps) => {
          const allSelectedNames = value.map(option => option.name).join(', ');
          return (
            <Tooltip title={allSelectedNames || "No communication ways selected"} arrow placement="top">
              <div
                style={{
                  display: 'flex',
                  overflowX: 'auto',
                  whiteSpace: 'nowrap',
                  flexWrap: 'nowrap',
                  gap: '6px',
                  cursor: 'pointer',
                  alignItems: 'center',
                  scrollbarWidth: 'thin',
                }}
              >
                {value.map((option, index) => (
                  <Chip
                    key={option._id}
                    label={option.name}
                    size="small"
                    {...getTagProps({ index })}
                    sx={{
                      borderRadius: '8px',
                      backgroundColor: '#1976d2',
                      color: '#fff',
                      fontWeight: 500,
                      '.MuiChip-deleteIcon': {
                        color: '#fff',
                      },
                      '&:hover': {
                        backgroundColor: '#115293',
                      },
                    }}
                  />
                ))}
              </div>
            </Tooltip>
          );
        }}

        sx={{
          '.MuiOutlinedInput-root': {
            borderRadius: '10px',
            minHeight: '48px !important',
            paddingTop: '4px',
            paddingBottom: '4px',
            display: 'flex',
            alignItems: 'center',
            background: mode === "dark" ? "#333" : "#fff",
            color: mode === "dark" ? "#fff" : "#666",
            '& fieldset': {
              border: mode === "dark"
                ? '1px solid #666'
                : '1px solid #ccc',
            },
            '&:hover fieldset': {
              border: "2px solid #102dff",
              boxShadow: '0 0 6px rgba(25, 118, 210, 0.4)',
            },
            '&.Mui-focused fieldset': {
              border: '2px solid #102dff',
              boxShadow: '0 0 8px rgba(25, 118, 210, 0.6)',
            },
          },
          '.MuiAutocomplete-inputRoot': {
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'nowrap !important',
          },
          '.MuiAutocomplete-input': {
            width: '1px solid #666 !important',
            minWidth: '1px solid #666 !important',
            padding: '0 !important',
            margin: '0 !important',
            flex: '0 0 1px solid #666 !important',
          },
        }}
      />
    </FormControl> */}
                <FormControl fullWidth>
                  <Autocomplete
                    multiple
                    // ✅ الترتيب: "No Communication Way" تطلع أول عنصر
                    options={(resCommunicationWayArray || []).slice().sort((a, b) => {
                      if (a.name === 'No Communication Way') return -1; // a يطلع فوق
                      if (b.name === 'No Communication Way') return 1; // b ينزل تحت
                      return 0;
                    })}
                    value={selectedCommunicationWay}
                    isOptionEqualToValue={(option, value) => option._id === value._id}
                    getOptionLabel={(option) => option.name}
                    filterOptions={filterOptionsCommunicationWay}
                    onChange={handleChange_CommunicationWay_filteration}
                    disableCloseOnSelect
                    disableListWrap
                    limitTags={100}
                    inputValue={inputValueCommunicationWay}
                    onInputChange={(event, newInputValuecommunicationway, reason) => {
                      if (reason === 'reset') return;
                      setInputValueCommunicationWay(newInputValuecommunicationway);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Communication Way"
                        variant="outlined"
                        InputLabelProps={{
                          style: {
                            color: mode === 'dark' ? '#fff' : '#666',
                            fontSize: '15px',
                            fontWeight: 500,
                          },
                        }}
                      />
                    )}
                    renderOption={(props, option, { selected }) => (
                      <MenuItem {...props}>
                        <Checkbox
                          checked={selected}
                          sx={{
                            color: '#666',
                            '&.Mui-checked': { color: '#666' },
                          }}
                        />
                        <ListItemText
                          primary={option.name}
                          secondary={option.description ? option.description : null}
                          secondaryTypographyProps={{
                            style: { fontSize: '0.75rem', color: '#666' },
                          }}
                        />
                      </MenuItem>
                    )}
                    renderTags={(value, getTagProps) => {
                      const allSelectedNames = value.map((option) => option.name).join(', ');
                      return (
                        <Tooltip
                          title={allSelectedNames || 'No communication ways selected'}
                          arrow
                          placement="top"
                        >
                          <div
                            style={{
                              display: 'flex',
                              overflowX: 'auto',
                              whiteSpace: 'nowrap',
                              flexWrap: 'nowrap',
                              gap: '6px',
                              cursor: 'pointer',
                              alignItems: 'center',
                              scrollbarWidth: 'thin',
                            }}
                          >
                            {value.map((option, index) => (
                              <Chip
                                key={option._id}
                                label={option.name}
                                size="small"
                                {...getTagProps({ index })}
                                sx={{
                                  borderRadius: '8px',
                                  backgroundColor: '#1976d2',
                                  color: '#fff',
                                  fontWeight: 500,
                                  '.MuiChip-deleteIcon': { color: '#fff' },
                                  '&:hover': { backgroundColor: '#115293' },
                                }}
                              />
                            ))}
                          </div>
                        </Tooltip>
                      );
                    }}
                    sx={{
                      '.MuiOutlinedInput-root': {
                        borderRadius: '10px',
                        minHeight: '48px !important',
                        paddingTop: '4px',
                        paddingBottom: '4px',
                        display: 'flex',
                        alignItems: 'center',
                        background: mode === 'dark' ? '#333' : '#fff',
                        color: mode === 'dark' ? '#fff' : '#666',
                        '& fieldset': {
                          border: mode === 'dark' ? '1px solid #666' : '1px solid #ccc',
                        },
                        '&:hover fieldset': {
                          border: '2px solid #102dff',
                          boxShadow: '0 0 6px rgba(25, 118, 210, 0.4)',
                        },
                        '&.Mui-focused fieldset': {
                          border: '2px solid #102dff',
                          boxShadow: '0 0 8px rgba(25, 118, 210, 0.6)',
                        },
                      },
                      '.MuiAutocomplete-inputRoot': {
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'nowrap !important',
                      },
                      '.MuiAutocomplete-input': {
                        width: '1px solid #666 !important',
                        minWidth: '1px solid #666 !important',
                        padding: '0 !important',
                        margin: '0 !important',
                        flex: '0 0 1px solid #666 !important',
                      },
                    }}
                  />
                </FormControl>
                {/* </div> */}

                {/* Campaigns */}
                {/* <div className="filter-item"> */}
                {/* <FormControl fullWidth>
  <Autocomplete
    multiple
    options={resCampaignArray}
    getOptionLabel={(option) => option.CampainName}
    filterOptions={filterOptionsCampaign}
    onChange={handleChange_Campaign_filteration}
    disableCloseOnSelect
    disableListWrap
    limitTags={100}
    renderInput={(params) => (
      <TextField
        {...params}
        label="Choose Campaign"
        variant="outlined"
        InputLabelProps={{
          style: {
              color:mode==="dark"?"#fff":"#666",
            fontSize: '15px',
            fontWeight: 500,
          }
        }}
      />
    )}
    renderOption={(props, option, { selected }) => (
      <MenuItem {...props}>
        <Checkbox 
          checked={selected}
          sx={{
            color: '#666',
            '&.Mui-checked': {
              color: '#666',
            },
          }}
        />
        <ListItemText 
          primary={option.CampainName}
          secondary={option.description ? option.description : null}
          secondaryTypographyProps={{
            style: {
              fontSize: '0.75rem',
              color: '#666'
            }
          }}
        />
      </MenuItem>
    )}
    renderTags={(value, getTagProps) => {
      const allSelectedNames = value.map(option => option.CampainName).join(', ');
      return (
        <Tooltip title={allSelectedNames} arrow placement="top">
          <div
            style={{
              display: 'flex',
              overflowX: 'auto',
              whiteSpace: 'nowrap',
              flexWrap: 'nowrap',
              gap: '6px',
              cursor: 'pointer',
              alignItems: 'center',
              scrollbarWidth: 'thin',
              '&::-webkit-scrollbar': {
                height: '6px',
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: '#666',
                borderRadius: '3px',
              },
              '&::-webkit-scrollbar-track': {
                backgroundColor: '#f0f0f0',
              }
            }}
          >
            {value.map((option, index) => (
              <Chip
                key={option._id}
                label={option.CampainName}
                size="small"
                {...getTagProps({ index })}
                sx={{
                  borderRadius: '8px',
                  backgroundColor: '#1976d2',
                  color: '#fff',
                  fontWeight: 500,
                  '.MuiChip-deleteIcon': {
                    color: '#fff',
                  },
                  '&:hover': {
                    backgroundColor: '#115293',
                  },
                }}
              />
            ))}
          </div>
        </Tooltip>
      );
    }}
    sx={{
      '.MuiOutlinedInput-root': {
        borderRadius: '10px',
        minHeight: '48px !important',
        paddingTop: '4px',
        paddingBottom: '4px',
        display: 'flex',
        alignItems: 'center',
        boxShadow: '0 1px solid #666 4px rgba(0,0,0,0.1)',
        transition: 'border-color 0.3s, box-shadow 0.3s',
         background:mode==="dark"?"#333":"#fff",

        '& fieldset': {
          border: mode==="dark"?"1px solid #666 solid #333":'1px solid #666 solid #ccc',
        },
        '&:hover fieldset': {
                border: "2px solid #102dff",
          boxShadow: '0 0 6px rgba(25, 118, 210, 0.4)',
        },
        '&.Mui-focused fieldset': {
          border: '2px solid #102dff',
          boxShadow: '0 0 8px rgba(25, 118, 210, 0.6)',
        },
      },
      '.MuiAutocomplete-inputRoot': {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'nowrap !important',
      },
      '.MuiAutocomplete-input': {
        width: '1px solid #666 !important',
        minWidth: '1px solid #666 !important',
        padding: '0 !important',
        margin: '0 !important',
        flex: '0 0 1px solid #666 !important',
      },
    }}
  />
</FormControl> */}

                <FormControl fullWidth>
                  <Autocomplete
                    multiple
                    options={resCampaignArray}
                    value={selectedCampaign}
                    isOptionEqualToValue={(option, value) => option._id === value._id}
                    getOptionLabel={(option) => option.CampainName}
                    filterOptions={filterOptionsCampaign}
                    onChange={handleChange_Campaign_filteration}
                    disableCloseOnSelect
                    disableListWrap
                    limitTags={100}
                    // 👇 نتحكم في قيمة البحث ومنمنع مسحه بعد الاختيار
                    inputValue={inputValueCampaign}
                    onInputChange={(event, newInputValuecampaign, reason) => {
                      if (reason === 'reset') return; // منع المسح بعد اختيار campaign
                      setInputValueCampaign(newInputValuecampaign);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Choose Campaign"
                        variant="outlined"
                        InputLabelProps={{
                          style: {
                            color: mode === 'dark' ? '#fff' : '#666',
                            fontSize: '15px',
                            fontWeight: 500,
                          },
                        }}
                      />
                    )}
                    renderOption={(props, option, { selected }) => (
                      <MenuItem {...props}>
                        <Checkbox
                          checked={selected}
                          sx={{
                            color: '#666',
                            '&.Mui-checked': { color: '#666' },
                          }}
                        />
                        <ListItemText
                          primary={option.CampainName}
                          secondary={option.description ? option.description : null}
                          secondaryTypographyProps={{
                            style: {
                              fontSize: '0.75rem',
                              color: '#666',
                            },
                          }}
                        />
                      </MenuItem>
                    )}
                    renderTags={(value, getTagProps) => {
                      const allSelectedNames = value.map((option) => option.CampainName).join(', ');
                      return (
                        <Tooltip
                          title={allSelectedNames || 'No campaigns selected'}
                          arrow
                          placement="top"
                        >
                          <div
                            style={{
                              display: 'flex',
                              overflowX: 'auto',
                              whiteSpace: 'nowrap',
                              flexWrap: 'nowrap',
                              gap: '6px',
                              cursor: 'pointer',
                              alignItems: 'center',
                              scrollbarWidth: 'thin',
                            }}
                          >
                            {value.map((option, index) => (
                              <Chip
                                key={option._id}
                                label={option.CampainName}
                                size="small"
                                {...getTagProps({ index })}
                                sx={{
                                  borderRadius: '8px',
                                  backgroundColor: '#1976d2',
                                  color: '#fff',
                                  fontWeight: 500,
                                  '.MuiChip-deleteIcon': { color: '#fff' },
                                  '&:hover': { backgroundColor: '#115293' },
                                }}
                              />
                            ))}
                          </div>
                        </Tooltip>
                      );
                    }}
                    sx={{
                      '.MuiOutlinedInput-root': {
                        borderRadius: '10px',
                        minHeight: '48px !important',
                        paddingTop: '4px',
                        paddingBottom: '4px',
                        display: 'flex',
                        alignItems: 'center',
                        transition: 'border-color 0.3s, box-shadow 0.3s',
                        background: mode === 'dark' ? '#333' : '#fff',
                        '& fieldset': {
                          border: mode === 'dark' ? '1px solid #666' : '1px solid #ccc',
                        },
                        '&:hover fieldset': {
                          border: '2px solid #102dff',
                          boxShadow: '0 0 6px rgba(25, 118, 210, 0.4)',
                        },
                        '&.Mui-focused fieldset': {
                          border: '2px solid #102dff',
                          boxShadow: '0 0 8px rgba(25, 118, 210, 0.6)',
                        },
                      },
                      '.MuiAutocomplete-inputRoot': {
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'nowrap !important',
                      },
                      '.MuiAutocomplete-input': {
                        width: '1px solid #666 !important',
                        minWidth: '1px solid #666 !important',
                        padding: '0 !important',
                        margin: '0 !important',
                        flex: '0 0 1px solid #666 !important',
                      },
                    }}
                  />
                </FormControl>

                {/* </div> */}

                {/* old stage */}

                {/* <div className="filter-item"> */}
                {/* <FormControl fullWidth>
    <Autocomplete
      multiple
      options={stages_data_array}
      getOptionLabel={(option) => option.name}
      onChange={(event, newValue) => {
        setFilters(prev => ({ ...prev, oldStage: newValue }));
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Choose Old Stage"
          variant="outlined"
          InputLabelProps={{
            style: {
              color:mode==="dark"?"#fff":"#666",
              fontSize: '15px',
              fontWeight: 500,
            }
          }}
        />
      )}
      renderOption={(props, option, { selected }) => (
        <MenuItem {...props}>
          <Checkbox 
            checked={selected}
            sx={{
              color: '#666',
              '&.Mui-checked': {
                color: '#666',
              },
            }}
          />
          <ListItemText 
            primary={option.name}
            secondary={option.description}
          />
        </MenuItem>
      )}
      sx={{
        '.MuiOutlinedInput-root': {
          borderRadius: '10px',
          minHeight: '48px',
          paddingTop: '4px',
          paddingBottom: '4px',
          display: 'flex',
          alignItems: 'center',
          boxShadow: '0 1px solid #666 4px rgba(0,0,0,0.1)',
          transition: 'border-color 0.3s, box-shadow 0.3s',
          background:mode==="dark"?"#333":"#fff",

          '& fieldset': {
            border:mode==="dark"?"1px solid #666 solid #333":'1px solid #666 solid #ccc',
          },
          '&:hover fieldset': {
                border: "2px solid #102dff",
            boxShadow: '0 0 6px rgba(25, 118, 210, 0.4)',
          },
          '&.Mui-focused fieldset': {
            border: '2px solid #102dff',
            boxShadow: '0 0 8px rgba(25, 118, 210, 0.6)',
          },
        },
      }}
    />
  </FormControl> */}

                {/* old stage */}
                <FormControl fullWidth>
                  <Autocomplete
                    multiple
                    value={oldstagevalue}
                    options={stages_data_array}
                    isOptionEqualToValue={(option, value) => option._id === value._id}
                    getOptionLabel={(option) => option.name}
                    disableCloseOnSelect // 👈 دي اللي بتخلي القايمة ما تقفلش بعد الاختيار
                    disableListWrap
                    limitTags={100}
                    onChange={(event, newValue) => {
                      setoldstagevalue(newValue);
                      setFilters((prev) => ({ ...prev, oldStage: newValue }));
                    }}
                    // 👇 للتحكم في قيمة البحث
                    inputValue={inputValueOldStage}
                    onInputChange={(event, newInputValue, reason) => {
                      if (reason === 'reset') return; // منع المسح بعد الاختيار

                      setInputValueOldStage(newInputValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Choose Old Stage"
                        variant="outlined"
                        InputLabelProps={{
                          style: {
                            color: mode === 'dark' ? '#fff' : '#666',
                            fontSize: '15px',
                            fontWeight: 500,
                          },
                        }}
                      />
                    )}
                    renderOption={(props, option, { selected }) => (
                      <MenuItem {...props}>
                        <Checkbox
                          checked={selected}
                          sx={{
                            color: '#666',
                            '&.Mui-checked': { color: '#666' },
                          }}
                        />
                        <ListItemText
                          primary={option.name}
                          secondary={option.description ? option.description : null}
                          secondaryTypographyProps={{
                            style: {
                              fontSize: '0.75rem',
                              color: '#666',
                            },
                          }}
                        />
                      </MenuItem>
                    )}
                    renderTags={(value, getTagProps) => {
                      const allSelectedNames = value.map((option) => option.name).join(', ');
                      return (
                        <Tooltip
                          title={allSelectedNames || 'No stages selected'}
                          arrow
                          placement="top"
                        >
                          <div
                            style={{
                              display: 'flex',
                              overflowX: 'auto',
                              whiteSpace: 'nowrap',
                              flexWrap: 'nowrap',
                              gap: '6px',
                              cursor: 'pointer',
                              alignItems: 'center',
                              scrollbarWidth: 'thin',
                              '&::-webkit-scrollbar': { height: '6px' },
                              '&::-webkit-scrollbar-thumb': {
                                backgroundColor: '#666',
                                borderRadius: '3px',
                              },
                              '&::-webkit-scrollbar-track': {
                                backgroundColor: '#f0f0f0',
                              },
                            }}
                          >
                            {value.map((option, index) => (
                              <Chip
                                key={option._id}
                                label={option.name}
                                size="small"
                                {...getTagProps({ index })}
                                sx={{
                                  borderRadius: '8px',
                                  backgroundColor: '#1976d2',
                                  color: '#fff',
                                  fontWeight: 500,
                                  '.MuiChip-deleteIcon': { color: '#fff' },
                                  '&:hover': { backgroundColor: '#115293' },
                                }}
                              />
                            ))}
                          </div>
                        </Tooltip>
                      );
                    }}
                    sx={{
                      '.MuiOutlinedInput-root': {
                        borderRadius: '10px',
                        minHeight: '48px !important',
                        paddingTop: '4px',
                        paddingBottom: '4px',
                        display: 'flex',
                        alignItems: 'center',
                        transition: 'border-color 0.3s, box-shadow 0.3s',
                        background: mode === 'dark' ? '#333' : '#fff',
                        color: mode === 'dark' ? '#fff' : '#666',
                        '& fieldset': {
                          border: mode === 'dark' ? '1px solid #666' : '1px solid #ccc',
                        },
                        '&:hover fieldset': {
                          border: '2px solid #102dff',
                          boxShadow: '0 0 6px rgba(25, 118, 210, 0.4)',
                        },
                        '&.Mui-focused fieldset': {
                          border: '2px solid #102dff',
                          boxShadow: '0 0 8px rgba(25, 118, 210, 0.6)',
                        },
                      },
                      '.MuiAutocomplete-inputRoot': {
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'nowrap !important',
                      },
                      '.MuiAutocomplete-input': {
                        width: '1px solid #666 !important',
                        minWidth: '1px solid #666 !important',
                        padding: '0 !important',
                        margin: '0 !important',
                        flex: '0 0 1px solid #666 !important',
                      },
                    }}
                  />
                </FormControl>
                {/* </div> */}

                {/* added by */}
                {/* <div className="filter-item"> */}
                {/* <FormControl fullWidth>
    <Autocomplete
      multiple
      options={usersAuth}
      getOptionLabel={(option) => option.name}
      filterOptions={filterOptionsselecteduser}
      onChange={handleChangeselecteduser}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Added By"
          variant="outlined"
          InputLabelProps={{
            style: {
              color:mode==="dark"?"#fff":"#666",
              fontSize: '15px',
              fontWeight: 500,
            }
          }}
        />
      )}
      renderOption={(props, option, { selected }) => (
        <MenuItem {...props}>
          <Checkbox 
            checked={selected}
            sx={{
              color: '#666',
              '&.Mui-checked': {
                color: '#666',
              },
            }}
          />
    <ListItemText 
  primary={option?.name}
  secondary={
    <>
      <div>{option?.email}</div>
      <div>{option?.role}</div>
    </>
  }
/>
        </MenuItem>
      )}
      sx={{
        '.MuiOutlinedInput-root': {
          borderRadius: '10px',
          minHeight: '48px',
          paddingTop: '4px',
          paddingBottom: '4px',
          display: 'flex',
          alignItems: 'center',
          boxShadow: '0 1px solid #666 4px rgba(0,0,0,0.1)',
          transition: 'border-color 0.3s, box-shadow 0.3s',
           background:mode==="dark"?"#333":"#fff",

          '& fieldset': {
            border: mode==="dark"?"1px solid #666 solid #333":'1px solid #666 solid #ccc',
          },
          '&:hover fieldset': {
                border: "2px solid #102dff",
            boxShadow: '0 0 6px rgba(25, 118, 210, 0.4)',
          },
          '&.Mui-focused fieldset': {
            border: '2px solid #102dff',
            boxShadow: '0 0 8px rgba(25, 118, 210, 0.6)',
          },
        },
      }}
    />
  </FormControl> */}

                <FormControl fullWidth>
                  <Autocomplete
                    multiple
                    options={usersAuth}
                    isOptionEqualToValue={(option, value) => option._id === value._id}
                    value={Addedbyvalue}
                    getOptionLabel={(option) => option.name}
                    filterOptions={filterOptionsselecteduser}
                    onChange={handleChangeselecteduser}
                    // 🔹 التحكم في البحث
                    inputValue={inputValueAddedBy}
                    onInputChange={(event, newInputValueaddedby, reason) => {
                      if (reason === 'reset') return; // منع المسح بعد الاختيار
                      setInputValueAddedBy(newInputValueaddedby);
                    }}
                    disableCloseOnSelect
                    disableListWrap
                    limitTags={100}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Added By"
                        variant="outlined"
                        InputLabelProps={{
                          style: {
                            color: mode === 'dark' ? '#fff' : '#666',
                            fontSize: '15px',
                            fontWeight: 500,
                          },
                        }}
                      />
                    )}
                    renderOption={(props, option, { selected }) => (
                      <MenuItem {...props}>
                        <Checkbox
                          checked={selected}
                          sx={{
                            color: '#666',
                            '&.Mui-checked': { color: '#666' },
                          }}
                        />
                        <ListItemText
                          primary={option?.name}
                          secondary={
                            <>
                              <div>{option?.email}</div>
                              <div>{option?.role}</div>
                            </>
                          }
                          secondaryTypographyProps={{
                            style: { fontSize: '0.75rem', color: '#666' },
                          }}
                        />
                      </MenuItem>
                    )}
                    renderTags={(value, getTagProps) => {
                      const allSelectedNames = value.map((option) => option.name).join(', ');
                      return (
                        <Tooltip
                          title={allSelectedNames || 'No users selected'}
                          arrow
                          placement="top"
                        >
                          <div
                            style={{
                              display: 'flex',
                              overflowX: 'auto',
                              whiteSpace: 'nowrap',
                              flexWrap: 'nowrap',
                              gap: '6px',
                              cursor: 'pointer',
                              alignItems: 'center',
                              scrollbarWidth: 'thin',
                              '&::-webkit-scrollbar': { height: '6px' },
                              '&::-webkit-scrollbar-thumb': {
                                backgroundColor: '#666',
                                borderRadius: '3px',
                              },
                              '&::-webkit-scrollbar-track': { backgroundColor: '#f0f0f0' },
                            }}
                          >
                            {value.map((option, index) => (
                              <Chip
                                key={option._id}
                                label={option.name}
                                size="small"
                                {...getTagProps({ index })}
                                sx={{
                                  borderRadius: '8px',
                                  backgroundColor: '#1976d2',
                                  color: '#fff',
                                  fontWeight: 500,
                                  '.MuiChip-deleteIcon': { color: '#fff' },
                                  '&:hover': { backgroundColor: '#115293' },
                                }}
                              />
                            ))}
                          </div>
                        </Tooltip>
                      );
                    }}
                    sx={{
                      '.MuiOutlinedInput-root': {
                        borderRadius: '10px',
                        minHeight: '48px !important',
                        paddingTop: '4px',
                        paddingBottom: '4px',
                        display: 'flex',
                        alignItems: 'center',
                        transition: 'border-color 0.3s, box-shadow 0.3s',
                        background: mode === 'dark' ? '#333' : '#fff',
                        color: mode === 'dark' ? '#fff' : '#666',
                        '& fieldset': {
                          border: mode === 'dark' ? '1px solid #666' : '1px solid #ccc',
                        },
                        '&:hover fieldset': {
                          border: '2px solid #102dff',
                          boxShadow: '0 0 6px rgba(25, 118, 210, 0.4)',
                        },
                        '&.Mui-focused fieldset': {
                          border: '2px solid #102dff',
                          boxShadow: '0 0 8px rgba(25, 118, 210, 0.6)',
                        },
                      },
                      '.MuiAutocomplete-inputRoot': {
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'nowrap !important',
                      },
                      '.MuiAutocomplete-input': {
                        width: '1px solid #666 !important',
                        minWidth: '1px solid #666 !important',
                        padding: '0 !important',
                        margin: '0 !important',
                        flex: '0 0 1px solid #666 !important',
                      },
                    }}
                  />
                </FormControl>

                {/* </div> */}

                {/* Assigned From Filter */}
                {/* <div className="filter-item"> */}
                {/* <FormControl fullWidth>
    <Autocomplete
      multiple
      options={usersAuth} // استخدم مصفوفة المستخدمين المتاحة
      getOptionLabel={(option) => option.name}
      filterOptions={(options, { inputValue }) =>
        options.filter(option =>
          option?.name.toLowerCase().includes(inputValue.toLowerCase()) ||
          option?.role.toLowerCase().includes(inputValue.toLowerCase())
        )
      }
      onChange={(event, newValue) => {
        setFilters(prev => ({ ...prev, assignedFrom: newValue }));
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Assigned From (User)"
          variant="outlined"
          InputLabelProps={{
            style: {
              color:mode==="dark"?"#fff":"#666",
              fontSize: '15px',
              fontWeight: 500,
            }
          }}
        />
      )}
      renderOption={(props, option, { selected }) => (
        <MenuItem {...props}>
          <Checkbox 
            checked={selected}
            sx={{
              color: '#666',
              '&.Mui-checked': {
                color: '#666',
              },
            }}
          />
          <ListItemText 
            primary={option?.name}
            secondary={option?.role}
          />
        </MenuItem>
      )}
      sx={{
        '.MuiOutlinedInput-root': {
          borderRadius: '10px',
          minHeight: '48px',
          paddingTop: '4px',
          paddingBottom: '4px',
          display: 'flex',
          alignItems: 'center',
          boxShadow: '0 1px solid #666 4px rgba(0,0,0,0.1)',
          transition: 'border-color 0.3s, box-shadow 0.3s',
          background:mode==="dark"?"#333":"#fff",

          '& fieldset': {
            border: mode==="dark"?"1px solid #666 solid #333":'1px solid #666 solid #ccc',
          },
          '&:hover fieldset': {
                border: "2px solid #102dff",
            boxShadow: '0 0 6px rgba(25, 118, 210, 0.4)',
          },
          '&.Mui-focused fieldset': {
            border: '2px solid #102dff',
            boxShadow: '0 0 8px rgba(25, 118, 210, 0.6)',
          },
        },
      }}
    />
  </FormControl> */}

                <FormControl fullWidth>
                  <Autocomplete
                    multiple
                    options={usersAuth}
                    value={assignedFromValue} // <-- 1. ربط قيمة المكون بالحالة
                    isOptionEqualToValue={(option, value) => option._id === value._id}
                    getOptionLabel={(option) => option.name}
                    filterOptions={(options, { inputValue }) =>
                      options.filter(
                        (option) =>
                          option?.name?.toLowerCase().includes(inputValue.toLowerCase()) ||
                          option?.role?.toLowerCase().includes(inputValue.toLowerCase()),
                      )
                    }
                    onChange={(event, newValue) => {
                      setAssignedFromValue(newValue); // <-- الخطوة 2: تحديث حالة الواجهة

                      setFilters((prev) => ({ ...prev, assignedFrom: newValue }));
                    }}
                    // 🔹 الحفاظ على البحث بعد الاختيار
                    inputValue={inputValueAssignedFrom}
                    onInputChange={(event, newInputValueassignedfrom, reason) => {
                      if (reason === 'reset') return;
                      setInputValueAssignedFrom(newInputValueassignedfrom);
                    }}
                    disableCloseOnSelect
                    disableListWrap
                    limitTags={100}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Assigned From (User)"
                        variant="outlined"
                        InputLabelProps={{
                          style: {
                            color: mode === 'dark' ? '#fff' : '#666',
                            fontSize: '15px',
                            fontWeight: 500,
                          },
                        }}
                      />
                    )}
                    renderOption={(props, option, { selected }) => (
                      <MenuItem {...props}>
                        <Checkbox
                          checked={selected}
                          sx={{
                            color: '#666',
                            '&.Mui-checked': {
                              color: '#666',
                            },
                          }}
                        />
                        <ListItemText
                          primary={option?.name}
                          secondary={option?.role}
                          secondaryTypographyProps={{
                            style: { fontSize: '0.75rem', color: '#666' },
                          }}
                        />
                      </MenuItem>
                    )}
                    renderTags={(value, getTagProps) => {
                      const allSelectedNames = value.map((option) => option.name).join(', ');
                      return (
                        <Tooltip
                          title={allSelectedNames || 'No users selected'}
                          arrow
                          placement="top"
                        >
                          <div
                            style={{
                              display: 'flex',
                              overflowX: 'auto',
                              whiteSpace: 'nowrap',
                              flexWrap: 'nowrap',
                              gap: '6px',
                              cursor: 'pointer',
                              alignItems: 'center',
                              scrollbarWidth: 'thin',
                              '&::-webkit-scrollbar': { height: '6px' },
                              '&::-webkit-scrollbar-thumb': {
                                backgroundColor: '#666',
                                borderRadius: '3px',
                              },
                              '&::-webkit-scrollbar-track': {
                                backgroundColor: '#f0f0f0',
                              },
                            }}
                          >
                            {value.map((option, index) => (
                              <Chip
                                key={option._id}
                                label={option.name}
                                size="small"
                                {...getTagProps({ index })}
                                sx={{
                                  borderRadius: '8px',
                                  backgroundColor: '#1976d2',
                                  color: '#fff',
                                  fontWeight: 500,
                                  '.MuiChip-deleteIcon': {
                                    color: '#fff',
                                  },
                                  '&:hover': {
                                    backgroundColor: '#115293',
                                  },
                                }}
                              />
                            ))}
                          </div>
                        </Tooltip>
                      );
                    }}
                    sx={{
                      '.MuiOutlinedInput-root': {
                        borderRadius: '10px',
                        minHeight: '48px !important',
                        paddingTop: '4px',
                        paddingBottom: '4px',
                        display: 'flex',
                        alignItems: 'center',
                        transition: 'border-color 0.3s, box-shadow 0.3s',
                        background: mode === 'dark' ? '#333' : '#fff',
                        color: mode === 'dark' ? '#fff' : '#666',
                        '& fieldset': {
                          border: mode === 'dark' ? '1px solid #666' : '1px solid #ccc',
                        },
                        '&:hover fieldset': {
                          border: '2px solid #102dff',
                          boxShadow: '0 0 6px rgba(25, 118, 210, 0.4)',
                        },
                        '&.Mui-focused fieldset': {
                          border: '2px solid #102dff',
                          boxShadow: '0 0 8px rgba(25, 118, 210, 0.6)',
                        },
                      },
                      '.MuiAutocomplete-inputRoot': {
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'nowrap !important',
                      },
                      '.MuiAutocomplete-input': {
                        width: '1px solid #666 !important',
                        minWidth: '1px solid #666 !important',
                        padding: '0 !important',
                        margin: '0 !important',
                        flex: '0 0 1px solid #666 !important',
                      },
                    }}
                  />
                </FormControl>
                {/* </div> */}

                {/* Assigned To Filter */}
                {/* <div className="filter-item"> */}
                {/* <FormControl fullWidth>
    <Autocomplete
      multiple
      options={salesarray} // استخدم مصفوفة المندوبين (salesarray)
       getOptionLabel={(option) => option.name}
     filterOptions={(options, { inputValue }) =>
  options.filter(option =>
    option?.name.toLowerCase().includes(inputValue.toLowerCase()) ||
    (option?.userlog?.role && option.userlog.role.toLowerCase().includes(inputValue.toLowerCase()))
  )
}
      onChange={(event, newValue) => {
        setFilters(prev => ({ ...prev, assignedTo: newValue }));
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Assigned To (Sales)"
          variant="outlined"
          InputLabelProps={{
            style: {
              color:mode==="dark"?"#fff":"#666",
              fontSize: '15px',
              fontWeight: 500,
            }
          }}
        />
      )}
      renderOption={(props, option, { selected }) => (
        <MenuItem {...props}>
          <Checkbox 
            checked={selected}
            sx={{
              color: '#666',
              '&.Mui-checked': {
                color: '#666',
              },
            }}
          />
          <ListItemText 
            primary={option.name}
            secondary={option?.userlog?.role}
          />
        </MenuItem>
      )}
      sx={{
        '.MuiOutlinedInput-root': {
          borderRadius: '10px',
          minHeight: '48px',
          paddingTop: '4px',
          paddingBottom: '4px',
          display: 'flex',
          alignItems: 'center',
          boxShadow: '0 1px solid #666 4px rgba(0,0,0,0.1)',
          transition: 'border-color 0.3s, box-shadow 0.3s',
          background:mode==="dark"?"#333":"#fff",

          '& fieldset': {
            border: mode==="dark"?"1px solid #666 solid #333":'1px solid #666 solid #ccc',
          },
          '&:hover fieldset': {
                border: "2px solid #102dff",
            boxShadow: '0 0 6px rgba(25, 118, 210, 0.4)',
          },
          '&.Mui-focused fieldset': {
            border: '2px solid #102dff',
            boxShadow: '0 0 8px rgba(25, 118, 210, 0.6)',
          },
        },
      }}
    />
  </FormControl> */}

                <FormControl fullWidth>
                  <Autocomplete
                    multiple
                    options={salesarray}
                    value={assignedToValue} // <-- 1. ربط قيمة المكون بالحالة
                    getOptionLabel={(option) => option.name}
                    isOptionEqualToValue={(option, value) => option._id === value._id}
                    filterOptions={(options, { inputValue }) =>
                      options.filter(
                        (option) =>
                          option?.name?.toLowerCase().includes(inputValue.toLowerCase()) ||
                          (option?.userlog?.role &&
                            option.userlog.role.toLowerCase().includes(inputValue.toLowerCase())),
                      )
                    }
                    // onChange={(event, newValue) => {
                    //   setFilters(prev => ({ ...prev, assignedTo: newValue }));
                    // }}
                    onChange={(event, newValue) => {
                      setAssignedToValue(newValue); // <-- 2. تحديث حالة الواجهة
                      setFilters((prev) => ({ ...prev, assignedTo: newValue })); // تحديث حالة الفلتر الرئيسية
                    }}
                    // 🔹 عشان القايمة ما تتقفلش بعد كل اختيار
                    disableCloseOnSelect
                    disableListWrap
                    limitTags={100}
                    // 🔹 للتحكم في قيمة البحث
                    inputValue={inputValueAssignedTo}
                    onInputChange={(event, newInputValueِAssignedTo, reason) => {
                      if (reason === 'reset') return;
                      setInputValueAssignedTo(newInputValueِAssignedTo);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Assigned To (Sales)"
                        variant="outlined"
                        InputLabelProps={{
                          style: {
                            color: mode === 'dark' ? '#fff' : '#666',
                            fontSize: '15px',
                            fontWeight: 500,
                          },
                        }}
                      />
                    )}
                    renderOption={(props, option, { selected }) => (
                      <MenuItem {...props}>
                        <Checkbox
                          checked={selected}
                          sx={{
                            color: '#666',
                            '&.Mui-checked': {
                              color: '#666',
                            },
                          }}
                        />
                        <ListItemText
                          primary={option.name}
                          secondary={option?.userlog?.role}
                          secondaryTypographyProps={{
                            style: { fontSize: '0.75rem', color: '#666' },
                          }}
                        />
                      </MenuItem>
                    )}
                    renderTags={(value, getTagProps) => {
                      const allSelectedNames = value.map((option) => option.name).join(', ');
                      return (
                        <Tooltip
                          title={allSelectedNames || 'No sales selected'}
                          arrow
                          placement="top"
                        >
                          <div
                            style={{
                              display: 'flex',
                              overflowX: 'auto',
                              whiteSpace: 'nowrap',
                              flexWrap: 'nowrap',
                              gap: '6px',
                              cursor: 'pointer',
                              alignItems: 'center',
                              scrollbarWidth: 'thin',
                              '&::-webkit-scrollbar': { height: '6px' },
                              '&::-webkit-scrollbar-thumb': {
                                backgroundColor: '#666',
                                borderRadius: '3px',
                              },
                              '&::-webkit-scrollbar-track': {
                                backgroundColor: '#f0f0f0',
                              },
                            }}
                          >
                            {value.map((option, index) => (
                              <Chip
                                key={option._id}
                                label={option.name}
                                size="small"
                                {...getTagProps({ index })}
                                sx={{
                                  borderRadius: '8px',
                                  backgroundColor: '#1976d2',
                                  color: '#fff',
                                  fontWeight: 500,
                                  '.MuiChip-deleteIcon': {
                                    color: '#fff',
                                  },
                                  '&:hover': {
                                    backgroundColor: '#115293',
                                  },
                                }}
                              />
                            ))}
                          </div>
                        </Tooltip>
                      );
                    }}
                    sx={{
                      '.MuiOutlinedInput-root': {
                        borderRadius: '10px',
                        minHeight: '48px !important',
                        paddingTop: '4px',
                        paddingBottom: '4px',
                        display: 'flex',
                        alignItems: 'center',
                        transition: 'border-color 0.3s, box-shadow 0.3s',
                        background: mode === 'dark' ? '#333' : '#fff',
                        color: mode === 'dark' ? '#fff' : '#666',
                        '& fieldset': {
                          border: mode === 'dark' ? '1px solid #666' : '1px solid #ccc',
                        },
                        '&:hover fieldset': {
                          border: '2px solid #102dff',
                          boxShadow: '0 0 6px rgba(25, 118, 210, 0.4)',
                        },
                        '&.Mui-focused fieldset': {
                          border: '2px solid #102dff',
                          boxShadow: '0 0 8px rgba(25, 118, 210, 0.6)',
                        },
                      },
                      '.MuiAutocomplete-inputRoot': {
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'nowrap !important',
                      },
                      '.MuiAutocomplete-input': {
                        width: '1px solid #666 !important',
                        minWidth: '1px solid #666 !important',
                        padding: '0 !important',
                        margin: '0 !important',
                        flex: '0 0 1px solid #666 !important',
                      },
                    }}
                  />
                </FormControl>
                {/* </div> */}

                {/* Country Code */}
                {/* <div className="filter-item "> */}
                {/* <div style={{ 
  backgroundColor: mode === "dark" ? "#252525" : "#fff",
  borderRadius: '10px',
  boxShadow: '0 1px solid #0F7687 4px rgba(0,0,0,0.1)',
  border: mode === "dark" ? '2px solid #444' : '2px solid #ccc',
  transition: 'border-color 0.3s, box-shadow 0.3s',
  '&:hover': {
    border: '2px solid #1976d2',
    boxShadow: '0 0 6px rgba(25, 118, 210, 0.4)',
  },
  '&:focus-within': {
    border: '2px solid #1976d2',
    boxShadow: '0 0 8px rgba(25, 118, 210, 0.6)',
  }
}}>
  <CountrySelect
    containerClassName="form-group"
    inputClassName=""
    onChange={handleCountryChange}
    placeHolder="Select Country"
    style={{
      color: mode === "dark" ? "#fff" : "#0F7687",
      width: '100%',
      padding: '12px 14px',
      borderRadius: 'inherit',
      backgroundColor: 'transparent',
      '& .country-select__control': {
        border: 'none',
        boxShadow: 'none',
        backgroundColor: 'transparent',
        minHeight: '48px',
      },
      '& .country-select__placeholder': {
        color: mode === "dark" ? "#aaa" : "#777",
      },
      '& .country-select__single-value': {
        color: 'inherit',
      },
      '& .country-select__indicator': {
        color: mode === "dark" ? "#aaa" : "#666",
        '&:hover': {
          color: mode === "dark" ? "#fff" : "#0F7687",
        }
      }
    }}
  /> */}

                {/* Country Filter */}
                {/* <FormControl
  variant="outlined"
  sx={{
    width: '100%',
    // minHeight: '40px',

    backgroundColor: mode === 'dark' ? '#2c2c2c' : '#fff',
    borderRadius: '12px',
    // boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
    border: mode === "dark" ? "1px solid #0F7687 solid #333" : "1px solid #0F7687 solid #ccc",
    '.MuiInputLabel-root': {
      color: mode === 'dark' ? '#fff' : '#0F7687',
    },
    '.MuiOutlinedInput-root': {
      borderRadius: '12px',
      backgroundColor: 'transparent',
      color: mode === 'dark' ? '#fff' : '#0F7687',
      // paddingTop: '4px',
      paddingBottom: '4px',
       minHeight: '10px',
       alignItems: 'center',


    },
    '.MuiOutlinedInput-notchedOutline': {
      borderColor: mode === 'dark' ? '#2c2c2c' : '#ccc',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: 'transparent',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#1976d2',
    },
  }}
>
  <Tooltip
    title={country ? country.label : 'No country selected'}
    arrow
    placement="top"
  >
    <Autocomplete
      id="country-select-filter"
      options={countries2}
      // autoHighlight
      value={country}
      onChange={(event, newValue) => {
        handleCountryChange(newValue);
      }}
      getOptionLabel={(option) => option.label}
      renderOption={(props, option) => (
        <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
          <img
            loading="lazy"
            width="20"
            src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
            srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
            alt=""
          />
          {option.label} ({option.code}) +{option.phone}
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Country"
          placeholder="Choose a country"
          InputLabelProps={{
            style: { color: mode === 'dark' ? '#fff' : '#0F7687', fontWeight: 'normal',textAlign:'center' },
          }}
          InputProps={{
            ...params.InputProps,
            style: { color: mode === 'dark' ? '#fff' : '#0F7687' },
          }}
          inputProps={{
            ...params.inputProps,
            autoComplete: 'new-password',
          }}
        />
      )}
    />
  </Tooltip>
</FormControl> */}

                <FormControl fullWidth>
                  <Autocomplete
                    id="country-select-filter"
                    options={countries2}
                    value={country}
                    onChange={(event, newValue) => {
                      handleCountryChange(newValue);
                    }}
                    getOptionLabel={(option) => option.label}
                    renderOption={(props, option) => (
                      <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
                        <img
                          loading="lazy"
                          width="20"
                          src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                          srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                          alt=""
                        />
                        {option.label} ({option.code}) +{option.phone}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Country"
                        placeholder="Choose a country"
                        variant="outlined"
                        InputLabelProps={{
                          style: {
                            color: mode === 'dark' ? '#fff' : '#666',
                            fontSize: '15px',
                            fontWeight: 500,
                          },
                        }}
                        InputProps={{
                          ...params.InputProps,
                          style: {
                            color: mode === 'dark' ? '#fff' : '#666',
                          },
                        }}
                        inputProps={{
                          ...params.inputProps,
                          autoComplete: 'new-password',
                        }}
                      />
                    )}
                    sx={{
                      '.MuiOutlinedInput-root': {
                        borderRadius: '10px',
                        minHeight: '48px',
                        paddingTop: '4px',
                        paddingBottom: '4px',
                        display: 'flex',
                        alignItems: 'center',
                        boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                        transition: 'border-color 0.3s, box-shadow 0.3s',
                        backgroundColor: mode === 'dark' ? '#333' : '#fff',
                        '& fieldset': {
                          border: mode === 'dark' ? '1px solid #333' : '1px solid #ccc',
                        },
                        '&:hover fieldset': {
                          border: '2px solid #102dff',
                          boxShadow: '0 0 6px rgba(25, 118, 210, 0.4)',
                        },
                        '&.Mui-focused fieldset': {
                          border: '2px solid #102dff',
                          boxShadow: '0 0 8px rgba(25, 118, 210, 0.6)',
                        },
                      },
                    }}
                  />
                </FormControl>

                {/* </div> */}

                {/* </div> */}
                {/* Apply Filter Button */}
                <div className="filter-item d-flex flex-wrap justify-content-center">
                  {/* <div
                  className="button-5 "
                  style={{
                    background: "#0F7687",
                    height: "40px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    width: "60%",
                    padding: "10px"
                  }}
                  // onClick={handleShowmoresearch}
                  >
                 <span style={{fontSize:'20px'}}> More Filter ....</span> <PersonSearchIcon />
                </div> */}
                </div>
                {/* </Row> */}
              </div>

              <Row className="d-flex justify-content-end align-items-center mt-3">
                {/* <button 
  onClick={resumeLoading}
  className="btn btn-primary"
>
  // {loading ? 'جاري التحميل...' : 'تحميل المزيد'}
</button> */}

                <div
                  className="filter-item button-5"
                  style={{
                    backgroundColor: '#f0e6ff', // لون بنفسجي فاتح
                    padding: '10px 20px',
                    margin: 8,
                    borderRadius: 12,
                    cursor: 'pointer',
                    color: '#5a0a96', // لون بنفسجي غامق
                    fontWeight: 'bold',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                    border: '2px solid #5a0a96',
                    boxShadow: '0px 2px 8px rgba(0,0,0,0.1)',
                  }}
                  onClick={applyLastFilter} // <--- ربط الدالة بالزر
                >
                  <FilterAltIcon /> Apply Last Filter
                </div>
                {/* Apply Filter Button */}
                <div
                  className="filter-item button-5"
                  style={{
                    backgroundColor: '#102dff',
                    padding: '10px 20px',
                    margin: 8,
                    borderRadius: 12,
                    cursor: 'pointer',
                    color: '#fff',
                    fontWeight: 'bold',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                    width: isSmallScreen ? '100%' : 'auto',
                    boxShadow: '0px 2px 8px rgba(0,0,0,0.1)',
                  }}
                  onClick={handlesearchsubmit}
                >
                  Apply Filter <SearchIcon />
                </div>

                {/* Reset Filters Button */}
                <div
                  className="filter-item button-5"
                  style={{
                    backgroundColor: '#f1f2f2',
                    padding: '10px 20px',
                    margin: 8,
                    borderRadius: 12,
                    cursor: 'pointer',
                    color: '#102dff',
                    fontWeight: 'bold',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                    border: '2px solid #102dff',
                    width: isSmallScreen ? '100%' : 'auto',
                    boxShadow: '0px 2px 8px rgba(0,0,0,0.1)',
                  }}
                  onClick={resetFilters}
                >
                  <ClearIcon />
                  Reset Filters
                </div>
              </Row>
              {/* <hr/> */}
            </div>
            {/* <Row className="d-flex justify-eontent-end ">
  <div
                  // className="w-50"
                  style={{
                    background: "#0F7687",
                    height: "40px",
                    // display: "flex",
                    alignItems: "center",
                    // justifyContent: "end",
                    cursor: "pointer",
                    // width: "50%",
                    padding: "10px",
                    borderRadius:'10px',
                    color:'white',
                    
                  }}
                  onClick={handlesearchsubmit}
                >


                 <span style={{fontSize:'15px'}}> Applay Filter </span> <FilterAltIcon />
                 </div>
</Row> */}
            {/* ================================================================================= */}
            {/* more filtiration */}
            {/* <div style={{border:'2px solid red',width:'100%'}}> */}
            {/* <Accordion defaultActiveKey={['1']}  className="plain-accordion"> */}
            {/* <Accordion.Item eventKey="0">
    <Accordion.Header className="accordion-header-right" >
      <h4 >More Filter...</h4>
    </Accordion.Header>
    <Accordion.Body style={{ margin: '0', padding: '10px 0' }}>
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          gap: '20px',
          justifyContent: 'flex-start',
          width: '100%',
        }}
      >
        <span style={{ fontWeight: 'bold', whiteSpace: 'nowrap' }}>
          Filter With Old Stage between 2 Dates From And To
        </span>

        <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <div style={{ fontWeight: 'bold' }}>From</div>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Select From Date"
              value={datefromstage ? dayjs(datefromstage) : null}
              onChange={handleDatefromChangestage}
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  sx={{
                    minWidth: 200,
                    ".MuiOutlinedInput-root": {
                      borderRadius: "12px",
                      backgroundColor: "#fff",
                      "& fieldset": {
                        border: "2px solid #ccc",
                      },
                      "&:hover fieldset": {
                        border: "2px solid #1976d2",
                      },
                      "&.Mui-focused fieldset": {
                        border: "2px solid #1976d2",
                      },
                    },
                    ".MuiInputLabel-root": {
                      color: "#555",
                      fontSize: "14px",
                    },
                  }}
                />
              )}
            />
          </LocalizationProvider>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <div style={{ fontWeight: 'bold' }}>To</div>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Select To Date"
              value={datetostage ? dayjs(datetostage) : null}
              onChange={handleDatetoChangestage}
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  sx={{
                    minWidth: 200,
                    ".MuiOutlinedInput-root": {
                      borderRadius: "12px",
                      backgroundColor: "#fff",
                      "& fieldset": {
                        border: "2px solid #ccc",
                      },
                      "&:hover fieldset": {
                        border: "2px solid #1976d2",
                      },
                      "&.Mui-focused fieldset": {
                        border: "2px solid #1976d2",
                      },
                    },
                    ".MuiInputLabel-root": {
                      color: "#555",
                      fontSize: "14px",
                    },
                  }}
                />
              )}
            />
          </LocalizationProvider>
        </Box>

      <Autocomplete
  options={resallstages?.data || []}
  getOptionLabel={(option) => option.name}
  onChange={(event, newValue) => setSelectedStage(newValue)}
    renderInput={(params) => (
      <TextField
        {...params}
        label="Filter by Old Stage"
        variant="outlined"
        style={{ minWidth: '200px' ,maxwidth:'200px'}}
      />
    
  )}
/>


{/* sales */}
            {/* <Autocomplete
    options={salesarray}
    getOptionLabel={(option) => option.name}
    onChange={(event, newValue) => setSelectedSalesId(newValue?._id)}
    renderInput={(params) => (
      <TextField
        {...params}
        label="Filter by Sales"
        variant="outlined"
        style={{ minWidth: '200px' ,maxwidth:'200px'}}
      />
    )}
  />
      </div> */}
            {/* <Button 
  variant="contained" 
  onClick={fetchLeadsByStage}
  style={{
    backgroundColor: '#0F7687',
    color: 'white',
    margin: '10px 0'
  }}
  disabled={!datefromstage || !datetostage || !selectedStage}
>
  Apply Filter <SearchIcon/>
</Button>

<hr/>
    </Accordion.Body> */}
            {/* </Accordion.Item> */}
            {/* </Accordion> */}
            {/* </div> */}
            {/* ================================================================================================ */}
            {/* <div style={{
        transition: 'all 0.3s ease',
        maxHeight: isOpenimportandexport ? '500px' : '0',
        overflow: 'hidden',
        background: '#f4f4f4',
        padding: isOpenimportandexport ? '15px' : '0 15px',
        border: isOpenimportandexport ? '1px solid #ccc' : 'none',
        marginTop: '10px',
        borderRadius:'10px'
      }}>
   {userlogin && userlogin.data && userlogin.data.role !== "Sales" ? (
  <div className='my-3 d-flex justify-content-center w-100' >
                
                <div style={{ border: 'none',background:mode==="dark"?"#0F7687":"#fff",color:mode==="dark"?"#ccc":"#102dff" }} className=' btn btn-info icon-plus  leedimportandexportandadd2 ' onClick={exportToExcel}>
                  <SystemUpdateAltIcon/> Export Leads Data To Excel Sheet
                </div>
                
                <div style={{ border: 'none',background:mode==="dark"?"#0F7687":"#fff",color:mode==="dark"?"#ccc":"#102dff" }} className=' btn btn-info icon-plus  leedimportandexportandadd2 mx-md-2' onClick={handleShow}>
                  <ImportExportIcon/> Import Leads Data From Excel Sheet
                </div>
                

                <div style={{ border: 'none',background:mode==="dark"?"#0F7687":"#fff",color:mode==="dark"?"#ccc":"#102dff" }} className=' btn btn-info icon-plus  leedimportandexportandadd2' 
    
    onClick={exportToExcelWithLastComment}
    disabled={!allleads?.length}
  >
    <SystemUpdateAltIcon /> Export Leads To Excell with Last Comments
                </div>


              </div>
            ) : null}
              </div> */}
            {/* Display filtered results count */}
            <div
              style={{
                margin: '10px 0',
                fontWeight: 'bold',
                position: 'relative',
                minHeight: '0px',
              }}
              className="d-flex align-items-center"
            >
              <div className="d-flex justify-content-between w-100">
                <div style={{ color: '#102dff ' }}>
                  Showing {indexOfFirstRow + 1}-{Math.min(indexOfLastRow, filteredUsers?.length)} of{' '}
                  {filteredUsers?.length} results
                </div>
                <Dropdown onSelect={(eventKey) => setSortOption(eventKey)} className="mx-2">
                  <Dropdown.Toggle
                    style={{ background: '#102dff', border: 'none', color: 'white' }}
                    id="dropdown-sort"
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3 7H21M3 12H15M3 17H9"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span className="ms-2">Sort By</span>
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item eventKey="today">Today's Leads</Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item eventKey="newestToOldestCreation">
                      Creation Date (Newest First )
                    </Dropdown.Item>
                    <Dropdown.Item eventKey="oldestToNewestCreation">
                      Creation Date (Oldest First)
                    </Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item eventKey="newestToOldestStage">
                      Stage Date (Newest First)
                    </Dropdown.Item>
                    <Dropdown.Item eventKey="oldestToNewestStage">
                      Stage Date (Oldest First)
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>

              {/* <div style={{
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)'
  }}>
    <NotificationBell userId={userlogin?.data?._id} />
  </div> */}
            </div>
            {/* زر التحكم في الأعمدة */}
            {/* <div className="d-flex flex-wrap my-3">
        {columns.map(col => (
          <Button 
            key={col.key}
            variant={col.visible ? "primary" : "outline-secondary"}
            size="sm"
            className="m-1"
            onClick={() => toggleColumn(col.key)}
          >
            {col.label}
          </Button>
        ))}
              </div> */}
            {/* <div className="d-flex flex-wrap my-3">
  {columns.map(col => (
    <label
      key={col.key}
      className="d-flex align-items-center m-1"
      style={{
        backgroundColor: col.visible ? '#0F7687' : '#e0e0e0',
        color: col.visible ? 'white' : 'black',
        borderRadius: '4px',
        padding: '5px 10px',
        cursor: 'pointer',
        fontSize: '14px',
      }}
    >
      <input
        type="checkbox"
        checked={col.visible}
        onChange={() => toggleColumn(col.key)}
        style={{ marginRight: '6px', accentColor: '#0F7687' }}
      />
      {col.label}
    </label>
  ))}
</div> */}
            <Offcanvas
              placement="end"
              name="end"
              show={showtablesetting}
              onHide={handleClosetablesetting}
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title>Offcanvas</Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <label>Table Column</label>

                <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '15px' }}>
                  <button
                    onClick={() => {
                      const allSelected = columns.every((col) => col.visible);
                      const updatedColumns = columns.map((col) => ({
                        ...col,
                        visible: !allSelected,
                      }));
                      setColumns(updatedColumns);
                    }}
                    style={{
                      width: '100%',
                      backgroundColor: '#f1f2f2',
                      color: '#102dff',
                      border: '1px solid #ccc',
                      borderRadius: '10px',
                      padding: '10px 10px',
                      fontSize: '14px',
                      cursor: 'pointer',
                      margin: '4px 0',
                      userSelect: 'none',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    Select All Columns
                  </button>

                  {columns.map((col, index) => (
                    <label
                      key={col.key}
                      draggable
                      onDragStart={(e) => e.dataTransfer.setData('dragIndex', index)}
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={(e) => {
                        const dragIndex = parseInt(e.dataTransfer.getData('dragIndex'));
                        const dropIndex = index;
                        if (dragIndex === dropIndex) return;
                        const newCols = [...columns];
                        const draggedCol = newCols.splice(dragIndex, 1)[0];
                        newCols.splice(dropIndex, 0, draggedCol);
                        setColumns(newCols);
                      }}
                      className="d-flex align-items-center"
                      style={{
                        width: '100%',
                        backgroundColor: col.visible ? '#f1f2f2' : '#e0e0e0',
                        color: col.visible ? '#102dff' : 'black',
                        border: col.visible ? '1px solid #ccc' : 'none',
                        borderRadius: '10px',
                        padding: '10px 10px',
                        cursor: 'move',
                        fontSize: '14px',
                        userSelect: 'none',
                        margin: '4px 0',
                      }}
                    >
                      <DragIndicatorOutlinedIcon style={{ color: '#666' }} />

                      <input
                        type="checkbox"
                        checked={col.visible}
                        onChange={() => {
                          const newCols = [...columns];
                          const targetIndex = newCols.findIndex((c) => c.key === col.key);
                          newCols[targetIndex].visible = !newCols[targetIndex].visible;
                          setColumns(newCols);
                        }}
                        style={{ marginRight: '6px', accentColor: '#102dff' }}
                      />
                      {col.label}
                    </label>
                  ))}
                </div>

                <hr />
                <div style={{ marginTop: '20px' }}></div>

                <label>Export And Import</label>
                <div
                  style={{
                    width: '100%',
                    border: 'none',
                    background: mode === 'dark' ? '#666' : '#fff',
                    color: mode === 'dark' ? '#ccc' : '#102dff',
                    padding: '10px',
                  }}
                  className=" btn btn-info icon-plus  leedimportandexportandadd2 my-2 "
                  onClick={exportFilteredToExcel}
                >
                  <SystemUpdateAltIcon /> Export Leads Data To Excel Sheet
                </div>

                <div
                  style={{
                    width: '100%',
                    border: 'none',
                    background: mode === 'dark' ? '#666' : '#fff',
                    color: mode === 'dark' ? '#ccc' : '#102dff',
                    padding: '10px',
                  }}
                  className=" btn btn-info icon-plus  leedimportandexportandadd2  my-2"
                  onClick={handleShow}
                >
                  <ImportExportIcon /> Import Leads Data From Excel Sheet
                </div>

                <div
                  style={{
                    width: '100%',
                    border: 'none',
                    background: mode === 'dark' ? '#666' : '#fff',
                    color: mode === 'dark' ? '#ccc' : '#102dff',
                  }}
                  className=" btn btn-info icon-plus  leedimportandexportandadd2"
                  onClick={exportToExcelWithLastComment}
                  disabled={!allleads?.length}
                >
                  <SystemUpdateAltIcon /> Export Leads To Excell with Last Comments
                </div>

                <div
                  style={{
                    width: '100%',
                    border: 'none',
                    background: mode === 'dark' ? '#666' : '#fff',
                    color: mode === 'dark' ? '#ccc' : '#102dff',
                  }}
                  className=" btn btn-info icon-plus my-2 leedimportandexportandadd2"
                  onClick={exportFilteredLeadsWithAllComments}
                  disabled={!allleads?.length}
                >
                  <SystemUpdateAltIcon /> Export Leads To Excell with All Comments
                </div>
              </Offcanvas.Body>
            </Offcanvas>
            {/* Table */}
            <div
              style={{
                //  overflowX: 'auto',
                width: '100%',
                marginTop: '20px',
                borderRadius: '15px',
                //  boxShadow: mode === "dark"
                //    ? '0 4px 20px rgba(144, 202, 249, 0.15)'
                //    : '0 4px 20px rgba(15, 118, 135, 0.15)'
              }}
            >
              <Table
                size="sm"
                // bordered
                // hover
                responsive
                style={{
                  minWidth: isExtraSmallScreen ? '1000px' : '100%',
                  textAlign: 'center',
                  color: mode === 'dark' ? '#90caf9' : '#666',
                  backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
                  borderCollapse: 'separate',
                  borderSpacing: '0',
                  borderRadius: '15px',
                  overflow: 'hidden',
                  //             boxShadow: mode === "dark"
                  // ? '0 4px 20px rgba(144, 202, 249, 0.15)'
                  // : '0 4px 20px rgba(15, 118, 135, 0.15)'
                  //  borderBottom:mode==="dark"?'2px solid #0F7687':"2px solid #0F7687",
                }}
                className={`tablee ${mode === 'dark' ? 'table-dark' : 'table-light'}`}
              >
                <thead
                  style={{
                    background:
                      mode === 'dark'
                        ? 'linear-gradient(to right, #1a1a1a, #2a2a2a)'
                        : 'linear-gradient(to right, #fff, #fff)',
                    color: '#666',
                    position: 'sticky',
                    top: 0,
                    zIndex: 10,
                    // boxShadow: "0 2px 15px rgba(0,0,0,0.2)",
                    borderBottom: mode === 'dark' ? '2px solid #90caf9' : '2px solid #666',
                  }}
                >
                  <tr style={{ textAlign: 'left', verticalAlign: 'left' }}>
                    {columns
                      .filter((col) => col.visible)
                      .map((col, index) => (
                        <th
                          key={col.key}
                          draggable
                          onDragStart={(e) => onDragStart(e, index)}
                          onDragOver={onDragOver}
                          onDrop={(e) => onDrop(e, index)}
                          style={{
                            position: 'relative',
                            color: '#666',
                            minWidth: `${col.width}px`,
                            maxWidth: `${col.width}px`,
                            whiteSpace: 'nowrap',
                            cursor: 'grab',
                            userSelect: 'none',
                          }}
                        >
                          {col.key === 'select' ? (
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                              <Checkbox
                                checked={areAllCurrentRowsSelected}
                                // onClick={handleClick}
                                indeterminate={
                                  selectedLeads.some((id) => currentRowsIds.includes(id)) &&
                                  !areAllCurrentRowsSelected
                                }
                                onChange={handleSelectAll}
                                sx={{
                                  color: '#666',
                                  '&.Mui-checked': { color: '#666' },
                                  '&.MuiCheckbox-indeterminate': { color: '#666' },
                                }}
                              />
                            </div>
                          ) : (
                            col.label
                          )}

                          {/* Resizer */}
                          <div
                            onMouseDown={(e) => startResizing(e, index)}
                            style={{
                              position: 'absolute',
                              right: 0,
                              top: 0,
                              height: '100%',
                              width: '5px',
                              cursor: 'col-resize',
                              userSelect: 'none',
                            }}
                          />
                        </th>
                      ))}
                  </tr>
                </thead>
                <tbody
                  style={{
                    backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
                    color: mode === 'dark' ? '#90caf9' : '#666',
                  }}
                >
                  {loading ? (
                    <tr>
                      <td colSpan={columns.filter((c) => c.visible).length}>
                        <Spinner animation="border" variant="" style={{ color: '#102dff' }} />
                      </td>
                    </tr>
                  ) : currentRows?.length > 0 ? (
                    currentRows.map((user, index) => (
                      <tr
                        key={index}
                        onMouseEnter={() => getallactiondata(user._id)}
                        style={{
                          cursor: 'pointer',
                          textAlign: 'center',
                          color: mode === 'dark' ? '#90caf9' : '#666',
                          backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
                        }}
                      >
                        {columns
                          .filter((col) => col.visible)
                          .map((col, colIndex) => {
                            // هنا نستخدم switch case لتحديد محتوى كل خلية بناءً على مفتاح العمود
                            switch (col.key) {
                              case 'select':
                                return (
                                  //                                 <td key={col.key} style={{ width: `${col.width}px` }}>
                                  //                                     {userlogin && userlogin.data && userlogin.data.role !== "Sales" && (
                                  //                                         <label style={{ cursor: "pointer", display: "inline-block" }}>
                                  //                                             <input
                                  //                                                 type="checkbox"
                                  //                                                 checked={selectedLeads.includes(user._id)}
                                  // onChange={() => handleLeadSelection(
                                  //   user._id,
                                  //   user.stage?.name,
                                  //   user.sales?.name
                                  // )}                                                onClick={handleClick}
                                  //                                                 style={{ position: "absolute",border:"2pd solid #102dff", background: 'transparent', opacity: 0, pointerEvents: "none" }}
                                  //                                             />
                                  //                                             <span style={{ border:"2px solid #102dff",width: "40px", height: "40px", borderRadius: "6px", display: "inline-flex", alignItems: "center", justifyContent: "center", transition: "all 0.2s", boxShadow: selectedLeads.includes(user._id) ? "0 0 6px rgba(25, 118, 210, 0.5)" : "0 0 2px rgba(0,0,0,0.1)", backgroundColor: selectedLeads.includes(user._id) ? "#102dff" : "#fff", color: "#fff" }}>
                                  //                                                 {selectedLeads.includes(user._id) && (<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg> )}
                                  //                                             </span>
                                  //                                         </label>
                                  //                                     )}
                                  //                                 </td>
                                  <td key={col.key} style={{ width: `${col.width}px` }}>
                                    {userlogin &&
                                      userlogin.data &&
                                      userlogin.data.role !== 'Sales' && (
                                        <input
                                          type="checkbox"
                                          //  onClick={handleClick}
                                          checked={selectedLeads.includes(user._id)}
                                          onChange={() =>
                                            handleLeadSelection(
                                              user._id,
                                              user.stage?.name,
                                              user.sales?.name,
                                            )
                                          }
                                          style={{
                                            width: '20px',
                                            height: '20px',
                                            cursor: 'pointer',
                                            accentColor: '#102dff',
                                            border: '2px solid #ddd',
                                            borderRadius: '4px',
                                          }}
                                        />
                                      )}
                                  </td>
                                );
                              case 'name':
                                return (
                                  <td
                                    key={col.key}
                                    style={{
                                      padding: '0',
                                      textAlign: 'left',
                                      width: `${col.width}px`,
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: 'flex',
                                        textAlign: 'left',
                                        alignItems: 'left',
                                        justifyContent: 'left',
                                        gap: '4px',
                                      }}
                                    >
                                      <div style={{ textAlign: 'left' }}>
                                        {' '}
                                        {userlogin &&
                                        userlogin.data &&
                                        userlogin.data.opencomments === false ? (
                                          <ShowAllCommentsForoneuser
                                            user={user}
                                            leadid={user._id}
                                          />
                                        ) : (
                                          <ShowClientsActions user={user} leadid={user._id} />
                                        )}
                                      </div>
                                    </div>
                                  </td>
                                );
                              case 'duplicate':
                                return (
                                  <td
                                    key={col.key}
                                    style={{ textAlign: 'left', width: `${col.width}px` }}
                                  >
                                    <Link
                                      to={`/LeadDuplication/${user._id}`}
                                      style={{
                                        textAlign: 'left',
                                        color: '#0f7687',
                                        textDecoration: 'none',
                                        '&:hover': { textDecoration: 'underline' },
                                      }}
                                    >
                                      <div style={{ textAlign: 'left' }}>
                                        {' '}
                                        {user.totalSubmissions || (
                                          <Skeleton animation="wave" width={40} />
                                        )}
                                      </div>
                                    </Link>
                                  </td>
                                );
                              case 'phone':
                                return (
                                  <td key={col.key} style={{ width: `250px` }}>
                                    <div
                                      style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '4px',
                                        alignItems: 'left',
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          gap: '4px',
                                        }}
                                      >
                                        <Tooltip title={user.phone}>
                                          <span
                                            style={{
                                              backgroundColor: 'transparent',
                                              color: mode === 'dark' ? '#fff' : '#000',
                                              display: 'inline-block',
                                              maxWidth: '120px',
                                              whiteSpace: 'nowrap',
                                              overflow: 'hidden',
                                              textOverflow: 'ellipsis',
                                              cursor: 'default',
                                            }}
                                            onMouseEnter={() => setShowFullNumber(true)}
                                            onMouseLeave={() => setShowFullNumber(false)}
                                          >
                                            {showFullNumber
                                              ? user.phone
                                              : `${user?.phone?.slice(0, 3)}${'*'.repeat(user?.phone?.length - 3 || 0)}`}
                                          </span>
                                        </Tooltip>
                                        <div style={{ fontSize: '12px', textAlign: 'left' }}>
                                          {getCountryFromPhone(`+${user.phone}`)}
                                        </div>
                                      </div>
                                      <div
                                        style={{
                                          display: 'flex',
                                          gap: '4px',
                                          justifyContent: 'left',
                                        }}
                                      >
                                        <Tooltip title="Phone Call">
                                          <IconButton
                                            size="small"
                                            onClick={() => window.open(`tel:${user.phone}`)}
                                            style={{
                                              color: mode === 'dark' ? '#90caf9' : '#0F7687',
                                              padding: '4px',
                                            }}
                                          >
                                            <LocalPhoneIcon fontSize="small" />
                                          </IconButton>
                                        </Tooltip>
                                        <Tooltip title="WhatsApp">
                                          {/* <IconButton size="small" onClick={() => window.open(`https://wa.me/${user.phone}`, '_blank' )} style={{ color: '#666', padding: '4px' }}>
                                                    <WhatsAppIcon fontSize="small" />
                                                </IconButton> */}

                                          <IconButton
                                            size="small"
                                            onClick={() => {
                                              // const phone = user?.whatsappnumber || user?.phone;
                                              const phone = user?.phone || user?.whatsappnumber;

                                              if (phone) {
                                                window.open(`https://wa.me/${phone}`, '_blank');
                                              } else {
                                                alert('No phone number available');
                                              }
                                            }}
                                            style={{ color: '#666', padding: '4px' }}
                                          >
                                            <WhatsAppIcon />
                                          </IconButton>
                                        </Tooltip>
                                      </div>
                                    </div>
                                  </td>
                                );
                              case 'project':
                                return (
                                  <td
                                    key={col.key}
                                    style={{
                                      verticalAlign: 'left',
                                      textAlign: 'left',
                                      width: `${col.width}px`,
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                    }}
                                  >
                                    <div style={{ textAlign: 'left' }}>{user.project?.name}</div>
                                  </td>
                                );
                              case 'lastComment':
                                return (
                                  <td
                                    key={col.key}
                                    style={{ textAlign: 'left', width: `${col.width}px` }}
                                  >
                                    <Tooltip
                                      title={
                                        hoveredLeadId === user._id ? (
                                          loadingComments ? (
                                            <div
                                              style={{
                                                padding: '10px 16px',
                                                background: 'rgba(97, 97, 97, 0.9)',
                                                color: '#fff',
                                                borderRadius: '8px',
                                                fontSize: '13px',
                                              }}
                                            >
                                              Waiting...
                                            </div>
                                          ) : comments.length === 0 ||
                                            !comments.some((item) => item?.Comments?.[0]) ? (
                                            <div
                                              style={{
                                                padding: '10px 16px',
                                                background: 'rgba(97, 97, 97, 0.9)',
                                                color: '#fff',
                                                borderRadius: '8px',
                                                fontSize: '13px',
                                              }}
                                            >
                                              No Comments
                                            </div>
                                          ) : (
                                            <div
                                              style={{
                                                width: '500px',
                                                maxWidth: 'unset',
                                                overflow: 'visible',
                                                padding: 10,
                                                background: '#fff',
                                                borderRadius: 12,
                                                color: '#333',
                                                fontSize: 13,
                                                lineHeight: 1.4,
                                              }}
                                            >
                                              {comments.map((item) => {
                                                const comment = item?.Comments?.[0];
                                                if (!comment) return null;
                                                return (
                                                  <div
                                                    key={comment._id}
                                                    style={{ marginBottom: 10 }}
                                                  >
                                                    <div
                                                      style={{
                                                        fontWeight: 'bold',
                                                        fontSize: 15,
                                                        marginBottom: 2,
                                                      }}
                                                    >
                                                      {comment.sales?.name || 'No Name'}
                                                    </div>
                                                    <div
                                                      style={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        fontSize: 11,
                                                        color: '#666',
                                                        borderBottom: '1px solid #ccc',
                                                        paddingBottom: 4,
                                                        marginBottom: 6,
                                                      }}
                                                    >
                                                      <span>
                                                        Action At |{' '}
                                                        {comment.stageDate
                                                          ? new Date(
                                                              comment.stageDate,
                                                            ).toLocaleString()
                                                          : 'No Date'}
                                                      </span>
                                                      <span>
                                                        Stage | {comment.stage?.name || 'No Stage'}
                                                      </span>
                                                    </div>
                                                    <div style={{ marginBottom: 6 }}>
                                                      <span
                                                        style={{
                                                          fontWeight: 'bold',
                                                          color: '#102dff',
                                                        }}
                                                      >
                                                        Comment
                                                      </span>
                                                      <p style={{ margin: 0 }}>
                                                        {comment.firstcomment?.text || 'Not Found'}
                                                      </p>
                                                    </div>
                                                    <div>
                                                      <span
                                                        style={{
                                                          fontWeight: 'bold',
                                                          color: '#102dff',
                                                        }}
                                                      >
                                                        Action (Plan)
                                                      </span>
                                                      <p style={{ margin: 0 }}>
                                                        {comment.secondcomment?.text || 'Not Found'}
                                                      </p>
                                                    </div>
                                                  </div>
                                                );
                                              })}
                                            </div>
                                          )
                                        ) : null
                                      }
                                      arrow
                                      placement="right"
                                      componentsProps={{
                                        tooltip: {
                                          sx: {
                                            backgroundColor: 'transparent',
                                            padding: 0,
                                            m: 0,
                                            boxShadow: 'none',
                                            border: 'none',
                                            overflow: 'visible',
                                          },
                                        },
                                      }}
                                    >
                                      <div style={{ textAlign: 'left' }}>
                                        {' '}
                                        <ChatBubbleOutlineIcon
                                          style={{ color: '#666', cursor: 'pointer' }}
                                        />
                                      </div>
                                    </Tooltip>
                                  </td>
                                );
                              case 'sales':
                                return (
                                  <td
                                    key={col.key}
                                    style={{
                                      minWidth: '180px',
                                      width: `${col.width}px`,
                                      ...(user.assign
                                        ? {
                                            color: '#333',
                                            backgroundColor: '#E7EBFF',
                                            borderRadius: '12px',
                                            padding: '10px',
                                            verticalAlign: 'middle',
                                          }
                                        : {}),
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                      }}
                                    >
                                      <span>
                                        {user.sales?.name || <Skeleton animation="wave" />}
                                      </span>
                                      {user?.sales?.userlog?.phone ? (
                                        <a
                                          href={`https://wa.me/${user.sales.userlog.phone.replace(/\D/g, '')}`}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          style={{ color: '#25D366', fontSize: '1.5rem' }}
                                          title={`Contact on WhatsApp: ${user.sales.userlog.phone}`}
                                        >
                                          <FaWhatsapp
                                            style={{ color: user.assign ? '#666' : '#0F7687' }}
                                          />
                                        </a>
                                      ) : (
                                        <Skeleton animation="wave" />
                                      )}
                                    </div>
                                    <div
                                      style={{
                                        marginTop: '5px',
                                        fontSize: '0.7rem',
                                        textAlign: 'left',
                                      }}
                                    >
                                      {/* {user?.lastdateassign ? (<>{moment(user.lastdateassign).format('D / M / YYYY')}{'\u00A0\u00A0'}{moment(user.lastdateassign).format('h : mm A')}</>) : (<Skeleton animation="wave" />)} */}
                                      {/* {moment(user.lastdateassign).isBefore(moment()) ? (<CloseIcon style={{ fontSize: '14px' }} />) : (<CheckIcon style={{ fontSize: '14px' }} />)} */}
                                      {moment(user.lastdateassign)
                                        .tz(moment.tz.guess())
                                        .format('DD/MM/YYYY h:mm A')}
                                    </div>
                                  </td>
                                );
                              case 'channel':
                                return (
                                  <td
                                    key={col.key}
                                    style={{
                                      textAlign: 'left',
                                      width: `${col.width}px`,
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                    }}
                                  >
                                    <div style={{ textAlign: 'left' }}>{user.chanel?.name}</div>
                                  </td>
                                );
                              case 'developer':
                                return (
                                  <td
                                    key={col.key}
                                    style={{
                                      textAlign: 'left',
                                      width: `${col.width}px`,
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                    }}
                                  >
                                    <div style={{ textAlign: 'left' }}>
                                      {user.project?.developer?.name}
                                    </div>
                                  </td>
                                );
                              case 'campaign':
                                return (
                                  <td
                                    key={col.key}
                                    style={{
                                      textAlign: 'left',
                                      width: `${col.width}px`,
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                    }}
                                  >
                                    <div style={{ textAlign: 'left' }}>
                                      {user.campaign?.CampainName}
                                    </div>
                                  </td>
                                );
                              case 'stage':
                                return (
                                  <td
                                    key={col.key}
                                    style={{ width: `${col.width}px`, verticalAlign: 'left' }}
                                  >
                                    <div
                                      style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'left',
                                        gap: '4px',
                                      }}
                                    >
                                      {user.stage?.name && (
                                        <div
                                          style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'left',
                                            gap: '5px',
                                            fontSize: '13px',
                                            fontWeight: '500',
                                            color: '#666',
                                            maxWidth: '200px',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                          }}
                                        >
                                          {user.stage.name === 'Done Deal' ? (
                                            <span style={{ fontSize: '18px' }}>🎉</span>
                                          ) : user.stage.name === 'Pending' ? (
                                            <SevereColdIcon
                                              style={{ color: '#9c27b0', fontSize: '18px' }}
                                            />
                                          ) : user.stage.name === 'Fresh' ? (
                                            <CheckIcon
                                              style={{ fontSize: '18px', color: '#4caf50' }}
                                            />
                                          ) : user.stage.name === 'Not Interested' ? (
                                            <div
                                              style={{
                                                fontSize: '18px',
                                                color: '#333',
                                                borderRadius: '50%',
                                                width: '20px',
                                                height: '20px',
                                                backgroundColor: '#333',
                                              }}
                                            >
                                              -
                                            </div>
                                          ) : user.stage.name === 'EOI' ? (
                                            <EditNoteIcon
                                              style={{ color: '#9c27b0', fontSize: '18px' }}
                                            />
                                          ) : user.stage.name === 'Reservation' ? (
                                            <AssignmentTurnedInIcon
                                              style={{ color: '#9c27b0', fontSize: '18px' }}
                                            />
                                          ) : user.stage.name === 'Transfer' ? (
                                            <TransferWithinAStationIcon
                                              style={{ color: 'red', fontSize: '18px' }}
                                            />
                                          ) : (
                                            <div
                                              style={{
                                                backgroundColor: moment(
                                                  user.stagedateupdated,
                                                ).isBefore(moment())
                                                  ? '#CC5500'
                                                  : 'royalblue',
                                                borderRadius: '50%',
                                                width: '20px',
                                                height: '20px',
                                                display: 'flex',
                                                alignItems: 'left',
                                                justifyContent: 'left',
                                                color: '#fff',
                                              }}
                                            >
                                              {moment(user.stagedateupdated).isBefore(moment()) ? (
                                                <div style={{ fontSize: '14px' }} />
                                              ) : (
                                                <div style={{ fontSize: '14px' }} />
                                              )}
                                            </div>
                                          )}
                                          <span
                                            style={{ color: mode === 'dark' ? '#fff' : '#666' }}
                                          >
                                            {user?.stage?.name}
                                          </span>
                                        </div>
                                      )}
                                      {user.stagedateupdated && (
                                        <div
                                          style={{
                                            textAlign: 'left',
                                            fontSize: isSmallScreen ? '10px' : '11px',
                                            color: '#666',
                                          }}
                                        >
                                          {moment(user.stagedateupdated).format(
                                            isSmallScreen ? 'DD/MM' : 'DD/MM/YYYY h:mm A',
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  </td>
                                );
                              case 'creationDate':
                                return (
                                  <td
                                    key={col.key}
                                    style={{
                                      textAlign: 'left',
                                      width: `${col.width}px`,
                                      fontSize: '14px',
                                      whiteSpace: 'nowrap',
                                    }}
                                  >
                                    <div style={{ textAlign: 'left' }}>
                                      {user
                                        ? moment(user.date)
                                            .tz('Asia/Dubai')
                                            .format('DD/MM/YYYY h:mm A')
                                        : null}
                                    </div>
                                  </td>
                                );
                              case 'addedBy':
                                return (
                                  <td
                                    key={col.key}
                                    style={{
                                      textAlign: 'left',
                                      width: `${col.width}px`,
                                      lineHeight: '1.4',
                                    }}
                                  >
                                    <div style={{ textAlign: 'left' }}>
                                      <div>
                                        <strong>User:</strong> {user.addby?.name}
                                      </div>
                                      <div>
                                        <strong>Role:</strong> {user.addby?.role}
                                      </div>
                                    </div>
                                  </td>
                                );
                              case 'actions':
                                return (
                                  <td
                                    key={col.key}
                                    style={{
                                      textAlign: 'left',
                                      width: `${col.width}px`,
                                      height: '100%',
                                      padding: '8px',
                                    }}
                                  >
                                    <ClientTablee user={user} allusers={fetchData} />
                                  </td>
                                );
                              default:
                                return null; // لا تعرض أي شيء إذا كان العمود غير معروف
                            }
                          })}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan={columns.filter((c) => c.visible).length}
                        style={{ textAlign: 'center', paddingTop: '20px', color: '#0F7687' }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <span style={{ color: '#666', fontSize: '20px', marginBottom: '10px' }}>
                            No Data Available
                            <br />
                            <svg
                              width="701"
                              height="536"
                              viewBox="0 0 701 536"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M350.5 536C543.932 536 700.74 445.468 700.74 333.791C700.74 222.114 543.932 131.583 350.5 131.583C157.068 131.583 0.260742 222.114 0.260742 333.791C0.260742 445.468 157.068 536 350.5 536Z"
                                fill="#F5F5F5"
                              />
                              <path
                                d="M614.997 491.426C653.468 491.426 684.654 473.424 684.654 451.218C684.654 429.012 653.468 411.01 614.997 411.01C576.526 411.01 545.34 429.012 545.34 451.218C545.34 473.424 576.526 491.426 614.997 491.426Z"
                                fill="#E6E6E6"
                              />
                              <path
                                d="M171.407 373.067L348.74 475.459C350.704 476.451 352.873 476.968 355.074 476.968C357.274 476.968 359.443 476.451 361.407 475.459L592.784 342.271C596.277 340.258 596.277 337.002 592.784 334.99L414.623 232.391C412.659 231.398 410.49 230.881 408.289 230.881C406.089 230.881 403.92 231.398 401.956 232.391L171.407 365.756C167.915 367.784 167.915 371.054 171.407 373.067Z"
                                fill="#E6E6E6"
                              />
                              <path
                                d="M133.701 348.042L44.3167 296.439C40.7798 294.397 40.7798 291.068 44.3167 289.04C66.5147 276.121 139.191 233.974 140.123 233.752C141.056 233.53 213.909 276.121 236.166 289.144C239.689 291.215 239.674 294.53 236.166 296.543L146.561 348.028C144.57 349.045 142.368 349.576 140.132 349.579C137.897 349.581 135.693 349.055 133.701 348.042Z"
                                fill="#E6E6E6"
                              />
                              <path
                                d="M441.054 189.09C460.81 177.695 492.849 177.695 512.576 189.09C529.313 198.754 531.814 213.508 520.212 224.725C520.867 224.906 521.498 225.164 522.091 225.495L584.482 261.515C587.131 262.995 587.131 265.525 584.482 267.049L580.575 269.299C579.109 270.051 577.476 270.421 575.828 270.375C574.18 270.328 572.571 269.866 571.149 269.032L513.123 231.015C512.88 230.865 512.657 230.686 512.457 230.482C492.686 241.773 460.81 241.744 441.128 230.378C421.446 219.013 421.372 200.5 441.054 189.09Z"
                                fill="#E6E6E6"
                              />
                              <path
                                d="M432.544 196.518V208.801C432.544 215.461 436.984 222.12 445.759 227.226C463.384 237.392 491.961 237.392 509.586 227.226C518.391 222.135 522.801 215.387 522.801 208.801V196.518C522.801 189.844 518.361 183.2 509.586 178.094C491.961 167.913 463.384 167.913 445.759 178.094C436.88 183.17 432.544 189.844 432.544 196.518ZM518.376 196.518C518.376 201.846 514.454 207.055 507.351 211.154C499.478 215.697 488.912 218.198 477.621 218.198C466.329 218.198 455.748 215.697 447.89 211.154C440.772 207.055 436.85 201.846 436.85 196.518C436.85 191.191 440.772 185.982 447.89 181.868C455.748 177.325 466.314 174.824 477.621 174.824C488.927 174.824 499.478 177.325 507.351 181.868C514.514 185.982 518.435 191.176 518.435 196.518H518.376Z"
                                fill="#BBE9F8"
                              />
                              <path
                                opacity="0.05"
                                d="M479.086 222.549V234.818C467.055 235.04 454.89 232.524 445.7 227.226C436.821 222.135 432.485 215.387 432.485 208.801V196.519C432.463 196.1 432.463 195.68 432.485 195.261C431.908 202.334 436.288 209.527 445.656 214.943C455.023 220.359 467.114 222.771 479.086 222.549Z"
                                fill="black"
                              />
                              <path
                                opacity="0.6"
                                d="M509.585 178.094C491.96 167.913 463.384 167.913 445.759 178.094C428.134 188.276 428.134 204.732 445.759 214.943C463.384 225.154 491.96 225.109 509.585 214.943C527.211 204.776 527.211 188.261 509.585 178.094ZM507.41 211.154C499.537 215.698 488.971 218.198 477.68 218.198C466.388 218.198 455.822 215.698 447.949 211.154C440.831 207.055 436.909 201.846 436.909 196.518C436.909 191.191 440.831 185.982 447.949 181.868C455.822 177.325 466.373 174.824 477.68 174.824C488.986 174.824 499.537 177.325 507.41 181.868C514.528 185.982 518.435 191.176 518.435 196.518C518.435 201.861 514.602 207.055 507.41 211.154Z"
                                fill="white"
                              />
                              <path
                                d="M518.451 196.519C518.421 198.689 517.808 200.81 516.675 202.66C514.381 199.06 511.181 196.126 507.396 194.151C499.538 189.608 488.972 187.107 477.666 187.107C466.359 187.107 455.823 189.608 447.95 194.151C444.17 196.139 440.969 199.07 438.656 202.66C437.545 200.802 436.943 198.684 436.91 196.519C436.91 191.177 440.832 185.982 447.95 181.868C455.823 177.325 466.374 174.824 477.666 174.824C488.957 174.824 499.538 177.325 507.396 181.868C514.603 185.982 518.451 191.177 518.451 196.519Z"
                                fill="#BBE9F8"
                              />
                              <path
                                opacity="0.5"
                                d="M507.41 187.373C499.538 182.83 488.971 180.329 477.68 180.329C466.389 180.329 455.822 182.934 448.009 187.373C442.089 190.762 438.449 194.891 437.339 199.212C438.449 203.548 442.134 207.677 448.009 211.051C455.882 215.594 466.433 218.095 477.739 218.095C489.045 218.095 499.597 215.594 507.47 211.051C513.389 207.662 517.03 203.533 518.14 199.212C516.97 194.95 513.286 190.821 507.41 187.373Z"
                                fill="white"
                              />
                              <path
                                d="M508.24 222.756C508.3 221.66 508.614 220.593 509.159 219.64C509.704 218.687 510.463 217.874 511.377 217.266C511.695 217.033 512.07 216.888 512.462 216.846C512.855 216.805 513.251 216.868 513.611 217.029L528.795 225.687C529.114 225.917 529.368 226.226 529.532 226.584C529.695 226.942 529.763 227.337 529.727 227.729C529.668 228.827 529.352 229.895 528.804 230.849C528.257 231.802 527.493 232.614 526.575 233.219C526.255 233.45 525.88 233.592 525.488 233.631C525.095 233.67 524.699 233.605 524.34 233.441L509.157 224.769C508.843 224.542 508.593 224.237 508.432 223.884C508.271 223.531 508.205 223.143 508.24 222.756Z"
                                fill="#00121B"
                              />
                              <path
                                d="M509.186 224.799C508.862 224.573 508.603 224.264 508.437 223.906C508.27 223.547 508.202 223.15 508.239 222.756C508.261 221.939 508.448 221.133 508.787 220.389L528.365 231.591C527.896 232.257 527.297 232.821 526.604 233.249C526.285 233.48 525.909 233.622 525.517 233.661C525.125 233.7 524.729 233.634 524.37 233.471L509.186 224.799Z"
                                fill="#263238"
                              />
                              <path
                                d="M577.778 259.102L525.436 228.809C526.086 227.663 527.012 226.697 528.129 225.998C528.538 225.705 529.015 225.522 529.515 225.465C530.015 225.408 530.521 225.479 530.985 225.672L581.3 252.576L577.778 259.102Z"
                                fill="#BBE9F8"
                              />
                              <path
                                opacity="0.6"
                                d="M577.778 259.102L525.436 228.809C526.086 227.663 527.012 226.697 528.129 225.998C528.538 225.705 529.015 225.522 529.515 225.465C530.015 225.408 530.521 225.479 530.985 225.672L581.3 252.576L577.778 259.102Z"
                                fill="white"
                              />
                              <path
                                d="M577.778 259.102L573.916 265.939L525.273 235.868C524.854 235.569 524.521 235.167 524.305 234.699C524.09 234.232 524 233.717 524.044 233.205C524.058 232.419 524.193 231.641 524.444 230.896C524.444 230.763 524.562 230.6 524.607 230.467C524.769 230.097 524.932 229.742 525.11 229.387L525.421 228.869L577.778 259.102Z"
                                fill="#BBE9F8"
                              />
                              <path
                                opacity="0.05"
                                d="M577.778 259.102L573.916 265.939L525.273 235.868C524.854 235.569 524.521 235.167 524.305 234.699C524.09 234.232 524 233.717 524.044 233.205C524.058 232.419 524.193 231.641 524.444 230.896C524.444 230.763 524.562 230.6 524.607 230.467C524.769 230.097 524.932 229.742 525.11 229.387L525.421 228.869L577.778 259.102Z"
                                fill="black"
                              />
                              <path
                                d="M577.704 265.555C579.273 264.523 580.575 263.135 581.506 261.505C582.437 259.874 582.97 258.047 583.061 256.172C583.061 252.739 580.634 251.348 577.66 253.079C576.093 254.11 574.792 255.495 573.861 257.123C572.931 258.75 572.397 260.574 572.303 262.447C572.318 265.895 574.73 267.286 577.704 265.555Z"
                                fill="#BBE9F8"
                              />
                              <g opacity="0.3">
                                <path
                                  d="M577.704 265.555C579.273 264.523 580.575 263.135 581.506 261.505C582.437 259.874 582.97 258.047 583.061 256.172C583.061 252.739 580.634 251.348 577.66 253.079C576.093 254.11 574.792 255.495 573.861 257.123C572.931 258.75 572.397 260.574 572.303 262.447C572.318 265.895 574.73 267.286 577.704 265.555Z"
                                  fill="black"
                                />
                              </g>
                              <path
                                d="M236.283 435.383C234.813 435.409 233.361 435.058 232.066 434.362L95.4891 355.5C94.9131 355.277 94.4181 354.885 94.069 354.375C93.72 353.865 93.5332 353.262 93.5332 352.644C93.5332 352.026 93.72 351.423 94.069 350.913C94.4181 350.404 94.9131 350.011 95.4891 349.788L127.691 331.186L128.431 332.474L96.229 351.061C95.9046 351.196 95.6209 351.412 95.4056 351.69C95.1902 351.968 95.0507 352.296 95.0007 352.644C95.0548 352.99 95.1959 353.317 95.4107 353.594C95.6255 353.871 95.9071 354.089 96.229 354.228L232.806 433.03C233.885 433.571 235.076 433.852 236.283 433.852C237.491 433.852 238.682 433.571 239.761 433.03L265.984 417.936L266.724 419.223L240.501 434.362C239.205 435.056 237.753 435.407 236.283 435.383Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M236.284 449.309C234.814 449.335 233.362 448.983 232.067 448.288L71.4422 355.5C70.8662 355.277 70.3712 354.885 70.0222 354.375C69.6731 353.865 69.4863 353.262 69.4863 352.644C69.4863 352.027 69.6731 351.423 70.0222 350.914C70.3712 350.404 70.8662 350.012 71.4422 349.788L115.69 324.231L116.43 325.518L72.123 351.061C71.7669 351.146 71.4498 351.348 71.2229 351.636C70.9961 351.923 70.8727 352.278 70.8727 352.644C70.8727 353.01 70.9961 353.366 71.2229 353.653C71.4498 353.94 71.7669 354.143 72.123 354.228L232.747 446.956C233.827 447.497 235.018 447.778 236.225 447.778C237.433 447.778 238.623 447.497 239.703 446.956L277.928 424.891L278.668 426.164L240.443 448.244C239.168 448.943 237.738 449.309 236.284 449.309Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M236.284 463.146C234.814 463.172 233.362 462.82 232.067 462.125L47.3944 355.501C46.8505 355.238 46.3868 354.835 46.0511 354.332C45.7155 353.83 45.5202 353.247 45.4854 352.644C45.5264 352.036 45.729 351.448 46.0723 350.944C46.4157 350.439 46.8874 350.035 47.4388 349.774L103.674 317.291L104.414 318.578L48.1787 351.061C47.8294 351.151 47.5199 351.355 47.299 351.64C47.0781 351.926 46.9582 352.276 46.9582 352.637C46.9582 352.998 47.0781 353.349 47.299 353.634C47.5199 353.919 47.8294 354.123 48.1787 354.213L232.851 460.837C233.931 461.378 235.121 461.659 236.329 461.659C237.536 461.659 238.727 461.378 239.806 460.837L290.122 431.832L290.862 433.105L240.546 462.125C239.237 462.826 237.769 463.178 236.284 463.146Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M43.917 262.403L140.108 317.942L236.285 262.403L140.108 206.878L43.917 262.403Z"
                                fill="#263238"
                              />
                              <path
                                d="M140.093 317.927V343.529C137.871 343.586 135.671 343.077 133.7 342.049L92.0126 317.942L47.7646 292.444C46.6438 291.715 45.7111 290.733 45.0424 289.575C44.3737 288.418 43.9881 287.119 43.917 285.784V262.402L137.444 316.403L140.093 317.927Z"
                                fill="#455A64"
                              />
                              <path
                                d="M236.285 262.402V285.725C236.21 287.059 235.823 288.357 235.155 289.513C234.487 290.67 233.556 291.654 232.437 292.384L194.198 314.464L146.502 342.004C144.526 343.034 142.321 343.543 140.094 343.484V317.882L143.053 316.166L236.285 262.402Z"
                                fill="#00121B"
                              />
                              <path
                                d="M49.9248 273.56V276.698C49.9411 276.918 50.0067 277.133 50.1168 277.325C50.227 277.517 50.3788 277.682 50.5611 277.807L51.2863 278.222C51.6266 278.429 51.9226 278.222 51.9226 277.852V274.685C51.9063 274.464 51.8407 274.25 51.7306 274.058C51.6205 273.866 51.4686 273.701 51.2863 273.575L50.5611 273.161C50.2208 272.983 49.9248 273.205 49.9248 273.56Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M53.166 275.425V278.562C53.1772 278.786 53.2422 279.004 53.3555 279.197C53.4689 279.39 53.6273 279.553 53.8172 279.672L54.5275 280.087C54.8827 280.294 55.1786 280.087 55.1786 279.717V276.579C55.1607 276.357 55.0928 276.142 54.98 275.95C54.8673 275.758 54.7126 275.594 54.5275 275.469L53.8172 275.055C53.462 274.848 53.166 275.011 53.166 275.425Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M56.4072 277.29V280.442C56.4235 280.663 56.4891 280.877 56.5993 281.069C56.7094 281.261 56.8612 281.426 57.0436 281.552L57.7687 281.966C58.1239 282.159 58.4198 281.966 58.4198 281.596V278.444C58.4019 278.222 58.334 278.007 58.2212 277.815C58.1085 277.623 57.9538 277.458 57.7687 277.334L57.0436 276.92C56.7032 276.713 56.4072 276.875 56.4072 277.29Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M59.6475 279.125V282.277C59.6637 282.497 59.7294 282.712 59.8395 282.904C59.9496 283.096 60.1015 283.261 60.2838 283.387L61.0089 283.801C61.3641 284.008 61.6453 283.801 61.6453 283.431V280.308C61.629 280.088 61.5634 279.873 61.4532 279.681C61.3431 279.489 61.1913 279.324 61.0089 279.199L60.2838 278.784C59.9286 278.577 59.6475 278.755 59.6475 279.125Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M62.8887 281.019V284.171C62.9049 284.392 62.9706 284.606 63.0807 284.798C63.1908 284.99 63.3427 285.155 63.525 285.281L64.2502 285.695C64.6053 285.902 64.8865 285.695 64.8865 285.325V282.173C64.8702 281.952 64.8046 281.738 64.6945 281.546C64.5843 281.354 64.4325 281.189 64.2502 281.063L63.525 280.649C63.2438 280.456 62.8887 280.604 62.8887 281.019Z"
                                fill="#263238"
                              />
                              <path
                                d="M66.2041 282.883V286.035C66.2204 286.256 66.286 286.471 66.3961 286.663C66.5063 286.855 66.6581 287.02 66.8404 287.145L67.5656 287.56C67.9207 287.767 68.2019 287.56 68.2019 287.19V284.052C68.1936 283.83 68.1314 283.612 68.0206 283.419C67.9097 283.226 67.7536 283.062 67.5656 282.942L66.8404 282.513C66.4113 282.321 66.2041 282.484 66.2041 282.883Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M69.3701 284.763V287.9C69.3864 288.121 69.452 288.336 69.5622 288.528C69.6723 288.72 69.8241 288.885 70.0065 289.01L70.7316 289.425C71.072 289.632 71.3679 289.425 71.3679 289.055V285.917C71.3517 285.696 71.286 285.482 71.1759 285.29C71.0658 285.098 70.9139 284.933 70.7316 284.807L70.0065 284.393C69.6513 284.186 69.3701 284.349 69.3701 284.763Z"
                                fill="#263238"
                              />
                              <path
                                d="M72.5967 286.628V289.765C72.6147 289.987 72.6826 290.202 72.7953 290.394C72.908 290.587 73.0627 290.751 73.2478 290.875L73.9582 291.289C74.3133 291.496 74.6093 291.289 74.6093 290.919V287.782C74.5913 287.56 74.5234 287.345 74.4107 287.153C74.2979 286.96 74.1432 286.796 73.9582 286.672L73.2478 286.258C72.8927 286.051 72.5967 286.213 72.5967 286.628Z"
                                fill="#263238"
                              />
                              <path
                                d="M75.8379 288.492V291.629C75.8542 291.85 75.9198 292.065 76.0299 292.257C76.1401 292.449 76.2919 292.614 76.4742 292.739L77.1994 293.168C77.5545 293.361 77.8505 293.168 77.8505 292.798V289.646C77.8325 289.424 77.7646 289.209 77.6519 289.017C77.5391 288.825 77.3845 288.66 77.1994 288.536L76.4742 288.122C76.1339 287.915 75.8379 288.078 75.8379 288.492Z"
                                fill="#263238"
                              />
                              <path
                                d="M79.0781 290.357V293.509C79.0944 293.73 79.16 293.945 79.2702 294.137C79.3803 294.329 79.5321 294.494 79.7145 294.619L80.4396 295.034C80.7948 295.241 81.076 295.034 81.076 294.664V291.512C81.0597 291.291 80.994 291.076 80.8839 290.884C80.7738 290.692 80.622 290.527 80.4396 290.402L79.7145 289.987C79.3593 289.78 79.0781 289.943 79.0781 290.357Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M82.3193 292.222V295.403C82.3356 295.624 82.4012 295.839 82.5114 296.031C82.6215 296.223 82.7733 296.388 82.9557 296.513L83.6808 296.928C84.036 297.135 84.3172 296.928 84.3172 296.558V293.406C84.3009 293.185 84.2353 292.97 84.1251 292.778C84.015 292.586 83.8632 292.421 83.6808 292.296L82.9557 291.881C82.6005 291.645 82.3193 291.822 82.3193 292.222Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M85.5605 294.086V297.239C85.5768 297.459 85.6424 297.674 85.7526 297.866C85.8627 298.058 86.0145 298.223 86.1969 298.348L86.922 298.763C87.2772 298.97 87.5584 298.763 87.5584 298.393V295.255C87.5501 295.033 87.4878 294.815 87.377 294.622C87.2662 294.429 87.11 294.265 86.922 294.146L86.1969 293.716C85.8417 293.524 85.5605 293.687 85.5605 294.086Z"
                                fill="#263238"
                              />
                              <path
                                d="M88.8008 295.965V299.103C88.8171 299.324 88.8827 299.538 88.9928 299.73C89.103 299.922 89.2548 300.087 89.4371 300.213L90.1623 300.627C90.5026 300.834 90.7986 300.627 90.7986 300.257V297.12C90.7823 296.899 90.7167 296.685 90.6066 296.493C90.4964 296.3 90.3446 296.135 90.1623 296.01L89.4371 295.596C89.082 295.403 88.8008 295.551 88.8008 295.965Z"
                                fill="#263238"
                              />
                              <path
                                d="M92.0273 297.83V300.968C92.0453 301.19 92.1132 301.405 92.226 301.597C92.3387 301.789 92.4934 301.954 92.6785 302.078L93.3888 302.492C93.744 302.699 94.04 302.492 94.04 302.122V298.985C94.022 298.763 93.9541 298.547 93.8414 298.355C93.7286 298.163 93.5739 297.999 93.3888 297.875L92.6785 297.46C92.3233 297.253 92.0273 297.416 92.0273 297.83Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M95.2686 299.695V302.803C95.2797 303.026 95.3447 303.244 95.4581 303.437C95.5714 303.631 95.7298 303.794 95.9197 303.912L96.63 304.327C96.9852 304.534 97.2812 304.327 97.2812 303.957V300.82C97.2632 300.597 97.1953 300.382 97.0826 300.19C96.9698 299.998 96.8151 299.834 96.63 299.71L95.9197 299.295C95.5645 299.118 95.2686 299.28 95.2686 299.695Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M98.5088 301.559V304.712C98.5251 304.932 98.5907 305.147 98.7008 305.339C98.8109 305.531 98.9628 305.696 99.1451 305.821L99.8703 306.236C100.225 306.428 100.507 306.236 100.507 305.866V302.714C100.49 302.493 100.425 302.279 100.315 302.086C100.204 301.894 100.053 301.729 99.8703 301.604L99.1451 301.189C98.7604 300.982 98.5088 301.145 98.5088 301.559Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M101.72 303.424V306.576C101.736 306.797 101.802 307.011 101.912 307.203C102.022 307.395 102.174 307.56 102.356 307.686L103.081 308.1C103.436 308.307 103.718 308.1 103.718 307.73V304.578C103.701 304.357 103.636 304.143 103.526 303.951C103.415 303.759 103.264 303.594 103.081 303.468L102.356 303.054C102.03 302.802 101.72 303.024 101.72 303.424Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M49.9248 282.883V286.035C49.9411 286.256 50.0067 286.471 50.1168 286.663C50.227 286.855 50.3788 287.02 50.5611 287.145L51.2863 287.56C51.6266 287.767 51.9226 287.56 51.9226 287.19V284.052C51.9063 283.832 51.8407 283.617 51.7306 283.425C51.6205 283.233 51.4686 283.068 51.2863 282.942L50.5611 282.513C50.2208 282.321 49.9248 282.484 49.9248 282.883Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M53.166 284.763V287.9C53.184 288.122 53.2519 288.338 53.3646 288.53C53.4774 288.722 53.6321 288.886 53.8172 289.01L54.5275 289.425C54.8827 289.632 55.1786 289.425 55.1786 289.055V285.917C55.1607 285.695 55.0928 285.48 54.98 285.288C54.8673 285.096 54.7126 284.931 54.5275 284.807L53.8172 284.393C53.462 284.186 53.166 284.349 53.166 284.763Z"
                                fill="#263238"
                              />
                              <path
                                d="M56.4072 286.628V289.765C56.4235 289.986 56.4891 290.2 56.5993 290.392C56.7094 290.584 56.8612 290.749 57.0436 290.875L57.7687 291.289C58.1239 291.496 58.4198 291.289 58.4198 290.919V287.782C58.4019 287.56 58.334 287.345 58.2212 287.153C58.1085 286.96 57.9538 286.796 57.7687 286.672L57.0436 286.258C56.7032 286.051 56.4072 286.213 56.4072 286.628Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M59.6475 288.492V291.629C59.6557 291.852 59.718 292.069 59.8288 292.263C59.9397 292.456 60.0958 292.62 60.2838 292.739L61.0089 293.168C61.3641 293.361 61.6453 293.168 61.6453 292.798V289.646C61.629 289.425 61.5634 289.211 61.4532 289.019C61.3431 288.827 61.1913 288.662 61.0089 288.536L60.2838 288.122C59.9286 287.915 59.6475 288.078 59.6475 288.492Z"
                                fill="#263238"
                              />
                              <path
                                d="M62.8887 290.357V293.509C62.9049 293.73 62.9706 293.945 63.0807 294.137C63.1908 294.329 63.3427 294.494 63.525 294.619L64.2502 295.034C64.6053 295.241 64.8865 295.034 64.8865 294.664V291.512C64.8702 291.291 64.8046 291.076 64.6945 290.884C64.5843 290.692 64.4325 290.527 64.2502 290.402L63.525 289.987C63.2438 289.78 62.8887 289.943 62.8887 290.357Z"
                                fill="#263238"
                              />
                              <path
                                d="M66.2041 292.222V295.403C66.2204 295.624 66.286 295.839 66.3961 296.031C66.5063 296.223 66.6581 296.388 66.8404 296.513L67.5656 296.928C67.9207 297.135 68.2019 296.928 68.2019 296.558V293.406C68.1856 293.185 68.12 292.97 68.0099 292.778C67.8998 292.586 67.7479 292.421 67.5656 292.296L66.8404 291.881C66.4113 291.645 66.2041 291.822 66.2041 292.222Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M69.3701 294.086V297.239C69.3864 297.459 69.452 297.674 69.5622 297.866C69.6723 298.058 69.8241 298.223 70.0065 298.348L70.7316 298.763C71.072 298.97 71.3679 298.763 71.3679 298.393V295.255C71.3517 295.035 71.286 294.82 71.1759 294.628C71.0658 294.436 70.9139 294.271 70.7316 294.146L70.0065 293.716C69.6513 293.524 69.3701 293.687 69.3701 294.086Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M72.5967 295.965V299.103C72.6147 299.325 72.6826 299.54 72.7953 299.732C72.908 299.924 73.0627 300.089 73.2478 300.213L73.9582 300.627C74.3133 300.834 74.6093 300.627 74.6093 300.257V297.12C74.5982 296.896 74.5331 296.678 74.4198 296.485C74.3064 296.292 74.148 296.129 73.9582 296.01L73.2478 295.596C72.8927 295.403 72.5967 295.551 72.5967 295.965Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M75.8379 297.83V300.968C75.8542 301.189 75.9198 301.403 76.0299 301.595C76.1401 301.787 76.2919 301.952 76.4742 302.078L77.1994 302.492C77.5545 302.699 77.8505 302.492 77.8505 302.122V298.985C77.8325 298.763 77.7646 298.547 77.6519 298.355C77.5391 298.163 77.3845 297.999 77.1994 297.875L76.4742 297.46C76.1339 297.253 75.8379 297.416 75.8379 297.83Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M79.0781 299.695V302.803C79.0864 303.025 79.1487 303.243 79.2595 303.436C79.3703 303.629 79.5265 303.793 79.7145 303.912L80.4396 304.327C80.7948 304.534 81.076 304.327 81.076 303.957V300.82C81.0597 300.599 80.994 300.384 80.8839 300.192C80.7738 300 80.622 299.835 80.4396 299.71L79.7145 299.295C79.3593 299.118 79.0781 299.28 79.0781 299.695Z"
                                fill="#263238"
                              />
                              <path
                                d="M82.3193 301.559V304.712C82.3356 304.932 82.4012 305.147 82.5114 305.339C82.6215 305.531 82.7733 305.696 82.9557 305.821L83.6808 306.236C84.036 306.428 84.3172 306.236 84.3172 305.866V302.714C84.3009 302.493 84.2353 302.279 84.1251 302.086C84.015 301.894 83.8632 301.729 83.6808 301.604L82.9557 301.189C82.6005 300.982 82.3193 301.145 82.3193 301.559Z"
                                fill="#263238"
                              />
                              <path
                                d="M85.5605 303.424V306.576C85.5768 306.797 85.6424 307.011 85.7526 307.203C85.8627 307.395 86.0145 307.56 86.1969 307.686L86.922 308.1C87.2772 308.307 87.5584 308.1 87.5584 307.73V304.578C87.5421 304.357 87.4765 304.143 87.3663 303.951C87.2562 303.759 87.1044 303.594 86.922 303.468L86.1969 303.054C85.8417 302.802 85.5605 303.024 85.5605 303.424Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M88.8008 305.289V308.441C88.8171 308.661 88.8827 308.876 88.9928 309.068C89.103 309.26 89.2548 309.425 89.4371 309.551L90.1623 309.965C90.5026 310.172 90.7986 309.965 90.7986 309.595V306.443C90.7823 306.222 90.7167 306.008 90.6066 305.816C90.4964 305.623 90.3446 305.459 90.1623 305.333L89.4371 304.919C89.082 304.726 88.8008 304.889 88.8008 305.289Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M92.0273 307.153V310.305C92.0453 310.527 92.1132 310.743 92.226 310.935C92.3387 311.127 92.4934 311.291 92.6785 311.415L93.3888 311.83C93.744 312.037 94.04 311.83 94.04 311.46V308.322C94.0288 308.099 93.9638 307.881 93.8505 307.688C93.7371 307.494 93.5787 307.331 93.3888 307.212L92.6785 306.783C92.3233 306.591 92.0273 306.754 92.0273 307.153Z"
                                fill="#263238"
                              />
                              <path
                                d="M95.2686 309.033V312.171C95.2865 312.393 95.3544 312.608 95.4672 312.8C95.5799 312.992 95.7346 313.156 95.9197 313.28L96.63 313.695C96.9852 313.902 97.2812 313.695 97.2812 313.325V310.202C97.2632 309.98 97.1953 309.765 97.0826 309.573C96.9698 309.381 96.8151 309.217 96.63 309.092L95.9197 308.678C95.5645 308.456 95.2686 308.619 95.2686 309.033Z"
                                fill="#263238"
                              />
                              <path
                                d="M98.5088 310.897V314.035C98.5251 314.255 98.5907 314.47 98.7008 314.662C98.8109 314.854 98.9628 315.019 99.1451 315.144L99.8703 315.559C100.225 315.766 100.507 315.559 100.507 315.189V312.052C100.49 311.831 100.425 311.616 100.315 311.424C100.204 311.232 100.053 311.067 99.8703 310.942L99.1451 310.527C98.7604 310.32 98.5088 310.483 98.5088 310.897Z"
                                fill="#263238"
                              />
                              <path
                                d="M101.72 312.762V315.899C101.728 316.122 101.79 316.339 101.901 316.533C102.012 316.726 102.168 316.89 102.356 317.009L103.081 317.438C103.436 317.631 103.718 317.438 103.718 317.068V313.916C103.701 313.695 103.636 313.481 103.526 313.289C103.415 313.097 103.264 312.932 103.081 312.806L102.356 312.392C102.03 312.185 101.72 312.348 101.72 312.762Z"
                                fill="#263238"
                              />
                              <path
                                d="M112.568 314.08L114.048 313.236C114.363 313.095 114.71 313.04 115.053 313.076C115.396 313.113 115.723 313.239 116.002 313.443C116.812 313.972 117.486 314.685 117.969 315.523C118.453 316.361 118.732 317.301 118.784 318.268C118.822 318.612 118.766 318.96 118.623 319.275C118.48 319.59 118.254 319.861 117.97 320.058L116.608 320.843L116.357 320.443C116.078 320.374 115.81 320.269 115.558 320.132C114.747 319.603 114.073 318.891 113.59 318.053C113.107 317.215 112.828 316.274 112.776 315.308C112.772 315.068 112.802 314.829 112.864 314.598L112.568 314.08Z"
                                fill="#BBE9F8"
                              />
                              <path
                                opacity="0.2"
                                d="M112.568 314.08L114.048 313.236C114.363 313.095 114.71 313.04 115.053 313.076C115.396 313.113 115.723 313.239 116.002 313.443C116.812 313.972 117.486 314.685 117.969 315.523C118.453 316.361 118.732 317.301 118.784 318.268C118.822 318.612 118.766 318.96 118.623 319.275C118.48 319.59 118.254 319.861 117.97 320.058L116.608 320.843L116.357 320.443C116.078 320.374 115.81 320.269 115.558 320.132C114.747 319.603 114.073 318.891 113.59 318.053C113.107 317.215 112.828 316.274 112.776 315.308C112.772 315.068 112.802 314.829 112.864 314.598L112.568 314.08Z"
                                fill="black"
                              />
                              <path
                                d="M114.596 314.242C115.409 314.771 116.086 315.485 116.57 316.327C117.054 317.168 117.33 318.112 117.378 319.081C117.378 320.857 116.135 321.568 114.596 320.68C113.785 320.151 113.111 319.438 112.628 318.6C112.144 317.762 111.865 316.821 111.813 315.855C111.813 314.065 113.057 313.354 114.596 314.242Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M124.658 321.05L126.138 320.206C126.451 320.058 126.797 319.998 127.141 320.032C127.485 320.066 127.814 320.193 128.091 320.399C128.902 320.928 129.576 321.64 130.059 322.478C130.543 323.316 130.822 324.257 130.874 325.223C130.91 325.569 130.853 325.918 130.71 326.236C130.567 326.553 130.343 326.826 130.06 327.028L128.698 327.813L128.447 327.398C128.166 327.336 127.897 327.231 127.648 327.088C126.837 326.559 126.163 325.846 125.68 325.008C125.196 324.17 124.917 323.229 124.865 322.263C124.863 322.024 124.893 321.785 124.954 321.553L124.658 321.05Z"
                                fill="#BBE9F8"
                              />
                              <path
                                opacity="0.2"
                                d="M124.658 321.05L126.138 320.206C126.451 320.058 126.797 319.998 127.141 320.032C127.485 320.066 127.814 320.193 128.091 320.399C128.902 320.928 129.576 321.64 130.059 322.478C130.543 323.316 130.822 324.257 130.874 325.223C130.91 325.569 130.853 325.918 130.71 326.236C130.567 326.553 130.343 326.826 130.06 327.028L128.698 327.813L128.447 327.398C128.166 327.336 127.897 327.231 127.648 327.088C126.837 326.559 126.163 325.846 125.68 325.008C125.196 324.17 124.917 323.229 124.865 322.263C124.863 322.024 124.893 321.785 124.954 321.553L124.658 321.05Z"
                                fill="black"
                              />
                              <path
                                d="M126.686 321.212C127.497 321.741 128.171 322.454 128.654 323.292C129.137 324.13 129.416 325.07 129.468 326.037C129.468 327.812 128.225 328.538 126.686 327.65C125.88 327.118 125.209 326.405 124.728 325.567C124.248 324.729 123.97 323.79 123.919 322.825C123.919 321.049 125.147 320.324 126.686 321.212Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M43.917 220.759L140.108 276.283L236.285 220.759L140.108 165.234L43.917 220.759Z"
                                fill="#263238"
                              />
                              <path
                                d="M43.917 248.521L140.108 304.06V276.283L43.917 220.759V248.521Z"
                                fill="#455A64"
                              />
                              <path
                                d="M140.108 304.06L236.285 248.521V220.759L140.108 276.283V304.06Z"
                                fill="#00121B"
                              />
                              <path
                                d="M55.9482 262.402V255.462L140.108 304.061V311.001L55.9482 262.402Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M230.277 251.999V258.94L140.108 311.001V304.061L230.277 251.999Z"
                                fill="#BBE9F8"
                              />
                              <path
                                opacity="0.2"
                                d="M230.277 251.999V258.94L140.108 311.001V304.061L230.277 251.999Z"
                                fill="black"
                              />
                              <path
                                d="M49.9248 231.917V235.055C49.9411 235.275 50.0067 235.49 50.1168 235.682C50.227 235.874 50.3788 236.039 50.5611 236.164L51.2863 236.579C51.6266 236.786 51.9226 236.579 51.9226 236.209V233.072C51.9063 232.851 51.8407 232.636 51.7306 232.444C51.6205 232.252 51.4686 232.087 51.2863 231.962L50.5611 231.547C50.2208 231.34 49.9248 231.503 49.9248 231.917Z"
                                fill="#263238"
                              />
                              <path
                                d="M53.166 233.782V236.919C53.184 237.141 53.2519 237.356 53.3646 237.548C53.4774 237.741 53.6321 237.905 53.8172 238.029L54.5275 238.443C54.8827 238.65 55.1786 238.443 55.1786 238.073V234.936C55.1607 234.714 55.0928 234.499 54.98 234.306C54.8673 234.114 54.7126 233.95 54.5275 233.826L53.8172 233.412C53.462 233.249 53.166 233.367 53.166 233.782Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M56.4072 235.646V238.784C56.4235 239.004 56.4891 239.219 56.5993 239.411C56.7094 239.603 56.8612 239.768 57.0436 239.894L57.7687 240.308C58.1239 240.515 58.4198 240.308 58.4198 239.938V236.801C58.4019 236.579 58.334 236.363 58.2212 236.171C58.1085 235.979 57.9538 235.815 57.7687 235.691L57.0436 235.276C56.7032 235.069 56.4072 235.232 56.4072 235.646Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M59.6475 237.511V240.648C59.6637 240.869 59.7294 241.084 59.8395 241.276C59.9496 241.468 60.1015 241.633 60.2838 241.758L61.0089 242.173C61.3641 242.365 61.6453 242.173 61.6453 241.803V238.651C61.629 238.43 61.5634 238.215 61.4532 238.023C61.3431 237.831 61.1913 237.666 61.0089 237.541L60.2838 237.126C59.9286 236.934 59.6475 237.097 59.6475 237.511Z"
                                fill="#263238"
                              />
                              <path
                                d="M62.8887 239.376V242.528C62.9049 242.749 62.9706 242.963 63.0807 243.155C63.1908 243.347 63.3427 243.512 63.525 243.638L64.2502 244.052C64.6053 244.259 64.8865 244.052 64.8865 243.682V240.53C64.8702 240.309 64.8046 240.095 64.6945 239.903C64.5843 239.711 64.4325 239.546 64.2502 239.42L63.525 239.006C63.2438 238.798 62.8887 238.976 62.8887 239.376Z"
                                fill="#263238"
                              />
                              <path
                                d="M66.2041 241.24V244.393C66.2204 244.613 66.286 244.828 66.3961 245.02C66.5063 245.212 66.6581 245.377 66.8404 245.502L67.5656 245.917C67.9207 246.124 68.2019 245.917 68.2019 245.547V242.395C68.1856 242.174 68.12 241.96 68.0099 241.767C67.8998 241.575 67.7479 241.41 67.5656 241.285L66.8404 240.87C66.4113 240.649 66.2041 240.841 66.2041 241.24Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M69.3701 243.105V246.257C69.3864 246.478 69.452 246.692 69.5622 246.884C69.6723 247.076 69.8241 247.241 70.0065 247.367L70.7316 247.781C71.072 247.989 71.3679 247.781 71.3679 247.411V244.274C71.3517 244.053 71.286 243.839 71.1759 243.647C71.0658 243.455 70.9139 243.29 70.7316 243.164L70.0065 242.735C69.6513 242.543 69.3701 242.705 69.3701 243.105Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M72.5967 244.984V248.121C72.6147 248.344 72.6826 248.559 72.7953 248.751C72.908 248.943 73.0627 249.107 73.2478 249.231L73.9582 249.646C74.3133 249.853 74.6093 249.646 74.6093 249.276V246.138C74.5913 245.916 74.5234 245.701 74.4107 245.509C74.2979 245.317 74.1432 245.153 73.9582 245.029L73.2478 244.614C72.8927 244.407 72.5967 244.57 72.5967 244.984Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M75.8379 246.849V249.986C75.8542 250.207 75.9198 250.421 76.0299 250.614C76.1401 250.806 76.2919 250.971 76.4742 251.096L77.1994 251.511C77.5545 251.718 77.8505 251.511 77.8505 251.141V248.048C77.8325 247.826 77.7646 247.61 77.6519 247.418C77.5391 247.226 77.3845 247.062 77.1994 246.938L76.4742 246.523C76.1339 246.272 75.8379 246.435 75.8379 246.849Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M79.0781 248.714V251.851C79.0864 252.074 79.1487 252.291 79.2595 252.484C79.3703 252.678 79.5265 252.841 79.7145 252.961L80.4396 253.39C80.7948 253.582 81.076 253.39 81.076 253.02V249.868C81.0597 249.647 80.994 249.433 80.8839 249.241C80.7738 249.049 80.622 248.884 80.4396 248.758L79.7145 248.344C79.3593 248.137 79.0781 248.299 79.0781 248.714Z"
                                fill="#263238"
                              />
                              <path
                                d="M82.3193 250.578V253.731C82.3356 253.951 82.4012 254.166 82.5114 254.358C82.6215 254.55 82.7733 254.715 82.9557 254.84L83.6808 255.255C84.036 255.462 84.3172 255.255 84.3172 254.885V251.733C84.3009 251.512 84.2353 251.298 84.1251 251.105C84.015 250.913 83.8632 250.748 83.6808 250.623L82.9557 250.208C82.6005 250.001 82.3193 250.164 82.3193 250.578Z"
                                fill="#263238"
                              />
                              <path
                                d="M85.5605 252.487V255.639C85.5768 255.86 85.6424 256.075 85.7526 256.267C85.8627 256.459 86.0145 256.624 86.1969 256.749L86.922 257.164C87.2772 257.371 87.5584 257.164 87.5584 256.794V253.642C87.5487 253.413 87.4862 253.19 87.3758 252.99C87.2654 252.789 87.1101 252.617 86.922 252.487L86.1969 252.073C85.8417 251.866 85.5605 252.043 85.5605 252.487Z"
                                fill="#263238"
                              />
                              <path
                                d="M88.8008 254.308V257.46C88.8171 257.68 88.8827 257.895 88.9928 258.087C89.103 258.279 89.2548 258.444 89.4371 258.569L90.1623 258.984C90.5026 259.191 90.7986 258.984 90.7986 258.614V255.447C90.7823 255.226 90.7167 255.012 90.6066 254.82C90.4964 254.628 90.3446 254.463 90.1623 254.337L89.4371 253.967C89.082 253.745 88.8008 253.967 88.8008 254.308Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M92.0273 256.187V259.324C92.0453 259.546 92.1132 259.761 92.226 259.954C92.3387 260.146 92.4934 260.31 92.6785 260.434L93.3888 260.848C93.744 261.056 94.04 260.848 94.04 260.478V257.341C94.0288 257.117 93.9638 256.9 93.8505 256.706C93.7371 256.513 93.5787 256.35 93.3888 256.231L92.6785 255.817C92.3233 255.61 92.0273 255.772 92.0273 256.187Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M95.2686 258.052V261.189C95.2865 261.411 95.3544 261.626 95.4672 261.818C95.5799 262.01 95.7346 262.175 95.9197 262.299L96.63 262.713C96.9852 262.92 97.2812 262.713 97.2812 262.343V259.206C97.2632 258.984 97.1953 258.769 97.0826 258.576C96.9698 258.384 96.8151 258.22 96.63 258.096L95.9197 257.682C95.5645 257.474 95.2686 257.637 95.2686 258.052Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M98.5088 259.887V263.024C98.5171 263.247 98.5793 263.464 98.6901 263.657C98.801 263.851 98.9571 264.014 99.1451 264.134L99.8703 264.548C100.225 264.755 100.507 264.548 100.507 264.178V261.07C100.49 260.85 100.425 260.635 100.315 260.443C100.204 260.251 100.053 260.086 99.8703 259.96L99.1451 259.546C98.7604 259.339 98.5088 259.502 98.5088 259.887Z"
                                fill="#263238"
                              />
                              <path
                                d="M101.72 261.781V264.918C101.728 265.141 101.79 265.358 101.901 265.551C102.012 265.745 102.168 265.908 102.356 266.028L103.081 266.457C103.436 266.649 103.718 266.457 103.718 266.087V262.935C103.701 262.714 103.636 262.5 103.526 262.308C103.415 262.116 103.264 261.951 103.081 261.825L102.356 261.411C102.03 261.203 101.72 261.366 101.72 261.781Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M49.9248 241.24V244.393C49.9411 244.613 50.0067 244.828 50.1168 245.02C50.227 245.212 50.3788 245.377 50.5611 245.502L51.2863 245.917C51.6266 246.124 51.9226 245.917 51.9226 245.547V242.395C51.9063 242.174 51.8407 241.96 51.7306 241.767C51.6205 241.575 51.4686 241.41 51.2863 241.285L50.5611 240.87C50.2208 240.649 49.9248 240.841 49.9248 241.24Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M53.166 243.105V246.257C53.184 246.479 53.2519 246.694 53.3646 246.886C53.4774 247.079 53.6321 247.243 53.8172 247.367L54.5275 247.781C54.8827 247.989 55.1786 247.781 55.1786 247.411V244.274C55.1675 244.05 55.1025 243.832 54.9891 243.639C54.8757 243.446 54.7174 243.283 54.5275 243.164L53.8172 242.735C53.462 242.543 53.166 242.705 53.166 243.105Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M56.4072 244.984V248.121C56.4235 248.342 56.4891 248.557 56.5993 248.749C56.7094 248.941 56.8612 249.106 57.0436 249.231L57.7687 249.646C58.1239 249.853 58.4198 249.646 58.4198 249.276V246.138C58.4019 245.916 58.334 245.701 58.2212 245.509C58.1085 245.317 57.9538 245.153 57.7687 245.029L57.0436 244.614C56.7032 244.407 56.4072 244.57 56.4072 244.984Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M59.6475 246.849V249.986C59.6637 250.207 59.7294 250.421 59.8395 250.614C59.9496 250.806 60.1015 250.971 60.2838 251.096L61.0089 251.511C61.3641 251.718 61.6453 251.511 61.6453 251.141V248.048C61.629 247.827 61.5634 247.612 61.4532 247.42C61.3431 247.228 61.1913 247.063 61.0089 246.938L60.2838 246.523C59.9286 246.272 59.6475 246.435 59.6475 246.849Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M62.8887 248.714V251.851C62.897 252.074 62.9592 252.291 63.07 252.484C63.1809 252.678 63.337 252.841 63.525 252.961L64.2502 253.39C64.6053 253.582 64.8865 253.39 64.8865 253.02V249.868C64.8702 249.647 64.8046 249.433 64.6945 249.241C64.5843 249.049 64.4325 248.884 64.2502 248.758L63.525 248.344C63.2438 248.137 62.8887 248.299 62.8887 248.714Z"
                                fill="#263238"
                              />
                              <path
                                d="M66.2041 250.578V253.731C66.2204 253.951 66.286 254.166 66.3961 254.358C66.5063 254.55 66.6581 254.715 66.8404 254.84L67.5656 255.255C67.9207 255.462 68.2019 255.255 68.2019 254.885V251.733C68.1856 251.512 68.12 251.298 68.0099 251.105C67.8998 250.913 67.7479 250.748 67.5656 250.623L66.8404 250.208C66.4113 250.001 66.2041 250.164 66.2041 250.578Z"
                                fill="#263238"
                              />
                              <path
                                d="M69.3701 252.487V255.64C69.3864 255.86 69.452 256.075 69.5622 256.267C69.6723 256.459 69.8241 256.624 70.0065 256.75L70.7316 257.164C71.072 257.371 71.3679 257.164 71.3679 256.794V253.642C71.3517 253.421 71.286 253.207 71.1759 253.015C71.0658 252.822 70.9139 252.658 70.7316 252.532L70.0065 252.118C69.6513 251.866 69.3701 252.044 69.3701 252.487Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M72.5967 254.308V257.46C72.6147 257.682 72.6826 257.897 72.7953 258.089C72.908 258.281 73.0627 258.446 73.2478 258.57L73.9582 258.984C74.3133 259.191 74.6093 258.984 74.6093 258.614V255.447C74.5982 255.223 74.5331 255.006 74.4198 254.812C74.3064 254.619 74.148 254.456 73.9582 254.337L73.2478 253.908C72.8927 253.745 72.5967 253.967 72.5967 254.308Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M75.8379 256.187V259.324C75.8542 259.545 75.9198 259.759 76.0299 259.951C76.1401 260.143 76.2919 260.308 76.4742 260.434L77.1994 260.848C77.5545 261.056 77.8505 260.848 77.8505 260.478V257.341C77.8394 257.117 77.7744 256.9 77.661 256.706C77.5476 256.513 77.3893 256.35 77.1994 256.231L76.4742 255.817C76.1339 255.61 75.8379 255.772 75.8379 256.187Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M79.0781 258.052V261.189C79.0944 261.41 79.16 261.624 79.2702 261.816C79.3803 262.008 79.5321 262.173 79.7145 262.299L80.4396 262.713C80.7948 262.92 81.076 262.713 81.076 262.343V259.206C81.0597 258.985 80.994 258.771 80.8839 258.579C80.7738 258.386 80.622 258.222 80.4396 258.096L79.7145 257.682C79.3593 257.474 79.0781 257.637 79.0781 258.052Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M82.3193 259.887V263.024C82.3276 263.247 82.3899 263.464 82.5007 263.657C82.6115 263.851 82.7677 264.014 82.9557 264.134L83.6808 264.548C84.036 264.755 84.3172 264.548 84.3172 264.178V261.07C84.3009 260.85 84.2353 260.635 84.1251 260.443C84.015 260.251 83.8632 260.086 83.6808 259.96L82.9557 259.546C82.6005 259.339 82.3193 259.502 82.3193 259.887Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M85.5605 261.781V264.918C85.5688 265.141 85.6311 265.358 85.7419 265.551C85.8527 265.745 86.0089 265.908 86.1969 266.028L86.922 266.457C87.2772 266.649 87.5584 266.457 87.5584 266.087V262.935C87.5421 262.714 87.4765 262.5 87.3663 262.308C87.2562 262.116 87.1044 261.951 86.922 261.825L86.1969 261.411C85.8417 261.203 85.5605 261.366 85.5605 261.781Z"
                                fill="#263238"
                              />
                              <path
                                d="M88.8008 263.645V266.797C88.8171 267.018 88.8827 267.232 88.9928 267.424C89.103 267.617 89.2548 267.782 89.4371 267.907L90.1623 268.321C90.5026 268.529 90.7986 268.321 90.7986 267.952V264.799C90.7823 264.579 90.7167 264.364 90.6066 264.172C90.4964 263.98 90.3446 263.815 90.1623 263.69L89.4371 263.275C89.082 263.068 88.8008 263.246 88.8008 263.645Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M92.0276 265.51V268.662C92.0456 268.884 92.1135 269.1 92.2262 269.292C92.339 269.484 92.4936 269.648 92.6787 269.772L93.3891 270.187C93.7442 270.394 94.0402 270.187 94.0402 269.817V266.664C94.0222 266.442 93.9543 266.227 93.8416 266.035C93.7288 265.843 93.5742 265.679 93.3891 265.555L92.6787 265.14C92.6163 265.088 92.5393 265.056 92.4581 265.049C92.377 265.041 92.2955 265.059 92.2246 265.099C92.1538 265.139 92.0969 265.2 92.0617 265.274C92.0265 265.347 92.0146 265.43 92.0276 265.51Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M95.2686 267.375V270.527C95.2865 270.749 95.3544 270.964 95.4672 271.157C95.5799 271.349 95.7346 271.513 95.9197 271.637L96.63 272.051C96.9852 272.259 97.2812 272.051 97.2812 271.681V268.544C97.27 268.32 97.205 268.103 97.0917 267.909C96.9783 267.716 96.8199 267.553 96.63 267.434L95.9197 267.005C95.5645 266.813 95.2686 266.975 95.2686 267.375Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M98.5088 269.254V272.392C98.5251 272.612 98.5907 272.827 98.7008 273.019C98.8109 273.211 98.9628 273.376 99.1451 273.501L99.8703 273.916C100.225 274.123 100.507 273.916 100.507 273.546V270.408C100.49 270.188 100.425 269.973 100.315 269.781C100.204 269.589 100.053 269.424 99.8703 269.299L99.1451 268.884C98.7604 268.677 98.5088 268.84 98.5088 269.254Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M101.72 271.119V274.256C101.736 274.477 101.802 274.691 101.912 274.884C102.022 275.076 102.174 275.241 102.356 275.366L103.081 275.781C103.436 275.988 103.718 275.781 103.718 275.411V272.273C103.701 272.052 103.636 271.838 103.526 271.646C103.415 271.454 103.264 271.289 103.081 271.163L102.356 270.749C102.03 270.542 101.72 270.705 101.72 271.119Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M112.568 272.436L114.048 271.577C114.363 271.436 114.71 271.381 115.053 271.418C115.396 271.454 115.723 271.581 116.002 271.785C116.812 272.31 117.486 273.02 117.969 273.856C118.453 274.692 118.732 275.63 118.784 276.594C118.82 276.94 118.763 277.29 118.62 277.607C118.477 277.924 118.253 278.198 117.97 278.4L116.608 279.184L116.357 278.77C116.076 278.707 115.807 278.602 115.558 278.459C114.747 277.93 114.073 277.217 113.59 276.379C113.107 275.541 112.828 274.601 112.776 273.634C112.774 273.395 112.804 273.156 112.864 272.924L112.568 272.436Z"
                                fill="#BBE9F8"
                              />
                              <path
                                opacity="0.2"
                                d="M112.568 272.436L114.048 271.577C114.363 271.436 114.71 271.381 115.053 271.418C115.396 271.454 115.723 271.581 116.002 271.785C116.812 272.31 117.486 273.02 117.969 273.856C118.453 274.692 118.732 275.63 118.784 276.594C118.82 276.94 118.763 277.29 118.62 277.607C118.477 277.924 118.253 278.198 117.97 278.4L116.608 279.184L116.357 278.77C116.076 278.707 115.807 278.602 115.558 278.459C114.747 277.93 114.073 277.217 113.59 276.379C113.107 275.541 112.828 274.601 112.776 273.634C112.774 273.395 112.804 273.156 112.864 272.924L112.568 272.436Z"
                                fill="black"
                              />
                              <path
                                d="M114.596 272.584C115.406 273.112 116.08 273.825 116.563 274.663C117.047 275.501 117.326 276.442 117.378 277.408C117.378 279.184 116.135 279.909 114.596 279.021C113.785 278.492 113.111 277.78 112.628 276.941C112.144 276.103 111.865 275.163 111.813 274.197C111.813 272.421 113.057 271.725 114.596 272.584Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M124.658 279.406L126.138 278.563C126.451 278.415 126.797 278.355 127.141 278.389C127.485 278.422 127.814 278.549 128.091 278.755C128.9 279.283 129.573 279.993 130.056 280.828C130.539 281.664 130.819 282.601 130.874 283.565C130.91 283.911 130.853 284.26 130.71 284.577C130.567 284.894 130.343 285.168 130.06 285.37L128.698 286.154L128.447 285.74C128.166 285.677 127.897 285.572 127.648 285.429C126.837 284.9 126.163 284.188 125.68 283.35C125.196 282.511 124.917 281.571 124.865 280.605C124.862 280.365 124.892 280.126 124.954 279.895L124.658 279.406Z"
                                fill="#BBE9F8"
                              />
                              <path
                                opacity="0.2"
                                d="M124.658 279.406L126.138 278.563C126.451 278.415 126.797 278.355 127.141 278.389C127.485 278.422 127.814 278.549 128.091 278.755C128.9 279.283 129.573 279.993 130.056 280.828C130.539 281.664 130.819 282.601 130.874 283.565C130.91 283.911 130.853 284.26 130.71 284.577C130.567 284.894 130.343 285.168 130.06 285.37L128.698 286.154L128.447 285.74C128.166 285.677 127.897 285.572 127.648 285.429C126.837 284.9 126.163 284.188 125.68 283.35C125.196 282.511 124.917 281.571 124.865 280.605C124.862 280.365 124.892 280.126 124.954 279.895L124.658 279.406Z"
                                fill="black"
                              />
                              <path
                                d="M126.686 279.568C127.497 280.097 128.171 280.81 128.654 281.648C129.137 282.486 129.416 283.427 129.468 284.393C129.468 286.169 128.225 286.879 126.686 285.991C125.88 285.463 125.209 284.752 124.728 283.917C124.248 283.081 123.97 282.144 123.919 281.182C123.919 279.391 125.147 278.68 126.686 279.568Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M43.917 179.116L140.108 234.64L236.285 179.116L140.108 123.576L43.917 179.116Z"
                                fill="#263238"
                              />
                              <path
                                d="M43.917 206.878L140.108 262.403V234.64L43.917 179.116V206.878Z"
                                fill="#455A64"
                              />
                              <path
                                d="M140.108 262.403L236.285 206.878V179.116L140.108 234.64V262.403Z"
                                fill="#00121B"
                              />
                              <path
                                d="M55.9482 220.759V213.818L140.108 262.402V269.343L55.9482 220.759Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M230.277 210.341V217.281L140.108 269.343V262.402L230.277 210.341Z"
                                fill="#BBE9F8"
                              />
                              <path
                                opacity="0.2"
                                d="M230.277 210.341V217.281L140.108 269.343V262.402L230.277 210.341Z"
                                fill="black"
                              />
                              <path
                                d="M49.9248 190.333V193.485C49.9411 193.706 50.0067 193.92 50.1168 194.112C50.227 194.304 50.3788 194.469 50.5611 194.595L51.2863 195.009C51.6266 195.217 51.9226 195.009 51.9226 194.639V191.487C51.9063 191.266 51.8407 191.052 51.7306 190.86C51.6205 190.668 51.4686 190.503 51.2863 190.377L50.5611 189.963C50.2208 189.682 49.9248 189.859 49.9248 190.333Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M53.166 192.124V195.276C53.184 195.498 53.2519 195.713 53.3646 195.905C53.4774 196.097 53.6321 196.261 53.8172 196.385L54.5275 196.8C54.8827 197.007 55.1786 196.8 55.1786 196.43V193.293C55.1675 193.069 55.1025 192.851 54.9891 192.658C54.8757 192.465 54.7174 192.302 54.5275 192.183L53.8172 191.754C53.462 191.561 53.166 191.724 53.166 192.124Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M56.4072 194.003V197.141C56.4235 197.361 56.4891 197.576 56.5993 197.768C56.7094 197.96 56.8612 198.125 57.0436 198.25L57.7687 198.665C58.1239 198.872 58.4198 198.665 58.4198 198.295V195.158C58.4019 194.935 58.334 194.72 58.2212 194.528C58.1085 194.336 57.9538 194.172 57.7687 194.048L57.0436 193.633C56.7032 193.426 56.4072 193.589 56.4072 194.003Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M59.6475 195.867V199.005C59.6637 199.226 59.7294 199.44 59.8395 199.632C59.9496 199.824 60.1015 199.989 60.2838 200.115L61.0089 200.529C61.3641 200.736 61.6453 200.529 61.6453 200.159V197.022C61.629 196.801 61.5634 196.587 61.4532 196.395C61.3431 196.202 61.1913 196.037 61.0089 195.912L60.2838 195.498C59.9286 195.29 59.6475 195.453 59.6475 195.867Z"
                                fill="#263238"
                              />
                              <path
                                d="M62.8887 197.732V200.87C62.897 201.092 62.9592 201.31 63.07 201.503C63.1809 201.696 63.337 201.86 63.525 201.979L64.2502 202.409C64.6053 202.601 64.8865 202.409 64.8865 202.039V198.887C64.8702 198.666 64.8046 198.451 64.6945 198.259C64.5843 198.067 64.4325 197.902 64.2502 197.777L63.525 197.362C63.2438 197.155 62.8887 197.318 62.8887 197.732Z"
                                fill="#263238"
                              />
                              <path
                                d="M66.2041 199.597V202.749C66.2204 202.97 66.286 203.184 66.3961 203.376C66.5063 203.568 66.6581 203.733 66.8404 203.859L67.5656 204.273C67.9207 204.465 68.2019 204.273 68.2019 203.903V200.692C68.1856 200.471 68.12 200.257 68.0099 200.065C67.8998 199.872 67.7479 199.708 67.5656 199.582L66.8404 199.168C66.4113 199.02 66.2041 199.212 66.2041 199.597Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M69.3701 201.462V204.614C69.3864 204.834 69.452 205.049 69.5622 205.241C69.6723 205.433 69.8241 205.598 70.0065 205.724L70.7316 206.138C71.072 206.345 71.3679 206.138 71.3679 205.768V202.616C71.3517 202.395 71.286 202.181 71.1759 201.989C71.0658 201.796 70.9139 201.632 70.7316 201.506L70.0065 201.092C69.6513 200.884 69.3701 201.062 69.3701 201.462Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M72.5967 203.326V206.478C72.6147 206.7 72.6826 206.915 72.7953 207.108C72.908 207.3 73.0627 207.464 73.2478 207.588L73.9582 208.003C74.3133 208.21 74.6093 208.003 74.6093 207.633V204.48C74.5913 204.258 74.5234 204.043 74.4107 203.851C74.2979 203.659 74.1432 203.495 73.9582 203.371L73.2478 202.956C72.8927 202.764 72.5967 202.927 72.5967 203.326Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M75.8379 205.206V208.343C75.8542 208.564 75.9198 208.778 76.0299 208.97C76.1401 209.163 76.2919 209.327 76.4742 209.453L77.1994 209.867C77.5545 210.075 77.8505 209.867 77.8505 209.497V206.36C77.8394 206.136 77.7744 205.919 77.661 205.725C77.5476 205.532 77.3893 205.369 77.1994 205.25L76.4742 204.836C76.1339 204.629 75.8379 204.792 75.8379 205.206Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M79.0781 207.07V210.208C79.0944 210.429 79.16 210.643 79.2702 210.835C79.3803 211.027 79.5321 211.192 79.7145 211.318L80.4396 211.732C80.7948 211.939 81.076 211.732 81.076 211.362V208.225C81.0597 208.004 80.994 207.79 80.8839 207.597C80.7738 207.405 80.622 207.24 80.4396 207.115L79.7145 206.7C79.3593 206.493 79.0781 206.612 79.0781 207.07Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M82.3193 208.935V212.072C82.3276 212.295 82.3899 212.512 82.5007 212.706C82.6115 212.899 82.7677 213.062 82.9557 213.182L83.6808 213.596C84.036 213.804 84.3172 213.596 84.3172 213.226V210.089C84.3009 209.868 84.2353 209.654 84.1251 209.462C84.015 209.27 83.8632 209.105 83.6808 208.979L82.9557 208.565C82.6005 208.358 82.3193 208.521 82.3193 208.935Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M85.5605 210.799V214.011C85.5688 214.233 85.6311 214.451 85.7419 214.644C85.8527 214.837 86.0089 215.001 86.1969 215.121L86.922 215.491C87.2772 215.683 87.5584 215.491 87.5584 215.121V211.968C87.5421 211.748 87.4765 211.533 87.3663 211.341C87.2562 211.149 87.1044 210.984 86.922 210.859L86.1969 210.444C85.8417 210.222 85.5605 210.385 85.5605 210.799Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M88.8008 212.664V215.816C88.8171 216.037 88.8827 216.251 88.9928 216.443C89.103 216.635 89.2548 216.8 89.4371 216.926L90.1623 217.34C90.5026 217.547 90.7986 217.34 90.7986 216.97V213.818C90.7823 213.597 90.7167 213.383 90.6066 213.191C90.4964 212.999 90.3446 212.834 90.1623 212.708L89.4371 212.294C89.082 212.087 88.8008 212.25 88.8008 212.664Z"
                                fill="#263238"
                              />
                              <path
                                d="M92.0276 214.528V217.68C92.0456 217.902 92.1135 218.118 92.2262 218.31C92.339 218.502 92.4936 218.666 92.6787 218.79L93.3891 219.205C93.7442 219.412 94.0402 219.205 94.0402 218.835V215.683C94.0222 215.46 93.9543 215.245 93.8416 215.053C93.7288 214.861 93.5742 214.697 93.3891 214.573L92.6787 214.158C92.6163 214.106 92.5393 214.074 92.4581 214.067C92.377 214.059 92.2955 214.077 92.2246 214.117C92.1538 214.157 92.0969 214.218 92.0617 214.292C92.0265 214.365 92.0146 214.448 92.0276 214.528Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M95.2686 216.394V219.546C95.2865 219.768 95.3544 219.983 95.4672 220.175C95.5799 220.367 95.7346 220.531 95.9197 220.656L96.63 221.07C96.9852 221.277 97.2812 221.07 97.2812 220.7V217.563C97.27 217.339 97.205 217.121 97.0917 216.928C96.9783 216.735 96.8199 216.572 96.63 216.453L95.9197 216.024C95.5645 215.831 95.2686 215.994 95.2686 216.394Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M98.5088 218.273V221.41C98.5251 221.631 98.5907 221.845 98.7008 222.037C98.8109 222.229 98.9628 222.394 99.1451 222.52L99.8703 222.934C100.225 223.142 100.507 222.934 100.507 222.564V219.427C100.49 219.206 100.425 218.992 100.315 218.8C100.204 218.608 100.053 218.443 99.8703 218.317L99.1451 217.903C98.7604 217.696 98.5088 217.858 98.5088 218.273Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M101.72 220.138V223.275C101.736 223.496 101.802 223.71 101.912 223.902C102.022 224.094 102.174 224.259 102.356 224.385L103.081 224.799C103.436 225.006 103.718 224.799 103.718 224.429V221.292C103.701 221.071 103.636 220.857 103.526 220.665C103.415 220.472 103.264 220.308 103.081 220.182L102.356 219.768C102.03 219.56 101.72 219.723 101.72 220.138Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M49.9248 199.597V202.749C49.9411 202.97 50.0067 203.184 50.1168 203.376C50.227 203.568 50.3788 203.733 50.5611 203.859L51.2863 204.273C51.3491 204.32 51.4244 204.348 51.5028 204.353C51.5812 204.357 51.6592 204.339 51.7271 204.299C51.795 204.26 51.8497 204.201 51.8845 204.131C51.9193 204.06 51.9325 203.981 51.9226 203.903V200.692C51.9063 200.471 51.8407 200.257 51.7306 200.065C51.6205 199.872 51.4686 199.708 51.2863 199.582L50.5611 199.168C50.2208 199.02 49.9248 199.212 49.9248 199.597Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M53.1663 201.462V204.614C53.1842 204.836 53.2521 205.051 53.3649 205.243C53.4776 205.436 53.6323 205.6 53.8174 205.724L54.5277 206.138C54.5902 206.191 54.6672 206.223 54.7483 206.23C54.8295 206.237 54.911 206.22 54.9818 206.179C55.0527 206.139 55.1095 206.078 55.1448 206.005C55.18 205.931 55.1919 205.849 55.1789 205.768V202.616C55.1609 202.394 55.093 202.179 54.9803 201.987C54.8675 201.795 54.7128 201.63 54.5277 201.506L53.8174 201.092C53.7549 201.04 53.678 201.008 53.5968 201C53.5156 200.993 53.4342 201.01 53.3633 201.051C53.2925 201.091 53.2356 201.152 53.2004 201.225C53.1652 201.299 53.1532 201.381 53.1663 201.462Z"
                                fill="#263238"
                              />
                              <path
                                d="M56.4065 203.326V206.478C56.4228 206.699 56.4884 206.913 56.5986 207.105C56.7087 207.297 56.8605 207.462 57.0429 207.588L57.768 208.002C58.1232 208.21 58.4191 208.002 58.4191 207.632V204.48C58.4012 204.258 58.3333 204.043 58.2205 203.851C58.1078 203.659 57.9531 203.494 57.768 203.37L57.0429 202.956C56.9801 202.909 56.9048 202.881 56.8264 202.877C56.748 202.872 56.6699 202.891 56.6021 202.93C56.5342 202.97 56.4794 203.028 56.4446 203.099C56.4098 203.169 56.3966 203.248 56.4065 203.326Z"
                                fill="#263238"
                              />
                              <path
                                d="M59.6475 205.206V208.343C59.6637 208.564 59.7294 208.778 59.8395 208.97C59.9496 209.163 60.1015 209.327 60.2838 209.453L61.0089 209.867C61.3641 210.075 61.6453 209.867 61.6453 209.497V206.36C61.637 206.137 61.5748 205.92 61.4639 205.727C61.3531 205.533 61.1969 205.37 61.0089 205.25L60.2838 204.836C59.9286 204.629 59.6475 204.792 59.6475 205.206Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M62.8887 207.07V210.208C62.9049 210.429 62.9706 210.643 63.0807 210.835C63.1908 211.027 63.3427 211.192 63.525 211.318L64.2502 211.732C64.6053 211.939 64.8865 211.732 64.8865 211.362V208.225C64.8702 208.004 64.8046 207.79 64.6945 207.597C64.5843 207.405 64.4325 207.24 64.2502 207.115L63.525 206.7C63.2438 206.493 62.8887 206.612 62.8887 207.07Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M66.2041 208.935V212.072C66.2124 212.295 66.2746 212.512 66.3855 212.706C66.4963 212.899 66.6524 213.062 66.8404 213.182L67.5656 213.596C67.9207 213.804 68.2019 213.596 68.2019 213.226V210.089C68.1856 209.868 68.12 209.654 68.0099 209.462C67.8998 209.27 67.7479 209.105 67.5656 208.979L66.8404 208.565C66.4113 208.358 66.2041 208.521 66.2041 208.935Z"
                                fill="#263238"
                              />
                              <path
                                d="M69.3701 210.799V214.01C69.3784 214.233 69.4406 214.451 69.5515 214.644C69.6623 214.837 69.8185 215.001 70.0065 215.12L70.7316 215.55C70.7944 215.597 70.8697 215.624 70.9481 215.629C71.0265 215.634 71.1045 215.615 71.1724 215.575C71.2403 215.536 71.2951 215.477 71.3298 215.407C71.3646 215.337 71.3779 215.257 71.3679 215.18V212.027C71.3517 211.807 71.286 211.592 71.1759 211.4C71.0658 211.208 70.9139 211.043 70.7316 210.918L70.0065 210.503C69.6513 210.222 69.3701 210.385 69.3701 210.799Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M72.5967 212.664V215.816C72.6147 216.038 72.6826 216.253 72.7953 216.445C72.908 216.638 73.0627 216.802 73.2478 216.926L73.9582 217.34C74.0206 217.393 74.0976 217.425 74.1787 217.432C74.2599 217.439 74.3414 217.422 74.4122 217.381C74.4831 217.341 74.54 217.28 74.5752 217.207C74.6104 217.133 74.6223 217.051 74.6093 216.97V213.818C74.5913 213.596 74.5234 213.381 74.4107 213.189C74.2979 212.997 74.1432 212.832 73.9582 212.708L73.2478 212.294C72.8927 212.087 72.5967 212.25 72.5967 212.664Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M75.8379 214.529V217.681C75.8542 217.902 75.9198 218.116 76.0299 218.308C76.1401 218.5 76.2919 218.665 76.4742 218.791L77.1994 219.205C77.5545 219.413 77.8505 219.205 77.8505 218.835V215.683C77.8325 215.461 77.7646 215.246 77.6519 215.054C77.5391 214.862 77.3845 214.697 77.1994 214.573L76.4742 214.159C76.1339 214.011 75.8379 214.129 75.8379 214.529Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M79.0781 216.394V219.546C79.0944 219.766 79.16 219.981 79.2702 220.173C79.3803 220.365 79.5321 220.53 79.7145 220.656L80.4396 221.07C80.7948 221.277 81.076 221.07 81.076 220.7V217.563C81.0677 217.34 81.0054 217.123 80.8946 216.929C80.7837 216.736 80.6276 216.572 80.4396 216.453L79.7145 216.024C79.3593 215.831 79.0781 215.994 79.0781 216.394Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M82.3193 218.273V221.41C82.3356 221.631 82.4012 221.845 82.5114 222.037C82.6215 222.229 82.7733 222.394 82.9557 222.52L83.6808 222.934C84.036 223.142 84.3172 222.934 84.3172 222.564V219.427C84.3009 219.206 84.2353 218.992 84.1251 218.8C84.015 218.608 83.8632 218.443 83.6808 218.317L82.9557 217.903C82.6005 217.696 82.3193 217.858 82.3193 218.273Z"
                                fill="#263238"
                              />
                              <path
                                d="M85.5605 220.138V223.275C85.5768 223.496 85.6424 223.71 85.7526 223.902C85.8627 224.094 86.0145 224.259 86.1969 224.385L86.922 224.799C87.2772 225.006 87.5584 224.799 87.5584 224.429V221.292C87.5421 221.071 87.4765 220.857 87.3663 220.665C87.2562 220.472 87.1044 220.308 86.922 220.182L86.1969 219.768C85.8417 219.56 85.5605 219.723 85.5605 220.138Z"
                                fill="#263238"
                              />
                              <path
                                d="M88.8008 222.002V225.139C88.8091 225.362 88.8713 225.579 88.9822 225.773C89.093 225.966 89.2491 226.129 89.4371 226.249L90.1623 226.678C90.2251 226.725 90.3004 226.753 90.3788 226.758C90.4572 226.762 90.5352 226.744 90.6031 226.704C90.671 226.665 90.7257 226.606 90.7605 226.536C90.7953 226.465 90.8085 226.386 90.7986 226.308V223.156C90.7823 222.935 90.7167 222.721 90.6066 222.529C90.4964 222.337 90.3446 222.172 90.1623 222.046L89.4371 221.632C89.082 221.41 88.8008 221.588 88.8008 222.002Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M92.0273 223.867V227.019C92.0453 227.241 92.1132 227.456 92.226 227.648C92.3387 227.84 92.4934 228.004 92.6785 228.129L93.3888 228.543C93.744 228.735 94.04 228.543 94.04 228.173V225.021C94.022 224.799 93.9541 224.584 93.8414 224.391C93.7286 224.199 93.5739 224.035 93.3888 223.911L92.6785 223.497C92.3233 223.289 92.0273 223.452 92.0273 223.867Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M95.2688 225.731V228.884C95.2868 229.106 95.3547 229.321 95.4674 229.513C95.5802 229.705 95.7349 229.869 95.9199 229.993L96.6303 230.408C96.6927 230.46 96.7697 230.492 96.8509 230.499C96.932 230.507 97.0135 230.489 97.0844 230.449C97.1552 230.409 97.2121 230.348 97.2473 230.274C97.2825 230.201 97.2944 230.118 97.2814 230.038V226.886C97.2634 226.664 97.1955 226.448 97.0828 226.256C96.97 226.064 96.8154 225.9 96.6303 225.776L95.9199 225.361C95.8575 225.309 95.7805 225.277 95.6993 225.27C95.6182 225.262 95.5367 225.28 95.4658 225.32C95.395 225.36 95.3381 225.421 95.3029 225.495C95.2677 225.568 95.2558 225.651 95.2688 225.731Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M98.5088 227.596V230.748C98.5251 230.969 98.5907 231.183 98.7008 231.375C98.8109 231.567 98.9628 231.732 99.1451 231.858L99.8703 232.272C100.225 232.479 100.507 232.272 100.507 231.902V228.809C100.49 228.589 100.425 228.374 100.315 228.182C100.204 227.99 100.053 227.825 99.8703 227.699L99.1451 227.285C98.7604 227.034 98.5088 227.196 98.5088 227.596Z"
                                fill="#263238"
                              />
                              <path
                                d="M101.72 229.46V232.613C101.736 232.833 101.802 233.048 101.912 233.24C102.022 233.432 102.174 233.597 102.356 233.722L103.081 234.137C103.436 234.344 103.718 234.137 103.718 233.767V230.629C103.709 230.407 103.647 230.189 103.536 229.996C103.425 229.803 103.269 229.639 103.081 229.52L102.356 229.09C102.03 228.898 101.72 229.061 101.72 229.46Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M112.568 230.778L114.048 229.934C114.362 229.791 114.708 229.733 115.051 229.767C115.394 229.801 115.722 229.925 116.002 230.127C116.812 230.655 117.486 231.368 117.969 232.206C118.453 233.044 118.732 233.985 118.784 234.951C118.82 235.297 118.763 235.646 118.62 235.963C118.477 236.281 118.253 236.554 117.97 236.756L116.608 237.541L116.357 237.126C116.076 237.064 115.807 236.959 115.558 236.816C114.747 236.287 114.073 235.574 113.59 234.736C113.107 233.898 112.828 232.957 112.776 231.991C112.773 231.752 112.803 231.513 112.864 231.281L112.568 230.778Z"
                                fill="#BBE9F8"
                              />
                              <path
                                opacity="0.2"
                                d="M112.568 230.778L114.048 229.934C114.362 229.791 114.708 229.733 115.051 229.767C115.394 229.801 115.722 229.925 116.002 230.127C116.812 230.655 117.486 231.368 117.969 232.206C118.453 233.044 118.732 233.985 118.784 234.951C118.82 235.297 118.763 235.646 118.62 235.963C118.477 236.281 118.253 236.554 117.97 236.756L116.608 237.541L116.357 237.126C116.076 237.064 115.807 236.959 115.558 236.816C114.747 236.287 114.073 235.574 113.59 234.736C113.107 233.898 112.828 232.957 112.776 231.991C112.773 231.752 112.803 231.513 112.864 231.281L112.568 230.778Z"
                                fill="black"
                              />
                              <path
                                d="M114.596 230.94C115.406 231.469 116.08 232.182 116.563 233.02C117.047 233.858 117.326 234.798 117.378 235.765C117.378 237.54 116.135 238.266 114.596 237.378C113.785 236.849 113.111 236.136 112.628 235.298C112.144 234.46 111.865 233.52 111.813 232.553C111.813 230.777 113.057 230.052 114.596 230.94Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M124.658 237.763L126.138 236.919C126.453 236.778 126.8 236.723 127.143 236.759C127.486 236.796 127.813 236.922 128.091 237.126C128.902 237.655 129.576 238.368 130.059 239.206C130.543 240.044 130.822 240.985 130.874 241.951C130.912 242.295 130.856 242.643 130.713 242.958C130.57 243.273 130.344 243.544 130.06 243.741L128.698 244.511L128.447 244.111C128.168 244.042 127.9 243.937 127.648 243.801C126.837 243.272 126.163 242.559 125.68 241.721C125.196 240.883 124.917 239.942 124.865 238.976C124.862 238.737 124.892 238.497 124.954 238.266L124.658 237.763Z"
                                fill="#BBE9F8"
                              />
                              <path
                                opacity="0.2"
                                d="M124.658 237.763L126.138 236.919C126.453 236.778 126.8 236.723 127.143 236.759C127.486 236.796 127.813 236.922 128.091 237.126C128.902 237.655 129.576 238.368 130.059 239.206C130.543 240.044 130.822 240.985 130.874 241.951C130.912 242.295 130.856 242.643 130.713 242.958C130.57 243.273 130.344 243.544 130.06 243.741L128.698 244.511L128.447 244.111C128.168 244.042 127.9 243.937 127.648 243.801C126.837 243.272 126.163 242.559 125.68 241.721C125.196 240.883 124.917 239.942 124.865 238.976C124.862 238.737 124.892 238.497 124.954 238.266L124.658 237.763Z"
                                fill="black"
                              />
                              <path
                                d="M126.686 237.925C127.497 238.454 128.171 239.167 128.654 240.005C129.137 240.843 129.416 241.784 129.468 242.75C129.468 244.526 128.225 245.236 126.686 244.348C125.88 243.817 125.209 243.103 124.728 242.265C124.248 241.427 123.97 240.488 123.919 239.524C123.919 237.689 125.147 237.037 126.686 237.925Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M43.917 137.458L140.108 192.997L236.285 137.458L140.108 81.9331L43.917 137.458Z"
                                fill="#263238"
                              />
                              <path
                                d="M43.917 165.234L140.108 220.759V192.996L43.917 137.457V165.234Z"
                                fill="#455A64"
                              />
                              <path
                                d="M140.108 220.759L236.285 165.234V137.457L140.108 192.996V220.759Z"
                                fill="#00121B"
                              />
                              <path
                                d="M55.9482 179.116V172.16L140.108 220.759V227.699L55.9482 179.116Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M230.277 168.697V175.638L140.108 227.699V220.759L230.277 168.697Z"
                                fill="#BBE9F8"
                              />
                              <path
                                opacity="0.2"
                                d="M230.277 168.697V175.638L140.108 227.699V220.759L230.277 168.697Z"
                                fill="black"
                              />
                              <path
                                d="M49.9248 148.616V151.768C49.9411 151.988 50.0067 152.203 50.1168 152.395C50.227 152.587 50.3788 152.752 50.5611 152.878L51.2863 153.292C51.3491 153.339 51.4244 153.367 51.5028 153.371C51.5812 153.376 51.6592 153.357 51.7271 153.318C51.795 153.278 51.8497 153.22 51.8845 153.149C51.9193 153.079 51.9325 153 51.9226 152.922V149.77C51.9063 149.549 51.8407 149.335 51.7306 149.143C51.6205 148.95 51.4686 148.786 51.2863 148.66L50.5611 148.246C50.2208 148.038 49.9248 148.201 49.9248 148.616Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M53.1663 150.48V153.632C53.1842 153.854 53.2521 154.069 53.3649 154.261C53.4776 154.454 53.6323 154.618 53.8174 154.742L54.5277 155.156C54.5902 155.209 54.6672 155.241 54.7483 155.248C54.8295 155.255 54.911 155.238 54.9818 155.198C55.0527 155.157 55.1095 155.096 55.1448 155.023C55.18 154.949 55.1919 154.867 55.1789 154.786V151.634C55.1609 151.412 55.093 151.197 54.9803 151.005C54.8675 150.813 54.7128 150.648 54.5277 150.524L53.8174 150.11C53.7549 150.058 53.678 150.026 53.5968 150.018C53.5156 150.011 53.4342 150.029 53.3633 150.069C53.2925 150.109 53.2356 150.17 53.2004 150.243C53.1652 150.317 53.1532 150.399 53.1663 150.48Z"
                                fill="#263238"
                              />
                              <path
                                d="M56.4065 152.345V155.497C56.4228 155.718 56.4884 155.932 56.5986 156.124C56.7087 156.316 56.8605 156.481 57.0429 156.607L57.768 157.021C58.1232 157.228 58.4191 157.021 58.4191 156.651V153.499C58.4012 153.277 58.3333 153.062 58.2205 152.869C58.1078 152.677 57.9531 152.513 57.768 152.389L57.0429 151.975C56.9801 151.927 56.9048 151.9 56.8264 151.895C56.748 151.891 56.6699 151.909 56.6021 151.949C56.5342 151.988 56.4794 152.047 56.4446 152.117C56.4098 152.188 56.3966 152.267 56.4065 152.345Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M59.6475 154.209V157.362C59.6637 157.582 59.7294 157.797 59.8395 157.989C59.9496 158.181 60.1015 158.346 60.2838 158.471L61.0089 158.886C61.3641 159.093 61.6453 158.886 61.6453 158.516V155.379C61.637 155.156 61.5748 154.938 61.4639 154.745C61.3531 154.552 61.1969 154.388 61.0089 154.269L60.2838 153.839C59.9286 153.647 59.6475 153.81 59.6475 154.209Z"
                                fill="#263238"
                              />
                              <path
                                d="M62.8887 156.089V159.256C62.9049 159.477 62.9706 159.691 63.0807 159.883C63.1908 160.075 63.3427 160.24 63.525 160.366L64.2502 160.78C64.6053 160.987 64.8865 160.78 64.8865 160.41V157.273C64.8702 157.052 64.8046 156.838 64.6945 156.646C64.5843 156.453 64.4325 156.289 64.2502 156.163L63.525 155.749C63.2438 155.512 62.8887 155.675 62.8887 156.089Z"
                                fill="#263238"
                              />
                              <path
                                d="M66.2041 157.953V161.091C66.2204 161.312 66.286 161.526 66.3961 161.718C66.5063 161.91 66.6581 162.075 66.8404 162.201L67.5656 162.615C67.9207 162.822 68.2019 162.615 68.2019 162.245V159.108C68.1856 158.887 68.12 158.673 68.0099 158.48C67.8998 158.288 67.7479 158.123 67.5656 157.998L66.8404 157.583C66.4113 157.376 66.2041 157.539 66.2041 157.953Z"
                                fill="#263238"
                              />
                              <path
                                d="M69.3701 159.818V162.955C69.3784 163.178 69.4406 163.395 69.5515 163.589C69.6623 163.782 69.8185 163.946 70.0065 164.065L70.7316 164.494C70.7944 164.542 70.8697 164.569 70.9481 164.574C71.0265 164.578 71.1045 164.56 71.1724 164.52C71.2403 164.481 71.2951 164.422 71.3298 164.352C71.3646 164.281 71.3779 164.202 71.3679 164.124V160.972C71.3517 160.751 71.286 160.537 71.1759 160.345C71.0658 160.153 70.9139 159.988 70.7316 159.862L70.0065 159.448C69.6513 159.256 69.3701 159.404 69.3701 159.818Z"
                                fill="#263238"
                              />
                              <path
                                d="M72.5967 161.683V164.835C72.6147 165.057 72.6826 165.272 72.7953 165.464C72.908 165.657 73.0627 165.821 73.2478 165.945L73.9582 166.359C74.0206 166.412 74.0976 166.444 74.1787 166.451C74.2599 166.458 74.3414 166.441 74.4122 166.401C74.4831 166.36 74.54 166.299 74.5752 166.226C74.6104 166.152 74.6223 166.07 74.6093 165.989V162.837C74.5913 162.615 74.5234 162.4 74.4107 162.208C74.2979 162.016 74.1432 161.851 73.9582 161.727L73.2478 161.313C72.8927 161.106 72.5967 161.269 72.5967 161.683Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M75.8379 163.547V166.655C75.8542 166.876 75.9198 167.09 76.0299 167.282C76.1401 167.474 76.2919 167.639 76.4742 167.765L77.1994 168.179C77.2618 168.232 77.3388 168.264 77.42 168.271C77.5011 168.278 77.5826 168.261 77.6535 168.22C77.7243 168.18 77.7812 168.119 77.8164 168.046C77.8516 167.972 77.8635 167.89 77.8505 167.809V164.657C77.8325 164.435 77.7646 164.22 77.6519 164.028C77.5391 163.836 77.3845 163.671 77.1994 163.547L76.4742 163.133C76.1339 162.97 75.8379 163.148 75.8379 163.547Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M79.0781 165.412V168.564C79.0944 168.785 79.16 168.999 79.2702 169.191C79.3803 169.383 79.5321 169.548 79.7145 169.674L80.4396 170.088C80.7948 170.295 81.076 170.088 81.076 169.718V166.655C81.0677 166.432 81.0054 166.215 80.8946 166.021C80.7837 165.828 80.6276 165.665 80.4396 165.545L79.7145 165.116C79.3593 164.849 79.0781 165.012 79.0781 165.412Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M82.3193 167.292V170.429C82.3356 170.65 82.4012 170.864 82.5114 171.056C82.6215 171.248 82.7733 171.413 82.9557 171.539L83.6808 171.953C84.036 172.16 84.3172 171.953 84.3172 171.583V168.446C84.3089 168.223 84.2466 168.006 84.1358 167.812C84.0249 167.619 83.8688 167.456 83.6808 167.336L82.9557 166.922C82.6005 166.655 82.3193 166.877 82.3193 167.292Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M85.5605 169.156V172.293C85.5768 172.514 85.6424 172.729 85.7526 172.921C85.8627 173.113 86.0145 173.278 86.1969 173.403L86.922 173.818C87.2772 174.025 87.5584 173.818 87.5584 173.448V170.31C87.5421 170.09 87.4765 169.875 87.3663 169.683C87.2562 169.491 87.1044 169.326 86.922 169.2L86.1969 168.786C85.8417 168.579 85.5605 168.742 85.5605 169.156Z"
                                fill="#263238"
                              />
                              <path
                                d="M88.8008 171.095V174.232C88.8091 174.455 88.8713 174.672 88.9822 174.866C89.093 175.059 89.2491 175.222 89.4371 175.342L90.1623 175.757C90.5026 175.964 90.7986 175.757 90.7986 175.387V172.249C90.7823 172.028 90.7167 171.814 90.6066 171.622C90.4964 171.43 90.3446 171.265 90.1623 171.139L89.4371 170.725C89.082 170.444 88.8008 170.607 88.8008 171.095Z"
                                fill="#263238"
                              />
                              <path
                                d="M92.0273 172.885V176.037C92.0453 176.26 92.1132 176.475 92.226 176.667C92.3387 176.859 92.4934 177.023 92.6785 177.147L93.3888 177.562C93.744 177.754 94.04 177.562 94.04 177.192V174.054C94.022 173.832 93.9541 173.617 93.8414 173.425C93.7286 173.233 93.5739 173.069 93.3888 172.945L92.6785 172.53C92.3233 172.308 92.0273 172.471 92.0273 172.885Z"
                                fill="#263238"
                              />
                              <path
                                d="M95.2688 174.75V177.902C95.2868 178.124 95.3547 178.339 95.4674 178.531C95.5802 178.724 95.7349 178.888 95.9199 179.012L96.6303 179.426C96.6927 179.479 96.7697 179.511 96.8509 179.518C96.932 179.525 97.0135 179.508 97.0844 179.468C97.1552 179.427 97.2121 179.366 97.2473 179.293C97.2825 179.219 97.2944 179.137 97.2814 179.056V175.904C97.2634 175.682 97.1955 175.467 97.0828 175.275C96.97 175.083 96.8154 174.918 96.6303 174.794L95.9199 174.38C95.8575 174.328 95.7805 174.296 95.6993 174.288C95.6182 174.281 95.5367 174.299 95.4658 174.339C95.395 174.379 95.3381 174.44 95.3029 174.514C95.2677 174.587 95.2558 174.669 95.2688 174.75Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M98.5088 176.614V179.766C98.5251 179.987 98.5907 180.202 98.7008 180.394C98.8109 180.586 98.9628 180.751 99.1451 180.876L99.8703 181.291C100.225 181.498 100.507 181.291 100.507 180.921V177.769C100.49 177.548 100.425 177.333 100.315 177.141C100.204 176.949 100.053 176.784 99.8703 176.659L99.1451 176.244C98.7604 176.037 98.5088 176.215 98.5088 176.614Z"
                                fill="#263238"
                              />
                              <path
                                d="M101.72 178.494V181.646C101.736 181.867 101.802 182.081 101.912 182.273C102.022 182.465 102.174 182.63 102.356 182.756L103.081 183.17C103.436 183.378 103.718 183.17 103.718 182.8V179.663C103.709 179.44 103.647 179.223 103.536 179.03C103.425 178.836 103.269 178.673 103.081 178.553L102.356 178.124C102.03 177.917 101.72 178.08 101.72 178.494Z"
                                fill="#263238"
                              />
                              <path
                                d="M49.9248 157.953V161.091C49.9411 161.312 50.0067 161.526 50.1168 161.718C50.227 161.91 50.3788 162.075 50.5611 162.201L51.2863 162.615C51.6266 162.822 51.9226 162.615 51.9226 162.245V159.108C51.9063 158.887 51.8407 158.673 51.7306 158.48C51.6205 158.288 51.4686 158.123 51.2863 157.998L50.5611 157.583C50.2208 157.376 49.9248 157.539 49.9248 157.953Z"
                                fill="#263238"
                              />
                              <path
                                d="M53.166 159.818V162.955C53.1772 163.179 53.2422 163.397 53.3555 163.59C53.4689 163.783 53.6273 163.946 53.8172 164.065L54.5275 164.494C54.8827 164.687 55.1786 164.494 55.1786 164.124V160.972C55.1607 160.75 55.0928 160.535 54.98 160.343C54.8673 160.151 54.7126 159.986 54.5275 159.862L53.8172 159.448C53.462 159.256 53.166 159.404 53.166 159.818Z"
                                fill="#263238"
                              />
                              <path
                                d="M56.4072 161.683V164.835C56.4235 165.056 56.4891 165.27 56.5993 165.462C56.7094 165.654 56.8612 165.819 57.0436 165.945L57.7687 166.359C57.8312 166.412 57.9081 166.444 57.9893 166.451C58.0705 166.458 58.1519 166.441 58.2228 166.401C58.2936 166.36 58.3505 166.299 58.3857 166.226C58.4209 166.152 58.4329 166.07 58.4198 165.989V162.837C58.4019 162.615 58.334 162.4 58.2212 162.208C58.1085 162.016 57.9538 161.851 57.7687 161.727L57.0436 161.313C56.7032 161.106 56.4072 161.269 56.4072 161.683Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M59.6475 163.547V166.655C59.6637 166.876 59.7294 167.09 59.8395 167.282C59.9496 167.474 60.1015 167.639 60.2838 167.765L61.0089 168.179C61.3641 168.386 61.6453 168.179 61.6453 167.809V164.657C61.629 164.436 61.5634 164.222 61.4532 164.03C61.3431 163.838 61.1913 163.673 61.0089 163.547L60.2838 163.133C59.9286 162.97 59.6475 163.148 59.6475 163.547Z"
                                fill="#263238"
                              />
                              <path
                                d="M62.8887 165.412V168.564C62.9049 168.785 62.9706 168.999 63.0807 169.191C63.1908 169.383 63.3427 169.548 63.525 169.674L64.2502 170.088C64.6053 170.295 64.8865 170.088 64.8865 169.718V166.655C64.8782 166.432 64.816 166.215 64.7051 166.021C64.5943 165.828 64.4382 165.665 64.2502 165.545L63.525 165.116C63.2438 164.849 62.8887 165.012 62.8887 165.412Z"
                                fill="#263238"
                              />
                              <path
                                d="M66.2041 167.292V170.429C66.2204 170.65 66.286 170.864 66.3961 171.056C66.5063 171.248 66.6581 171.413 66.8404 171.539L67.5656 171.953C67.9207 172.16 68.2019 171.953 68.2019 171.583V168.446C68.1936 168.223 68.1314 168.006 68.0206 167.812C67.9097 167.619 67.7536 167.456 67.5656 167.336L66.8404 166.922C66.4113 166.655 66.2041 166.877 66.2041 167.292Z"
                                fill="#263238"
                              />
                              <path
                                d="M69.3701 169.156V172.293C69.3864 172.514 69.452 172.729 69.5622 172.921C69.6723 173.113 69.8241 173.278 70.0065 173.403L70.7316 173.818C71.072 174.025 71.3679 173.818 71.3679 173.448V170.31C71.3517 170.09 71.286 169.875 71.1759 169.683C71.0658 169.491 70.9139 169.326 70.7316 169.2L70.0065 168.786C69.6513 168.579 69.3701 168.742 69.3701 169.156Z"
                                fill="#263238"
                              />
                              <path
                                d="M72.5967 171.095V174.232C72.6078 174.456 72.6728 174.674 72.7862 174.867C72.8996 175.06 73.0579 175.223 73.2478 175.342L73.9582 175.757C74.3133 175.964 74.6093 175.757 74.6093 175.387V172.249C74.5913 172.027 74.5234 171.812 74.4107 171.62C74.2979 171.428 74.1432 171.263 73.9582 171.139L73.2478 170.725C72.8927 170.444 72.5967 170.607 72.5967 171.095Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M75.8379 172.885V176.037C75.8542 176.258 75.9198 176.473 76.0299 176.665C76.1401 176.857 76.2919 177.022 76.4742 177.147L77.1994 177.562C77.5545 177.754 77.8505 177.562 77.8505 177.192V174.054C77.8325 173.832 77.7646 173.617 77.6519 173.425C77.5391 173.233 77.3845 173.069 77.1994 172.945L76.4742 172.53C76.1339 172.308 75.8379 172.471 75.8379 172.885Z"
                                fill="#263238"
                              />
                              <path
                                d="M79.0781 174.75V177.902C79.0944 178.123 79.16 178.337 79.2702 178.529C79.3803 178.721 79.5321 178.886 79.7145 179.012L80.4396 179.426C80.7948 179.633 81.076 179.426 81.076 179.056V175.904C81.0597 175.683 80.994 175.469 80.8839 175.277C80.7738 175.085 80.622 174.92 80.4396 174.794L79.7145 174.38C79.3593 174.172 79.0781 174.35 79.0781 174.75Z"
                                fill="#263238"
                              />
                              <path
                                d="M82.3193 176.614V179.766C82.3356 179.987 82.4012 180.202 82.5114 180.394C82.6215 180.586 82.7733 180.751 82.9557 180.876L83.6808 181.291C84.036 181.498 84.3172 181.291 84.3172 180.921V177.769C84.3009 177.548 84.2353 177.333 84.1251 177.141C84.015 176.949 83.8632 176.784 83.6808 176.659L82.9557 176.244C82.6005 176.037 82.3193 176.215 82.3193 176.614Z"
                                fill="#263238"
                              />
                              <path
                                d="M85.5605 178.495V181.647C85.5768 181.867 85.6424 182.082 85.7526 182.274C85.8627 182.466 86.0145 182.631 86.1969 182.757L86.922 183.171C87.2772 183.378 87.5584 183.171 87.5584 182.801V179.664C87.5598 179.431 87.5022 179.202 87.3909 178.997C87.2796 178.793 87.1183 178.62 86.922 178.495L86.1969 178.065C85.8417 177.917 85.5605 178.08 85.5605 178.495Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M88.8008 180.359V183.496C88.8171 183.717 88.8827 183.932 88.9928 184.124C89.103 184.316 89.2548 184.481 89.4371 184.606L90.1623 185.021C90.5026 185.228 90.7986 185.021 90.7986 184.651V181.454C90.7823 181.233 90.7167 181.019 90.6066 180.827C90.4964 180.635 90.3446 180.47 90.1623 180.344L89.4371 179.974C89.082 179.782 88.8008 179.974 88.8008 180.359Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M92.0273 182.223V185.361C92.0453 185.583 92.1132 185.798 92.226 185.99C92.3387 186.182 92.4934 186.347 92.6785 186.471L93.3888 186.885C93.744 187.092 94.04 186.885 94.04 186.515V183.378C94.022 183.156 93.9541 182.94 93.8414 182.748C93.7286 182.556 93.5739 182.392 93.3888 182.268L92.6785 181.853C92.3233 181.646 92.0273 181.809 92.0273 182.223Z"
                                fill="#263238"
                              />
                              <path
                                d="M95.2686 184.088V187.225C95.2797 187.449 95.3447 187.667 95.4581 187.86C95.5714 188.054 95.7298 188.217 95.9197 188.335L96.63 188.765C96.9852 188.957 97.2812 188.765 97.2812 188.395V185.242C97.2632 185.02 97.1953 184.805 97.0826 184.613C96.9698 184.421 96.8151 184.257 96.63 184.133L95.9197 183.718C95.5645 183.511 95.2686 183.674 95.2686 184.088Z"
                                fill="#263238"
                              />
                              <path
                                d="M98.5088 185.893V189.045C98.5251 189.266 98.5907 189.481 98.7008 189.673C98.8109 189.865 98.9628 190.03 99.1451 190.155L99.8703 190.57C100.225 190.777 100.507 190.57 100.507 190.2V187.048C100.49 186.827 100.425 186.612 100.315 186.42C100.204 186.228 100.053 186.063 99.8703 185.938L99.1451 185.523C98.7604 185.375 98.5088 185.538 98.5088 185.893Z"
                                fill="#263238"
                              />
                              <path
                                d="M101.72 187.817V190.969C101.736 191.19 101.802 191.404 101.912 191.596C102.022 191.788 102.174 191.953 102.356 192.079L103.081 192.493C103.436 192.701 103.718 192.493 103.718 192.123V188.971C103.701 188.75 103.636 188.536 103.526 188.344C103.415 188.152 103.264 187.987 103.081 187.861L102.356 187.447C102.03 187.24 101.72 187.373 101.72 187.817Z"
                                fill="#263238"
                              />
                              <path
                                d="M112.568 189.134L114.048 188.291C114.361 188.143 114.708 188.083 115.052 188.117C115.396 188.15 115.724 188.277 116.002 188.483C116.81 189.011 117.483 189.721 117.966 190.556C118.449 191.392 118.73 192.329 118.784 193.293C118.82 193.639 118.763 193.988 118.62 194.305C118.477 194.622 118.253 194.896 117.97 195.098L116.608 195.882L116.357 195.468C116.076 195.405 115.807 195.3 115.558 195.157C114.747 194.628 114.073 193.916 113.59 193.078C113.107 192.239 112.828 191.299 112.776 190.333C112.772 190.093 112.802 189.854 112.864 189.623L112.568 189.134Z"
                                fill="#BBE9F8"
                              />
                              <path
                                opacity="0.2"
                                d="M112.568 189.134L114.048 188.291C114.361 188.143 114.708 188.083 115.052 188.117C115.396 188.15 115.724 188.277 116.002 188.483C116.81 189.011 117.483 189.721 117.966 190.556C118.449 191.392 118.73 192.329 118.784 193.293C118.82 193.639 118.763 193.988 118.62 194.305C118.477 194.622 118.253 194.896 117.97 195.098L116.608 195.882L116.357 195.468C116.076 195.405 115.807 195.3 115.558 195.157C114.747 194.628 114.073 193.916 113.59 193.078C113.107 192.239 112.828 191.299 112.776 190.333C112.772 190.093 112.802 189.854 112.864 189.623L112.568 189.134Z"
                                fill="black"
                              />
                              <path
                                d="M114.596 189.297C115.406 189.826 116.08 190.538 116.563 191.376C117.047 192.215 117.326 193.155 117.378 194.121C117.378 195.897 116.135 196.607 114.596 195.719C113.786 195.194 113.111 194.484 112.628 193.648C112.144 192.812 111.865 191.874 111.813 190.91C111.813 189.134 113.057 188.409 114.596 189.297Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M124.658 196.119L126.138 195.261C126.452 195.121 126.798 195.065 127.14 195.098C127.483 195.132 127.811 195.254 128.091 195.453C128.902 195.982 129.576 196.695 130.059 197.533C130.543 198.371 130.822 199.311 130.874 200.278C130.91 200.624 130.853 200.973 130.71 201.29C130.567 201.607 130.343 201.881 130.06 202.083L128.698 202.867L128.447 202.453C128.166 202.39 127.897 202.285 127.648 202.142C126.837 201.613 126.163 200.901 125.68 200.063C125.196 199.224 124.917 198.284 124.865 197.318C124.864 197.078 124.894 196.839 124.954 196.608L124.658 196.119Z"
                                fill="#BBE9F8"
                              />
                              <path
                                opacity="0.2"
                                d="M124.658 196.119L126.138 195.261C126.452 195.121 126.798 195.065 127.14 195.098C127.483 195.132 127.811 195.254 128.091 195.453C128.902 195.982 129.576 196.695 130.059 197.533C130.543 198.371 130.822 199.311 130.874 200.278C130.91 200.624 130.853 200.973 130.71 201.29C130.567 201.607 130.343 201.881 130.06 202.083L128.698 202.867L128.447 202.453C128.166 202.39 127.897 202.285 127.648 202.142C126.837 201.613 126.163 200.901 125.68 200.063C125.196 199.224 124.917 198.284 124.865 197.318C124.864 197.078 124.894 196.839 124.954 196.608L124.658 196.119Z"
                                fill="black"
                              />
                              <path
                                d="M126.686 196.252C127.497 196.781 128.171 197.493 128.654 198.332C129.137 199.17 129.416 200.11 129.468 201.076C129.468 202.852 128.225 203.577 126.686 202.69C125.882 202.16 125.212 201.448 124.732 200.613C124.251 199.778 123.973 198.842 123.919 197.88C123.919 196.104 125.147 195.379 126.686 196.252Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M43.917 95.8136L140.108 151.353L236.285 95.8136L140.108 40.2891L43.917 95.8136Z"
                                fill="#263238"
                              />
                              <path
                                d="M43.917 123.576L140.108 179.116V151.353L43.917 95.814V123.576Z"
                                fill="#455A64"
                              />
                              <path
                                d="M140.108 179.116L236.285 123.576V95.814L140.108 151.353V179.116Z"
                                fill="#00121B"
                              />
                              <path
                                d="M55.9482 137.457V130.517L140.108 179.115V186.056L55.9482 137.457Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M230.277 127.054V133.994L140.108 186.056V179.115L230.277 127.054Z"
                                fill="#BBE9F8"
                              />
                              <path
                                opacity="0.2"
                                d="M230.277 127.054V133.994L140.108 186.056V179.115L230.277 127.054Z"
                                fill="black"
                              />
                              <path
                                d="M49.9248 106.972V110.109C49.9411 110.33 50.0067 110.544 50.1168 110.737C50.227 110.929 50.3788 111.094 50.5611 111.219L51.2863 111.634C51.6266 111.841 51.9226 111.634 51.9226 111.264V108.126C51.9063 107.905 51.8407 107.691 51.7306 107.499C51.6205 107.307 51.4686 107.142 51.2863 107.016L50.5611 106.602C50.2208 106.395 49.9248 106.558 49.9248 106.972Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M53.166 108.837V111.974C53.1772 112.198 53.2422 112.416 53.3555 112.609C53.4689 112.802 53.6273 112.965 53.8172 113.084L54.5275 113.513C54.8827 113.705 55.1786 113.513 55.1786 113.143V109.991C55.1607 109.769 55.0928 109.554 54.98 109.362C54.8673 109.169 54.7126 109.005 54.5275 108.881L53.8172 108.467C53.462 108.26 53.166 108.422 53.166 108.837Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M56.4072 110.701V113.854C56.4235 114.074 56.4891 114.289 56.5993 114.481C56.7094 114.673 56.8612 114.838 57.0436 114.964L57.7687 115.378C58.1239 115.57 58.4198 115.378 58.4198 115.008V111.9C58.4019 111.678 58.334 111.463 58.2212 111.271C58.1085 111.079 57.9538 110.914 57.7687 110.79L57.0436 110.376C56.7032 110.124 56.4072 110.287 56.4072 110.701Z"
                                fill="#263238"
                              />
                              <path
                                d="M59.6475 112.566V115.719C59.6637 115.939 59.7294 116.154 59.8395 116.346C59.9496 116.538 60.1015 116.703 60.2838 116.829L61.0089 117.243C61.3641 117.45 61.6453 117.243 61.6453 116.873V113.721C61.629 113.5 61.5634 113.286 61.4532 113.094C61.3431 112.901 61.1913 112.737 61.0089 112.611L60.2838 112.197C59.9286 111.989 59.6475 112.167 59.6475 112.566Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M62.8887 114.431V117.583C62.9049 117.804 62.9706 118.018 63.0807 118.21C63.1908 118.402 63.3427 118.567 63.525 118.693L64.2502 119.107C64.6053 119.314 64.8865 119.107 64.8865 118.737V115.585C64.8702 115.364 64.8046 115.15 64.6945 114.958C64.5843 114.766 64.4325 114.601 64.2502 114.475L63.525 114.061C63.2438 113.868 62.8887 114.031 62.8887 114.431Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M66.2041 116.34V119.477C66.2204 119.698 66.286 119.912 66.3961 120.104C66.5063 120.297 66.6581 120.461 66.8404 120.587L67.5656 121.001C67.9207 121.209 68.2019 121.001 68.2019 120.631V117.494C68.1936 117.271 68.1314 117.054 68.0206 116.861C67.9097 116.667 67.7536 116.504 67.5656 116.384L66.8404 115.97C66.4113 115.733 66.2041 115.896 66.2041 116.34Z"
                                fill="#263238"
                              />
                              <path
                                d="M69.3701 118.174V121.312C69.3864 121.533 69.452 121.747 69.5622 121.939C69.6723 122.131 69.8241 122.296 70.0065 122.422L70.7316 122.836C71.072 123.043 71.3679 122.836 71.3679 122.466V119.299C71.3517 119.078 71.286 118.864 71.1759 118.672C71.0658 118.48 70.9139 118.315 70.7316 118.189L70.0065 117.775C69.6513 117.597 69.3701 117.819 69.3701 118.174Z"
                                fill="#263238"
                              />
                              <path
                                d="M72.5967 120.039V123.177C72.6078 123.4 72.6728 123.618 72.7862 123.811C72.8996 124.005 73.0579 124.168 73.2478 124.287L73.9582 124.701C74.3133 124.908 74.6093 124.701 74.6093 124.331V121.194C74.5913 120.972 74.5234 120.756 74.4107 120.564C74.2979 120.372 74.1432 120.208 73.9582 120.084L73.2478 119.669C72.8927 119.462 72.5967 119.625 72.5967 120.039Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M75.8379 121.904V125.041C75.8542 125.262 75.9198 125.477 76.0299 125.669C76.1401 125.861 76.2919 126.026 76.4742 126.151L77.1994 126.58C77.5545 126.773 77.8505 126.58 77.8505 126.211V123.058C77.8325 122.836 77.7646 122.621 77.6519 122.429C77.5391 122.237 77.3845 122.073 77.1994 121.949L76.4742 121.534C76.1339 121.327 75.8379 121.49 75.8379 121.904Z"
                                fill="#263238"
                              />
                              <path
                                d="M79.0781 123.739V126.891C79.0944 127.112 79.16 127.326 79.2702 127.518C79.3803 127.71 79.5321 127.875 79.7145 128.001L80.4396 128.415C80.7948 128.622 81.076 128.415 81.076 128.045V124.923C81.0597 124.702 80.994 124.487 80.8839 124.295C80.7738 124.103 80.622 123.938 80.4396 123.813L79.7145 123.398C79.3593 123.191 79.0781 123.369 79.0781 123.739Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M82.3193 125.633V128.785C82.3356 129.006 82.4012 129.22 82.5114 129.412C82.6215 129.605 82.7733 129.77 82.9557 129.895L83.6808 130.309C84.036 130.517 84.3172 130.309 84.3172 129.94V126.787C84.3009 126.567 84.2353 126.352 84.1251 126.16C84.015 125.968 83.8632 125.803 83.6808 125.678L82.9557 125.263C82.6005 125.056 82.3193 125.219 82.3193 125.633Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M85.5605 127.498V130.65C85.5768 130.87 85.6424 131.085 85.7526 131.277C85.8627 131.469 86.0145 131.634 86.1969 131.76L86.922 132.174C87.2772 132.381 87.5584 132.174 87.5584 131.804V128.667C87.5501 128.444 87.4878 128.227 87.377 128.033C87.2662 127.84 87.11 127.676 86.922 127.557L86.1969 127.128C85.8417 126.935 85.5605 127.098 85.5605 127.498Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M88.8008 129.377V132.515C88.8171 132.735 88.8827 132.95 88.9928 133.142C89.103 133.334 89.2548 133.499 89.4371 133.624L90.1623 134.039C90.5026 134.246 90.7986 134.039 90.7986 133.669V130.532C90.7823 130.311 90.7167 130.096 90.6066 129.904C90.4964 129.712 90.3446 129.547 90.1623 129.422L89.4371 129.007C89.082 128.8 88.8008 128.963 88.8008 129.377Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M92.0273 131.242V134.379C92.0453 134.601 92.1132 134.817 92.226 135.009C92.3387 135.201 92.4934 135.365 92.6785 135.489L93.3888 135.904C93.744 136.111 94.04 135.904 94.04 135.534V132.396C94.022 132.174 93.9541 131.959 93.8414 131.767C93.7286 131.575 93.5739 131.41 93.3888 131.286L92.6785 130.872C92.3233 130.665 92.0273 130.828 92.0273 131.242Z"
                                fill="#263238"
                              />
                              <path
                                d="M95.2686 133.106V136.244C95.2797 136.467 95.3447 136.685 95.4581 136.878C95.5714 137.072 95.7298 137.235 95.9197 137.353L96.63 137.783C96.9852 137.975 97.2812 137.783 97.2812 137.413V134.261C97.2632 134.038 97.1953 133.823 97.0826 133.631C96.9698 133.439 96.8151 133.275 96.63 133.151L95.9197 132.736C95.5645 132.529 95.2686 132.692 95.2686 133.106Z"
                                fill="#263238"
                              />
                              <path
                                d="M98.5088 134.971V138.123C98.5251 138.344 98.5907 138.558 98.7008 138.75C98.8109 138.942 98.9628 139.107 99.1451 139.233L99.8703 139.647C100.225 139.84 100.507 139.647 100.507 139.277V136.125C100.49 135.904 100.425 135.69 100.315 135.498C100.204 135.306 100.053 135.141 99.8703 135.015L99.1451 134.601C98.7604 134.394 98.5088 134.557 98.5088 134.971Z"
                                fill="#263238"
                              />
                              <path
                                d="M101.72 136.836V140.018C101.736 140.239 101.802 140.453 101.912 140.645C102.022 140.837 102.174 141.002 102.356 141.128L103.081 141.542C103.436 141.749 103.718 141.542 103.718 141.172V138.02C103.701 137.799 103.636 137.585 103.526 137.393C103.415 137.201 103.264 137.036 103.081 136.91L102.356 136.496C102.03 136.259 101.72 136.436 101.72 136.836Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M49.9248 116.34V119.477C49.9411 119.698 50.0067 119.912 50.1168 120.104C50.227 120.297 50.3788 120.461 50.5611 120.587L51.2863 121.001C51.6266 121.209 51.9226 121.001 51.9226 120.631V117.494C51.9063 117.273 51.8407 117.059 51.7306 116.867C51.6205 116.675 51.4686 116.51 51.2863 116.384L50.5611 115.97C50.2208 115.733 49.9248 115.896 49.9248 116.34Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M53.166 118.174V121.312C53.184 121.534 53.2519 121.749 53.3646 121.941C53.4774 122.133 53.6321 122.298 53.8172 122.422L54.5275 122.836C54.8827 123.043 55.1786 122.836 55.1786 122.466V119.299C55.1607 119.077 55.0928 118.862 54.98 118.67C54.8673 118.478 54.7126 118.313 54.5275 118.189L53.8172 117.775C53.462 117.597 53.166 117.819 53.166 118.174Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M56.4072 120.039V123.177C56.4235 123.397 56.4891 123.612 56.5993 123.804C56.7094 123.996 56.8612 124.161 57.0436 124.287L57.7687 124.701C58.1239 124.908 58.4198 124.701 58.4198 124.331V121.194C58.4019 120.972 58.334 120.756 58.2212 120.564C58.1085 120.372 57.9538 120.208 57.7687 120.084L57.0436 119.669C56.7032 119.462 56.4072 119.625 56.4072 120.039Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M59.6475 121.904V125.041C59.6557 125.264 59.718 125.481 59.8288 125.675C59.9397 125.868 60.0958 126.032 60.2838 126.151L61.0089 126.58C61.3641 126.773 61.6453 126.58 61.6453 126.211V123.058C61.629 122.838 61.5634 122.623 61.4532 122.431C61.3431 122.239 61.1913 122.074 61.0089 121.949L60.2838 121.534C59.9286 121.327 59.6475 121.49 59.6475 121.904Z"
                                fill="#263238"
                              />
                              <path
                                d="M62.8887 123.739V126.891C62.9049 127.112 62.9706 127.326 63.0807 127.518C63.1908 127.71 63.3427 127.875 63.525 128.001L64.2502 128.415C64.6053 128.622 64.8865 128.415 64.8865 128.045V124.923C64.8702 124.702 64.8046 124.487 64.6945 124.295C64.5843 124.103 64.4325 123.938 64.2502 123.813L63.525 123.398C63.2438 123.191 62.8887 123.369 62.8887 123.739Z"
                                fill="#263238"
                              />
                              <path
                                d="M66.2041 125.633V128.785C66.2204 129.006 66.286 129.22 66.3961 129.412C66.5063 129.605 66.6581 129.77 66.8404 129.895L67.5656 130.309C67.9207 130.517 68.2019 130.309 68.2019 129.94V126.787C68.1856 126.567 68.12 126.352 68.0099 126.16C67.8998 125.968 67.7479 125.803 67.5656 125.678L66.8404 125.263C66.4113 125.056 66.2041 125.219 66.2041 125.633Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M69.3701 127.498V130.65C69.3864 130.87 69.452 131.085 69.5622 131.277C69.6723 131.469 69.8241 131.634 70.0065 131.76L70.7316 132.174C71.072 132.381 71.3679 132.174 71.3679 131.804V128.667C71.3517 128.446 71.286 128.231 71.1759 128.039C71.0658 127.847 70.9139 127.682 70.7316 127.557L70.0065 127.128C69.6513 126.935 69.3701 127.098 69.3701 127.498Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M72.5967 129.377V132.515C72.6147 132.737 72.6826 132.952 72.7953 133.144C72.908 133.336 73.0627 133.5 73.2478 133.624L73.9582 134.039C74.3133 134.246 74.6093 134.039 74.6093 133.669V130.532C74.5913 130.309 74.5234 130.094 74.4107 129.902C74.2979 129.71 74.1432 129.546 73.9582 129.422L73.2478 129.007C72.8927 128.8 72.5967 128.963 72.5967 129.377Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M75.8379 131.242V134.379C75.8542 134.6 75.9198 134.814 76.0299 135.007C76.1401 135.199 76.2919 135.364 76.4742 135.489L77.1994 135.904C77.5545 136.111 77.8505 135.904 77.8505 135.534V132.396C77.8325 132.174 77.7646 131.959 77.6519 131.767C77.5391 131.575 77.3845 131.41 77.1994 131.286L76.4742 130.872C76.1339 130.665 75.8379 130.828 75.8379 131.242Z"
                                fill="#263238"
                              />
                              <path
                                d="M79.0781 133.106V136.244C79.0864 136.466 79.1487 136.684 79.2595 136.877C79.3703 137.07 79.5265 137.234 79.7145 137.353L80.4396 137.783C80.7948 137.975 81.076 137.783 81.076 137.413V134.261C81.0597 134.04 80.994 133.825 80.8839 133.633C80.7738 133.441 80.622 133.276 80.4396 133.151L79.7145 132.736C79.3593 132.529 79.0781 132.692 79.0781 133.106Z"
                                fill="#263238"
                              />
                              <path
                                d="M82.3193 134.971V138.123C82.3356 138.344 82.4012 138.558 82.5114 138.75C82.6215 138.942 82.7733 139.107 82.9557 139.233L83.6808 139.647C84.036 139.84 84.3172 139.647 84.3172 139.277V136.125C84.3009 135.904 84.2353 135.69 84.1251 135.498C84.015 135.306 83.8632 135.141 83.6808 135.015L82.9557 134.601C82.6005 134.394 82.3193 134.557 82.3193 134.971Z"
                                fill="#263238"
                              />
                              <path
                                d="M85.5605 136.836V140.017C85.5768 140.238 85.6424 140.453 85.7526 140.645C85.8627 140.837 86.0145 141.002 86.1969 141.127L86.922 141.497C87.2772 141.704 87.5584 141.497 87.5584 141.127V137.975C87.5421 137.754 87.4765 137.54 87.3663 137.348C87.2562 137.156 87.1044 136.991 86.922 136.865L86.1969 136.451C85.8417 136.259 85.5605 136.436 85.5605 136.836Z"
                                fill="#263238"
                              />
                              <path
                                d="M88.8008 138.701V141.853C88.8171 142.074 88.8827 142.288 88.9928 142.48C89.103 142.672 89.2548 142.837 89.4371 142.963L90.1623 143.377C90.5026 143.584 90.7986 143.377 90.7986 143.007V139.855C90.7823 139.634 90.7167 139.42 90.6066 139.228C90.4964 139.036 90.3446 138.871 90.1623 138.745L89.4371 138.331C89.082 138.138 88.8008 138.301 88.8008 138.701Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M92.0273 140.565V143.717C92.0453 143.939 92.1132 144.154 92.226 144.346C92.3387 144.539 92.4934 144.703 92.6785 144.827L93.3888 145.241C93.744 145.448 94.04 145.241 94.04 144.871V141.734C94.0288 141.51 93.9638 141.292 93.8505 141.099C93.7371 140.906 93.5787 140.743 93.3888 140.624L92.6785 140.195C92.3233 140.017 92.0273 140.165 92.0273 140.565Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M95.2686 142.445V145.582C95.2865 145.804 95.3544 146.019 95.4672 146.211C95.5799 146.404 95.7346 146.568 95.9197 146.692L96.63 147.106C96.9852 147.313 97.2812 147.106 97.2812 146.736V143.599C97.2632 143.377 97.1953 143.162 97.0826 142.97C96.9698 142.777 96.8151 142.613 96.63 142.489L95.9197 142.075C95.5645 141.867 95.2686 142.03 95.2686 142.445Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M98.5088 144.309V147.417C98.5171 147.64 98.5793 147.857 98.6901 148.05C98.801 148.244 98.9571 148.407 99.1451 148.527L99.8703 148.941C100.225 149.148 100.507 148.941 100.507 148.571V145.434C100.49 145.213 100.425 144.999 100.315 144.807C100.204 144.614 100.053 144.45 99.8703 144.324L99.1451 143.91C98.7604 143.732 98.5088 143.895 98.5088 144.309Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M101.72 146.174V149.311C101.728 149.534 101.79 149.751 101.901 149.944C102.012 150.138 102.168 150.301 102.356 150.421L103.081 150.85C103.436 151.042 103.718 150.85 103.718 150.48V147.328C103.701 147.107 103.636 146.893 103.526 146.701C103.415 146.509 103.264 146.344 103.081 146.218L102.356 145.804C102.03 145.596 101.72 145.759 101.72 146.174Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M112.568 147.491L114.048 146.648C114.363 146.507 114.71 146.452 115.053 146.488C115.396 146.524 115.723 146.651 116.002 146.855C116.812 147.384 117.486 148.096 117.969 148.935C118.453 149.773 118.732 150.713 118.784 151.679C118.822 152.023 118.766 152.371 118.623 152.687C118.48 153.002 118.254 153.272 117.97 153.47L116.608 154.239L116.357 153.84C116.078 153.77 115.81 153.666 115.558 153.529C114.747 153 114.073 152.288 113.59 151.45C113.107 150.611 112.828 149.671 112.776 148.705C112.772 148.465 112.802 148.226 112.864 147.994L112.568 147.491Z"
                                fill="#BBE9F8"
                              />
                              <path
                                opacity="0.2"
                                d="M112.568 147.491L114.048 146.648C114.363 146.507 114.71 146.452 115.053 146.488C115.396 146.524 115.723 146.651 116.002 146.855C116.812 147.384 117.486 148.096 117.969 148.935C118.453 149.773 118.732 150.713 118.784 151.679C118.822 152.023 118.766 152.371 118.623 152.687C118.48 153.002 118.254 153.272 117.97 153.47L116.608 154.239L116.357 153.84C116.078 153.77 115.81 153.666 115.558 153.529C114.747 153 114.073 152.288 113.59 151.45C113.107 150.611 112.828 149.671 112.776 148.705C112.772 148.465 112.802 148.226 112.864 147.994L112.568 147.491Z"
                                fill="black"
                              />
                              <path
                                d="M114.596 147.653C115.406 148.182 116.08 148.895 116.563 149.733C117.047 150.571 117.326 151.512 117.378 152.478C117.378 154.254 116.135 154.964 114.596 154.076C113.785 153.547 113.111 152.835 112.628 151.996C112.144 151.158 111.865 150.218 111.813 149.252C111.813 147.417 113.057 146.766 114.596 147.653Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M124.658 154.461L126.138 153.618C126.452 153.475 126.798 153.417 127.141 153.451C127.484 153.485 127.812 153.609 128.091 153.81C128.902 154.339 129.576 155.052 130.059 155.89C130.543 156.728 130.822 157.668 130.874 158.635C130.91 158.981 130.853 159.33 130.71 159.647C130.567 159.964 130.343 160.238 130.06 160.44L128.698 161.224L128.447 160.81C128.166 160.747 127.897 160.642 127.648 160.499C126.837 159.97 126.163 159.258 125.68 158.42C125.196 157.581 124.917 156.641 124.865 155.675C124.863 155.435 124.893 155.196 124.954 154.964L124.658 154.461Z"
                                fill="#BBE9F8"
                              />
                              <path
                                opacity="0.2"
                                d="M124.658 154.461L126.138 153.618C126.452 153.475 126.798 153.417 127.141 153.451C127.484 153.485 127.812 153.609 128.091 153.81C128.902 154.339 129.576 155.052 130.059 155.89C130.543 156.728 130.822 157.668 130.874 158.635C130.91 158.981 130.853 159.33 130.71 159.647C130.567 159.964 130.343 160.238 130.06 160.44L128.698 161.224L128.447 160.81C128.166 160.747 127.897 160.642 127.648 160.499C126.837 159.97 126.163 159.258 125.68 158.42C125.196 157.581 124.917 156.641 124.865 155.675C124.863 155.435 124.893 155.196 124.954 154.964L124.658 154.461Z"
                                fill="black"
                              />
                              <path
                                d="M126.686 154.624C127.497 155.153 128.171 155.865 128.654 156.704C129.137 157.542 129.416 158.482 129.468 159.448C129.468 161.224 128.225 161.949 126.686 161.061C125.887 160.536 125.221 159.832 124.741 159.005C124.261 158.178 123.979 157.251 123.919 156.296C123.919 154.461 125.147 153.736 126.686 154.624Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M232.437 51.9508L143.897 0.910235C142.702 0.311362 141.385 -0.000488281 140.049 -0.000488281C138.713 -0.000488281 137.396 0.311362 136.201 0.910235L47.7646 51.9508C46.6463 52.6816 45.7154 53.6651 45.0471 54.8219C44.3787 55.9786 43.9916 57.2763 43.917 58.6102V81.9329L140.108 137.457L236.299 81.9329V58.625C236.225 57.2872 235.837 55.9858 235.166 54.8261C234.495 53.6665 233.56 52.6814 232.437 51.9508Z"
                                fill="#00121B"
                              />
                              <path
                                d="M140.197 108.393V137.457L44.0059 81.9325V58.6246C44.0744 57.4336 44.39 56.2699 44.9327 55.2075C45.4754 54.1451 46.2332 53.2073 47.158 52.4536C45.6781 53.6819 45.9889 55.3245 47.8535 56.4049L136.32 107.46C137.511 108.099 138.846 108.42 140.197 108.393Z"
                                fill="#455A64"
                              />
                              <path
                                d="M47.7652 56.3904L136.32 107.461C137.51 108.066 138.826 108.382 140.161 108.382C141.495 108.382 142.811 108.066 144.001 107.461L232.438 56.3756C234.569 55.1473 234.569 53.1643 232.438 51.936L143.897 0.910235C142.703 0.311362 141.386 -0.000488281 140.05 -0.000488281C138.714 -0.000488281 137.396 0.311362 136.202 0.910235L47.7652 51.9508C45.6342 53.1791 45.6342 55.1621 47.7652 56.3904Z"
                                fill="#263238"
                              />
                              <path
                                d="M55.9482 95.8141V88.8735L140.108 137.458V144.398L55.9482 95.8141Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M230.277 85.3955V92.3361L140.108 144.398V137.457L230.277 85.3955Z"
                                fill="#BBE9F8"
                              />
                              <path
                                opacity="0.2"
                                d="M230.277 85.3955V92.3361L140.108 144.398V137.457L230.277 85.3955Z"
                                fill="black"
                              />
                              <path
                                d="M49.9248 65.3139V68.466C49.9411 68.6869 50.0067 68.9012 50.1168 69.0933C50.227 69.2854 50.3788 69.4503 50.5611 69.5759L51.2863 69.9903C51.6266 70.1975 51.9226 69.9903 51.9226 69.6203V66.483C51.9063 66.2622 51.8407 66.0478 51.7306 65.8557C51.6205 65.6636 51.4686 65.4987 51.2863 65.3731L50.5611 64.944C50.2208 64.7516 49.9248 64.9144 49.9248 65.3139Z"
                                fill="#263238"
                              />
                              <path
                                d="M53.166 67.1932V70.3305C53.184 70.5526 53.2519 70.7677 53.3646 70.9599C53.4774 71.1521 53.6321 71.3164 53.8172 71.4404L54.5275 71.8548C54.8827 72.0619 55.1786 71.8548 55.1786 71.4848V68.3475C55.1607 68.1254 55.0928 67.9102 54.98 67.718C54.8673 67.5259 54.7126 67.3616 54.5275 67.2376L53.8172 66.8232C53.462 66.616 53.166 66.7788 53.166 67.1932Z"
                                fill="#263238"
                              />
                              <path
                                d="M56.4072 69.0574V72.1947C56.4235 72.4156 56.4891 72.6299 56.5993 72.822C56.7094 73.0141 56.8612 73.179 57.0436 73.3046L57.7687 73.719C58.1239 73.9262 58.4198 73.719 58.4198 73.349V70.2117C58.4019 69.9896 58.334 69.7745 58.2212 69.5823C58.1085 69.3901 57.9538 69.2259 57.7687 69.1018L57.0436 68.6875C56.7032 68.4803 56.4072 68.6431 56.4072 69.0574Z"
                                fill="#263238"
                              />
                              <path
                                d="M59.6475 70.9225V74.0598C59.6557 74.2825 59.718 74.4998 59.8288 74.6932C59.9397 74.8865 60.0958 75.05 60.2838 75.1697L61.0089 75.5989C61.3641 75.7912 61.6453 75.5989 61.6453 75.2289V72.0768C61.629 71.8559 61.5634 71.6416 61.4532 71.4495C61.3431 71.2574 61.1913 71.0925 61.0089 70.9669L60.2838 70.5525C59.9286 70.3453 59.6475 70.4637 59.6475 70.9225Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M62.8887 72.7874V75.9395C62.9049 76.1603 62.9706 76.3747 63.0807 76.5668C63.1908 76.7589 63.3427 76.9238 63.525 77.0494L64.2502 77.4638C64.6053 77.6709 64.8865 77.4638 64.8865 77.0938V73.9417C64.8702 73.7209 64.8046 73.5065 64.6945 73.3144C64.5843 73.1223 64.4325 72.9574 64.2502 72.8318L63.525 72.4174C63.2438 72.2103 62.8887 72.373 62.8887 72.7874Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M66.2041 74.6518V77.8631C66.2204 78.0839 66.286 78.2983 66.3961 78.4904C66.5063 78.6825 66.6581 78.8474 66.8404 78.973L67.5656 79.3874C67.9207 79.5945 68.2019 79.3874 68.2019 79.0174V75.8653C68.1856 75.6444 68.12 75.4301 68.0099 75.238C67.8998 75.0459 67.7479 74.881 67.5656 74.7554L66.8404 74.341C66.4113 74.0746 66.2041 74.2522 66.2041 74.6518Z"
                                fill="#263238"
                              />
                              <path
                                d="M69.3701 76.5161V79.6682C69.3864 79.889 69.452 80.1034 69.5622 80.2955C69.6723 80.4876 69.8241 80.6525 70.0065 80.7781L70.7316 81.1925C71.072 81.3996 71.3679 81.1925 71.3679 80.8225V77.6852C71.3517 77.4644 71.286 77.25 71.1759 77.0579C71.0658 76.8658 70.9139 76.7009 70.7316 76.5753L70.0065 76.1461C69.6513 75.9537 69.3701 76.1165 69.3701 76.5161Z"
                                fill="#263238"
                              />
                              <path
                                d="M72.5967 78.3959V81.5332C72.6147 81.7553 72.6826 81.9704 72.7953 82.1626C72.908 82.3548 73.0627 82.519 73.2478 82.6431L73.9582 83.0574C74.3133 83.2646 74.6093 83.0574 74.6093 82.6875V79.5502C74.5982 79.3264 74.5331 79.1086 74.4198 78.9154C74.3064 78.7221 74.148 78.5591 73.9582 78.4403L73.2478 78.0259C72.8927 77.8631 72.5967 77.9815 72.5967 78.3959Z"
                                fill="#263238"
                              />
                              <path
                                d="M75.8379 80.2601V83.3974C75.8542 83.6182 75.9198 83.8326 76.0299 84.0246C76.1401 84.2167 76.2919 84.3817 76.4742 84.5073L77.1994 84.9217C77.5545 85.1288 77.8505 84.9217 77.8505 84.5517V81.4144C77.8325 81.1923 77.7646 80.9771 77.6519 80.7849C77.5391 80.5928 77.3845 80.4285 77.1994 80.3045L76.4742 79.8901C76.1339 79.6829 75.8379 79.8457 75.8379 80.2601Z"
                                fill="#263238"
                              />
                              <path
                                d="M79.0781 82.1253V85.2626C79.0864 85.4853 79.1487 85.7027 79.2595 85.896C79.3703 86.0893 79.5265 86.2528 79.7145 86.3725L80.4396 86.7869C80.7948 86.994 81.076 86.7869 81.076 86.4169V83.2796C81.0597 83.0588 80.994 82.8444 80.8839 82.6523C80.7738 82.4602 80.622 82.2953 80.4396 82.1697L79.7145 81.7553C79.3593 81.5482 79.0781 81.7109 79.0781 82.1253Z"
                                fill="#263238"
                              />
                              <path
                                d="M82.3193 83.9896V87.1417C82.3356 87.3625 82.4012 87.5768 82.5114 87.7689C82.6215 87.961 82.7733 88.126 82.9557 88.2516L83.6808 88.6659C84.036 88.8583 84.3172 88.6659 84.3172 88.296V85.1439C84.3009 84.923 84.2353 84.7087 84.1251 84.5166C84.015 84.3245 83.8632 84.1596 83.6808 84.034L82.9557 83.6196C82.6005 83.4124 82.3193 83.5752 82.3193 83.9896Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M85.5605 85.8547V89.0068C85.5768 89.2277 85.6424 89.442 85.7526 89.6341C85.8627 89.8262 86.0145 89.9911 86.1969 90.1167L86.922 90.5311C87.2772 90.7383 87.5584 90.5311 87.5584 90.1611V87.009C87.5421 86.7882 87.4765 86.5738 87.3663 86.3818C87.2562 86.1897 87.1044 86.0247 86.922 85.8991L86.1969 85.4847C85.8417 85.2628 85.5605 85.4551 85.5605 85.8547Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M88.8008 87.7187V90.8708C88.8171 91.0916 88.8827 91.306 88.9928 91.4981C89.103 91.6902 89.2548 91.8551 89.4371 91.9807L90.1623 92.3951C90.5026 92.6023 90.7986 92.3951 90.7986 92.0251V88.873C90.7823 88.6522 90.7167 88.4378 90.6066 88.2457C90.4964 88.0536 90.3446 87.8887 90.1623 87.7631L89.4371 87.3487C89.082 87.1564 88.8008 87.3192 88.8008 87.7187Z"
                                fill="#263238"
                              />
                              <path
                                d="M92.0273 89.5839V92.7361C92.0453 92.9582 92.1132 93.1733 92.226 93.3655C92.3387 93.5577 92.4934 93.7219 92.6785 93.846L93.3888 94.2603C93.744 94.4675 94.04 94.2603 94.04 93.8904V90.7531C94.0288 90.5293 93.9638 90.3115 93.8505 90.1183C93.7371 89.925 93.5787 89.7621 93.3888 89.6432L92.6785 89.214C92.3233 89.0216 92.0273 89.1844 92.0273 89.5839Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M95.2686 91.4632V94.6005C95.2865 94.8226 95.3544 95.0378 95.4672 95.2299C95.5799 95.4221 95.7346 95.5864 95.9197 95.7104L96.63 96.1248C96.9852 96.332 97.2812 96.1248 97.2812 95.7548V92.6619C97.2632 92.4398 97.1953 92.2247 97.0826 92.0325C96.9698 91.8403 96.8151 91.6761 96.63 91.552L95.9197 91.1376C95.5645 90.8861 95.2686 91.0489 95.2686 91.4632Z"
                                fill="#263238"
                              />
                              <path
                                d="M98.5088 93.3279V96.4653C98.5251 96.6861 98.5907 96.9004 98.7008 97.0925C98.8109 97.2846 98.9628 97.4496 99.1451 97.5752L99.8703 97.9895C100.225 98.1967 100.507 97.9895 100.507 97.6196V94.4822C100.49 94.2614 100.425 94.0471 100.315 93.855C100.204 93.6629 100.053 93.4979 99.8703 93.3723L99.1451 92.958C98.7604 92.7508 98.5088 92.9136 98.5088 93.3279Z"
                                fill="#263238"
                              />
                              <path
                                d="M101.72 95.1922V98.3295C101.728 98.5522 101.79 98.7695 101.901 98.9629C102.012 99.1562 102.168 99.3197 102.356 99.4394L103.081 99.8686C103.436 100.061 103.718 99.8686 103.718 99.4986V96.3465C103.701 96.1257 103.636 95.9113 103.526 95.7192C103.415 95.5271 103.264 95.3622 103.081 95.2366L102.356 94.8222C102.03 94.615 101.72 94.7778 101.72 95.1922Z"
                                fill="#263238"
                              />
                              <path
                                d="M49.9248 74.6518V77.8631C49.9411 78.0839 50.0067 78.2983 50.1168 78.4904C50.227 78.6825 50.3788 78.8474 50.5611 78.973L51.2863 79.3874C51.6266 79.5945 51.9226 79.3874 51.9226 79.0174V75.8653C51.9063 75.6444 51.8407 75.4301 51.7306 75.238C51.6205 75.0459 51.4686 74.881 51.2863 74.7554L50.5611 74.341C50.2208 74.0746 49.9248 74.2522 49.9248 74.6518Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M53.166 76.5161V79.6682C53.184 79.8903 53.2519 80.1054 53.3646 80.2976C53.4774 80.4898 53.6321 80.654 53.8172 80.7781L54.5275 81.1925C54.8827 81.3996 55.1786 81.1925 55.1786 80.8225V77.6852C55.1675 77.4614 55.1025 77.2437 54.9891 77.0504C54.8757 76.8572 54.7174 76.6942 54.5275 76.5753L53.8172 76.1461C53.462 75.9537 53.166 76.1165 53.166 76.5161Z"
                                fill="#263238"
                              />
                              <path
                                d="M56.4072 78.3959V81.5332C56.4235 81.754 56.4891 81.9684 56.5993 82.1604C56.7094 82.3525 56.8612 82.5175 57.0436 82.6431L57.7687 83.0574C58.1239 83.2646 58.4198 83.0574 58.4198 82.6875V79.5502C58.4087 79.3264 58.3437 79.1086 58.2303 78.9154C58.117 78.7221 57.9586 78.5591 57.7687 78.4403L57.0436 78.0259C56.7032 77.8631 56.4072 77.9815 56.4072 78.3959Z"
                                fill="#263238"
                              />
                              <path
                                d="M59.6475 80.2601V83.3974C59.6637 83.6182 59.7294 83.8326 59.8395 84.0246C59.9496 84.2167 60.1015 84.3817 60.2838 84.5073L61.0089 84.9217C61.3641 85.1288 61.6453 84.9217 61.6453 84.5517V81.4144C61.629 81.1935 61.5634 80.9792 61.4532 80.7871C61.3431 80.595 61.1913 80.4301 61.0089 80.3045L60.2838 79.8901C59.9286 79.6829 59.6475 79.8457 59.6475 80.2601Z"
                                fill="#263238"
                              />
                              <path
                                d="M62.8887 82.1253V85.2626C62.897 85.4853 62.9592 85.7027 63.07 85.896C63.1809 86.0893 63.337 86.2528 63.525 86.3725L64.2502 86.7869C64.6053 86.994 64.8865 86.7869 64.8865 86.4169V83.2796C64.8702 83.0588 64.8046 82.8444 64.6945 82.6523C64.5843 82.4602 64.4325 82.2953 64.2502 82.1697L63.525 81.7553C63.2438 81.5482 62.8887 81.7109 62.8887 82.1253Z"
                                fill="#263238"
                              />
                              <path
                                d="M66.2041 83.9896V87.1417C66.2204 87.3625 66.286 87.5768 66.3961 87.7689C66.5063 87.961 66.6581 88.126 66.8404 88.2516L67.5656 88.6659C67.9207 88.8583 68.2019 88.6659 68.2019 88.296V85.1439C68.1856 84.923 68.12 84.7087 68.0099 84.5166C67.8998 84.3245 67.7479 84.1596 67.5656 84.034L66.8404 83.6196C66.4113 83.4124 66.2041 83.5752 66.2041 83.9896Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M69.3701 85.8547V89.0068C69.3864 89.2277 69.452 89.442 69.5622 89.6341C69.6723 89.8262 69.8241 89.9911 70.0065 90.1167L70.7316 90.5311C71.072 90.7383 71.3679 90.5311 71.3679 90.1611V87.009C71.3517 86.7882 71.286 86.5738 71.1759 86.3818C71.0658 86.1897 70.9139 86.0247 70.7316 85.8991L70.0065 85.4847C69.6513 85.2628 69.3701 85.4551 69.3701 85.8547Z"
                                fill="#263238"
                              />
                              <path
                                d="M72.5967 87.7187V90.8708C72.6147 91.0929 72.6826 91.3081 72.7953 91.5003C72.908 91.6924 73.0627 91.8567 73.2478 91.9807L73.9582 92.3951C74.3133 92.6023 74.6093 92.3951 74.6093 92.0251V88.873C74.5913 88.6509 74.5234 88.4358 74.4107 88.2436C74.2979 88.0514 74.1432 87.8872 73.9582 87.7631L73.2478 87.3487C72.8927 87.1564 72.5967 87.3192 72.5967 87.7187Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M75.8372 89.5838V92.736C75.8535 92.9568 75.9191 93.1711 76.0292 93.3632C76.1393 93.5553 76.2912 93.7202 76.4735 93.8459L77.1987 94.2602C77.5538 94.4674 77.8498 94.2602 77.8498 93.8903V90.7529C77.8387 90.5292 77.7737 90.3114 77.6603 90.1182C77.5469 89.9249 77.3886 89.7619 77.1987 89.643L76.4735 89.2139C76.4107 89.1667 76.3354 89.1391 76.257 89.1345C76.1786 89.1299 76.1006 89.1485 76.0327 89.1879C75.9648 89.2274 75.9101 89.286 75.8753 89.3564C75.8405 89.4268 75.8273 89.5059 75.8372 89.5838Z"
                                fill="#263238"
                              />
                              <path
                                d="M79.0781 91.4632V94.6005C79.0944 94.8213 79.16 95.0357 79.2702 95.2278C79.3803 95.4199 79.5321 95.5848 79.7145 95.7104L80.4396 96.1248C80.7948 96.332 81.076 96.1248 81.076 95.7548V92.6619C81.0597 92.4411 80.994 92.2267 80.8839 92.0346C80.7738 91.8425 80.622 91.6776 80.4396 91.552L79.7145 91.1376C79.3593 90.8861 79.0781 91.0489 79.0781 91.4632Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M82.3193 93.3279V96.4653C82.3356 96.6861 82.4012 96.9004 82.5114 97.0925C82.6215 97.2846 82.7733 97.4496 82.9557 97.5752L83.6808 97.9895C84.036 98.1967 84.3172 97.9895 84.3172 97.6196V94.4822C84.3009 94.2614 84.2353 94.0471 84.1251 93.855C84.015 93.6629 83.8632 93.4979 83.6808 93.3723L82.9557 92.958C82.6005 92.7508 82.3193 92.9136 82.3193 93.3279Z"
                                fill="#263238"
                              />
                              <path
                                d="M85.5605 95.1922V98.3295C85.5688 98.5522 85.6311 98.7695 85.7419 98.9629C85.8527 99.1562 86.0089 99.3197 86.1969 99.4394L86.922 99.8686C87.2772 100.061 87.5584 99.8686 87.5584 99.4986V96.3465C87.5421 96.1257 87.4765 95.9113 87.3663 95.7192C87.2562 95.5271 87.1044 95.3622 86.922 95.2366L86.1969 94.8222C85.8417 94.615 85.5605 94.7778 85.5605 95.1922Z"
                                fill="#263238"
                              />
                              <path
                                d="M88.8008 97.1014V100.253C88.8171 100.474 88.8827 100.689 88.9928 100.881C89.103 101.073 89.2548 101.238 89.4371 101.363L90.1623 101.778C90.5026 101.985 90.7986 101.778 90.7986 101.408V98.2556C90.7823 98.0348 90.7167 97.8205 90.6066 97.6284C90.4964 97.4363 90.3446 97.2714 90.1623 97.1457L89.4371 96.7314C89.082 96.4798 88.8008 96.6426 88.8008 97.1014Z"
                                fill="#263238"
                              />
                              <path
                                d="M92.0269 98.9218V102.074C92.0449 102.296 92.1128 102.511 92.2255 102.703C92.3383 102.896 92.493 103.06 92.6781 103.184L93.3884 103.598C93.4509 103.651 93.5278 103.683 93.609 103.69C93.6901 103.697 93.7716 103.68 93.8425 103.639C93.9133 103.599 93.9702 103.538 94.0054 103.465C94.0406 103.391 94.0525 103.309 94.0395 103.228V100.061C94.0216 99.8392 93.9537 99.6241 93.8409 99.4319C93.7282 99.2397 93.5735 99.0754 93.3884 98.9514L92.6781 98.537C92.6147 98.4828 92.536 98.4497 92.453 98.4424C92.3699 98.4352 92.2866 98.4541 92.2149 98.4965C92.1431 98.5389 92.0863 98.6027 92.0526 98.679C92.0189 98.7553 92.0099 98.8402 92.0269 98.9218Z"
                                fill="#263238"
                              />
                              <path
                                d="M95.2686 100.786V103.938C95.2865 104.16 95.3544 104.375 95.4672 104.568C95.5799 104.76 95.7346 104.924 95.9197 105.048L96.63 105.462C96.9852 105.67 97.2812 105.462 97.2812 105.092V101.955C97.27 101.731 97.205 101.514 97.0917 101.32C96.9783 101.127 96.8199 100.964 96.63 100.845L95.9197 100.416C95.5645 100.224 95.2686 100.387 95.2686 100.786Z"
                                fill="#263238"
                              />
                              <path
                                d="M98.5088 102.666V105.803C98.5251 106.024 98.5907 106.238 98.7008 106.43C98.8109 106.623 98.9628 106.787 99.1451 106.913L99.8703 107.327C100.225 107.535 100.507 107.327 100.507 106.957V103.82C100.498 103.597 100.436 103.38 100.325 103.187C100.214 102.993 100.058 102.83 99.8703 102.71L99.1451 102.296C98.7604 102.089 98.5088 102.251 98.5088 102.666Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M101.72 104.5V107.638C101.736 107.858 101.802 108.073 101.912 108.265C102.022 108.457 102.174 108.622 102.356 108.747L103.081 109.162C103.436 109.369 103.718 109.162 103.718 108.792V105.684C103.701 105.463 103.636 105.249 103.526 105.057C103.415 104.865 103.264 104.7 103.081 104.574L102.356 104.16C102.03 103.953 101.72 104.116 101.72 104.5Z"
                                fill="#263238"
                              />
                              <path
                                d="M112.568 105.847L114.048 104.989C114.363 104.849 114.708 104.793 115.05 104.826C115.393 104.86 115.721 104.982 116.002 105.181C116.812 105.71 117.486 106.423 117.969 107.261C118.453 108.099 118.732 109.039 118.784 110.006C118.82 110.352 118.763 110.701 118.62 111.018C118.477 111.335 118.253 111.609 117.97 111.811L116.608 112.595L116.357 112.181C116.076 112.118 115.807 112.013 115.558 111.87C114.747 111.341 114.073 110.629 113.59 109.791C113.107 108.952 112.828 108.012 112.776 107.046C112.774 106.806 112.804 106.567 112.864 106.336L112.568 105.847Z"
                                fill="#BBE9F8"
                              />
                              <path
                                opacity="0.2"
                                d="M112.568 105.847L114.048 104.989C114.363 104.849 114.708 104.793 115.05 104.826C115.393 104.86 115.721 104.982 116.002 105.181C116.812 105.71 117.486 106.423 117.969 107.261C118.453 108.099 118.732 109.039 118.784 110.006C118.82 110.352 118.763 110.701 118.62 111.018C118.477 111.335 118.253 111.609 117.97 111.811L116.608 112.595L116.357 112.181C116.076 112.118 115.807 112.013 115.558 111.87C114.747 111.341 114.073 110.629 113.59 109.791C113.107 108.952 112.828 108.012 112.776 107.046C112.774 106.806 112.804 106.567 112.864 106.336L112.568 105.847Z"
                                fill="black"
                              />
                              <path
                                d="M114.596 105.98C115.406 106.509 116.08 107.222 116.563 108.06C117.047 108.898 117.326 109.839 117.378 110.805C117.378 112.581 116.135 113.306 114.596 112.418C113.785 111.889 113.111 111.176 112.628 110.338C112.144 109.5 111.865 108.56 111.813 107.594C111.813 105.832 113.057 105.107 114.596 105.98Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M124.658 112.817L126.138 111.974C126.453 111.833 126.8 111.778 127.143 111.814C127.486 111.851 127.813 111.977 128.091 112.181C128.902 112.71 129.576 113.423 130.059 114.261C130.543 115.099 130.822 116.039 130.874 117.005C130.91 117.351 130.853 117.701 130.71 118.018C130.567 118.335 130.343 118.609 130.06 118.811L128.698 119.595L128.447 119.181C128.166 119.118 127.897 119.013 127.648 118.87C126.837 118.341 126.163 117.629 125.68 116.791C125.196 115.952 124.917 115.012 124.865 114.046C124.862 113.806 124.892 113.567 124.954 113.335L124.658 112.817Z"
                                fill="#BBE9F8"
                              />
                              <path
                                opacity="0.2"
                                d="M124.658 112.817L126.138 111.974C126.453 111.833 126.8 111.778 127.143 111.814C127.486 111.851 127.813 111.977 128.091 112.181C128.902 112.71 129.576 113.423 130.059 114.261C130.543 115.099 130.822 116.039 130.874 117.005C130.91 117.351 130.853 117.701 130.71 118.018C130.567 118.335 130.343 118.609 130.06 118.811L128.698 119.595L128.447 119.181C128.166 119.118 127.897 119.013 127.648 118.87C126.837 118.341 126.163 117.629 125.68 116.791C125.196 115.952 124.917 115.012 124.865 114.046C124.862 113.806 124.892 113.567 124.954 113.335L124.658 112.817Z"
                                fill="black"
                              />
                              <path
                                d="M126.686 112.98C127.497 113.509 128.171 114.221 128.654 115.06C129.137 115.898 129.416 116.838 129.468 117.804C129.468 119.58 128.225 120.29 126.686 119.403C125.88 118.871 125.209 118.158 124.728 117.32C124.248 116.482 123.97 115.543 123.919 114.578C123.919 112.802 125.147 112.092 126.686 112.98Z"
                                fill="#BBE9F8"
                              />
                              <path
                                d="M180.021 365.845C180.162 367.803 180.764 369.7 181.777 371.382C182.79 373.063 184.186 374.482 185.851 375.523L349.066 469.761C350.874 470.673 352.871 471.148 354.896 471.148C356.921 471.148 358.918 470.673 360.727 469.761L584.053 340.82C585.812 339.889 587.285 338.496 588.311 336.79C589.338 335.085 589.88 333.132 589.88 331.142C589.88 329.151 589.338 327.198 588.311 325.493C587.285 323.788 585.812 322.395 584.053 321.463L420.824 227.24C419.021 226.322 417.025 225.843 415.001 225.843C412.977 225.843 410.981 226.322 409.178 227.24L185.851 356.181C184.187 357.219 182.792 358.636 181.779 360.315C180.766 361.994 180.163 363.889 180.021 365.845Z"
                                fill="#07178E"
                              />
                              <path
                                opacity="0.2"
                                d="M354.895 458.543V471.152C352.865 471.196 350.857 470.717 349.065 469.76L185.85 375.523C184.142 374.625 182.703 373.289 181.679 371.653C180.656 370.017 180.085 368.138 180.025 366.209C179.965 364.28 180.417 362.37 181.337 360.673C182.256 358.976 183.61 357.554 185.258 356.551C182.639 358.415 182.846 361.168 185.85 362.899L349.065 457.137C350.855 458.099 352.863 458.583 354.895 458.543Z"
                                fill="white"
                              />
                              <path
                                d="M174.559 356.389C172.937 355.285 171.598 353.815 170.649 352.098C169.701 350.38 169.17 348.464 169.099 346.503V151.723C169.209 149.703 169.793 147.737 170.803 145.983C171.813 144.23 173.222 142.739 174.915 141.631L398.256 12.7492C399.942 11.6944 401.883 11.1187 403.871 11.0837C405.86 11.0488 407.82 11.5559 409.542 12.5508C411.264 13.5456 412.683 14.9906 413.646 16.7307C414.609 18.4707 415.079 20.4401 415.008 22.4275V217.148C414.898 219.171 414.313 221.138 413.3 222.892C412.287 224.646 410.874 226.136 409.177 227.241L185.851 356.182C184.116 357.096 182.191 357.591 180.23 357.627C178.269 357.663 176.327 357.239 174.559 356.389Z"
                                fill="#07178E"
                              />
                              <path
                                opacity="0.2"
                                d="M185.155 356.522C183.463 357.43 181.561 357.875 179.641 357.813C177.722 357.75 175.853 357.182 174.224 356.165C172.595 355.148 171.263 353.719 170.363 352.023C169.463 350.326 169.027 348.422 169.098 346.503V151.723C169.164 149.695 169.75 147.718 170.8 145.981L181.737 152.286C180.684 154.016 180.093 155.988 180.02 158.013V352.807C180.02 356.256 182.269 357.809 185.155 356.522Z"
                                fill="white"
                              />
                              <path
                                opacity="0.4"
                                d="M180.021 158.027V352.807C180.021 356.522 182.625 358.031 185.851 356.181L409.178 227.241C410.875 226.136 412.287 224.646 413.3 222.892C414.314 221.138 414.899 219.17 415.008 217.148V22.3682C415.008 18.6538 412.404 17.1443 409.178 19.0089L185.851 147.935C184.154 149.04 182.741 150.53 181.728 152.284C180.715 154.037 180.13 156.005 180.021 158.027Z"
                                fill="white"
                              />
                              <path
                                d="M185.851 362.9L349.066 457.137C350.874 458.049 352.871 458.524 354.896 458.524C356.921 458.524 358.919 458.049 360.727 457.137L584.053 328.197C587.265 326.332 587.265 323.328 584.053 321.463L420.824 227.24C419.021 226.322 417.025 225.843 415.001 225.843C412.977 225.843 410.981 226.322 409.178 227.24L185.851 356.181C182.625 358.031 182.625 361.05 185.851 362.9Z"
                                fill="#07178E"
                              />
                              <path
                                opacity="0.6"
                                d="M185.851 362.9L349.066 457.137C350.874 458.049 352.871 458.524 354.896 458.524C356.921 458.524 358.919 458.049 360.727 457.137L584.053 328.197C587.265 326.332 587.265 323.328 584.053 321.463L420.824 227.24C419.021 226.322 417.025 225.843 415.001 225.843C412.977 225.843 410.981 226.322 409.178 227.24L185.851 356.181C182.625 358.031 182.625 361.05 185.851 362.9Z"
                                fill="white"
                              />
                              <path
                                d="M189.033 158.753L404.353 34.4439C406.277 33.3192 407.846 34.2219 407.846 36.4565V205.132C407.779 206.344 407.428 207.523 406.821 208.574C406.215 209.626 405.369 210.52 404.353 211.184L189.033 335.493C187.094 336.603 185.525 335.7 185.525 333.48V164.805C185.59 163.591 185.942 162.409 186.552 161.357C187.161 160.305 188.011 159.413 189.033 158.753Z"
                                fill="#455A64"
                              />
                              <path
                                d="M204.793 357.854L412.093 238.177C412.996 237.717 413.995 237.477 415.008 237.477C416.021 237.477 417.02 237.717 417.923 238.177L428.519 244.289C428.874 244.405 429.184 244.631 429.403 244.934C429.622 245.237 429.74 245.602 429.74 245.976C429.74 246.35 429.622 246.714 429.403 247.017C429.184 247.32 428.874 247.546 428.519 247.663L221.19 367.325C220.287 367.785 219.288 368.024 218.275 368.024C217.261 368.024 216.262 367.785 215.359 367.325L204.793 361.213C204.443 361.093 204.139 360.866 203.924 360.565C203.709 360.264 203.594 359.903 203.594 359.533C203.594 359.163 203.709 358.802 203.924 358.501C204.139 358.2 204.443 357.974 204.793 357.854Z"
                                fill="#07178E"
                              />
                              <path
                                opacity="0.4"
                                d="M204.793 357.854L412.093 238.177C412.996 237.717 413.995 237.477 415.008 237.477C416.021 237.477 417.02 237.717 417.923 238.177L428.519 244.289C428.874 244.405 429.184 244.631 429.403 244.934C429.622 245.237 429.74 245.602 429.74 245.976C429.74 246.35 429.622 246.714 429.403 247.017C429.184 247.32 428.874 247.546 428.519 247.663L221.19 367.325C220.287 367.785 219.288 368.024 218.275 368.024C217.261 368.024 216.262 367.785 215.359 367.325L204.793 361.213C204.443 361.093 204.139 360.866 203.924 360.565C203.709 360.264 203.594 359.903 203.594 359.533C203.594 359.163 203.709 358.802 203.924 358.501C204.139 358.2 204.443 357.974 204.793 357.854Z"
                                fill="white"
                              />
                              <path
                                d="M232.126 373.629L439.411 253.967C440.314 253.507 441.313 253.267 442.326 253.267C443.34 253.267 444.339 253.507 445.241 253.967L510.459 291.615C510.809 291.735 511.113 291.961 511.328 292.262C511.543 292.563 511.658 292.924 511.658 293.294C511.658 293.664 511.543 294.025 511.328 294.326C511.113 294.627 510.809 294.854 510.459 294.974L303.396 414.488C302.492 414.944 301.494 415.182 300.481 415.182C299.468 415.182 298.47 414.944 297.566 414.488L232.126 376.988C231.776 376.868 231.472 376.641 231.257 376.34C231.042 376.039 230.927 375.678 230.927 375.308C230.927 374.938 231.042 374.578 231.257 374.276C231.472 373.975 231.776 373.749 232.126 373.629Z"
                                fill="#07178E"
                              />
                              <path
                                opacity="0.4"
                                d="M232.126 373.629L439.411 253.967C440.314 253.507 441.313 253.267 442.326 253.267C443.34 253.267 444.339 253.507 445.241 253.967L510.459 291.615C510.809 291.735 511.113 291.961 511.328 292.262C511.543 292.563 511.658 292.924 511.658 293.294C511.658 293.664 511.543 294.025 511.328 294.326C511.113 294.627 510.809 294.854 510.459 294.974L303.396 414.488C302.492 414.944 301.494 415.182 300.481 415.182C299.468 415.182 298.47 414.944 297.566 414.488L232.126 376.988C231.776 376.868 231.472 376.641 231.257 376.34C231.042 376.039 230.927 375.678 230.927 375.308C230.927 374.938 231.042 374.578 231.257 374.276C231.472 373.975 231.776 373.749 232.126 373.629Z"
                                fill="white"
                              />
                              <path
                                d="M417.938 307.79L424.434 304.046C424.715 303.883 424.686 303.617 424.434 303.454L416.931 299.118C416.77 299.039 416.593 298.997 416.413 298.997C416.234 298.997 416.057 299.039 415.895 299.118L409.369 302.803C409.088 302.951 409.103 303.232 409.369 303.395L416.872 307.731C417.032 307.826 417.212 307.881 417.398 307.891C417.583 307.901 417.768 307.867 417.938 307.79ZM405.092 292.903L398.596 296.647C398.329 296.81 398.344 297.076 398.596 297.254L406.099 301.59C406.259 301.67 406.437 301.712 406.617 301.712C406.797 301.712 406.974 301.67 407.135 301.59L413.617 297.845C413.898 297.683 413.883 297.416 413.617 297.239L406.114 292.918C405.957 292.835 405.782 292.79 405.605 292.788C405.427 292.785 405.252 292.824 405.092 292.903ZM384.123 305.008L373.142 311.357C372.861 311.519 372.876 311.786 373.142 311.949L380.645 316.285C380.805 316.369 380.983 316.413 381.163 316.413C381.344 316.413 381.521 316.369 381.681 316.285L392.662 309.951C392.943 309.788 392.928 309.522 392.662 309.359L385.159 305.023C385.005 304.948 384.836 304.908 384.665 304.905C384.493 304.903 384.323 304.938 384.167 305.008H384.123ZM395.607 298.378L389.11 302.137C388.844 302.285 388.858 302.551 389.11 302.729L396.613 307.065C396.774 307.146 396.951 307.188 397.131 307.188C397.311 307.188 397.488 307.146 397.649 307.065L404.131 303.321C404.412 303.158 404.397 302.892 404.131 302.729L396.687 298.363C396.526 298.284 396.349 298.242 396.169 298.242C395.989 298.242 395.812 298.284 395.651 298.363L395.607 298.378ZM370.182 313.162L363.656 316.832C363.375 316.995 363.39 317.261 363.656 317.424L371.159 321.76C371.32 321.84 371.497 321.881 371.677 321.881C371.857 321.881 372.034 321.84 372.195 321.76L378.692 318.001C378.958 317.853 378.943 317.572 378.692 317.409L371.218 313.162C371.058 313.081 370.88 313.039 370.7 313.039C370.521 313.039 370.343 313.081 370.182 313.162ZM360.697 318.638L354.215 322.382C353.934 322.544 353.948 322.811 354.215 322.974L361.718 327.31C361.879 327.389 362.056 327.431 362.236 327.431C362.415 327.431 362.592 327.389 362.754 327.31L369.28 323.521C369.546 323.373 369.531 323.107 369.28 322.929L361.777 318.593C361.613 318.5 361.429 318.449 361.24 318.444C361.052 318.439 360.865 318.48 360.697 318.564V318.638ZM390.294 336.174L396.79 332.43C397.057 332.267 397.042 332.001 396.79 331.838L389.288 327.502C389.128 327.418 388.95 327.374 388.77 327.374C388.589 327.374 388.411 327.418 388.252 327.502L381.755 331.246C381.489 331.409 381.503 331.675 381.755 331.838L389.258 336.174C389.418 336.258 389.595 336.302 389.776 336.302C389.956 336.302 390.134 336.258 390.294 336.174ZM380.808 341.664L387.305 337.905C387.571 337.757 387.556 337.476 387.305 337.313L379.802 332.978C379.641 332.897 379.463 332.855 379.284 332.855C379.104 332.855 378.926 332.897 378.766 332.978L372.269 336.722C372.003 336.884 372.018 337.151 372.269 337.313L379.772 341.649C379.922 341.72 380.085 341.758 380.251 341.76C380.417 341.763 380.582 341.73 380.734 341.664H380.808ZM371.322 347.14L377.819 343.381C378.085 343.233 378.07 342.967 377.819 342.789L370.316 338.453C370.155 338.372 369.978 338.33 369.798 338.33C369.618 338.33 369.44 338.372 369.28 338.453L362.783 342.197C362.517 342.36 362.532 342.626 362.783 342.789L370.286 347.125C370.432 347.205 370.593 347.253 370.759 347.266C370.925 347.279 371.092 347.256 371.248 347.199L371.322 347.14ZM361.836 352.615L368.333 348.871C368.599 348.708 368.584 348.442 368.333 348.264L360.697 343.928C360.536 343.848 360.358 343.806 360.179 343.806C359.999 343.806 359.821 343.848 359.661 343.928L353.164 347.673C352.898 347.835 352.912 348.102 353.164 348.279L360.667 352.6C360.833 352.697 361.021 352.75 361.213 352.752C361.404 352.755 361.594 352.708 361.762 352.615H361.836ZM408.526 313.266L415.022 309.522C415.304 309.359 415.274 309.092 415.022 308.93L407.519 304.594C407.36 304.509 407.182 304.465 407.002 304.465C406.821 304.465 406.643 304.509 406.484 304.594L400.002 308.338C399.721 308.5 399.735 308.767 400.002 308.93L407.505 313.266C407.653 313.336 407.814 313.372 407.978 313.372C408.142 313.372 408.304 313.336 408.452 313.266H408.526ZM399.78 330.698L414.253 322.337C414.534 322.189 414.519 321.923 414.253 321.745L396.021 311.223C395.861 311.139 395.683 311.095 395.503 311.095C395.322 311.095 395.145 311.139 394.985 311.223L387.334 315.53C387.068 315.693 387.083 315.959 387.334 316.122L396.983 321.701C397.279 321.864 397.294 322.13 396.983 322.293L390.989 325.756C390.723 325.904 390.738 326.185 390.989 326.348L398.492 330.684C398.673 330.799 398.883 330.861 399.097 330.863C399.311 330.866 399.522 330.809 399.706 330.698H399.78ZM351.285 324.039L344.803 327.783C344.522 327.946 344.536 328.212 344.803 328.375L352.306 332.711C352.467 332.791 352.644 332.832 352.824 332.832C353.003 332.832 353.181 332.791 353.342 332.711L359.838 328.967C360.105 328.804 360.09 328.538 359.838 328.36L352.335 324.024C352.162 323.931 351.968 323.883 351.771 323.885C351.574 323.888 351.381 323.941 351.211 324.039H351.285ZM341.799 329.515L335.317 333.259C335.036 333.421 335.05 333.688 335.317 333.865L342.82 338.187C342.98 338.27 343.157 338.313 343.338 338.313C343.518 338.313 343.696 338.27 343.856 338.187L350.337 334.472C350.604 334.309 350.589 334.043 350.337 333.865L342.835 329.529C342.666 329.434 342.475 329.382 342.281 329.38C342.087 329.377 341.896 329.424 341.725 329.515H341.799ZM294.443 390.929C294.604 391.01 294.781 391.052 294.961 391.052C295.141 391.052 295.318 391.01 295.479 390.929L301.961 387.185C302.242 387.022 302.227 386.756 301.961 386.593L294.458 382.257C294.298 382.173 294.12 382.129 293.94 382.129C293.759 382.129 293.581 382.173 293.422 382.257L286.925 386.001C286.659 386.149 286.674 386.43 286.925 386.593L294.443 390.929ZM265.837 373.333L259.341 377.077C259.074 377.24 259.089 377.507 259.341 377.669L266.843 382.005C267.005 382.085 267.182 382.126 267.361 382.126C267.541 382.126 267.718 382.085 267.879 382.005L274.42 378.276C274.687 378.128 274.672 377.847 274.42 377.684L266.917 373.348C266.752 373.258 266.567 373.209 266.379 373.207C266.191 373.204 266.005 373.248 265.837 373.333ZM281.109 386.179C281.269 386.263 281.447 386.307 281.627 386.307C281.808 386.307 281.986 386.263 282.145 386.179L288.627 382.435C288.908 382.272 288.893 382.005 288.627 381.843L281.124 377.507C280.965 377.422 280.787 377.378 280.606 377.378C280.426 377.378 280.248 377.422 280.088 377.507L273.562 381.236C273.281 381.399 273.31 381.665 273.562 381.828L281.109 386.179ZM311.077 394.259L317.558 390.515C317.84 390.352 317.825 390.085 317.558 389.908L310.056 385.572C309.895 385.491 309.717 385.449 309.538 385.449C309.358 385.449 309.18 385.491 309.02 385.572L302.523 389.316C302.257 389.479 302.271 389.745 302.523 389.923L310.026 394.244C310.186 394.333 310.366 394.381 310.549 394.383C310.733 394.386 310.914 394.343 311.077 394.259ZM300.555 399.719C300.716 399.8 300.893 399.842 301.073 399.842C301.253 399.842 301.43 399.8 301.591 399.719L308.073 395.975C308.354 395.813 308.339 395.546 308.073 395.369L300.57 391.047C300.41 390.964 300.232 390.921 300.052 390.921C299.871 390.921 299.694 390.964 299.534 391.047L293.037 394.791C292.771 394.954 292.786 395.221 293.037 395.398L300.555 399.719ZM275.323 367.917L268.826 371.661C268.56 371.824 268.575 372.09 268.826 372.253L276.329 376.589C276.489 376.673 276.667 376.717 276.847 376.717C277.028 376.717 277.206 376.673 277.365 376.589L283.862 372.845C284.128 372.682 284.114 372.416 283.862 372.253L276.344 367.917C276.186 367.835 276.011 367.793 275.834 367.793C275.656 367.793 275.481 367.835 275.323 367.917ZM322.753 340.525L316.301 344.239C316.019 344.402 316.034 344.668 316.301 344.846L323.803 349.182C323.964 349.263 324.142 349.305 324.321 349.305C324.501 349.305 324.679 349.263 324.839 349.182L331.336 345.438C331.602 345.275 331.588 345.009 331.336 344.831L323.833 340.51C323.672 340.411 323.488 340.355 323.299 340.347C323.11 340.34 322.922 340.38 322.753 340.466V340.525ZM284.809 362.442L278.312 366.186C278.046 366.334 278.061 366.615 278.312 366.778L285.815 371.114C285.976 371.194 286.153 371.236 286.333 371.236C286.513 371.236 286.691 371.194 286.851 371.114L293.348 367.37C293.614 367.207 293.599 366.94 293.348 366.778L285.845 362.442C285.69 362.348 285.515 362.294 285.334 362.284C285.154 362.273 284.973 362.307 284.809 362.382V362.442ZM332.239 335.049L325.757 338.793C325.476 338.956 325.491 339.223 325.757 339.4L333.26 343.721C333.419 343.806 333.597 343.85 333.778 343.85C333.958 343.85 334.136 343.806 334.296 343.721L340.792 339.977C341.059 339.814 341.044 339.548 340.792 339.37L333.289 335.034C333.13 334.944 332.952 334.893 332.769 334.886C332.587 334.878 332.405 334.914 332.239 334.99V335.049ZM313.341 345.941L306.859 349.685C306.578 349.848 306.593 350.114 306.859 350.292L314.362 354.628C314.523 354.709 314.7 354.751 314.88 354.751C315.06 354.751 315.237 354.709 315.398 354.628L321.894 350.884C322.161 350.721 322.146 350.455 321.894 350.277L314.392 345.956C314.231 345.867 314.051 345.819 313.868 345.816C313.685 345.814 313.504 345.857 313.341 345.941ZM303.855 351.417L297.373 355.175C297.092 355.323 297.107 355.59 297.373 355.767L304.876 360.103C305.037 360.184 305.214 360.226 305.394 360.226C305.574 360.226 305.751 360.184 305.912 360.103L312.409 356.359C312.675 356.197 312.66 355.93 312.409 355.767L304.906 351.431C304.735 351.335 304.542 351.282 304.345 351.28C304.149 351.277 303.954 351.324 303.781 351.417H303.855ZM294.369 356.892L287.887 360.651C287.606 360.799 287.621 361.065 287.887 361.243L295.39 365.579C295.551 365.66 295.728 365.702 295.908 365.702C296.088 365.702 296.265 365.66 296.426 365.579L302.923 361.835C303.189 361.672 303.174 361.406 302.923 361.243L295.42 356.907C295.249 356.81 295.056 356.758 294.859 356.755C294.663 356.753 294.469 356.8 294.295 356.892H294.369ZM342.864 363.566L349.361 359.822C349.627 359.659 349.612 359.393 349.361 359.215L341.858 354.879C341.697 354.799 341.52 354.757 341.34 354.757C341.16 354.757 340.983 354.799 340.822 354.879L334.325 358.624C334.059 358.786 334.074 359.053 334.325 359.23L341.754 363.478C341.907 363.576 342.081 363.635 342.261 363.651C342.442 363.666 342.623 363.637 342.79 363.566H342.864ZM426.181 280.797L419.684 284.541C419.418 284.704 419.432 284.971 419.684 285.148L427.187 289.469C427.346 289.554 427.524 289.598 427.705 289.598C427.885 289.598 428.063 289.554 428.223 289.469L434.705 285.725C434.986 285.563 434.971 285.296 434.705 285.119L427.202 280.797C427.034 280.704 426.846 280.655 426.654 280.655C426.462 280.655 426.274 280.704 426.107 280.797H426.181ZM414.697 287.427L408.2 291.171C407.934 291.334 407.949 291.6 408.2 291.778L415.703 296.114C415.864 296.195 416.041 296.237 416.221 296.237C416.401 296.237 416.578 296.195 416.739 296.114L423.221 292.37C423.502 292.207 423.487 291.941 423.221 291.763L415.718 287.442C415.552 287.346 415.364 287.295 415.172 287.292C414.981 287.29 414.791 287.336 414.623 287.427H414.697ZM435.666 275.322L429.096 279.125C428.829 279.288 428.844 279.554 429.096 279.732L436.599 284.053C436.758 284.137 436.936 284.181 437.117 284.181C437.297 284.181 437.475 284.137 437.635 284.053L444.116 280.309C444.398 280.146 444.383 279.88 444.116 279.702L436.614 275.366C436.458 275.281 436.285 275.233 436.108 275.225C435.931 275.217 435.755 275.25 435.592 275.322H435.666ZM386.565 325.948L393.046 322.204C393.328 322.041 393.313 321.775 393.046 321.612L385.543 317.276C385.384 317.192 385.206 317.148 385.025 317.148C384.845 317.148 384.667 317.192 384.508 317.276L378.011 321.02C377.745 321.183 377.759 321.449 378.011 321.612L385.514 325.948C385.666 326.023 385.833 326.061 386.002 326.061C386.172 326.061 386.339 326.023 386.491 325.948H386.565ZM446.188 269.861C446.028 269.781 445.85 269.739 445.67 269.739C445.491 269.739 445.313 269.781 445.152 269.861L438.656 273.605C438.389 273.768 438.404 274.034 438.656 274.212L446.159 278.533C446.318 278.617 446.496 278.662 446.677 278.662C446.857 278.662 447.035 278.617 447.195 278.533L453.676 274.789C453.958 274.626 453.943 274.36 453.676 274.182L446.188 269.861ZM352.35 358.091L358.847 354.347C359.113 354.184 359.098 353.918 358.847 353.74L351.344 349.404C351.183 349.323 351.006 349.281 350.826 349.281C350.646 349.281 350.469 349.323 350.308 349.404L343.693 353.118C343.426 353.281 343.441 353.548 343.693 353.725L351.196 358.046C351.357 358.145 351.541 358.201 351.73 358.209C351.919 358.217 352.107 358.176 352.276 358.091H352.35ZM468.608 290.964L475.09 287.22C475.371 287.057 475.356 286.791 475.09 286.628L467.587 282.292C467.428 282.208 467.25 282.164 467.069 282.164C466.889 282.164 466.711 282.208 466.551 282.292L460.055 286.036C459.788 286.184 459.803 286.465 460.055 286.628L467.558 290.964C467.72 291.047 467.9 291.091 468.083 291.091C468.266 291.091 468.446 291.047 468.608 290.964ZM448.393 290.254L454.89 286.51C455.171 286.347 455.141 286.081 454.89 285.918L447.387 281.582C447.226 281.502 447.049 281.461 446.869 281.461C446.689 281.461 446.512 281.502 446.351 281.582L439.869 285.326C439.588 285.489 439.603 285.755 439.869 285.933L447.372 290.269C447.536 290.338 447.713 290.369 447.89 290.358C448.067 290.348 448.239 290.297 448.393 290.209V290.254ZM456.829 276.106C456.669 276.022 456.491 275.978 456.311 275.978C456.13 275.978 455.952 276.022 455.793 276.106L449.311 279.85C449.03 280.013 449.044 280.279 449.311 280.457L456.814 284.793C456.974 284.874 457.152 284.916 457.332 284.916C457.512 284.916 457.689 284.874 457.85 284.793L464.346 281.049C464.627 280.886 464.598 280.62 464.346 280.442L456.829 276.106ZM458.826 274.952L477.058 285.474C477.219 285.555 477.396 285.597 477.576 285.597C477.756 285.597 477.933 285.555 478.094 285.474L484.576 281.73C484.857 281.567 484.842 281.301 484.576 281.138L466.344 270.616C466.184 270.532 466.007 270.488 465.826 270.488C465.646 270.488 465.468 270.532 465.308 270.616L458.826 274.36C458.516 274.464 458.53 274.686 458.826 274.908V274.952ZM436.821 287.028L430.339 290.787C430.058 290.935 430.073 291.201 430.339 291.378L437.842 295.714C438.003 295.795 438.18 295.837 438.36 295.837C438.54 295.837 438.717 295.795 438.878 295.714L445.374 291.97C445.656 291.808 445.626 291.541 445.374 291.378L437.871 287.042C437.713 286.951 437.536 286.898 437.353 286.888C437.171 286.878 436.988 286.91 436.821 286.983V287.028ZM365.432 328.212L358.935 331.956C358.669 332.119 358.684 332.386 358.935 332.548L366.438 336.884C366.599 336.964 366.777 337.005 366.956 337.005C367.136 337.005 367.313 336.964 367.474 336.884L373.956 333.125C374.237 332.977 374.222 332.711 373.956 332.534L366.453 328.198C366.293 328.121 366.118 328.083 365.941 328.086C365.764 328.088 365.59 328.132 365.432 328.212ZM458.086 296.38C458.246 296.465 458.424 296.509 458.604 296.509C458.785 296.509 458.963 296.465 459.122 296.38L465.604 292.636C465.885 292.474 465.871 292.207 465.604 292.044L458.101 287.708C457.942 287.624 457.764 287.58 457.583 287.58C457.403 287.58 457.225 287.624 457.065 287.708L450.569 291.452C450.302 291.615 450.317 291.882 450.569 292.044L458.086 296.38ZM374.918 322.737L368.421 326.481C368.155 326.644 368.17 326.91 368.421 327.073L375.924 331.409C376.085 331.488 376.263 331.53 376.442 331.53C376.622 331.53 376.799 331.488 376.96 331.409L383.442 327.65C383.723 327.502 383.708 327.221 383.442 327.058L375.939 322.722C375.779 322.646 375.604 322.608 375.427 322.61C375.25 322.613 375.076 322.656 374.918 322.737ZM303.811 385.454C303.971 385.534 304.149 385.576 304.328 385.576C304.508 385.576 304.686 385.534 304.846 385.454L311.343 381.709C311.609 381.547 311.595 381.28 311.343 381.118L303.796 376.796C303.635 376.717 303.457 376.675 303.278 376.675C303.098 376.675 302.921 376.717 302.76 376.796L296.263 380.555C295.997 380.703 296.012 380.97 296.263 381.147L303.811 385.454ZM289.545 372.031L283.048 375.775C282.767 375.923 282.796 376.204 283.048 376.367L290.551 380.703C290.712 380.784 290.889 380.826 291.069 380.826C291.249 380.826 291.426 380.784 291.587 380.703L298.069 376.959C298.35 376.796 298.335 376.53 298.069 376.367L290.566 372.031C290.408 371.949 290.233 371.907 290.055 371.907C289.877 371.907 289.702 371.949 289.545 372.031ZM314.332 379.993L320.814 376.249C321.095 376.086 321.081 375.82 320.814 375.657L313.341 371.321C313.18 371.241 313.003 371.2 312.823 371.2C312.643 371.2 312.466 371.241 312.305 371.321L305.808 375.08C305.542 375.228 305.557 375.494 305.808 375.672L313.311 380.008C313.471 380.084 313.646 380.122 313.824 380.119C314.001 380.117 314.175 380.073 314.332 379.993ZM323.818 374.517L330.315 370.773C330.581 370.61 330.566 370.344 330.315 370.166L322.812 365.845C322.652 365.761 322.475 365.717 322.294 365.717C322.114 365.717 321.936 365.761 321.776 365.845L315.279 369.589C315.013 369.752 315.028 370.019 315.279 370.196L322.782 374.532C322.944 374.611 323.122 374.65 323.302 374.647C323.482 374.645 323.659 374.6 323.818 374.517ZM333.304 369.042L339.801 365.298C340.067 365.135 340.052 364.869 339.801 364.691L332.298 360.37C332.138 360.286 331.96 360.242 331.78 360.242C331.599 360.242 331.422 360.286 331.262 360.37L324.765 364.114C324.499 364.277 324.514 364.543 324.765 364.721L332.268 369.057C332.43 369.135 332.608 369.174 332.788 369.172C332.968 369.169 333.145 369.125 333.304 369.042ZM299.031 366.541L292.534 370.3C292.253 370.448 292.282 370.714 292.534 370.892L300.037 375.228C300.198 375.308 300.375 375.35 300.555 375.35C300.735 375.35 300.912 375.308 301.073 375.228L307.555 371.484C307.836 371.321 307.821 371.054 307.555 370.892L300.022 366.57C299.869 366.493 299.701 366.45 299.53 366.445C299.358 366.44 299.188 366.473 299.031 366.541ZM308.516 361.065L302.02 364.824C301.754 364.972 301.768 365.239 302.02 365.416L309.523 369.752C309.684 369.833 309.861 369.875 310.041 369.875C310.221 369.875 310.398 369.833 310.559 369.752L317.04 366.008C317.322 365.845 317.307 365.579 317.04 365.416L309.538 361.08C309.38 361.001 309.206 360.958 309.029 360.955C308.852 360.953 308.677 360.99 308.516 361.065ZM346.46 339.163L339.978 342.907C339.712 343.07 339.727 343.337 339.978 343.514L347.481 347.835C347.641 347.92 347.819 347.964 347.999 347.964C348.18 347.964 348.358 347.92 348.517 347.835L354.999 344.091C355.28 343.928 355.265 343.662 354.999 343.485L347.496 339.149C347.334 339.07 347.156 339.031 346.976 339.033C346.797 339.036 346.62 339.08 346.46 339.163ZM336.974 344.639L330.478 348.383C330.211 348.546 330.226 348.812 330.478 348.99L337.981 353.311C338.14 353.395 338.318 353.439 338.499 353.439C338.679 353.439 338.857 353.395 339.017 353.311L345.498 349.567C345.779 349.404 345.765 349.138 345.498 348.96L337.995 344.624C337.841 344.555 337.674 344.52 337.505 344.523C337.337 344.526 337.171 344.565 337.019 344.639H336.974ZM355.946 333.688L349.45 337.432C349.183 337.595 349.198 337.861 349.45 338.024L356.952 342.36C357.114 342.439 357.291 342.481 357.47 342.481C357.65 342.481 357.827 342.439 357.988 342.36L364.47 338.601C364.751 338.453 364.737 338.187 364.47 338.009L356.967 333.673C356.807 333.597 356.632 333.559 356.455 333.561C356.278 333.564 356.104 333.607 355.946 333.688ZM318.002 355.59L311.506 359.334C311.239 359.497 311.254 359.763 311.506 359.941L319.009 364.277C319.169 364.357 319.347 364.399 319.527 364.399C319.707 364.399 319.884 364.357 320.045 364.277L326.526 360.533C326.808 360.37 326.793 360.103 326.526 359.926L319.024 355.605C318.867 355.522 318.692 355.477 318.515 355.475C318.337 355.472 318.162 355.512 318.002 355.59ZM327.488 350.114L320.992 353.858C320.725 354.021 320.74 354.288 320.992 354.465L328.495 358.801C328.655 358.882 328.833 358.924 329.013 358.924C329.192 358.924 329.37 358.882 329.531 358.801L336.012 355.057C336.294 354.894 336.279 354.628 336.012 354.45L328.524 350.159C328.364 350.076 328.187 350.032 328.006 350.032C327.826 350.032 327.648 350.076 327.488 350.159V350.114ZM320.563 388.783L327.044 385.039C327.326 384.876 327.311 384.61 327.044 384.432L319.541 380.096C319.381 380.016 319.203 379.974 319.024 379.974C318.844 379.974 318.666 380.016 318.506 380.096L312.009 383.84C311.743 384.003 311.757 384.27 312.009 384.447L319.512 388.768C319.672 388.857 319.852 388.905 320.035 388.908C320.219 388.911 320.4 388.868 320.563 388.783ZM264.89 383.16L257.387 378.824C257.226 378.743 257.049 378.701 256.869 378.701C256.689 378.701 256.512 378.743 256.351 378.824L249.855 382.568C249.588 382.731 249.603 382.997 249.855 383.16L257.358 387.496C257.519 387.575 257.696 387.617 257.876 387.617C258.055 387.617 258.232 387.575 258.393 387.496L264.89 383.737C265.201 383.604 265.186 383.337 264.89 383.16ZM279.112 387.333L271.609 382.997C271.448 382.916 271.271 382.874 271.091 382.874C270.911 382.874 270.733 382.916 270.573 382.997L260.584 388.754C260.302 388.916 260.317 389.183 260.584 389.36L268.101 393.682C268.261 393.766 268.439 393.81 268.619 393.81C268.8 393.81 268.978 393.766 269.137 393.682L279.112 387.91C279.422 387.777 279.408 387.496 279.112 387.333ZM253.377 374.784L245.874 370.448C245.713 370.367 245.536 370.325 245.356 370.325C245.176 370.325 244.999 370.367 244.838 370.448L236.847 375.05C236.58 375.213 236.595 375.479 236.847 375.657L244.35 379.993C244.51 380.074 244.688 380.116 244.867 380.116C245.047 380.116 245.225 380.074 245.385 379.993L253.377 375.376C253.687 375.228 253.673 374.946 253.377 374.784ZM259.503 371.247C259.663 371.331 259.841 371.375 260.021 371.375C260.202 371.375 260.38 371.331 260.539 371.247L267.021 367.503C267.302 367.34 267.287 367.074 267.021 366.911L259.518 362.575C259.359 362.491 259.181 362.446 259 362.446C258.82 362.446 258.642 362.491 258.482 362.575L251.986 366.319C251.719 366.482 251.734 366.748 251.986 366.911L259.503 371.247ZM292.327 392.083L284.824 387.747C284.664 387.663 284.486 387.619 284.306 387.619C284.125 387.619 283.948 387.663 283.788 387.747L271.298 394.954C271.031 395.102 271.046 395.369 271.298 395.546L278.801 399.882C278.962 399.963 279.139 400.005 279.319 400.005C279.499 400.005 279.676 399.963 279.837 399.882L292.312 392.675C292.623 392.512 292.623 392.246 292.327 392.083ZM298.557 400.859L291.054 396.538C290.894 396.455 290.716 396.411 290.536 396.411C290.356 396.411 290.178 396.455 290.018 396.538L282.027 401.155C281.746 401.318 281.761 401.584 282.027 401.747L289.545 406.083C289.704 406.167 289.882 406.211 290.063 406.211C290.243 406.211 290.421 406.167 290.581 406.083L298.557 401.48C298.868 401.303 298.853 401.036 298.542 400.859H298.557ZM330.034 330.521C330.193 330.605 330.371 330.649 330.552 330.649C330.732 330.649 330.91 330.605 331.07 330.521L337.551 326.777C337.833 326.614 337.818 326.348 337.551 326.17L330.049 321.834C329.888 321.753 329.71 321.711 329.531 321.711C329.351 321.711 329.173 321.753 329.013 321.834L322.516 325.578C322.25 325.741 322.264 326.007 322.516 326.185L330.034 330.521ZM311.062 341.487C311.223 341.567 311.4 341.609 311.58 341.609C311.76 341.609 311.937 341.567 312.098 341.487L318.58 337.743C318.861 337.58 318.846 337.313 318.58 337.136L311.077 332.815C310.917 332.732 310.739 332.688 310.559 332.688C310.378 332.688 310.201 332.732 310.041 332.815L303.544 336.559C303.278 336.722 303.293 336.988 303.544 337.165L311.062 341.487ZM268.945 365.771C269.106 365.852 269.283 365.894 269.463 365.894C269.643 365.894 269.82 365.852 269.981 365.771L276.463 362.027C276.744 361.864 276.729 361.598 276.463 361.435L268.945 357.114C268.784 357.035 268.607 356.993 268.427 356.993C268.247 356.993 268.07 357.035 267.909 357.114L261.412 360.873C261.146 361.021 261.161 361.302 261.412 361.465L268.945 365.771ZM320.503 335.996C320.663 336.081 320.841 336.125 321.021 336.125C321.202 336.125 321.38 336.081 321.539 335.996L328.021 332.252C328.302 332.09 328.287 331.823 328.021 331.646L320.518 327.31C320.357 327.229 320.18 327.187 320 327.187C319.82 327.187 319.643 327.229 319.482 327.31L312.986 331.054C312.719 331.216 312.734 331.483 312.986 331.66L320.503 335.996ZM301.532 346.962C301.692 347.043 301.87 347.085 302.049 347.085C302.229 347.085 302.407 347.043 302.567 346.962L309.049 343.218C309.33 343.055 309.316 342.789 309.049 342.611L301.502 338.32C301.342 338.237 301.164 338.193 300.984 338.193C300.804 338.193 300.626 338.237 300.466 338.32L294.103 342.019C293.836 342.182 293.851 342.449 294.103 342.626L301.532 346.962ZM303.722 401.569C303.562 401.485 303.384 401.441 303.204 401.441C303.023 401.441 302.845 401.485 302.686 401.569L292.697 407.326C292.43 407.489 292.445 407.755 292.697 407.933L300.2 412.254C300.359 412.338 300.537 412.382 300.718 412.382C300.898 412.382 301.076 412.338 301.236 412.254L311.225 406.482C311.491 406.32 311.476 406.053 311.225 405.89L303.722 401.569ZM287.917 354.82C288.077 354.901 288.255 354.943 288.435 354.943C288.615 354.943 288.792 354.901 288.953 354.82L295.434 351.076C295.716 350.913 295.701 350.647 295.434 350.484L287.932 346.148C287.77 346.069 287.593 346.027 287.414 346.027C287.234 346.027 287.057 346.069 286.896 346.148L280.399 349.907C280.133 350.055 280.147 350.322 280.399 350.499L287.917 354.82ZM278.431 360.296C278.592 360.377 278.769 360.419 278.949 360.419C279.129 360.419 279.306 360.377 279.467 360.296L285.949 356.552C286.23 356.389 286.215 356.123 285.949 355.96L278.46 351.639C278.299 351.559 278.122 351.518 277.942 351.518C277.763 351.518 277.586 351.559 277.425 351.639L270.928 355.397C270.662 355.545 270.676 355.812 270.928 355.989L278.431 360.296ZM479.47 300.11C479.31 300.027 479.133 299.983 478.953 299.983C478.772 299.983 478.595 300.027 478.435 300.11L462.452 309.329C462.186 309.492 462.2 309.758 462.452 309.936L469.955 314.272C470.116 314.353 470.293 314.395 470.473 314.395C470.653 314.395 470.83 314.353 470.991 314.272L486.959 305.052C487.24 304.89 487.225 304.623 486.959 304.446L479.47 300.11ZM458.501 312.215C458.341 312.132 458.163 312.089 457.983 312.089C457.803 312.089 457.625 312.132 457.465 312.215L450.968 315.929C450.702 316.092 450.717 316.359 450.968 316.536L458.471 320.872C458.632 320.953 458.809 320.995 458.989 320.995C459.169 320.995 459.346 320.953 459.507 320.872L465.989 317.128C466.27 316.965 466.255 316.699 465.989 316.521L458.501 312.215ZM330.004 383.248L336.486 379.49C336.767 379.342 336.752 379.075 336.486 378.898L328.983 374.562C328.822 374.481 328.645 374.439 328.465 374.439C328.285 374.439 328.108 374.481 327.947 374.562L321.45 378.306C321.184 378.469 321.199 378.735 321.45 378.898L328.953 383.234C329.116 383.335 329.301 383.394 329.492 383.407C329.683 383.42 329.874 383.386 330.049 383.308L330.004 383.248ZM439.514 323.107C439.353 323.027 439.176 322.986 438.996 322.986C438.817 322.986 438.639 323.027 438.478 323.107L431.982 326.866C431.715 327.014 431.73 327.28 431.982 327.458L439.485 331.794C439.645 331.874 439.823 331.916 440.002 331.916C440.182 331.916 440.36 331.874 440.52 331.794L447.002 328.05C447.283 327.887 447.269 327.62 447.002 327.458L439.514 323.107ZM488.942 294.575C488.782 294.492 488.604 294.449 488.424 294.449C488.243 294.449 488.066 294.492 487.906 294.575L481.468 298.363C481.202 298.526 481.217 298.793 481.468 298.97L488.971 303.291C489.131 303.376 489.309 303.42 489.489 303.42C489.67 303.42 489.847 303.376 490.007 303.291L496.489 299.547C496.77 299.385 496.755 299.118 496.489 298.941L488.942 294.575ZM505.93 293.421L487.699 282.899C487.538 282.818 487.36 282.776 487.181 282.776C487.001 282.776 486.823 282.818 486.663 282.899L480.181 286.643C479.9 286.806 479.914 287.072 480.181 287.235L498.413 297.757C498.572 297.841 498.75 297.885 498.931 297.885C499.111 297.885 499.289 297.841 499.449 297.757L505.93 294.013C506.3 293.924 506.286 293.657 505.99 293.48L505.93 293.421ZM404.057 343.573C403.895 343.494 403.718 343.452 403.539 343.452C403.359 343.452 403.182 343.494 403.021 343.573L395.044 348.191C394.763 348.353 394.778 348.62 395.044 348.782L402.547 353.118C402.708 353.198 402.885 353.239 403.065 353.239C403.245 353.239 403.422 353.198 403.583 353.118L411.574 348.501C411.855 348.338 411.841 348.072 411.574 347.909L404.057 343.573ZM428.03 329.737C427.869 329.657 427.692 329.616 427.512 329.616C427.333 329.616 427.156 329.657 426.994 329.737L417.005 335.508C416.724 335.671 416.754 335.937 417.005 336.1L424.508 340.436C424.669 340.516 424.847 340.557 425.026 340.557C425.206 340.557 425.383 340.516 425.544 340.436L435.518 334.665C435.8 334.502 435.785 334.235 435.518 334.073L428.03 329.737ZM382.155 356.256C381.993 356.176 381.816 356.135 381.637 356.135C381.457 356.135 381.28 356.176 381.119 356.256L327.696 387.155C327.414 387.303 327.444 387.57 327.696 387.747L335.198 392.083C335.359 392.164 335.537 392.206 335.716 392.206C335.896 392.206 336.074 392.164 336.234 392.083L389.657 361.243C389.924 361.08 389.909 360.814 389.657 360.651L382.155 356.256ZM325.742 388.813C325.581 388.733 325.404 388.692 325.224 388.692C325.044 388.692 324.867 388.733 324.706 388.813L316.715 393.43C316.434 393.593 316.449 393.859 316.715 394.037L324.218 398.358C324.378 398.441 324.556 398.484 324.736 398.484C324.916 398.484 325.094 398.441 325.254 398.358L333.245 393.741C333.526 393.578 333.511 393.312 333.245 393.149L325.742 388.813ZM393.135 349.892C392.974 349.812 392.797 349.77 392.617 349.77C392.437 349.77 392.26 349.812 392.099 349.892L384.108 354.51C383.842 354.658 383.856 354.924 384.108 355.101L391.611 359.437C391.772 359.518 391.949 359.56 392.129 359.56C392.309 359.56 392.486 359.518 392.647 359.437L400.638 354.835C400.904 354.672 400.89 354.406 400.638 354.228L393.135 349.892ZM314.702 395.147C314.542 395.066 314.364 395.024 314.184 395.024C314.005 395.024 313.827 395.066 313.666 395.147L305.69 399.764C305.409 399.912 305.424 400.193 305.69 400.356L313.193 404.692C313.354 404.772 313.531 404.814 313.711 404.814C313.891 404.814 314.068 404.772 314.229 404.692L322.22 400.089C322.501 399.927 322.486 399.66 322.22 399.483L314.702 395.147ZM415.067 337.21C414.906 337.129 414.729 337.087 414.549 337.087C414.369 337.087 414.192 337.129 414.031 337.21L406.04 341.827C405.758 341.975 405.773 342.241 406.04 342.419L413.557 346.755C413.715 346.836 413.89 346.878 414.068 346.878C414.245 346.878 414.42 346.836 414.578 346.755L422.57 342.153C422.851 341.99 422.836 341.723 422.57 341.546L415.067 337.21ZM449.015 317.616C448.854 317.537 448.677 317.495 448.497 317.495C448.317 317.495 448.14 317.537 447.979 317.616L441.482 321.375C441.216 321.523 441.231 321.79 441.482 321.967L448.985 326.303C449.146 326.384 449.323 326.426 449.503 326.426C449.683 326.426 449.86 326.384 450.021 326.303L456.503 322.559C456.784 322.396 456.769 322.13 456.503 321.967L449.015 317.616ZM469.733 302.522L476.23 298.763C476.511 298.615 476.481 298.349 476.23 298.171L468.727 293.924C468.566 293.843 468.389 293.801 468.209 293.801C468.029 293.801 467.851 293.843 467.691 293.924L461.327 297.638C461.046 297.801 461.061 298.067 461.327 298.23L468.83 302.566C468.985 302.646 469.156 302.69 469.33 302.695C469.504 302.7 469.677 302.666 469.837 302.596L469.733 302.522ZM427.32 302.241L433.817 298.497C434.098 298.334 434.068 298.067 433.817 297.905L426.314 293.569C426.153 293.489 425.975 293.448 425.796 293.448C425.616 293.448 425.439 293.489 425.278 293.569L418.796 297.328C418.515 297.475 418.53 297.742 418.796 297.919L426.299 302.255C426.466 302.361 426.657 302.421 426.854 302.432C427.05 302.442 427.247 302.402 427.424 302.315L427.32 302.241ZM405.832 339.415L424.804 328.464C425.085 328.301 425.056 328.035 424.804 327.857L417.301 323.536C417.142 323.452 416.964 323.408 416.783 323.408C416.603 323.408 416.425 323.452 416.265 323.536L397.294 334.487C397.027 334.65 397.042 334.916 397.294 335.094L404.796 339.43C404.965 339.537 405.159 339.6 405.358 339.61C405.558 339.62 405.757 339.579 405.936 339.489L405.832 339.415ZM459.211 307.968C459.371 308.051 459.549 308.094 459.729 308.094C459.909 308.094 460.087 308.051 460.247 307.968L466.744 304.224C467.025 304.061 466.995 303.795 466.744 303.617L459.241 299.281C459.08 299.2 458.903 299.158 458.723 299.158C458.543 299.158 458.366 299.2 458.205 299.281L451.723 303.025C451.442 303.188 451.457 303.454 451.723 303.632L459.211 307.968ZM449.533 301.811L456.015 298.053C456.296 297.905 456.281 297.624 456.015 297.461L448.512 293.125C448.351 293.044 448.174 293.002 447.994 293.002C447.814 293.002 447.637 293.044 447.476 293.125L441.053 296.884C440.787 297.046 440.802 297.313 441.053 297.476L448.556 301.811C448.717 301.91 448.899 301.968 449.087 301.981C449.275 301.994 449.464 301.961 449.636 301.886L449.533 301.811ZM396.346 344.89L402.828 341.146C403.109 340.984 403.095 340.717 402.828 340.54L395.325 336.218C395.166 336.134 394.988 336.09 394.807 336.09C394.627 336.09 394.449 336.134 394.289 336.218L387.793 339.962C387.526 340.125 387.541 340.392 387.793 340.569L395.296 344.905C395.466 345.016 395.662 345.079 395.865 345.09C396.068 345.1 396.269 345.057 396.45 344.964L396.346 344.89ZM438.241 320.073C438.401 320.156 438.579 320.199 438.759 320.199C438.94 320.199 439.117 320.156 439.277 320.073L445.774 316.329C446.055 316.166 446.026 315.9 445.774 315.722L438.271 311.401C438.111 311.317 437.934 311.273 437.753 311.273C437.573 311.273 437.395 311.317 437.235 311.401L430.753 315.145C430.472 315.308 430.487 315.574 430.753 315.752L438.241 320.073ZM349.02 372.357L355.502 368.598C355.783 368.45 355.769 368.169 355.502 368.006L347.999 363.67C347.839 363.589 347.661 363.547 347.481 363.547C347.301 363.547 347.124 363.589 346.963 363.67L340.467 367.414C340.2 367.577 340.215 367.843 340.467 368.006L347.97 372.342C348.132 372.426 348.311 372.471 348.493 372.474C348.676 372.477 348.856 372.436 349.02 372.357ZM358.506 366.866L364.988 363.122C365.269 362.96 365.255 362.693 364.988 362.53L357.485 358.194C357.326 358.11 357.148 358.066 356.967 358.066C356.787 358.066 356.609 358.11 356.449 358.194L349.923 361.998C349.657 362.16 349.672 362.427 349.923 362.59L357.426 366.926C357.596 367.009 357.785 367.047 357.974 367.037C358.163 367.026 358.346 366.968 358.506 366.866ZM339.534 377.832L346.016 374.073C346.297 373.925 346.283 373.659 346.016 373.481L338.499 369.145C338.338 369.065 338.16 369.023 337.981 369.023C337.801 369.023 337.623 369.065 337.463 369.145L330.966 372.889C330.7 373.052 330.714 373.319 330.966 373.481L338.469 377.817C338.633 377.904 338.815 377.951 339 377.953C339.185 377.956 339.368 377.914 339.534 377.832ZM377.478 355.915L383.96 352.171C384.241 352.009 384.226 351.742 383.96 351.579L376.427 347.199C376.266 347.119 376.089 347.078 375.91 347.078C375.73 347.078 375.553 347.119 375.392 347.199L368.895 350.958C368.629 351.106 368.643 351.372 368.895 351.55L376.398 355.886C376.562 355.978 376.746 356.03 376.934 356.035C377.123 356.04 377.309 355.999 377.478 355.915ZM367.992 361.391L374.474 357.647C374.755 357.484 374.74 357.218 374.474 357.055L366.971 352.719C366.81 352.639 366.633 352.598 366.453 352.598C366.274 352.598 366.096 352.639 365.935 352.719L359.439 356.478C359.172 356.626 359.187 356.907 359.439 357.07L366.942 361.406C367.105 361.487 367.286 361.527 367.469 361.525C367.651 361.522 367.831 361.476 367.992 361.391ZM386.964 350.44L393.446 346.696C393.727 346.533 393.712 346.267 393.446 346.104L385.854 341.768C385.694 341.685 385.517 341.641 385.336 341.641C385.156 341.641 384.978 341.685 384.818 341.768L378.455 345.497C378.189 345.645 378.203 345.911 378.455 346.089L385.958 350.425C386.114 350.503 386.285 350.545 386.459 350.548C386.634 350.55 386.806 350.514 386.964 350.44ZM430.369 269.417C430.527 269.498 430.702 269.54 430.879 269.54C431.057 269.54 431.232 269.498 431.39 269.417L437.886 265.658C438.167 265.51 438.153 265.244 437.886 265.066L435.888 263.912C435.728 263.831 435.55 263.789 435.37 263.789C435.191 263.789 435.013 263.831 434.853 263.912L428.356 267.656C428.075 267.819 428.104 268.085 428.356 268.248L430.369 269.417ZM383.694 299.547C383.853 299.632 384.031 299.676 384.212 299.676C384.392 299.676 384.57 299.632 384.73 299.547L391.211 295.803C391.493 295.655 391.478 295.374 391.211 295.211L383.679 290.964C383.519 290.88 383.341 290.836 383.161 290.836C382.98 290.836 382.803 290.88 382.643 290.964L376.146 294.708C375.865 294.871 375.88 295.137 376.146 295.3L383.694 299.547ZM402.665 288.596C402.826 288.677 403.004 288.719 403.183 288.719C403.363 288.719 403.541 288.677 403.701 288.596L410.183 284.852C410.464 284.689 410.45 284.423 410.183 284.26L402.68 279.924C402.519 279.845 402.342 279.803 402.162 279.803C401.983 279.803 401.805 279.845 401.644 279.924L395.148 283.683C394.867 283.831 394.881 284.112 395.148 284.275L402.665 288.596ZM372.106 306.236C372.267 306.317 372.444 306.359 372.624 306.359C372.804 306.359 372.981 306.317 373.142 306.236L379.624 302.492C379.905 302.329 379.89 302.063 379.624 301.9L372.121 297.564C371.961 297.48 371.784 297.436 371.603 297.436C371.423 297.436 371.245 297.48 371.085 297.564L364.559 301.323C364.293 301.471 364.307 301.752 364.559 301.915L372.106 306.236ZM393.254 294.072C393.413 294.156 393.591 294.2 393.772 294.2C393.952 294.2 394.13 294.156 394.289 294.072L400.771 290.328C401.052 290.165 401.038 289.899 400.771 289.736L393.254 285.4C393.097 285.316 392.921 285.272 392.743 285.272C392.565 285.272 392.389 285.316 392.232 285.4L385.736 289.144C385.455 289.307 385.469 289.573 385.736 289.736L393.254 294.072ZM353.208 317.187C353.369 317.267 353.547 317.308 353.726 317.308C353.906 317.308 354.083 317.267 354.244 317.187L360.697 313.458C360.978 313.31 360.963 313.029 360.697 312.866L353.194 308.53C353.033 308.449 352.856 308.407 352.676 308.407C352.496 308.407 352.318 308.449 352.158 308.53L345.661 312.274C345.395 312.437 345.41 312.703 345.661 312.866L353.208 317.187ZM362.694 311.712C362.854 311.796 363.032 311.84 363.212 311.84C363.393 311.84 363.571 311.796 363.73 311.712L370.212 307.968C370.493 307.805 370.478 307.539 370.212 307.376L362.709 303.04C362.549 302.956 362.372 302.912 362.191 302.912C362.011 302.912 361.833 302.956 361.673 303.04L355.177 306.784C354.91 306.947 354.925 307.213 355.177 307.376L362.694 311.712ZM411.456 280.368C411.616 280.451 411.794 280.495 411.974 280.495C412.154 280.495 412.332 280.451 412.492 280.368L418.988 276.624C419.27 276.461 419.255 276.195 418.988 276.017L416.991 274.863C416.83 274.782 416.652 274.74 416.473 274.74C416.293 274.74 416.115 274.782 415.955 274.863L409.458 278.607C409.177 278.77 409.192 279.036 409.458 279.199L411.456 280.368ZM439.928 263.942C440.09 264.021 440.267 264.063 440.446 264.063C440.626 264.063 440.803 264.021 440.964 263.942L447.446 260.183C447.727 260.035 447.713 259.769 447.446 259.591L445.345 258.407C445.185 258.323 445.007 258.279 444.827 258.279C444.646 258.279 444.469 258.323 444.309 258.407L437.812 262.151C437.531 262.314 437.561 262.58 437.812 262.743L439.928 263.942ZM455.689 273.043C455.85 273.123 456.027 273.164 456.207 273.164C456.387 273.164 456.564 273.123 456.725 273.043L463.207 269.284C463.488 269.136 463.473 268.87 463.207 268.692L455.6 264.327C455.44 264.246 455.262 264.204 455.082 264.204C454.902 264.204 454.725 264.246 454.564 264.327L448.009 268.115C447.742 268.278 447.757 268.544 448.009 268.707L455.689 273.043ZM479.367 297.12L485.863 293.361C486.145 293.213 486.13 292.947 485.863 292.77L478.361 288.434C478.2 288.353 478.022 288.311 477.843 288.311C477.663 288.311 477.485 288.353 477.325 288.434L470.843 292.178C470.562 292.34 470.576 292.607 470.843 292.77L478.346 297.106C478.498 297.178 478.664 297.217 478.833 297.22C479.001 297.222 479.168 297.188 479.322 297.12H479.367ZM420.927 274.922C421.084 275.005 421.26 275.049 421.438 275.049C421.616 275.049 421.791 275.005 421.948 274.922L428.445 271.178C428.726 271.016 428.711 270.749 428.445 270.572L426.447 269.417C426.286 269.337 426.109 269.295 425.929 269.295C425.749 269.295 425.572 269.337 425.411 269.417L418.84 273.206C418.559 273.369 418.574 273.635 418.84 273.798L420.927 274.922ZM343.693 322.692C343.854 322.772 344.031 322.813 344.211 322.813C344.39 322.813 344.568 322.772 344.729 322.692L351.211 318.934C351.492 318.786 351.477 318.519 351.211 318.342L343.708 314.006C343.547 313.925 343.37 313.883 343.19 313.883C343.01 313.883 342.833 313.925 342.672 314.006L336.175 317.75C335.909 317.912 335.924 318.179 336.175 318.342L343.693 322.692Z"
                                fill="#07178E"
                              />
                              <path
                                opacity="0.8"
                                d="M417.938 307.79L424.434 304.046C424.715 303.883 424.686 303.617 424.434 303.454L416.931 299.118C416.77 299.039 416.593 298.997 416.413 298.997C416.234 298.997 416.057 299.039 415.895 299.118L409.369 302.803C409.088 302.951 409.103 303.232 409.369 303.395L416.872 307.731C417.032 307.826 417.212 307.881 417.398 307.891C417.583 307.901 417.768 307.867 417.938 307.79ZM405.092 292.903L398.596 296.647C398.329 296.81 398.344 297.076 398.596 297.254L406.099 301.59C406.259 301.67 406.437 301.712 406.617 301.712C406.797 301.712 406.974 301.67 407.135 301.59L413.617 297.845C413.898 297.683 413.883 297.416 413.617 297.239L406.114 292.918C405.957 292.835 405.782 292.79 405.605 292.788C405.427 292.785 405.252 292.824 405.092 292.903ZM384.123 305.008L373.142 311.357C372.861 311.519 372.876 311.786 373.142 311.949L380.645 316.285C380.805 316.369 380.983 316.413 381.163 316.413C381.344 316.413 381.521 316.369 381.681 316.285L392.662 309.951C392.943 309.788 392.928 309.522 392.662 309.359L385.159 305.023C385.005 304.948 384.836 304.908 384.665 304.905C384.493 304.903 384.323 304.938 384.167 305.008H384.123ZM395.607 298.378L389.11 302.137C388.844 302.285 388.858 302.551 389.11 302.729L396.613 307.065C396.774 307.146 396.951 307.188 397.131 307.188C397.311 307.188 397.488 307.146 397.649 307.065L404.131 303.321C404.412 303.158 404.397 302.892 404.131 302.729L396.687 298.363C396.526 298.284 396.349 298.242 396.169 298.242C395.989 298.242 395.812 298.284 395.651 298.363L395.607 298.378ZM370.182 313.162L363.656 316.832C363.375 316.995 363.39 317.261 363.656 317.424L371.159 321.76C371.32 321.84 371.497 321.881 371.677 321.881C371.857 321.881 372.034 321.84 372.195 321.76L378.692 318.001C378.958 317.853 378.943 317.572 378.692 317.409L371.218 313.162C371.058 313.081 370.88 313.039 370.7 313.039C370.521 313.039 370.343 313.081 370.182 313.162ZM360.697 318.638L354.215 322.382C353.934 322.544 353.948 322.811 354.215 322.974L361.718 327.31C361.879 327.389 362.056 327.431 362.236 327.431C362.415 327.431 362.592 327.389 362.754 327.31L369.28 323.521C369.546 323.373 369.531 323.107 369.28 322.929L361.777 318.593C361.613 318.5 361.429 318.449 361.24 318.444C361.052 318.439 360.865 318.48 360.697 318.564V318.638ZM390.294 336.174L396.79 332.43C397.057 332.267 397.042 332.001 396.79 331.838L389.288 327.502C389.128 327.418 388.95 327.374 388.77 327.374C388.589 327.374 388.411 327.418 388.252 327.502L381.755 331.246C381.489 331.409 381.503 331.675 381.755 331.838L389.258 336.174C389.418 336.258 389.595 336.302 389.776 336.302C389.956 336.302 390.134 336.258 390.294 336.174ZM380.808 341.664L387.305 337.905C387.571 337.757 387.556 337.476 387.305 337.313L379.802 332.978C379.641 332.897 379.463 332.855 379.284 332.855C379.104 332.855 378.926 332.897 378.766 332.978L372.269 336.722C372.003 336.884 372.018 337.151 372.269 337.313L379.772 341.649C379.922 341.72 380.085 341.758 380.251 341.76C380.417 341.763 380.582 341.73 380.734 341.664H380.808ZM371.322 347.14L377.819 343.381C378.085 343.233 378.07 342.967 377.819 342.789L370.316 338.453C370.155 338.372 369.978 338.33 369.798 338.33C369.618 338.33 369.44 338.372 369.28 338.453L362.783 342.197C362.517 342.36 362.532 342.626 362.783 342.789L370.286 347.125C370.432 347.205 370.593 347.253 370.759 347.266C370.925 347.279 371.092 347.256 371.248 347.199L371.322 347.14ZM361.836 352.615L368.333 348.871C368.599 348.708 368.584 348.442 368.333 348.264L360.697 343.928C360.536 343.848 360.358 343.806 360.179 343.806C359.999 343.806 359.821 343.848 359.661 343.928L353.164 347.673C352.898 347.835 352.912 348.102 353.164 348.279L360.667 352.6C360.833 352.697 361.021 352.75 361.213 352.752C361.404 352.755 361.594 352.708 361.762 352.615H361.836ZM408.526 313.266L415.022 309.522C415.304 309.359 415.274 309.092 415.022 308.93L407.519 304.594C407.36 304.509 407.182 304.465 407.002 304.465C406.821 304.465 406.643 304.509 406.484 304.594L400.002 308.338C399.721 308.5 399.735 308.767 400.002 308.93L407.505 313.266C407.653 313.336 407.814 313.372 407.978 313.372C408.142 313.372 408.304 313.336 408.452 313.266H408.526ZM399.78 330.698L414.253 322.337C414.534 322.189 414.519 321.923 414.253 321.745L396.021 311.223C395.861 311.139 395.683 311.095 395.503 311.095C395.322 311.095 395.145 311.139 394.985 311.223L387.334 315.53C387.068 315.693 387.083 315.959 387.334 316.122L396.983 321.701C397.279 321.864 397.294 322.13 396.983 322.293L390.989 325.756C390.723 325.904 390.738 326.185 390.989 326.348L398.492 330.684C398.673 330.799 398.883 330.861 399.097 330.863C399.311 330.866 399.522 330.809 399.706 330.698H399.78ZM351.285 324.039L344.803 327.783C344.522 327.946 344.536 328.212 344.803 328.375L352.306 332.711C352.467 332.791 352.644 332.832 352.824 332.832C353.003 332.832 353.181 332.791 353.342 332.711L359.838 328.967C360.105 328.804 360.09 328.538 359.838 328.36L352.335 324.024C352.162 323.931 351.968 323.883 351.771 323.885C351.574 323.888 351.381 323.941 351.211 324.039H351.285ZM341.799 329.515L335.317 333.259C335.036 333.421 335.05 333.688 335.317 333.865L342.82 338.187C342.98 338.27 343.157 338.313 343.338 338.313C343.518 338.313 343.696 338.27 343.856 338.187L350.337 334.472C350.604 334.309 350.589 334.043 350.337 333.865L342.835 329.529C342.666 329.434 342.475 329.382 342.281 329.38C342.087 329.377 341.896 329.424 341.725 329.515H341.799ZM294.443 390.929C294.604 391.01 294.781 391.052 294.961 391.052C295.141 391.052 295.318 391.01 295.479 390.929L301.961 387.185C302.242 387.022 302.227 386.756 301.961 386.593L294.458 382.257C294.298 382.173 294.12 382.129 293.94 382.129C293.759 382.129 293.581 382.173 293.422 382.257L286.925 386.001C286.659 386.149 286.674 386.43 286.925 386.593L294.443 390.929ZM265.837 373.333L259.341 377.077C259.074 377.24 259.089 377.507 259.341 377.669L266.843 382.005C267.005 382.085 267.182 382.126 267.361 382.126C267.541 382.126 267.718 382.085 267.879 382.005L274.42 378.276C274.687 378.128 274.672 377.847 274.42 377.684L266.917 373.348C266.752 373.258 266.567 373.209 266.379 373.207C266.191 373.204 266.005 373.248 265.837 373.333ZM281.109 386.179C281.269 386.263 281.447 386.307 281.627 386.307C281.808 386.307 281.986 386.263 282.145 386.179L288.627 382.435C288.908 382.272 288.893 382.005 288.627 381.843L281.124 377.507C280.965 377.422 280.787 377.378 280.606 377.378C280.426 377.378 280.248 377.422 280.088 377.507L273.562 381.236C273.281 381.399 273.31 381.665 273.562 381.828L281.109 386.179ZM311.077 394.259L317.558 390.515C317.84 390.352 317.825 390.085 317.558 389.908L310.056 385.572C309.895 385.491 309.717 385.449 309.538 385.449C309.358 385.449 309.18 385.491 309.02 385.572L302.523 389.316C302.257 389.479 302.271 389.745 302.523 389.923L310.026 394.244C310.186 394.333 310.366 394.381 310.549 394.383C310.733 394.386 310.914 394.343 311.077 394.259ZM300.555 399.719C300.716 399.8 300.893 399.842 301.073 399.842C301.253 399.842 301.43 399.8 301.591 399.719L308.073 395.975C308.354 395.813 308.339 395.546 308.073 395.369L300.57 391.047C300.41 390.964 300.232 390.921 300.052 390.921C299.871 390.921 299.694 390.964 299.534 391.047L293.037 394.791C292.771 394.954 292.786 395.221 293.037 395.398L300.555 399.719ZM275.323 367.917L268.826 371.661C268.56 371.824 268.575 372.09 268.826 372.253L276.329 376.589C276.489 376.673 276.667 376.717 276.847 376.717C277.028 376.717 277.206 376.673 277.365 376.589L283.862 372.845C284.128 372.682 284.114 372.416 283.862 372.253L276.344 367.917C276.186 367.835 276.011 367.793 275.834 367.793C275.656 367.793 275.481 367.835 275.323 367.917ZM322.753 340.525L316.301 344.239C316.019 344.402 316.034 344.668 316.301 344.846L323.803 349.182C323.964 349.263 324.142 349.305 324.321 349.305C324.501 349.305 324.679 349.263 324.839 349.182L331.336 345.438C331.602 345.275 331.588 345.009 331.336 344.831L323.833 340.51C323.672 340.411 323.488 340.355 323.299 340.347C323.11 340.34 322.922 340.38 322.753 340.466V340.525ZM284.809 362.442L278.312 366.186C278.046 366.334 278.061 366.615 278.312 366.778L285.815 371.114C285.976 371.194 286.153 371.236 286.333 371.236C286.513 371.236 286.691 371.194 286.851 371.114L293.348 367.37C293.614 367.207 293.599 366.94 293.348 366.778L285.845 362.442C285.69 362.348 285.515 362.294 285.334 362.284C285.154 362.273 284.973 362.307 284.809 362.382V362.442ZM332.239 335.049L325.757 338.793C325.476 338.956 325.491 339.223 325.757 339.4L333.26 343.721C333.419 343.806 333.597 343.85 333.778 343.85C333.958 343.85 334.136 343.806 334.296 343.721L340.792 339.977C341.059 339.814 341.044 339.548 340.792 339.37L333.289 335.034C333.13 334.944 332.952 334.893 332.769 334.886C332.587 334.878 332.405 334.914 332.239 334.99V335.049ZM313.341 345.941L306.859 349.685C306.578 349.848 306.593 350.114 306.859 350.292L314.362 354.628C314.523 354.709 314.7 354.751 314.88 354.751C315.06 354.751 315.237 354.709 315.398 354.628L321.894 350.884C322.161 350.721 322.146 350.455 321.894 350.277L314.392 345.956C314.231 345.867 314.051 345.819 313.868 345.816C313.685 345.814 313.504 345.857 313.341 345.941ZM303.855 351.417L297.373 355.175C297.092 355.323 297.107 355.59 297.373 355.767L304.876 360.103C305.037 360.184 305.214 360.226 305.394 360.226C305.574 360.226 305.751 360.184 305.912 360.103L312.409 356.359C312.675 356.197 312.66 355.93 312.409 355.767L304.906 351.431C304.735 351.335 304.542 351.282 304.345 351.28C304.149 351.277 303.954 351.324 303.781 351.417H303.855ZM294.369 356.892L287.887 360.651C287.606 360.799 287.621 361.065 287.887 361.243L295.39 365.579C295.551 365.66 295.728 365.702 295.908 365.702C296.088 365.702 296.265 365.66 296.426 365.579L302.923 361.835C303.189 361.672 303.174 361.406 302.923 361.243L295.42 356.907C295.249 356.81 295.056 356.758 294.859 356.755C294.663 356.753 294.469 356.8 294.295 356.892H294.369ZM342.864 363.566L349.361 359.822C349.627 359.659 349.612 359.393 349.361 359.215L341.858 354.879C341.697 354.799 341.52 354.757 341.34 354.757C341.16 354.757 340.983 354.799 340.822 354.879L334.325 358.624C334.059 358.786 334.074 359.053 334.325 359.23L341.754 363.478C341.907 363.576 342.081 363.635 342.261 363.651C342.442 363.666 342.623 363.637 342.79 363.566H342.864ZM426.181 280.797L419.684 284.541C419.418 284.704 419.432 284.971 419.684 285.148L427.187 289.469C427.346 289.554 427.524 289.598 427.705 289.598C427.885 289.598 428.063 289.554 428.223 289.469L434.705 285.725C434.986 285.563 434.971 285.296 434.705 285.119L427.202 280.797C427.034 280.704 426.846 280.655 426.654 280.655C426.462 280.655 426.274 280.704 426.107 280.797H426.181ZM414.697 287.427L408.2 291.171C407.934 291.334 407.949 291.6 408.2 291.778L415.703 296.114C415.864 296.195 416.041 296.237 416.221 296.237C416.401 296.237 416.578 296.195 416.739 296.114L423.221 292.37C423.502 292.207 423.487 291.941 423.221 291.763L415.718 287.442C415.552 287.346 415.364 287.295 415.172 287.292C414.981 287.29 414.791 287.336 414.623 287.427H414.697ZM435.666 275.322L429.096 279.125C428.829 279.288 428.844 279.554 429.096 279.732L436.599 284.053C436.758 284.137 436.936 284.181 437.117 284.181C437.297 284.181 437.475 284.137 437.635 284.053L444.116 280.309C444.398 280.146 444.383 279.88 444.116 279.702L436.614 275.366C436.458 275.281 436.285 275.233 436.108 275.225C435.931 275.217 435.755 275.25 435.592 275.322H435.666ZM386.565 325.948L393.046 322.204C393.328 322.041 393.313 321.775 393.046 321.612L385.543 317.276C385.384 317.192 385.206 317.148 385.025 317.148C384.845 317.148 384.667 317.192 384.508 317.276L378.011 321.02C377.745 321.183 377.759 321.449 378.011 321.612L385.514 325.948C385.666 326.023 385.833 326.061 386.002 326.061C386.172 326.061 386.339 326.023 386.491 325.948H386.565ZM446.188 269.861C446.028 269.781 445.85 269.739 445.67 269.739C445.491 269.739 445.313 269.781 445.152 269.861L438.656 273.605C438.389 273.768 438.404 274.034 438.656 274.212L446.159 278.533C446.318 278.617 446.496 278.662 446.677 278.662C446.857 278.662 447.035 278.617 447.195 278.533L453.676 274.789C453.958 274.626 453.943 274.36 453.676 274.182L446.188 269.861ZM352.35 358.091L358.847 354.347C359.113 354.184 359.098 353.918 358.847 353.74L351.344 349.404C351.183 349.323 351.006 349.281 350.826 349.281C350.646 349.281 350.469 349.323 350.308 349.404L343.693 353.118C343.426 353.281 343.441 353.548 343.693 353.725L351.196 358.046C351.357 358.145 351.541 358.201 351.73 358.209C351.919 358.217 352.107 358.176 352.276 358.091H352.35ZM468.608 290.964L475.09 287.22C475.371 287.057 475.356 286.791 475.09 286.628L467.587 282.292C467.428 282.208 467.25 282.164 467.069 282.164C466.889 282.164 466.711 282.208 466.551 282.292L460.055 286.036C459.788 286.184 459.803 286.465 460.055 286.628L467.558 290.964C467.72 291.047 467.9 291.091 468.083 291.091C468.266 291.091 468.446 291.047 468.608 290.964ZM448.393 290.254L454.89 286.51C455.171 286.347 455.141 286.081 454.89 285.918L447.387 281.582C447.226 281.502 447.049 281.461 446.869 281.461C446.689 281.461 446.512 281.502 446.351 281.582L439.869 285.326C439.588 285.489 439.603 285.755 439.869 285.933L447.372 290.269C447.536 290.338 447.713 290.369 447.89 290.358C448.067 290.348 448.239 290.297 448.393 290.209V290.254ZM456.829 276.106C456.669 276.022 456.491 275.978 456.311 275.978C456.13 275.978 455.952 276.022 455.793 276.106L449.311 279.85C449.03 280.013 449.044 280.279 449.311 280.457L456.814 284.793C456.974 284.874 457.152 284.916 457.332 284.916C457.512 284.916 457.689 284.874 457.85 284.793L464.346 281.049C464.627 280.886 464.598 280.62 464.346 280.442L456.829 276.106ZM458.826 274.952L477.058 285.474C477.219 285.555 477.396 285.597 477.576 285.597C477.756 285.597 477.933 285.555 478.094 285.474L484.576 281.73C484.857 281.567 484.842 281.301 484.576 281.138L466.344 270.616C466.184 270.532 466.007 270.488 465.826 270.488C465.646 270.488 465.468 270.532 465.308 270.616L458.826 274.36C458.516 274.464 458.53 274.686 458.826 274.908V274.952ZM436.821 287.028L430.339 290.787C430.058 290.935 430.073 291.201 430.339 291.378L437.842 295.714C438.003 295.795 438.18 295.837 438.36 295.837C438.54 295.837 438.717 295.795 438.878 295.714L445.374 291.97C445.656 291.808 445.626 291.541 445.374 291.378L437.871 287.042C437.713 286.951 437.536 286.898 437.353 286.888C437.171 286.878 436.988 286.91 436.821 286.983V287.028ZM365.432 328.212L358.935 331.956C358.669 332.119 358.684 332.386 358.935 332.548L366.438 336.884C366.599 336.964 366.777 337.005 366.956 337.005C367.136 337.005 367.313 336.964 367.474 336.884L373.956 333.125C374.237 332.977 374.222 332.711 373.956 332.534L366.453 328.198C366.293 328.121 366.118 328.083 365.941 328.086C365.764 328.088 365.59 328.132 365.432 328.212ZM458.086 296.38C458.246 296.465 458.424 296.509 458.604 296.509C458.785 296.509 458.963 296.465 459.122 296.38L465.604 292.636C465.885 292.474 465.871 292.207 465.604 292.044L458.101 287.708C457.942 287.624 457.764 287.58 457.583 287.58C457.403 287.58 457.225 287.624 457.065 287.708L450.569 291.452C450.302 291.615 450.317 291.882 450.569 292.044L458.086 296.38ZM374.918 322.737L368.421 326.481C368.155 326.644 368.17 326.91 368.421 327.073L375.924 331.409C376.085 331.488 376.263 331.53 376.442 331.53C376.622 331.53 376.799 331.488 376.96 331.409L383.442 327.65C383.723 327.502 383.708 327.221 383.442 327.058L375.939 322.722C375.779 322.646 375.604 322.608 375.427 322.61C375.25 322.613 375.076 322.656 374.918 322.737ZM303.811 385.454C303.971 385.534 304.149 385.576 304.328 385.576C304.508 385.576 304.686 385.534 304.846 385.454L311.343 381.709C311.609 381.547 311.595 381.28 311.343 381.118L303.796 376.796C303.635 376.717 303.457 376.675 303.278 376.675C303.098 376.675 302.921 376.717 302.76 376.796L296.263 380.555C295.997 380.703 296.012 380.97 296.263 381.147L303.811 385.454ZM289.545 372.031L283.048 375.775C282.767 375.923 282.796 376.204 283.048 376.367L290.551 380.703C290.712 380.784 290.889 380.826 291.069 380.826C291.249 380.826 291.426 380.784 291.587 380.703L298.069 376.959C298.35 376.796 298.335 376.53 298.069 376.367L290.566 372.031C290.408 371.949 290.233 371.907 290.055 371.907C289.877 371.907 289.702 371.949 289.545 372.031ZM314.332 379.993L320.814 376.249C321.095 376.086 321.081 375.82 320.814 375.657L313.341 371.321C313.18 371.241 313.003 371.2 312.823 371.2C312.643 371.2 312.466 371.241 312.305 371.321L305.808 375.08C305.542 375.228 305.557 375.494 305.808 375.672L313.311 380.008C313.471 380.084 313.646 380.122 313.824 380.119C314.001 380.117 314.175 380.073 314.332 379.993ZM323.818 374.517L330.315 370.773C330.581 370.61 330.566 370.344 330.315 370.166L322.812 365.845C322.652 365.761 322.475 365.717 322.294 365.717C322.114 365.717 321.936 365.761 321.776 365.845L315.279 369.589C315.013 369.752 315.028 370.019 315.279 370.196L322.782 374.532C322.944 374.611 323.122 374.65 323.302 374.647C323.482 374.645 323.659 374.6 323.818 374.517ZM333.304 369.042L339.801 365.298C340.067 365.135 340.052 364.869 339.801 364.691L332.298 360.37C332.138 360.286 331.96 360.242 331.78 360.242C331.599 360.242 331.422 360.286 331.262 360.37L324.765 364.114C324.499 364.277 324.514 364.543 324.765 364.721L332.268 369.057C332.43 369.135 332.608 369.174 332.788 369.172C332.968 369.169 333.145 369.125 333.304 369.042ZM299.031 366.541L292.534 370.3C292.253 370.448 292.282 370.714 292.534 370.892L300.037 375.228C300.198 375.308 300.375 375.35 300.555 375.35C300.735 375.35 300.912 375.308 301.073 375.228L307.555 371.484C307.836 371.321 307.821 371.054 307.555 370.892L300.022 366.57C299.869 366.493 299.701 366.45 299.53 366.445C299.358 366.44 299.188 366.473 299.031 366.541ZM308.516 361.065L302.02 364.824C301.754 364.972 301.768 365.239 302.02 365.416L309.523 369.752C309.684 369.833 309.861 369.875 310.041 369.875C310.221 369.875 310.398 369.833 310.559 369.752L317.04 366.008C317.322 365.845 317.307 365.579 317.04 365.416L309.538 361.08C309.38 361.001 309.206 360.958 309.029 360.955C308.852 360.953 308.677 360.99 308.516 361.065ZM346.46 339.163L339.978 342.907C339.712 343.07 339.727 343.337 339.978 343.514L347.481 347.835C347.641 347.92 347.819 347.964 347.999 347.964C348.18 347.964 348.358 347.92 348.517 347.835L354.999 344.091C355.28 343.928 355.265 343.662 354.999 343.485L347.496 339.149C347.334 339.07 347.156 339.031 346.976 339.033C346.797 339.036 346.62 339.08 346.46 339.163ZM336.974 344.639L330.478 348.383C330.211 348.546 330.226 348.812 330.478 348.99L337.981 353.311C338.14 353.395 338.318 353.439 338.499 353.439C338.679 353.439 338.857 353.395 339.017 353.311L345.498 349.567C345.779 349.404 345.765 349.138 345.498 348.96L337.995 344.624C337.841 344.555 337.674 344.52 337.505 344.523C337.337 344.526 337.171 344.565 337.019 344.639H336.974ZM355.946 333.688L349.45 337.432C349.183 337.595 349.198 337.861 349.45 338.024L356.952 342.36C357.114 342.439 357.291 342.481 357.47 342.481C357.65 342.481 357.827 342.439 357.988 342.36L364.47 338.601C364.751 338.453 364.737 338.187 364.47 338.009L356.967 333.673C356.807 333.597 356.632 333.559 356.455 333.561C356.278 333.564 356.104 333.607 355.946 333.688ZM318.002 355.59L311.506 359.334C311.239 359.497 311.254 359.763 311.506 359.941L319.009 364.277C319.169 364.357 319.347 364.399 319.527 364.399C319.707 364.399 319.884 364.357 320.045 364.277L326.526 360.533C326.808 360.37 326.793 360.103 326.526 359.926L319.024 355.605C318.867 355.522 318.692 355.477 318.515 355.475C318.337 355.472 318.162 355.512 318.002 355.59ZM327.488 350.114L320.992 353.858C320.725 354.021 320.74 354.288 320.992 354.465L328.495 358.801C328.655 358.882 328.833 358.924 329.013 358.924C329.192 358.924 329.37 358.882 329.531 358.801L336.012 355.057C336.294 354.894 336.279 354.628 336.012 354.45L328.524 350.159C328.364 350.076 328.187 350.032 328.006 350.032C327.826 350.032 327.648 350.076 327.488 350.159V350.114ZM320.563 388.783L327.044 385.039C327.326 384.876 327.311 384.61 327.044 384.432L319.541 380.096C319.381 380.016 319.203 379.974 319.024 379.974C318.844 379.974 318.666 380.016 318.506 380.096L312.009 383.84C311.743 384.003 311.757 384.27 312.009 384.447L319.512 388.768C319.672 388.857 319.852 388.905 320.035 388.908C320.219 388.911 320.4 388.868 320.563 388.783ZM264.89 383.16L257.387 378.824C257.226 378.743 257.049 378.701 256.869 378.701C256.689 378.701 256.512 378.743 256.351 378.824L249.855 382.568C249.588 382.731 249.603 382.997 249.855 383.16L257.358 387.496C257.519 387.575 257.696 387.617 257.876 387.617C258.055 387.617 258.232 387.575 258.393 387.496L264.89 383.737C265.201 383.604 265.186 383.337 264.89 383.16ZM279.112 387.333L271.609 382.997C271.448 382.916 271.271 382.874 271.091 382.874C270.911 382.874 270.733 382.916 270.573 382.997L260.584 388.754C260.302 388.916 260.317 389.183 260.584 389.36L268.101 393.682C268.261 393.766 268.439 393.81 268.619 393.81C268.8 393.81 268.978 393.766 269.137 393.682L279.112 387.91C279.422 387.777 279.408 387.496 279.112 387.333ZM253.377 374.784L245.874 370.448C245.713 370.367 245.536 370.325 245.356 370.325C245.176 370.325 244.999 370.367 244.838 370.448L236.847 375.05C236.58 375.213 236.595 375.479 236.847 375.657L244.35 379.993C244.51 380.074 244.688 380.116 244.867 380.116C245.047 380.116 245.225 380.074 245.385 379.993L253.377 375.376C253.687 375.228 253.673 374.946 253.377 374.784ZM259.503 371.247C259.663 371.331 259.841 371.375 260.021 371.375C260.202 371.375 260.38 371.331 260.539 371.247L267.021 367.503C267.302 367.34 267.287 367.074 267.021 366.911L259.518 362.575C259.359 362.491 259.181 362.446 259 362.446C258.82 362.446 258.642 362.491 258.482 362.575L251.986 366.319C251.719 366.482 251.734 366.748 251.986 366.911L259.503 371.247ZM292.327 392.083L284.824 387.747C284.664 387.663 284.486 387.619 284.306 387.619C284.125 387.619 283.948 387.663 283.788 387.747L271.298 394.954C271.031 395.102 271.046 395.369 271.298 395.546L278.801 399.882C278.962 399.963 279.139 400.005 279.319 400.005C279.499 400.005 279.676 399.963 279.837 399.882L292.312 392.675C292.623 392.512 292.623 392.246 292.327 392.083ZM298.557 400.859L291.054 396.538C290.894 396.455 290.716 396.411 290.536 396.411C290.356 396.411 290.178 396.455 290.018 396.538L282.027 401.155C281.746 401.318 281.761 401.584 282.027 401.747L289.545 406.083C289.704 406.167 289.882 406.211 290.063 406.211C290.243 406.211 290.421 406.167 290.581 406.083L298.557 401.48C298.868 401.303 298.853 401.036 298.542 400.859H298.557ZM330.034 330.521C330.193 330.605 330.371 330.649 330.552 330.649C330.732 330.649 330.91 330.605 331.07 330.521L337.551 326.777C337.833 326.614 337.818 326.348 337.551 326.17L330.049 321.834C329.888 321.753 329.71 321.711 329.531 321.711C329.351 321.711 329.173 321.753 329.013 321.834L322.516 325.578C322.25 325.741 322.264 326.007 322.516 326.185L330.034 330.521ZM311.062 341.487C311.223 341.567 311.4 341.609 311.58 341.609C311.76 341.609 311.937 341.567 312.098 341.487L318.58 337.743C318.861 337.58 318.846 337.313 318.58 337.136L311.077 332.815C310.917 332.732 310.739 332.688 310.559 332.688C310.378 332.688 310.201 332.732 310.041 332.815L303.544 336.559C303.278 336.722 303.293 336.988 303.544 337.165L311.062 341.487ZM268.945 365.771C269.106 365.852 269.283 365.894 269.463 365.894C269.643 365.894 269.82 365.852 269.981 365.771L276.463 362.027C276.744 361.864 276.729 361.598 276.463 361.435L268.945 357.114C268.784 357.035 268.607 356.993 268.427 356.993C268.247 356.993 268.07 357.035 267.909 357.114L261.412 360.873C261.146 361.021 261.161 361.302 261.412 361.465L268.945 365.771ZM320.503 335.996C320.663 336.081 320.841 336.125 321.021 336.125C321.202 336.125 321.38 336.081 321.539 335.996L328.021 332.252C328.302 332.09 328.287 331.823 328.021 331.646L320.518 327.31C320.357 327.229 320.18 327.187 320 327.187C319.82 327.187 319.643 327.229 319.482 327.31L312.986 331.054C312.719 331.216 312.734 331.483 312.986 331.66L320.503 335.996ZM301.532 346.962C301.692 347.043 301.87 347.085 302.049 347.085C302.229 347.085 302.407 347.043 302.567 346.962L309.049 343.218C309.33 343.055 309.316 342.789 309.049 342.611L301.502 338.32C301.342 338.237 301.164 338.193 300.984 338.193C300.804 338.193 300.626 338.237 300.466 338.32L294.103 342.019C293.836 342.182 293.851 342.449 294.103 342.626L301.532 346.962ZM303.722 401.569C303.562 401.485 303.384 401.441 303.204 401.441C303.023 401.441 302.845 401.485 302.686 401.569L292.697 407.326C292.43 407.489 292.445 407.755 292.697 407.933L300.2 412.254C300.359 412.338 300.537 412.382 300.718 412.382C300.898 412.382 301.076 412.338 301.236 412.254L311.225 406.482C311.491 406.32 311.476 406.053 311.225 405.89L303.722 401.569ZM287.917 354.82C288.077 354.901 288.255 354.943 288.435 354.943C288.615 354.943 288.792 354.901 288.953 354.82L295.434 351.076C295.716 350.913 295.701 350.647 295.434 350.484L287.932 346.148C287.77 346.069 287.593 346.027 287.414 346.027C287.234 346.027 287.057 346.069 286.896 346.148L280.399 349.907C280.133 350.055 280.147 350.322 280.399 350.499L287.917 354.82ZM278.431 360.296C278.592 360.377 278.769 360.419 278.949 360.419C279.129 360.419 279.306 360.377 279.467 360.296L285.949 356.552C286.23 356.389 286.215 356.123 285.949 355.96L278.46 351.639C278.299 351.559 278.122 351.518 277.942 351.518C277.763 351.518 277.586 351.559 277.425 351.639L270.928 355.397C270.662 355.545 270.676 355.812 270.928 355.989L278.431 360.296ZM479.47 300.11C479.31 300.027 479.133 299.983 478.953 299.983C478.772 299.983 478.595 300.027 478.435 300.11L462.452 309.329C462.186 309.492 462.2 309.758 462.452 309.936L469.955 314.272C470.116 314.353 470.293 314.395 470.473 314.395C470.653 314.395 470.83 314.353 470.991 314.272L486.959 305.052C487.24 304.89 487.225 304.623 486.959 304.446L479.47 300.11ZM458.501 312.215C458.341 312.132 458.163 312.089 457.983 312.089C457.803 312.089 457.625 312.132 457.465 312.215L450.968 315.929C450.702 316.092 450.717 316.359 450.968 316.536L458.471 320.872C458.632 320.953 458.809 320.995 458.989 320.995C459.169 320.995 459.346 320.953 459.507 320.872L465.989 317.128C466.27 316.965 466.255 316.699 465.989 316.521L458.501 312.215ZM330.004 383.248L336.486 379.49C336.767 379.342 336.752 379.075 336.486 378.898L328.983 374.562C328.822 374.481 328.645 374.439 328.465 374.439C328.285 374.439 328.108 374.481 327.947 374.562L321.45 378.306C321.184 378.469 321.199 378.735 321.45 378.898L328.953 383.234C329.116 383.335 329.301 383.394 329.492 383.407C329.683 383.42 329.874 383.386 330.049 383.308L330.004 383.248ZM439.514 323.107C439.353 323.027 439.176 322.986 438.996 322.986C438.817 322.986 438.639 323.027 438.478 323.107L431.982 326.866C431.715 327.014 431.73 327.28 431.982 327.458L439.485 331.794C439.645 331.874 439.823 331.916 440.002 331.916C440.182 331.916 440.36 331.874 440.52 331.794L447.002 328.05C447.283 327.887 447.269 327.62 447.002 327.458L439.514 323.107ZM488.942 294.575C488.782 294.492 488.604 294.449 488.424 294.449C488.243 294.449 488.066 294.492 487.906 294.575L481.468 298.363C481.202 298.526 481.217 298.793 481.468 298.97L488.971 303.291C489.131 303.376 489.309 303.42 489.489 303.42C489.67 303.42 489.847 303.376 490.007 303.291L496.489 299.547C496.77 299.385 496.755 299.118 496.489 298.941L488.942 294.575ZM505.93 293.421L487.699 282.899C487.538 282.818 487.36 282.776 487.181 282.776C487.001 282.776 486.823 282.818 486.663 282.899L480.181 286.643C479.9 286.806 479.914 287.072 480.181 287.235L498.413 297.757C498.572 297.841 498.75 297.885 498.931 297.885C499.111 297.885 499.289 297.841 499.449 297.757L505.93 294.013C506.3 293.924 506.286 293.657 505.99 293.48L505.93 293.421ZM404.057 343.573C403.895 343.494 403.718 343.452 403.539 343.452C403.359 343.452 403.182 343.494 403.021 343.573L395.044 348.191C394.763 348.353 394.778 348.62 395.044 348.782L402.547 353.118C402.708 353.198 402.885 353.239 403.065 353.239C403.245 353.239 403.422 353.198 403.583 353.118L411.574 348.501C411.855 348.338 411.841 348.072 411.574 347.909L404.057 343.573ZM428.03 329.737C427.869 329.657 427.692 329.616 427.512 329.616C427.333 329.616 427.156 329.657 426.994 329.737L417.005 335.508C416.724 335.671 416.754 335.937 417.005 336.1L424.508 340.436C424.669 340.516 424.847 340.557 425.026 340.557C425.206 340.557 425.383 340.516 425.544 340.436L435.518 334.665C435.8 334.502 435.785 334.235 435.518 334.073L428.03 329.737ZM382.155 356.256C381.993 356.176 381.816 356.135 381.637 356.135C381.457 356.135 381.28 356.176 381.119 356.256L327.696 387.155C327.414 387.303 327.444 387.57 327.696 387.747L335.198 392.083C335.359 392.164 335.537 392.206 335.716 392.206C335.896 392.206 336.074 392.164 336.234 392.083L389.657 361.243C389.924 361.08 389.909 360.814 389.657 360.651L382.155 356.256ZM325.742 388.813C325.581 388.733 325.404 388.692 325.224 388.692C325.044 388.692 324.867 388.733 324.706 388.813L316.715 393.43C316.434 393.593 316.449 393.859 316.715 394.037L324.218 398.358C324.378 398.441 324.556 398.484 324.736 398.484C324.916 398.484 325.094 398.441 325.254 398.358L333.245 393.741C333.526 393.578 333.511 393.312 333.245 393.149L325.742 388.813ZM393.135 349.892C392.974 349.812 392.797 349.77 392.617 349.77C392.437 349.77 392.26 349.812 392.099 349.892L384.108 354.51C383.842 354.658 383.856 354.924 384.108 355.101L391.611 359.437C391.772 359.518 391.949 359.56 392.129 359.56C392.309 359.56 392.486 359.518 392.647 359.437L400.638 354.835C400.904 354.672 400.89 354.406 400.638 354.228L393.135 349.892ZM314.702 395.147C314.542 395.066 314.364 395.024 314.184 395.024C314.005 395.024 313.827 395.066 313.666 395.147L305.69 399.764C305.409 399.912 305.424 400.193 305.69 400.356L313.193 404.692C313.354 404.772 313.531 404.814 313.711 404.814C313.891 404.814 314.068 404.772 314.229 404.692L322.22 400.089C322.501 399.927 322.486 399.66 322.22 399.483L314.702 395.147ZM415.067 337.21C414.906 337.129 414.729 337.087 414.549 337.087C414.369 337.087 414.192 337.129 414.031 337.21L406.04 341.827C405.758 341.975 405.773 342.241 406.04 342.419L413.557 346.755C413.715 346.836 413.89 346.878 414.068 346.878C414.245 346.878 414.42 346.836 414.578 346.755L422.57 342.153C422.851 341.99 422.836 341.723 422.57 341.546L415.067 337.21ZM449.015 317.616C448.854 317.537 448.677 317.495 448.497 317.495C448.317 317.495 448.14 317.537 447.979 317.616L441.482 321.375C441.216 321.523 441.231 321.79 441.482 321.967L448.985 326.303C449.146 326.384 449.323 326.426 449.503 326.426C449.683 326.426 449.86 326.384 450.021 326.303L456.503 322.559C456.784 322.396 456.769 322.13 456.503 321.967L449.015 317.616ZM469.733 302.522L476.23 298.763C476.511 298.615 476.481 298.349 476.23 298.171L468.727 293.924C468.566 293.843 468.389 293.801 468.209 293.801C468.029 293.801 467.851 293.843 467.691 293.924L461.327 297.638C461.046 297.801 461.061 298.067 461.327 298.23L468.83 302.566C468.985 302.646 469.156 302.69 469.33 302.695C469.504 302.7 469.677 302.666 469.837 302.596L469.733 302.522ZM427.32 302.241L433.817 298.497C434.098 298.334 434.068 298.067 433.817 297.905L426.314 293.569C426.153 293.489 425.975 293.448 425.796 293.448C425.616 293.448 425.439 293.489 425.278 293.569L418.796 297.328C418.515 297.475 418.53 297.742 418.796 297.919L426.299 302.255C426.466 302.361 426.657 302.421 426.854 302.432C427.05 302.442 427.247 302.402 427.424 302.315L427.32 302.241ZM405.832 339.415L424.804 328.464C425.085 328.301 425.056 328.035 424.804 327.857L417.301 323.536C417.142 323.452 416.964 323.408 416.783 323.408C416.603 323.408 416.425 323.452 416.265 323.536L397.294 334.487C397.027 334.65 397.042 334.916 397.294 335.094L404.796 339.43C404.965 339.537 405.159 339.6 405.358 339.61C405.558 339.62 405.757 339.579 405.936 339.489L405.832 339.415ZM459.211 307.968C459.371 308.051 459.549 308.094 459.729 308.094C459.909 308.094 460.087 308.051 460.247 307.968L466.744 304.224C467.025 304.061 466.995 303.795 466.744 303.617L459.241 299.281C459.08 299.2 458.903 299.158 458.723 299.158C458.543 299.158 458.366 299.2 458.205 299.281L451.723 303.025C451.442 303.188 451.457 303.454 451.723 303.632L459.211 307.968ZM449.533 301.811L456.015 298.053C456.296 297.905 456.281 297.624 456.015 297.461L448.512 293.125C448.351 293.044 448.174 293.002 447.994 293.002C447.814 293.002 447.637 293.044 447.476 293.125L441.053 296.884C440.787 297.046 440.802 297.313 441.053 297.476L448.556 301.811C448.717 301.91 448.899 301.968 449.087 301.981C449.275 301.994 449.464 301.961 449.636 301.886L449.533 301.811ZM396.346 344.89L402.828 341.146C403.109 340.984 403.095 340.717 402.828 340.54L395.325 336.218C395.166 336.134 394.988 336.09 394.807 336.09C394.627 336.09 394.449 336.134 394.289 336.218L387.793 339.962C387.526 340.125 387.541 340.392 387.793 340.569L395.296 344.905C395.466 345.016 395.662 345.079 395.865 345.09C396.068 345.1 396.269 345.057 396.45 344.964L396.346 344.89ZM438.241 320.073C438.401 320.156 438.579 320.199 438.759 320.199C438.94 320.199 439.117 320.156 439.277 320.073L445.774 316.329C446.055 316.166 446.026 315.9 445.774 315.722L438.271 311.401C438.111 311.317 437.934 311.273 437.753 311.273C437.573 311.273 437.395 311.317 437.235 311.401L430.753 315.145C430.472 315.308 430.487 315.574 430.753 315.752L438.241 320.073ZM349.02 372.357L355.502 368.598C355.783 368.45 355.769 368.169 355.502 368.006L347.999 363.67C347.839 363.589 347.661 363.547 347.481 363.547C347.301 363.547 347.124 363.589 346.963 363.67L340.467 367.414C340.2 367.577 340.215 367.843 340.467 368.006L347.97 372.342C348.132 372.426 348.311 372.471 348.493 372.474C348.676 372.477 348.856 372.436 349.02 372.357ZM358.506 366.866L364.988 363.122C365.269 362.96 365.255 362.693 364.988 362.53L357.485 358.194C357.326 358.11 357.148 358.066 356.967 358.066C356.787 358.066 356.609 358.11 356.449 358.194L349.923 361.998C349.657 362.16 349.672 362.427 349.923 362.59L357.426 366.926C357.596 367.009 357.785 367.047 357.974 367.037C358.163 367.026 358.346 366.968 358.506 366.866ZM339.534 377.832L346.016 374.073C346.297 373.925 346.283 373.659 346.016 373.481L338.499 369.145C338.338 369.065 338.16 369.023 337.981 369.023C337.801 369.023 337.623 369.065 337.463 369.145L330.966 372.889C330.7 373.052 330.714 373.319 330.966 373.481L338.469 377.817C338.633 377.904 338.815 377.951 339 377.953C339.185 377.956 339.368 377.914 339.534 377.832ZM377.478 355.915L383.96 352.171C384.241 352.009 384.226 351.742 383.96 351.579L376.427 347.199C376.266 347.119 376.089 347.078 375.91 347.078C375.73 347.078 375.553 347.119 375.392 347.199L368.895 350.958C368.629 351.106 368.643 351.372 368.895 351.55L376.398 355.886C376.562 355.978 376.746 356.03 376.934 356.035C377.123 356.04 377.309 355.999 377.478 355.915ZM367.992 361.391L374.474 357.647C374.755 357.484 374.74 357.218 374.474 357.055L366.971 352.719C366.81 352.639 366.633 352.598 366.453 352.598C366.274 352.598 366.096 352.639 365.935 352.719L359.439 356.478C359.172 356.626 359.187 356.907 359.439 357.07L366.942 361.406C367.105 361.487 367.286 361.527 367.469 361.525C367.651 361.522 367.831 361.476 367.992 361.391ZM386.964 350.44L393.446 346.696C393.727 346.533 393.712 346.267 393.446 346.104L385.854 341.768C385.694 341.685 385.517 341.641 385.336 341.641C385.156 341.641 384.978 341.685 384.818 341.768L378.455 345.497C378.189 345.645 378.203 345.911 378.455 346.089L385.958 350.425C386.114 350.503 386.285 350.545 386.459 350.548C386.634 350.55 386.806 350.514 386.964 350.44ZM430.369 269.417C430.527 269.498 430.702 269.54 430.879 269.54C431.057 269.54 431.232 269.498 431.39 269.417L437.886 265.658C438.167 265.51 438.153 265.244 437.886 265.066L435.888 263.912C435.728 263.831 435.55 263.789 435.37 263.789C435.191 263.789 435.013 263.831 434.853 263.912L428.356 267.656C428.075 267.819 428.104 268.085 428.356 268.248L430.369 269.417ZM383.694 299.547C383.853 299.632 384.031 299.676 384.212 299.676C384.392 299.676 384.57 299.632 384.73 299.547L391.211 295.803C391.493 295.655 391.478 295.374 391.211 295.211L383.679 290.964C383.519 290.88 383.341 290.836 383.161 290.836C382.98 290.836 382.803 290.88 382.643 290.964L376.146 294.708C375.865 294.871 375.88 295.137 376.146 295.3L383.694 299.547ZM402.665 288.596C402.826 288.677 403.004 288.719 403.183 288.719C403.363 288.719 403.541 288.677 403.701 288.596L410.183 284.852C410.464 284.689 410.45 284.423 410.183 284.26L402.68 279.924C402.519 279.845 402.342 279.803 402.162 279.803C401.983 279.803 401.805 279.845 401.644 279.924L395.148 283.683C394.867 283.831 394.881 284.112 395.148 284.275L402.665 288.596ZM372.106 306.236C372.267 306.317 372.444 306.359 372.624 306.359C372.804 306.359 372.981 306.317 373.142 306.236L379.624 302.492C379.905 302.329 379.89 302.063 379.624 301.9L372.121 297.564C371.961 297.48 371.784 297.436 371.603 297.436C371.423 297.436 371.245 297.48 371.085 297.564L364.559 301.323C364.293 301.471 364.307 301.752 364.559 301.915L372.106 306.236ZM393.254 294.072C393.413 294.156 393.591 294.2 393.772 294.2C393.952 294.2 394.13 294.156 394.289 294.072L400.771 290.328C401.052 290.165 401.038 289.899 400.771 289.736L393.254 285.4C393.097 285.316 392.921 285.272 392.743 285.272C392.565 285.272 392.389 285.316 392.232 285.4L385.736 289.144C385.455 289.307 385.469 289.573 385.736 289.736L393.254 294.072ZM353.208 317.187C353.369 317.267 353.547 317.308 353.726 317.308C353.906 317.308 354.083 317.267 354.244 317.187L360.697 313.458C360.978 313.31 360.963 313.029 360.697 312.866L353.194 308.53C353.033 308.449 352.856 308.407 352.676 308.407C352.496 308.407 352.318 308.449 352.158 308.53L345.661 312.274C345.395 312.437 345.41 312.703 345.661 312.866L353.208 317.187ZM362.694 311.712C362.854 311.796 363.032 311.84 363.212 311.84C363.393 311.84 363.571 311.796 363.73 311.712L370.212 307.968C370.493 307.805 370.478 307.539 370.212 307.376L362.709 303.04C362.549 302.956 362.372 302.912 362.191 302.912C362.011 302.912 361.833 302.956 361.673 303.04L355.177 306.784C354.91 306.947 354.925 307.213 355.177 307.376L362.694 311.712ZM411.456 280.368C411.616 280.451 411.794 280.495 411.974 280.495C412.154 280.495 412.332 280.451 412.492 280.368L418.988 276.624C419.27 276.461 419.255 276.195 418.988 276.017L416.991 274.863C416.83 274.782 416.652 274.74 416.473 274.74C416.293 274.74 416.115 274.782 415.955 274.863L409.458 278.607C409.177 278.77 409.192 279.036 409.458 279.199L411.456 280.368ZM439.928 263.942C440.09 264.021 440.267 264.063 440.446 264.063C440.626 264.063 440.803 264.021 440.964 263.942L447.446 260.183C447.727 260.035 447.713 259.769 447.446 259.591L445.345 258.407C445.185 258.323 445.007 258.279 444.827 258.279C444.646 258.279 444.469 258.323 444.309 258.407L437.812 262.151C437.531 262.314 437.561 262.58 437.812 262.743L439.928 263.942ZM455.689 273.043C455.85 273.123 456.027 273.164 456.207 273.164C456.387 273.164 456.564 273.123 456.725 273.043L463.207 269.284C463.488 269.136 463.473 268.87 463.207 268.692L455.6 264.327C455.44 264.246 455.262 264.204 455.082 264.204C454.902 264.204 454.725 264.246 454.564 264.327L448.009 268.115C447.742 268.278 447.757 268.544 448.009 268.707L455.689 273.043ZM479.367 297.12L485.863 293.361C486.145 293.213 486.13 292.947 485.863 292.77L478.361 288.434C478.2 288.353 478.022 288.311 477.843 288.311C477.663 288.311 477.485 288.353 477.325 288.434L470.843 292.178C470.562 292.34 470.576 292.607 470.843 292.77L478.346 297.106C478.498 297.178 478.664 297.217 478.833 297.22C479.001 297.222 479.168 297.188 479.322 297.12H479.367ZM420.927 274.922C421.084 275.005 421.26 275.049 421.438 275.049C421.616 275.049 421.791 275.005 421.948 274.922L428.445 271.178C428.726 271.016 428.711 270.749 428.445 270.572L426.447 269.417C426.286 269.337 426.109 269.295 425.929 269.295C425.749 269.295 425.572 269.337 425.411 269.417L418.84 273.206C418.559 273.369 418.574 273.635 418.84 273.798L420.927 274.922ZM343.693 322.692C343.854 322.772 344.031 322.813 344.211 322.813C344.39 322.813 344.568 322.772 344.729 322.692L351.211 318.934C351.492 318.786 351.477 318.519 351.211 318.342L343.708 314.006C343.547 313.925 343.37 313.883 343.19 313.883C343.01 313.883 342.833 313.925 342.672 314.006L336.175 317.75C335.909 317.912 335.924 318.179 336.175 318.342L343.693 322.692Z"
                                fill="white"
                              />
                              <path
                                d="M385.707 379.608L449.77 342.611C450.853 342.064 452.049 341.778 453.262 341.778C454.476 341.778 455.672 342.064 456.755 342.611L493.485 363.818C495.409 364.927 495.409 366.777 493.485 367.858L429.437 404.854C428.353 405.409 427.154 405.698 425.937 405.698C424.72 405.698 423.52 405.409 422.437 404.854L385.707 383.648C383.783 382.523 383.783 380.718 385.707 379.608Z"
                                fill="#07178E"
                              />
                              <path
                                opacity="0.4"
                                d="M385.707 379.608L449.77 342.611C450.853 342.064 452.049 341.778 453.262 341.778C454.476 341.778 455.672 342.064 456.755 342.611L493.485 363.818C495.409 364.927 495.409 366.777 493.485 367.858L429.437 404.854C428.353 405.409 427.154 405.698 425.937 405.698C424.72 405.698 423.52 405.409 422.437 404.854L385.707 383.648C383.783 382.523 383.783 380.718 385.707 379.608Z"
                                fill="white"
                              />
                              <path
                                d="M174.559 356.374C175.126 356.695 175.727 356.953 176.35 357.143C175.725 356.964 175.124 356.711 174.559 356.389C174.366 356.282 174.182 356.159 174.012 356.019C174.186 356.149 174.369 356.267 174.559 356.374Z"
                                fill="#07178E"
                              />
                              <path
                                opacity="0.6"
                                d="M414.949 21.4209C414.535 18.4612 412.108 17.3069 409.178 18.994L185.851 147.949C184.125 149.009 182.702 150.498 181.722 152.271L170.801 145.937C171.777 144.158 173.193 142.66 174.915 141.586L398.256 12.7489C399.869 11.7312 401.721 11.1549 403.627 11.0778C405.533 11.0006 407.426 11.4253 409.116 12.3093C410.806 13.1934 412.234 14.5057 413.258 16.1152C414.282 17.7246 414.865 19.5746 414.949 21.4801V21.4209Z"
                                fill="white"
                              />
                              <path
                                d="M184.756 356.921C184.756 356.921 184.756 356.921 184.844 356.848L184.756 356.921Z"
                                fill="#07178E"
                              />
                              <path
                                opacity="0.8"
                                d="M589.884 331.142C589.74 333.099 589.137 334.996 588.124 336.677C587.111 338.358 585.716 339.778 584.053 340.82L360.697 469.761C358.899 470.699 356.893 471.167 354.866 471.122V458.529C356.897 458.573 358.905 458.094 360.697 457.137L584.023 328.197C586.983 326.451 587.22 323.757 584.615 321.848C586.12 322.917 587.372 324.304 588.282 325.909C589.193 327.515 589.739 329.301 589.884 331.142Z"
                                fill="white"
                              />
                              <path
                                d="M194.02 313.664C194.02 316.417 195.958 317.527 198.341 316.15L395.888 202.171C397.135 201.36 398.175 200.268 398.925 198.984C399.676 197.699 400.115 196.257 400.209 194.772V61.584L194.02 180.669V313.664Z"
                                fill="#00121B"
                              />
                              <path
                                d="M269.138 152.611V159.004C269.138 160.306 270.07 160.839 271.195 160.188L312.217 136.377V125.219L271.195 149.045C270.598 149.438 270.101 149.965 269.744 150.584C269.386 151.203 269.179 151.897 269.138 152.611Z"
                                fill="#FAFAFA"
                              />
                              <path
                                d="M323.034 118.988C324.173 118.337 325.091 118.87 325.091 120.172V126.565C325.054 127.28 324.848 127.976 324.491 128.596C324.133 129.216 323.634 129.742 323.034 130.132L312.216 136.377V125.219L323.034 118.988Z"
                                fill="#07178E"
                              />
                              <path
                                d="M322.219 127.764L321.006 127.379C321.136 126.872 321.201 126.35 321.198 125.825C321.253 125.338 321.182 124.845 320.99 124.394C320.798 123.943 320.492 123.549 320.103 123.25C319.829 123.105 319.521 123.036 319.21 123.051C318.9 123.067 318.6 123.167 318.342 123.339C317.575 123.928 316.957 124.689 316.538 125.56C316.119 126.432 315.911 127.389 315.93 128.356C315.876 128.845 315.951 129.339 316.145 129.79C316.34 130.241 316.648 130.634 317.04 130.931C317.268 131.067 317.529 131.138 317.795 131.138C318.146 131.13 318.488 131.028 318.786 130.842C319.718 130.199 320.406 129.26 320.74 128.178L321.953 128.548H322.086C322.182 128.544 322.275 128.511 322.352 128.453C322.428 128.394 322.485 128.314 322.515 128.223C322.527 128.124 322.504 128.024 322.45 127.94C322.396 127.857 322.314 127.794 322.219 127.764ZM318.342 130.073C318.221 130.166 318.076 130.222 317.924 130.235C317.772 130.248 317.619 130.218 317.484 130.147C317.24 129.922 317.053 129.642 316.94 129.331C316.827 129.019 316.79 128.685 316.833 128.356C316.821 127.547 316.991 126.746 317.329 126.011C317.667 125.277 318.165 124.627 318.786 124.109C318.954 124.013 319.141 123.958 319.334 123.946C319.446 123.947 319.557 123.973 319.659 124.02C319.901 124.249 320.086 124.532 320.2 124.845C320.313 125.159 320.351 125.495 320.31 125.825C320.324 126.635 320.155 127.436 319.817 128.171C319.479 128.906 318.98 129.556 318.357 130.073H318.342Z"
                                fill="#FAFAFA"
                              />
                              <path
                                d="M194.02 171.642C194.113 170.157 194.553 168.715 195.303 167.43C196.053 166.146 197.094 165.054 198.341 164.243L395.888 50.1749C398.27 48.7987 400.209 49.9234 400.209 52.6611V61.5847L194.02 180.669V171.642Z"
                                fill="#263238"
                              />
                              <path
                                d="M375.954 66.2903C375.362 66.6722 374.87 67.1894 374.517 67.7993C374.165 68.4091 373.962 69.0941 373.927 69.7976C373.927 71.0851 374.829 71.603 375.954 70.9667C376.543 70.5832 377.033 70.0653 377.383 69.4555C377.733 68.8458 377.933 68.1616 377.967 67.4594C377.967 66.1719 377.064 65.654 375.954 66.2903Z"
                                fill="#07178E"
                              />
                              <path
                                d="M383.027 62.221C382.437 62.6014 381.946 63.1163 381.594 63.7234C381.241 64.3305 381.038 65.0125 381 65.7135C381 67.0158 381.903 67.5337 383.027 66.8826C383.615 66.5005 384.103 65.9849 384.453 65.3779C384.803 64.7709 385.004 64.0897 385.04 63.3901C385.04 62.1026 384.137 61.5846 383.027 62.221Z"
                                fill="#07178E"
                              />
                              <path
                                d="M390.102 58.1515C389.519 58.526 389.033 59.0316 388.681 59.6277C388.329 60.2238 388.121 60.894 388.074 61.5848C388.074 62.8722 388.977 63.405 390.102 62.7538C390.691 62.3703 391.181 61.8524 391.53 61.2427C391.88 60.6329 392.08 59.9488 392.114 59.2466C392.114 58.0183 391.212 57.5003 390.102 58.1515Z"
                                fill="#07178E"
                              />
                              <path
                                d="M198.341 316.122L395.888 202.172C397.135 201.361 398.175 200.269 398.925 198.984C399.676 197.7 400.115 196.257 400.209 194.773V98.3594L194.02 217.385V313.665C194.02 316.418 195.958 317.601 198.341 316.122Z"
                                fill="#FAFAFA"
                              />
                              <path
                                opacity="0.4"
                                d="M274.613 150.376L304.743 132.988C305.897 132.322 306.83 132.781 306.83 134.039C306.783 134.742 306.569 135.425 306.207 136.03C305.844 136.634 305.342 137.144 304.743 137.516L274.657 154.786C273.488 155.452 272.541 155.008 272.541 153.795C272.595 153.103 272.811 152.433 273.17 151.839C273.53 151.245 274.024 150.744 274.613 150.376Z"
                                fill="#455A64"
                              />
                              <path
                                d="M269.329 227.048C269.137 227.152 268.989 227.167 268.885 227.048L268.649 226.797L263.765 218.45V229.534C263.765 229.741 263.714 229.944 263.617 230.126C263.554 230.291 263.44 230.431 263.292 230.526L261.812 231.355C261.766 231.393 261.709 231.414 261.649 231.414C261.589 231.414 261.532 231.393 261.486 231.355C261.387 231.235 261.339 231.081 261.353 230.926V213.522C261.353 213.318 261.398 213.115 261.486 212.93C261.55 212.762 261.664 212.618 261.812 212.516L263.04 211.82C263.232 211.702 263.395 211.687 263.499 211.82L263.721 212.072L268.619 220.433V209.349C268.622 209.145 268.667 208.943 268.752 208.757C268.82 208.596 268.933 208.457 269.078 208.358L270.558 207.544C270.603 207.505 270.661 207.484 270.72 207.484C270.78 207.484 270.838 207.505 270.883 207.544C270.937 207.6 270.978 207.668 271.004 207.742C271.029 207.816 271.039 207.895 271.031 207.973V225.346C271.033 225.553 270.982 225.757 270.883 225.938C270.825 226.109 270.71 226.255 270.558 226.353L269.329 227.048Z"
                                fill="#07178E"
                              />
                              <path
                                d="M273.385 212.916C273.42 211.891 273.544 210.871 273.755 209.867C273.963 208.881 274.286 207.923 274.717 207.011C275.124 206.12 275.652 205.288 276.285 204.54C276.91 203.787 277.667 203.155 278.52 202.675C279.178 202.232 279.947 201.981 280.74 201.95C281.328 201.952 281.892 202.186 282.308 202.601C282.767 203.101 283.098 203.706 283.27 204.362C283.511 205.22 283.641 206.106 283.655 206.997C283.655 207.322 283.655 207.692 283.655 208.106V210.667C283.655 211.081 283.655 211.466 283.655 211.806C283.62 212.831 283.496 213.851 283.285 214.855C283.076 215.846 282.754 216.809 282.323 217.726C281.914 218.615 281.381 219.442 280.74 220.182C280.109 220.92 279.359 221.545 278.52 222.032C277.854 222.47 277.082 222.72 276.285 222.757C275.995 222.76 275.706 222.706 275.437 222.597C275.168 222.487 274.923 222.326 274.717 222.121C274.246 221.629 273.914 221.021 273.755 220.36C273.53 219.504 273.406 218.625 273.385 217.74C273.385 217.4 273.385 217.03 273.385 216.63C273.385 216.231 273.385 215.787 273.385 215.358C273.385 214.929 273.385 214.485 273.385 214.07C273.385 213.656 273.385 213.271 273.385 212.916ZM281.302 208.476C281.37 207.559 281.078 206.651 280.488 205.946C279.985 205.517 279.334 205.546 278.52 206.02C277.663 206.541 276.978 207.302 276.552 208.21C276.037 209.298 275.759 210.484 275.738 211.688C275.738 212.383 275.738 213.168 275.738 213.981C275.738 214.795 275.738 215.565 275.738 216.231C275.7 216.683 275.753 217.138 275.893 217.57C276.033 218.002 276.256 218.402 276.552 218.747C277.055 219.161 277.706 219.131 278.52 218.658C279.377 218.137 280.061 217.375 280.488 216.468C280.998 215.388 281.276 214.213 281.302 213.02C281.302 212.324 281.302 211.54 281.302 210.726C281.302 209.912 281.272 209.157 281.258 208.491L281.302 208.476Z"
                                fill="#07178E"
                              />
                              <path
                                d="M294.68 193.574C295.358 193.143 296.129 192.879 296.929 192.805C297.221 192.789 297.512 192.831 297.787 192.931C298.062 193.03 298.313 193.183 298.527 193.382C298.999 193.881 299.335 194.492 299.504 195.158C299.746 196.081 299.88 197.03 299.904 197.984C299.904 199.286 299.904 200.618 299.904 201.965C299.865 203.074 299.732 204.178 299.504 205.265C299.288 206.284 298.961 207.277 298.527 208.225C298.126 209.097 297.597 209.905 296.959 210.622C296.333 211.336 295.592 211.941 294.769 212.413L290.329 214.958C290.281 214.998 290.221 215.02 290.159 215.02C290.097 215.02 290.036 214.998 289.989 214.958C289.939 214.899 289.901 214.831 289.878 214.757C289.856 214.683 289.848 214.606 289.855 214.529V197.067C289.858 196.862 289.904 196.661 289.989 196.475C290.061 196.312 290.18 196.173 290.329 196.075L294.68 193.574ZM297.551 199.346C297.538 198.845 297.463 198.348 297.329 197.866C297.237 197.5 297.054 197.164 296.796 196.889C296.551 196.663 296.227 196.541 295.893 196.549C295.434 196.588 294.991 196.74 294.606 196.993L292.253 198.339V210.445L294.68 208.965C295.156 208.708 295.579 208.361 295.923 207.944C296.276 207.538 296.57 207.085 296.796 206.597C297.035 206.087 297.214 205.55 297.329 204.999C297.454 204.424 297.529 203.84 297.551 203.252C297.595 201.98 297.595 200.692 297.551 199.346Z"
                                fill="#07178E"
                              />
                              <path
                                d="M307.688 186.071C307.866 185.967 308.014 185.967 308.103 186.071C308.223 186.234 308.309 186.421 308.354 186.618L312.631 201.151C312.64 201.21 312.64 201.269 312.631 201.328C312.628 201.533 312.583 201.734 312.498 201.92C312.425 202.083 312.307 202.222 312.157 202.32L310.9 203.045C310.663 203.178 310.5 203.208 310.411 203.045C310.323 202.953 310.257 202.841 310.219 202.719L309.464 200.159L303.944 203.341L303.204 206.774C303.154 206.963 303.085 207.147 302.997 207.322C302.892 207.541 302.721 207.722 302.509 207.84L301.251 208.565C301.205 208.603 301.148 208.625 301.088 208.625C301.028 208.625 300.971 208.603 300.925 208.565C300.826 208.445 300.778 208.291 300.792 208.136C300.784 208.072 300.784 208.007 300.792 207.943L305.069 188.468C305.123 188.186 305.202 187.908 305.306 187.64C305.395 187.44 305.545 187.275 305.735 187.166L307.688 186.071ZM308.65 197.333L306.726 190.777L304.802 199.552L308.65 197.333Z"
                                fill="#07178E"
                              />
                              <path
                                d="M321.14 178.301C321.186 178.263 321.243 178.242 321.303 178.242C321.362 178.242 321.42 178.263 321.466 178.301C321.517 178.36 321.557 178.428 321.582 178.501C321.608 178.575 321.618 178.653 321.614 178.731V180.64C321.606 180.845 321.556 181.047 321.466 181.232C321.398 181.397 321.285 181.541 321.14 181.646L317.988 183.451V198.25C317.988 198.455 317.943 198.657 317.855 198.842C317.786 199.011 317.667 199.156 317.514 199.256L316.109 200.07C316.061 200.11 316.001 200.132 315.938 200.132C315.876 200.132 315.816 200.11 315.768 200.07C315.718 200.011 315.681 199.943 315.658 199.869C315.635 199.795 315.627 199.718 315.635 199.641V184.842L312.483 186.663C312.437 186.701 312.38 186.722 312.32 186.722C312.26 186.722 312.203 186.701 312.157 186.663C312.105 186.605 312.065 186.537 312.039 186.463C312.014 186.39 312.004 186.311 312.009 186.234V184.325C312.017 184.119 312.067 183.917 312.157 183.733C312.225 183.571 312.338 183.432 312.483 183.333L321.14 178.301Z"
                                fill="#07178E"
                              />
                              <path
                                d="M327.859 174.424C328.051 174.321 328.185 174.306 328.273 174.424C328.4 174.584 328.487 174.771 328.525 174.972L332.802 189.504C332.811 189.563 332.811 189.623 332.802 189.682C332.794 189.887 332.744 190.089 332.654 190.274C332.586 190.435 332.473 190.574 332.328 190.673L331.07 191.398C330.834 191.531 330.671 191.546 330.582 191.398C330.485 191.307 330.418 191.188 330.39 191.058L329.62 188.557L324.145 191.813L323.39 195.231C323.346 195.425 323.281 195.613 323.197 195.793C323.096 196.011 322.924 196.189 322.709 196.297L321.451 197.022C321.406 197.06 321.348 197.081 321.288 197.081C321.229 197.081 321.171 197.06 321.126 197.022C321.072 196.965 321.031 196.897 321.005 196.823C320.98 196.749 320.97 196.67 320.978 196.593C320.97 196.524 320.97 196.454 320.978 196.385L325.254 176.925C325.31 176.641 325.395 176.364 325.506 176.096C325.59 175.898 325.735 175.732 325.92 175.623L327.859 174.424ZM328.821 185.671L326.897 179.115L324.973 187.891L328.821 185.671Z"
                                fill="#07178E"
                              />
                              <path
                                d="M658.757 274.567C660.858 231.947 657.677 221.647 646.489 213.582L641.546 238.192C641.546 238.192 646.06 267.419 645.275 277.112C644.609 285.621 643.529 296.262 641.368 303.099C640.967 304.305 640.141 305.325 639.045 305.97C636.085 307.716 634.901 309.536 632.667 311.771C630.921 313.517 629.47 313.931 629.707 314.508C630.024 315.14 630.566 315.629 631.227 315.878C631.888 316.128 632.619 316.12 633.274 315.855C634.736 315.314 636.127 314.599 637.417 313.724C636.358 316.315 634.889 318.718 633.066 320.842C628.893 325.726 628.627 328.774 636.825 329.026C641.96 329.189 646.119 326.066 650.233 314.908C651.833 310.804 653.133 306.591 654.125 302.299C656.3 291.156 658.416 281.419 658.757 274.567Z"
                                fill="#A35B5A"
                              />
                              <path
                                d="M637.018 210.133C642.449 209.467 649.789 210.77 654.362 219.382C658.934 227.995 659.763 242.661 659.97 257.237C659.97 257.237 650.351 264.918 639.089 260.774L637.018 210.133Z"
                                fill="#BBE9F8"
                              />
                              <path
                                opacity="0.5"
                                d="M637.018 210.133C642.449 209.467 649.789 210.77 654.362 219.382C658.934 227.995 659.763 242.661 659.97 257.237C659.97 257.237 650.351 264.918 639.089 260.774L637.018 210.133Z"
                                fill="black"
                              />
                              <path
                                d="M647.48 433.371C648.279 433.697 648.457 435.265 648.516 438.358C648.516 440.711 648.96 444.81 646.192 445.565C643.425 446.32 639.415 445.817 637.713 443.567C635.65 440.557 633.437 437.653 631.083 434.866C628.434 431.906 625.548 429.094 624.542 424.965C623.639 421.251 624.542 419.667 627.043 418.646C630.55 417.24 635.922 422.198 638.601 423.086C640.924 423.722 646.666 433.031 647.48 433.371Z"
                                fill="#263238"
                              />
                              <path
                                d="M647.54 430.5L647.451 434.303C645.999 435.176 644.336 435.637 642.642 435.637C640.947 435.637 639.285 435.176 637.832 434.303C637.684 433.933 636.959 428.842 636.959 428.842L647.54 430.5Z"
                                fill="#A35B5A"
                              />
                              <path
                                d="M616.181 454.593C616.181 454.593 617.188 457.922 617.661 460.838C618.076 463.146 618.653 467.009 617.809 468.71C616.966 470.412 613.799 471.478 608.93 471.33C605.778 471.226 600.82 473.268 597.402 475.059C593.984 476.85 586.643 477.531 582.973 477.027C578.652 476.421 574.212 473.801 573.561 471.996C572.91 470.19 573.872 468.341 584.187 464.212C584.276 464.212 598.482 459.905 603.543 454.563L616.181 454.593Z"
                                fill="#263238"
                              />
                              <path
                                d="M616.27 450.478C616.27 450.478 616.196 453.305 616.167 454.918C616.137 456.531 614.184 458.899 609.256 458.603C605.793 458.41 603.336 457.419 603.603 454.563L603.692 450.463L616.27 450.478Z"
                                fill="#A35B5A"
                              />
                              <path
                                d="M651.15 380.081C650.457 373.326 649.103 366.654 647.11 360.162C647.11 360.162 648.841 343.1 649.863 326.91C650.958 309.418 650.721 287.397 651.15 283.047C651.15 283.047 594.915 270.349 593.435 290.55C591.955 310.75 594.042 362.353 594.516 371.261C594.989 380.17 596.336 388.058 597.845 402.501C599.355 416.945 603.661 450.464 603.661 450.464C605.596 451.5 607.756 452.042 609.951 452.042C612.145 452.042 614.306 451.5 616.24 450.464C616.24 450.464 621.124 410.093 620.946 399.838C620.792 392.23 619.653 384.674 617.557 377.358C617.557 377.358 619.037 360.695 620.265 346.207C621.494 331.719 622.707 324.764 623.062 318.46L624.291 317.883C624.291 317.883 624.971 342.952 625.43 351.846C625.889 360.74 627.132 369.308 629.322 385.883C631.231 400.252 637.195 430.708 637.195 430.708C643.573 434.348 647.554 430.486 647.554 430.486C647.554 430.486 652.615 392.542 651.15 380.081Z"
                                fill="#BBE9F8"
                              />
                              <path
                                opacity="0.7"
                                d="M651.15 380.081C650.457 373.326 649.103 366.654 647.11 360.162C647.11 360.162 648.841 343.1 649.863 326.91C650.958 309.418 650.721 287.397 651.15 283.047C651.15 283.047 594.915 270.349 593.435 290.55C591.955 310.75 594.042 362.353 594.516 371.261C594.989 380.17 596.336 388.058 597.845 402.501C599.355 416.945 603.661 450.464 603.661 450.464C605.596 451.5 607.756 452.042 609.951 452.042C612.145 452.042 614.306 451.5 616.24 450.464C616.24 450.464 621.124 410.093 620.946 399.838C620.792 392.23 619.653 384.674 617.557 377.358C617.557 377.358 619.037 360.695 620.265 346.207C621.494 331.719 622.707 324.764 623.062 318.46L624.291 317.883C624.291 317.883 624.971 342.952 625.43 351.846C625.889 360.74 627.132 369.308 629.322 385.883C631.231 400.252 637.195 430.708 637.195 430.708C643.573 434.348 647.554 430.486 647.554 430.486C647.554 430.486 652.615 392.542 651.15 380.081Z"
                                fill="black"
                              />
                              <path
                                opacity="0.4"
                                d="M623.092 318.474C623.092 318.474 636.943 312.022 643.943 306.088C643.943 306.088 637.372 314.967 628.922 318.711C628.922 318.711 625.252 349.788 625.282 349.137L624.261 318.445L623.092 318.474Z"
                                fill="black"
                              />
                              <path
                                d="M613.488 203.119L616.418 221.587L633.067 220.744L631.128 199.138L613.488 203.119Z"
                                fill="#A35B5A"
                              />
                              <path
                                d="M650.648 219.797C649.168 214.766 642.893 209.172 636.515 210.208C635.035 210.444 633.555 210.696 632.179 210.948C631.424 214.055 623.463 216.453 615.309 214.544C612.852 215.18 610.588 215.846 608.546 216.527C602.626 218.465 597.284 223.378 596.366 242.483C596.366 242.483 593.407 287.027 593.185 295.64C607.658 301.752 622.782 301.915 631.276 300.272C648.827 296.854 651.106 289.647 651.106 289.647C651.106 289.647 652.054 257.593 651.832 243.771C651.654 231.962 651.698 223.26 650.648 219.797Z"
                                fill="#263238"
                              />
                              <path
                                d="M601.175 180.447C601.175 180.447 596.81 187.077 597.313 187.728C597.816 188.379 601.013 188.956 601.013 188.956L601.175 180.447Z"
                                fill="#8C3F3E"
                              />
                              <path
                                d="M603.217 184.709C602.186 184.712 601.178 184.409 600.319 183.839C599.46 183.268 598.79 182.455 598.394 181.504C597.997 180.552 597.892 179.504 598.091 178.493C598.291 177.482 598.786 176.552 599.514 175.822C600.242 175.092 601.17 174.594 602.181 174.392C603.191 174.19 604.24 174.292 605.192 174.686C606.145 175.08 606.959 175.748 607.533 176.605C608.106 177.462 608.411 178.469 608.411 179.5C608.411 180.879 607.865 182.202 606.891 183.178C605.917 184.155 604.596 184.705 603.217 184.709ZM603.217 175.46C602.414 175.457 601.628 175.693 600.959 176.137C600.29 176.582 599.768 177.215 599.459 177.956C599.15 178.698 599.069 179.514 599.225 180.302C599.381 181.09 599.767 181.814 600.335 182.382C600.903 182.95 601.627 183.337 602.415 183.493C603.203 183.649 604.019 183.567 604.761 183.258C605.502 182.95 606.136 182.427 606.58 181.758C607.024 181.089 607.26 180.303 607.257 179.5C607.238 178.442 606.804 177.433 606.048 176.691C605.292 175.949 604.276 175.534 603.217 175.534V175.46Z"
                                fill="#263238"
                              />
                              <path
                                d="M613.296 162.127C604.417 163.991 601.916 167.869 601.087 181.912C600.214 196.563 601.709 201.151 603.633 203.149C604.935 204.48 612.157 204.717 615.812 203.726C620.37 202.468 630.685 198.813 635.509 191.428C641.192 182.756 642.686 170.991 636.604 166.167C628.036 159.389 616.892 161.372 613.296 162.127Z"
                                fill="#A35B5A"
                              />
                              <path
                                d="M605.274 203.874C608.06 204.407 610.913 204.487 613.724 204.111C614.988 203.356 615.982 202.222 616.566 200.87C616.566 200.87 614.894 203.208 605.274 203.874Z"
                                fill="#8C3F3E"
                              />
                              <path
                                d="M598.497 178.419L614.213 180.447L613.577 181.557L598.497 179.603V178.419Z"
                                fill="#263238"
                              />
                              <path
                                d="M596.943 169.037C598.16 171.056 599.891 172.716 601.96 173.847C604.165 175.001 606.399 175.06 608.826 177.428C609.719 178.326 610.45 179.373 610.987 180.521C611.09 180.772 612.955 183.288 613.059 182.903C613.059 182.903 614.45 177.487 618.978 178.168C623.506 178.848 624.202 184.709 621.301 188.275C618.401 191.842 615.693 190.465 615.693 190.465C615.693 190.465 615.841 198.22 619.274 202.6C619.274 202.6 623.181 203.873 630.358 202.334C634.798 201.387 641.028 195.867 643.677 190.036C649.227 177.665 649.596 166.536 641.724 163.206C640.865 157.509 636.381 154.949 631.276 153.78C628.552 153.294 625.768 153.259 623.033 153.676C619.948 154.014 616.826 153.722 613.858 152.818C612.302 152.158 610.634 151.806 608.945 151.782C607.272 151.945 605.556 153.35 605.792 155.008C604.466 154.141 602.91 153.693 601.325 153.725C599.741 153.757 598.204 154.266 596.913 155.185C593.776 157.524 593.717 161.031 594.871 164.523C595.382 166.104 596.078 167.619 596.943 169.037Z"
                                fill="#263238"
                              />
                              <path
                                d="M641.871 165.175L647.169 162.052C646.736 161.39 646.064 160.919 645.293 160.739C644.523 160.559 643.712 160.683 643.03 161.085C642.348 161.487 641.847 162.136 641.631 162.898C641.415 163.659 641.501 164.475 641.871 165.175Z"
                                fill="#263238"
                              />
                              <path
                                d="M612.97 185.997L613.133 179.855C612.714 179.817 612.291 179.866 611.892 179.997C611.492 180.129 611.123 180.341 610.809 180.621C610.495 180.9 610.241 181.242 610.063 181.623C609.886 182.005 609.789 182.419 609.777 182.839C609.766 183.26 609.842 183.679 609.998 184.069C610.155 184.459 610.391 184.814 610.69 185.109C610.989 185.405 611.346 185.637 611.738 185.789C612.13 185.942 612.55 186.013 612.97 185.997Z"
                                fill="#263238"
                              />
                              <path
                                d="M607.657 220.138C596.514 212.62 574.538 196.46 571.874 194.773C568.174 192.509 562.506 191.991 559.029 193.84C555.803 195.572 557.623 199.893 563.868 207.263C569.921 214.396 596.218 241.3 596.218 241.3L607.657 220.138Z"
                                fill="#A35B5A"
                              />
                              <path
                                d="M608.264 217.503C600.509 212.59 584.586 202.705 584.586 202.705C584.586 202.705 573.605 210.592 576.15 223.837C576.15 223.837 592.103 239.124 596.869 243.075C600.095 245.68 609.403 241.595 610.72 232.243C612.452 220.685 608.264 217.503 608.264 217.503Z"
                                fill="#BBE9F8"
                              />
                              <path
                                opacity="0.5"
                                d="M608.264 217.503C600.509 212.59 584.586 202.705 584.586 202.705C584.586 202.705 573.605 210.592 576.15 223.837C576.15 223.837 592.103 239.124 596.869 243.075C600.095 245.68 609.403 241.595 610.72 232.243C612.452 220.685 608.264 217.503 608.264 217.503Z"
                                fill="black"
                              />
                              <path
                                d="M557.697 196.326C558.541 190.215 577.32 177.28 583.743 173.3C586.642 171.534 589.346 169.465 591.808 167.129C592.785 166.181 593.643 165.131 594.605 164.169C595.567 163.207 596.396 161.89 597.565 160.884C598.953 159.531 600.528 158.385 602.241 157.48C605.515 156.082 609.162 155.822 612.6 156.74C613.399 156.918 614.199 157.14 615.027 157.243C616.759 157.465 618.727 157.243 620.074 158.309C620.222 158.408 620.347 158.539 620.439 158.693C620.532 158.846 620.589 159.018 620.606 159.197C620.606 159.759 620.059 160.114 619.556 160.366C615.604 162.289 610.943 162.941 607.643 165.856C607.391 166.078 605.852 168.105 606.696 168.327C607.539 168.549 610.41 167.365 613.518 167.454C617.262 167.558 614.79 169.718 613.518 170.414C611.499 171.576 609.312 172.42 607.036 172.915C603.543 173.758 600.495 174.143 598.157 175.697C595.819 177.251 575.012 198.295 575.012 198.295L557.697 196.326Z"
                                fill="#A35B5A"
                              />
                            </svg>
                          </span>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </Col>
        </Row>
      </div>
      {/* Pagination Controls */}
      {/* <Container style={{
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '16px',
  marginTop: '20px',
  padding: '10px',
  backgroundColor: mode === "dark" ? "#252525" : "#fff",
  borderRadius: '8px',
  border: mode === "dark" ? '1px solid #0F7687 solid #444' : '1px solid #0F7687 solid #e0e0e0'
}}>
  <FormControl variant="outlined" size="small">
    <Select
      value={limit}
      onChange={(e) => {
        setLimit(Number(e.target.value));
        setCurrentPage(1); // إعادة تعيين الصفحة إلى 1 عند تغيير الـ limit
      }}
      style={{
        minWidth: '80px',
        color: mode === "dark" ? "#90caf9" : "#0F7687",
        backgroundColor: mode === "dark" ? "#333" : "#f5f5f5"
      }}
      MenuProps={{
        PaperProps: {
          style: {
            maxHeight: 300,
            backgroundColor: mode === "dark" ? "#333" : "#fff",
            color: mode === "dark" ? "#90caf9" : "#0F7687"
          }
        }
      }}
    >
      {[5,8,10,25,50,75,100,125,150,175,200,225,250,275,300,325,350,375,400,425,450,475,500].map((item) => (
        <MenuItem 
          key={item} 
          value={item}
          style={{
            backgroundColor: limit === item ? (mode === "dark" ? "#0F7687" : "#e0f7fa") : 'inherit'
          }}
        >
          {item}
        </MenuItem>
      ))}
    </Select>
  </FormControl>

  <IconButton 
    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
    disabled={currentPage === 1}
    style={{ color: mode === "dark" ? "#90caf9" : "#0F7687" }}
  >
    <ChevronLeft />
  </IconButton>

  <FormControl variant="outlined" size="small">
    <Select
      value={currentPage}
      onChange={(e) => setCurrentPage(Number(e.target.value))}
      style={{
        minWidth: '80px',
        color: mode === "dark" ? "#90caf9" : "#0F7687",
        backgroundColor: mode === "dark" ? "#333" : "#f5f5f5"
      }}
      MenuProps={{
        PaperProps: {
          style: {
            maxHeight: 300,
            backgroundColor: mode === "dark" ? "#333" : "#fff",
            color: mode === "dark" ? "#90caf9" : "#0F7687"
          }
        }
      }}
    >
      {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
        <MenuItem 
          key={page} 
          value={page}
          style={{
            backgroundColor: currentPage === page ? (mode === "dark" ? "#0F7687" : "#e0f7fa") : 'inherit'
          }}
        >
          {page}
        </MenuItem>
      ))}
    </Select>
  </FormControl>

  <span style={{ 
    color: mode === "dark" ? "#fff" : "#333",
    minWidth: '100px',
    textAlign: 'center'
  }}>
    Page {currentPage} of {totalPages}
  </span>

  <IconButton
    onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
    disabled={currentPage === totalPages}
    style={{ color: mode === "dark" ? "#90caf9" : "#0F7687" }}
  >
    <ChevronRight />
  </IconButton>
</Container> */}
      {/* pagination */}
      {/* {filters.length > 0 && ( */}
      <Container
        style={{
          position: 'fixed',
          bottom: 0,
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 1000,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '16px',
          padding: '10px',
          backgroundColor: mode === 'dark' ? '#252525' : '#fff',
          borderRadius: '8px',
          // border: mode === 'dark' ? '1px solid #0F7687 solid #444' : '1px solid #0F7687 solid #e0e0e0',
          width: 'fit-content',
          margin: '0 auto',
          border: '1px solid #ccc',
        }}
      >
        {/* Limit Selector */}
        <FormControl variant="outlined" size="small">
          <Select
            value={limit}
            onChange={(e) => {
              setLimit(Number(e.target.value));
              setCurrentPage(1);
            }}
            style={{
              minWidth: '80px',
              color: mode === 'dark' ? '#90caf9' : '#0F7687',
              backgroundColor: mode === 'dark' ? '#333' : '#f5f5f5',
            }}
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 300,
                  backgroundColor: mode === 'dark' ? '#333' : '#fff',
                  color: mode === 'dark' ? '#90caf9' : '#0F7687',
                },
              },
            }}
          >
            {[25, 50, 100, 250, 500].map((item) => (
              <MenuItem
                key={item}
                value={item}
                style={{
                  backgroundColor:
                    limit === item ? (mode === 'dark' ? '#0F7687' : '#e0f7fa') : 'inherit',
                }}
              >
                {item}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Prev Button */}
        <IconButton
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
          disabled={currentPage === 1}
          style={{ color: mode === 'dark' ? '#90caf9' : '#0F7687' }}
        >
          <ChevronLeft />
        </IconButton>

        {/* Page Selector */}
        <FormControl variant="outlined" size="small">
          <Select
            value={currentPage}
            onChange={(e) => setCurrentPage(Number(e.target.value))}
            style={{
              minWidth: '80px',
              color: mode === 'dark' ? '#90caf9' : '#0F7687',
              backgroundColor: mode === 'dark' ? '#333' : '#f5f5f5',
            }}
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 300,
                  backgroundColor: mode === 'dark' ? '#333' : '#fff',
                  color: mode === 'dark' ? '#90caf9' : '#0F7687',
                },
              },
            }}
          >
            {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
              <MenuItem
                key={page}
                value={page}
                style={{
                  backgroundColor:
                    currentPage === page ? (mode === 'dark' ? '#0F7687' : '#e0f7fa') : 'inherit',
                }}
              >
                {page}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Info */}
        <span
          style={{
            color: mode === 'dark' ? '#fff' : '#333',
            minWidth: '100px',
            textAlign: 'center',
          }}
        >
          Page {currentPage} of {totalPages}
        </span>

        {/* Next Button */}
        <IconButton
          onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
          disabled={currentPage === totalPages}
          style={{ color: mode === 'dark' ? '#90caf9' : '#0F7687' }}
        >
          <ChevronRight />
        </IconButton>
        <Typography
          variant="body2"
          style={{
            color: mode === 'dark' ? '#90caf9' : '#0F7687',
            fontWeight: 'bold',
            whiteSpace: 'nowrap', // لمنع النص من النزول لسطر جديد
          }}
        >
          Showing {indexOfFirstRow + 1}-{Math.min(indexOfLastRow, filteredUsers?.length)} of{' '}
          {filteredUsers?.length}
        </Typography>
      </Container>
      {/* )} */}
    </div>
  );
};
